// src/money.ts
var ZERO = 0;
var ErrorMoney = class extends Error {
};
function cents(n) {
  if (!Number.isSafeInteger(n)) {
    throw new ErrorMoney(`dinheiro precisa ser centavo inteiro, recebeu ${n}`);
  }
  return n;
}
function fromReais(n) {
  if (!Number.isFinite(n)) throw new ErrorMoney(`valor inv\xE1lido: ${n}`);
  return cents(Math.round(n * 100));
}
function fromColumn(text) {
  if (text === null || text === void 0) return null;
  const clean2 = text.trim();
  if (!/^-?\d+(\.\d{1,2})?$/.test(clean2)) {
    throw new ErrorMoney(
      `coluna numeric fora do formato esperado: ${JSON.stringify(text)}`
    );
  }
  const negative = clean2.startsWith("-");
  const [whole = "0", decimal = ""] = clean2.replace("-", "").split(".");
  const total = Number(whole) * 100 + Number(decimal.padEnd(2, "0"));
  return cents(negative ? -total : total);
}
function toColumn(d) {
  const sign = d < 0 ? "-" : "";
  const abs = Math.abs(d);
  return `${sign}${Math.trunc(abs / 100)}.${String(abs % 100).padStart(2, "0")}`;
}
function sum(...values) {
  return cents(values.reduce((t, v) => t + v, 0));
}
function subtract(a, b) {
  return cents(a - b);
}
function negate(d) {
  return cents(-d);
}
function multiply(d, factor) {
  if (!Number.isFinite(factor)) throw new ErrorMoney(`fator inv\xE1lido: ${factor}`);
  const raw = d * factor;
  return cents(raw < 0 ? -Math.round(-raw) : Math.round(raw));
}
function percentageOf(d, pontos) {
  return multiply(d, pontos / 100);
}
function apportion(total, parts, weights) {
  if (!Number.isInteger(parts) || parts <= 0) {
    throw new ErrorMoney(`n\xFAmero de partes inv\xE1lido: ${parts}`);
  }
  const p = weights ?? Array.from({ length: parts }, () => 1);
  if (p.length !== parts) {
    throw new ErrorMoney(`${parts} partes e ${p.length} pesos`);
  }
  if (p.some((x) => !Number.isFinite(x) || x < 0)) {
    throw new ErrorMoney("peso inv\xE1lido");
  }
  const sumWeights = p.reduce((t, x) => t + x, 0);
  if (sumWeights <= 0) throw new ErrorMoney("a soma dos pesos \xE9 zero");
  const exact = p.map((weight) => total * weight / sumWeights);
  const tenant = exact.map((v) => v < 0 ? -Math.floor(-v) : Math.floor(v));
  let remainder = total - tenant.reduce((t, v) => t + v, 0);
  const order = exact.map((v, i) => ({ i, rest: Math.abs(v - (tenant[i] ?? 0)) })).sort((a, b) => b.rest - a.rest || a.i - b.i);
  const step = remainder < 0 ? -1 : 1;
  for (let k = 0; remainder !== 0; k++) {
    const target = order[k % order.length];
    if (!target) break;
    tenant[target.i] = (tenant[target.i] ?? 0) + step;
    remainder -= step;
  }
  return tenant.map((v) => cents(v));
}
function parseMoneyInput(text) {
  const clean2 = text.replace(/R\$/i, "").replace(/\s/g, "");
  if (clean2 === "") return null;
  let normalized;
  if (clean2.includes(",")) {
    if (!/^\d{1,3}(\.\d{3})*(,\d{1,2})?$|^\d+(,\d{1,2})?$/.test(clean2)) return null;
    normalized = clean2.replace(/\./g, "").replace(",", ".");
  } else if (/^\d+\.\d{1,2}$/.test(clean2)) {
    normalized = clean2;
  } else if (/^\d{1,3}(\.\d{3})+$|^\d+$/.test(clean2)) {
    normalized = clean2.replace(/\./g, "");
  } else {
    return null;
  }
  return fromColumn(normalized);
}
function format(d) {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
    d / 100
  );
}
function isZero(d) {
  return d === 0;
}
function compareMoney(a, b) {
  return a - b;
}

// src/awards.ts
function recurrenceAward(input) {
  if (input.boletoTypes === 0) {
    return { estado: "recusado", reason: "tipos_de_boleto_nao_declarados" };
  }
  const state = input.state ?? "garantido";
  if (state === "perdendo") {
    return {
      estado: "apurado",
      value: {
        basis: input.basis.gross,
        amount: percentageOf(input.basis.gross, input.percentage),
        feeTotal: ZERO
      }
    };
  }
  if (input.basis.boletosWithoutFee > 0) {
    return { estado: "recusado", reason: "tarifa_do_banco_ausente" };
  }
  const feeTotal = input.basis.fee;
  const afterFee = subtract(input.basis.gross, feeTotal);
  const basis = afterFee < 0 ? ZERO : afterFee;
  return {
    estado: "apurado",
    value: {
      basis,
      amount: percentageOf(basis, input.percentage),
      feeTotal
    }
  };
}
function formatPercentage(value2) {
  const [whole, decimals = ""] = value2.split(".");
  const trimmed = decimals.replace(/0+$/, "");
  return trimmed === "" ? whole : `${whole},${trimmed}`;
}
function monthEnd(period) {
  const year = Number(period.slice(0, 4));
  const month = Number(period.slice(5, 7));
  const day = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return `${period.slice(0, 8)}${String(day).padStart(2, "0")}`;
}
function directAward(input) {
  if (input.tiers.length === 0) {
    return { estado: "recusado", reason: "faixas_nao_declaradas" };
  }
  if (input.vehicleKinds === 0) {
    return { estado: "recusado", reason: "tipos_de_veiculo_nao_declarados" };
  }
  if (input.adhesionKinds === 0) {
    return { estado: "recusado", reason: "tipos_de_adesao_nao_declarados" };
  }
  if (input.boletoTypes === 0) {
    return { estado: "recusado", reason: "tipos_de_boleto_nao_declarados" };
  }
  const reached = reachedTier(input.plates, input.tiers);
  return {
    estado: "apurado",
    value: {
      plates: input.plates,
      amount: reached?.amount ?? ZERO,
      tierReached: reached?.minPlates ?? null
    }
  };
}
function reachedTier(plates, tiers) {
  return [...tiers].filter((t) => t.minPlates <= plates).sort((a, b) => b.minPlates - a.minPlates)[0] ?? null;
}
function nextTier(plates, tiers) {
  const next = [...tiers].filter((t) => t.minPlates > plates).sort((a, b) => a.minPlates - b.minPlates)[0];
  return next === void 0 ? null : { tier: next, missing: next.minPlates - plates };
}
function directCycleEnd(period, deadlineDays) {
  const end = /* @__PURE__ */ new Date(`${monthEnd(`${period}-01`)}T00:00:00.000Z`);
  end.setUTCDate(end.getUTCDate() + deadlineDays);
  return end.toISOString().slice(0, 10);
}
function countsActivations(family) {
  return family === "direta" || family === "antecipada";
}
var CAREER_PLAN_TIERS = [
  { minPlates: 30, amount: "1000.00", role: "L\xEDder Junior" },
  { minPlates: 50, amount: "2120.00", role: "L\xEDder" },
  { minPlates: 75, amount: "3200.00", role: "L\xEDder" },
  { minPlates: 100, amount: "4300.00", role: "L\xEDder" },
  { minPlates: 125, amount: "5320.00", role: "Coordenador" },
  { minPlates: 150, amount: "6350.00", role: "Coordenador" },
  { minPlates: 175, amount: "7400.00", role: "Coordenador" },
  { minPlates: 200, amount: "8460.00", role: "Coordenador" },
  { minPlates: 225, amount: "9240.00", role: "Coordenador" },
  { minPlates: 250, amount: "10030.00", role: "Coordenador" },
  { minPlates: 275, amount: "11120.00", role: "Coordenador" },
  { minPlates: 300, amount: "12200.00", role: "Coordenador" },
  { minPlates: 325, amount: "12980.00", role: "Coordenador" },
  { minPlates: 350, amount: "13750.00", role: "Coordenador" },
  { minPlates: 375, amount: "14820.00", role: "Coordenador" },
  { minPlates: 400, amount: "15900.00", role: "Gestor" },
  { minPlates: 425, amount: "16680.00", role: "Gestor" },
  { minPlates: 450, amount: "17450.00", role: "Gestor" },
  { minPlates: 475, amount: "18500.00", role: "Gestor" },
  { minPlates: 500, amount: "19550.00", role: "Gestor" },
  { minPlates: 525, amount: "20750.00", role: "Gestor" },
  { minPlates: 550, amount: "21950.00", role: "Gestor" },
  { minPlates: 575, amount: "23150.00", role: "Gestor" },
  { minPlates: 600, amount: "24350.00", role: "Diretor Regional" },
  { minPlates: 625, amount: "25140.00", role: "Diretor Regional" },
  { minPlates: 650, amount: "25940.00", role: "Diretor Regional" },
  { minPlates: 675, amount: "26730.00", role: "Diretor Regional" },
  { minPlates: 700, amount: "27520.00", role: "Diretor Regional" },
  { minPlates: 725, amount: "28580.00", role: "Diretor Regional" },
  { minPlates: 750, amount: "29640.00", role: "Diretor Regional" },
  { minPlates: 775, amount: "30690.00", role: "Diretor Regional" },
  { minPlates: 800, amount: "31750.00", role: "Diretor Regional" },
  { minPlates: 825, amount: "32280.00", role: "Diretor Regional" },
  { minPlates: 850, amount: "32800.00", role: "Diretor Regional" },
  { minPlates: 875, amount: "33320.00", role: "Diretor Regional" },
  { minPlates: 900, amount: "33850.00", role: "Diretor Regional" },
  { minPlates: 925, amount: "35160.00", role: "Diretor Regional" },
  { minPlates: 950, amount: "36480.00", role: "Diretor Regional" },
  { minPlates: 975, amount: "37790.00", role: "Diretor Regional" },
  { minPlates: 1e3, amount: "39100.00", role: "Diretor Regional" },
  { minPlates: 1200, amount: "48650.00", role: "Diretor Nacional" }
];
function careerRole(plates) {
  let role = null;
  for (const tier of CAREER_PLAN_TIERS) {
    if (plates >= tier.minPlates) role = tier.role;
  }
  return role;
}
function shiftPeriod(period, n) {
  const [year, month] = period.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1 + n, 1)).toISOString().slice(0, 7);
}
function directCompetence(period, deadlineDays) {
  if (deadlineDays === null) return period;
  const paying = shiftPeriod(period, 1);
  for (let back = 0; back <= 12; back++) {
    const candidate = shiftPeriod(period, -back);
    if (directCycleEnd(candidate, deadlineDays).slice(0, 7) <= paying) return candidate;
  }
  return shiftPeriod(period, -12);
}
function awardShares(total, memberShare) {
  if (!Number.isFinite(memberShare) || memberShare <= 0) {
    throw new ErrorMoney(
      `parte concedida inv\xE1lida: ${memberShare}%. Conceder zero \xE9 n\xE3o conceder, e a linha da concess\xE3o n\xE3o deveria existir.`
    );
  }
  if (memberShare >= 100) {
    throw new ErrorMoney(
      `${memberShare}% da premia\xE7\xE3o concedidos. A concess\xE3o \xE9 uma PARTE do que o l\xEDder recebe: conceder tudo o deixaria com zero, e conceder acima pagaria mais do que a casa decidiu.`
    );
  }
  const [member, leader] = apportion(total, 2, [memberShare, 100 - memberShare]);
  return { member: member ?? ZERO, leader: leader ?? ZERO };
}
function leaderAmount(teamBasis, percentage, granted) {
  const total = percentageOf(teamBasis, percentage);
  const rest = subtract(total, granted);
  return rest < 0 ? ZERO : rest;
}
function productLineAmount(line2, rates, combination, discount) {
  const owned = new Set(line2.products);
  const hits = rates.filter((r) => owned.has(r.code));
  if (hits.length === 0) return { amount: ZERO, paidProducts: [], discounted: false };
  const discounted = discount !== null && line2.paidWithDiscount && line2.contractDate !== null && line2.contractDate >= discount.from;
  const values = hits.map((r) => ({
    code: r.code,
    amount: discounted ? subtract(r.amount, percentageOf(r.amount, discount.percentage)) : r.amount
  }));
  if (combination === "soma") {
    return {
      amount: sum(...values.map((v) => v.amount)),
      paidProducts: values.map((v) => v.code),
      discounted
    };
  }
  const best = [...values].sort(
    (a, b) => b.amount === a.amount ? a.code.localeCompare(b.code) : b.amount - a.amount
  )[0];
  return { amount: best.amount, paidProducts: [best.code], discounted };
}
function productAward(input) {
  if (input.rates.length === 0) {
    return { estado: "recusado", reason: "produtos_nao_declarados" };
  }
  if (input.boletoTypes === 0) {
    return { estado: "recusado", reason: "tipos_de_boleto_nao_declarados" };
  }
  if (input.unchecked > 0) {
    return { estado: "recusado", reason: "produtos_nao_consultados" };
  }
  const lines = input.lines.map(
    (l) => productLineAmount(l, input.rates, input.combination, input.discount)
  );
  return {
    estado: "apurado",
    value: {
      amount: sum(...lines.map((l) => l.amount)),
      paidLines: lines.filter((l) => l.amount > 0).length,
      lines
    }
  };
}

// src/award-balance.ts
var BALANCE_SETTLED_STATUSES = [
  "pagamento_efetuado",
  "pagamento_recusado"
];
var BALANCE_PART_SOURCES = [
  "competencia_aberta",
  "aguardando_nota",
  "no_financeiro"
];
function balanceParts({
  statement,
  lots,
  closedPeriods
}) {
  const key = (period, category) => `${period}|${category}`;
  const extrato = /* @__PURE__ */ new Map();
  const awards = /* @__PURE__ */ new Map();
  for (const g of statement) {
    const k = key(g.period, g.category);
    extrato.set(k, sum(extrato.get(k) ?? ZERO, g.amount));
    if (g.award !== void 0) {
      const byAward = awards.get(k) ?? /* @__PURE__ */ new Map();
      const before = byAward.get(g.award.id);
      byAward.set(g.award.id, {
        id: g.award.id,
        title: g.award.title,
        amount: sum(before?.amount ?? ZERO, g.amount)
      });
      awards.set(k, byAward);
    }
  }
  const positive = (k) => {
    const v = extrato.get(k) ?? ZERO;
    return v > 0 ? v : ZERO;
  };
  const awardsOf = (k) => [...awards.get(k)?.values() ?? []].filter((a) => a.amount !== 0).sort((a, b) => b.amount - a.amount);
  const parts = [];
  const withLot = /* @__PURE__ */ new Set();
  for (const lot of lots) {
    const k = key(lot.period, lot.category);
    withLot.add(k);
    const head = { period: lot.period, category: lot.category, awards: awardsOf(k) };
    if (lot.expense === null) {
      parts.push({ ...head, source: "aguardando_nota", amount: positive(k), expense: null });
    } else if (!BALANCE_SETTLED_STATUSES.includes(lot.expense.status)) {
      parts.push({
        ...head,
        source: "no_financeiro",
        amount: lot.expense.amount,
        expense: {
          status: lot.expense.status,
          dueDate: lot.expense.dueDate ?? null,
          sentOn: lot.expense.sentOn ?? null
        }
      });
    }
  }
  for (const g of statement) {
    const k = key(g.period, g.category);
    if (withLot.has(k) || closedPeriods.has(g.period)) continue;
    withLot.add(k);
    parts.push({
      period: g.period,
      category: g.category,
      source: "competencia_aberta",
      amount: positive(k),
      expense: null,
      awards: awardsOf(k)
    });
  }
  return parts.filter((p) => p.amount > 0).sort(
    (a, b) => a.period.localeCompare(b.period) || a.category.localeCompare(b.category)
  );
}
function consultantBalance(input) {
  return sum(...balanceParts(input).map((p) => p.amount));
}

// src/award-daily.ts
var AWARD_BUCKETS = [5, 10, 15, 20, 25, 30];
function bucketOf(month, date) {
  if (date === null) return null;
  const day = date.slice(0, 7);
  if (day < month) return 5;
  if (day > month) return 30;
  const n = Number(date.slice(8, 10));
  let best = 5;
  for (const b of AWARD_BUCKETS) if (Math.abs(n - b) < Math.abs(n - best)) best = b;
  return best;
}
function inMonth(month, date) {
  return date !== null && date.slice(0, 7) === month;
}
function awardDays(paid, open) {
  const days = AWARD_BUCKETS.map((day) => ({ day, paid: ZERO, open: ZERO }));
  const undated = { paid: ZERO, open: ZERO, count: 0 };
  const add3 = (rows, side) => {
    for (const row of rows) {
      const column = days.find((d) => d.day === row.bucket);
      if (column === void 0 || row.amount === null) {
        undated[side] = sum(undated[side], row.amount ?? ZERO);
        undated.count += 1;
        continue;
      }
      column[side] = sum(column[side], row.amount);
    }
  };
  add3(paid, "paid");
  add3(open, "open");
  return { days, undated };
}
function dayShares(total, rows) {
  if (rows.length === 0) {
    return total === ZERO ? [] : [{ bucket: null, amount: total }];
  }
  const weights = rows.map((r) => r.weight < 0 ? 0 : r.weight);
  const weightSum = weights.reduce((t, w) => t + w, 0);
  const parts = weightSum <= 0 ? apportion(total, rows.length) : apportion(total, rows.length, weights);
  return rows.map((r, i) => ({ bucket: r.bucket, amount: parts[i] ?? ZERO }));
}

// src/statement.ts
function apportionAward(total, sources) {
  if (sources.length === 0) {
    if (total !== ZERO) {
      throw new ErrorMoney(
        `${total} centavos a repartir e nenhuma linha que os tenha gerado`
      );
    }
    return [];
  }
  if (total === ZERO) return sources.map(() => ZERO);
  const weights = sources.map((s) => {
    const basis = s.gross - s.fee;
    return basis < 0 ? 0 : basis;
  });
  const sum2 = weights.reduce((t, w) => t + w, 0);
  if (sum2 <= 0) return apportion(total, sources.length);
  return apportion(total, sources.length, weights);
}

// src/wallet.ts
function monthsEndingAt(month, count3) {
  const year = Number(month.slice(0, 4));
  const index = Number(month.slice(5, 7)) - 1;
  const absolute = year * 12 + index;
  return Array.from({ length: count3 }, (_, i) => {
    const at2 = absolute - (count3 - 1 - i);
    const y = Math.floor(at2 / 12);
    const m = at2 % 12 + 1;
    return `${y}-${String(m).padStart(2, "0")}`;
  });
}
function lastClosedMonth(month, current) {
  if (month < current) return month;
  return monthsEndingAt(current, 2)[0];
}
function monthsAfter(month, count3) {
  const year = Number(month.slice(0, 4));
  const index = Number(month.slice(5, 7)) - 1;
  const absolute = year * 12 + index;
  return Array.from({ length: count3 }, (_, i) => {
    const at2 = absolute + i + 1;
    return `${Math.floor(at2 / 12)}-${String(at2 % 12 + 1).padStart(2, "0")}`;
  });
}
function variation(previous, current) {
  if (previous === 0) return null;
  return Math.round((current - previous) / Math.abs(previous) * 1e3) / 10;
}
function matchesOpenBoleto(row, filter) {
  const fold2 = (text) => text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
  const search = filter.search?.trim() ?? "";
  if (search !== "") {
    const plate = search.toUpperCase().replace(/[^A-Z0-9]/g, "");
    const byName = row.memberName !== null && fold2(row.memberName).includes(fold2(search));
    const byPlate = plate !== "" && row.plate !== null && row.plate.includes(plate);
    if (!byName && !byPlate) return false;
  }
  if (filter.minAmount != null && row.amount < filter.minAmount) return false;
  if (filter.maxAmount != null && row.amount > filter.maxAmount) return false;
  const within2 = (date, from, until) => {
    if (!from && !until) return true;
    if (date === null) return false;
    return (!from || date >= from) && (!until || date <= until);
  };
  return within2(row.dueDate, filter.dueFrom, filter.dueUntil) && within2(row.contractDate, filter.contractFrom, filter.contractUntil);
}
function walletScenarios(input) {
  if (input.rates.length < 2) return null;
  const perSaleAt = (rate) => input.effective === null || input.averageBoleto === null || input.averageBoleto <= 0 ? null : Math.round(input.averageBoleto * input.effective * rate);
  const scenario = (rate) => {
    const monthly = Math.round(input.ceiling * rate);
    const perSale = perSaleAt(rate);
    return {
      rate,
      monthly,
      perSale,
      projection: Array.from(
        { length: input.horizon },
        (_, i) => monthly + (perSale ?? 0) * input.plannedSales * (i + 1)
      )
    };
  };
  const best = scenario(Math.max(...input.rates));
  const worst = scenario(Math.min(...input.rates));
  const expected = scenario(input.rates.reduce((a, b) => a + b, 0) / input.rates.length);
  const salesFor = (gap2, perSale) => perSale === null || perSale <= 0 ? null : gap2 <= 0 ? 0 : Math.ceil(gap2 / perSale);
  return {
    best,
    expected,
    worst,
    salesToBest: salesFor(best.monthly - expected.monthly, expected.perSale),
    salesToAvoidWorst: salesFor(expected.monthly - worst.monthly, worst.perSale)
  };
}
function walletPlan(input) {
  if (input.perPlan <= 0) return null;
  const gap2 = Math.max(0, input.target - input.current);
  const newPlans = Math.ceil(gap2 / input.perPlan);
  const rate = input.paymentRate === null || input.paymentRate <= 0 ? 1 : Math.min(1, input.paymentRate);
  const sales = Math.ceil(newPlans / rate);
  return {
    gap: gap2,
    newPlans,
    sales,
    plansNow: input.plansNow,
    plansNeeded: input.plansNow + newPlans,
    salesPerMonthNeeded: input.months === null || input.months <= 0 ? null : Math.ceil(sales / input.months),
    monthsAtPace: input.salesPerMonth === null || input.salesPerMonth <= 0 ? null : Math.ceil(sales / input.salesPerMonth)
  };
}

// src/recurrence-planner.ts
var SEARCH_LIMIT = 600;
function recurrencePlan(input) {
  const churn = (input.churnPercent ?? 0) / 100;
  if (input.target <= 0 || input.ticket <= 0 || input.commissionPercent <= 0) return null;
  if (churn < 0 || churn >= 1) return null;
  const sales = Math.max(0, Math.floor(input.salesPerMonth));
  const perClientExact = input.ticket * input.commissionPercent / 100;
  const clientsNeeded = Math.ceil(input.target / perClientExact - 1e-9);
  const at2 = (month, clients2) => ({
    month,
    clients: clients2,
    recurrence: Math.round(clients2 * perClientExact)
  });
  const months = [];
  let clients = 0;
  let monthsToGoal = null;
  const reachable = sales > 0 && (churn === 0 || sales / churn >= clientsNeeded - 1e-9);
  const last = reachable ? SEARCH_LIMIT : 12;
  for (let m = 1; m <= last; m++) {
    clients = clients * (1 - churn) + sales;
    months.push(at2(m, clients));
    if (monthsToGoal === null && clients >= clientsNeeded - 1e-9) {
      monthsToGoal = m;
    }
    if (m >= 12 && (monthsToGoal !== null || !reachable)) break;
  }
  const horizon = monthsToGoal === null ? 12 : Math.min(SEARCH_LIMIT, Math.max(8, monthsToGoal + 2));
  while (months.length < horizon) {
    clients = clients * (1 - churn) + sales;
    months.push(at2(months.length + 1, clients));
  }
  return {
    perClient: Math.round(perClientExact),
    clientsNeeded,
    monthsToGoal,
    inTwelveMonths: months[11],
    projection: months.slice(0, horizon)
  };
}

// src/permissions.ts
var WILDCARD = "*";
function permission(resource, action) {
  return `${resource}:${action}`;
}
function permissionParts(p) {
  const i = p.indexOf(":");
  if (i < 0) return { resource: p, action: WILDCARD };
  return { resource: p.slice(0, i), action: p.slice(i + 1) };
}
function canAccess(granted, resource, action) {
  for (const raw of granted) {
    const { resource: r, action: a } = permissionParts(raw);
    const resourceMatches = r === WILDCARD || r === resource;
    const actionMatches = a === WILDCARD || a === action;
    if (resourceMatches && actionMatches) return true;
  }
  return false;
}
function expandPermissions(granted, catalog) {
  const effective = /* @__PURE__ */ new Set();
  for (const r of catalog) {
    for (const a of r.actions) {
      if (canAccess(granted, r.resource, a.action)) {
        effective.add(permission(r.resource, a.action));
      }
    }
  }
  return [...effective].sort();
}
function applyExceptions(effective, exceptions) {
  const result = new Set(effective);
  for (const e of exceptions) {
    const key = permission(e.resource, e.action);
    if (e.status === "permitir") result.add(key);
    else result.delete(key);
  }
  return result;
}
function composeCatalog(...declarations) {
  const byResource = /* @__PURE__ */ new Map();
  for (const list of declarations) {
    for (const decl of list) {
      const existing = byResource.get(decl.resource);
      if (existing) {
        throw new Error(
          `Recurso de permiss\xE3o declarado duas vezes: "${decl.resource}"`
        );
      }
      byResource.set(decl.resource, decl);
    }
  }
  return [...byResource.values()].sort(
    (a, b) => a.resource.localeCompare(b.resource)
  );
}

// src/redaction.ts
function redactIdentifiers(text) {
  return text.replace(/[\w.+-]+@[\w.-]+\.\w+/g, "[e-mail]").replace(
    /(?<!\d)(\d{3}\.?\d{3}\.?\d{3}-?\d{2}|\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})(?!\d)/g,
    "[documento]"
  ).replace(/(?<![A-Z0-9])[A-Z]{3}-?\d[A-Z0-9]\d{2}(?![A-Z0-9])/gi, "[placa]");
}

// src/account-access.ts
var ACCOUNT_ACCESS_REASONS = [
  "excecao_permite",
  "excecao_nega",
  "grupo_autorizado",
  "sem_autorizacao"
];
function accountAccess(input) {
  if (input.exception === "negar") return { allowed: false, reason: "excecao_nega" };
  if (input.exception === "permitir") return { allowed: true, reason: "excecao_permite" };
  if (input.groupId !== null && input.grantedGroupIds.has(input.groupId)) {
    return { allowed: true, reason: "grupo_autorizado" };
  }
  return { allowed: false, reason: "sem_autorizacao" };
}
var ACCOUNT_ACCESS_REASON_LABELS = {
  excecao_permite: "Exce\xE7\xE3o: permitido",
  excecao_nega: "Exce\xE7\xE3o: negado",
  grupo_autorizado: "Pelo grupo",
  sem_autorizacao: "Sem autoriza\xE7\xE3o"
};

// src/normalization.ts
function digitsOnly(value2) {
  if (value2 == null) return null;
  const d = value2.replace(/\D/g, "");
  return d.length > 0 ? d : null;
}
function normalizePlate(value2) {
  if (value2 == null) return null;
  const p = value2.toUpperCase().replace(/[^A-Z0-9]/g, "");
  if (!/^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(p)) return null;
  return p;
}
function normalizeCpf(value2) {
  const d = digitsOnly(value2);
  if (d == null || d.length !== 11) return null;
  return d;
}
function normalizeDocument(value2) {
  const d = digitsOnly(value2);
  if (d == null || d.length !== 11 && d.length !== 14) return null;
  return d;
}
function isValidCpf(value2) {
  const cpf = normalizeCpf(value2);
  if (cpf == null) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;
  const digit = (until) => {
    let sum2 = 0;
    for (let i = 0; i < until; i++) {
      sum2 += Number(cpf[i]) * (until + 1 - i);
    }
    const rest = sum2 * 10 % 11;
    return rest === 10 ? 0 : rest;
  };
  return digit(9) === Number(cpf[9]) && digit(10) === Number(cpf[10]);
}
function isValidCnpj(value2) {
  const cnpj = digitsOnly(value2);
  if (cnpj == null || cnpj.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(cnpj)) return false;
  const digit = (until) => {
    let sum2 = 0;
    let weight = until - 7;
    for (let i = 0; i < until; i++) {
      sum2 += Number(cnpj[i]) * weight;
      weight = weight === 2 ? 9 : weight - 1;
    }
    const rest = sum2 % 11;
    return rest < 2 ? 0 : 11 - rest;
  };
  return digit(12) === Number(cnpj[12]) && digit(13) === Number(cnpj[13]);
}
function normalizePhone(value2) {
  let d = digitsOnly(value2);
  if (d == null) return null;
  if (d.length > 11 && d.startsWith("55")) d = d.slice(2);
  if (d.length !== 10 && d.length !== 11) return null;
  if (d.length === 11 && d[2] !== "9") return null;
  const ddd = Number(d.slice(0, 2));
  if (ddd < 11 || ddd > 99) return null;
  return d;
}
function formatPhone(value2) {
  if (value2 == null) return "";
  const d = normalizePhone(value2);
  if (!d) return value2;
  const ddd = d.slice(0, 2);
  const rest = d.slice(2);
  const cut = rest.length === 9 ? 5 : 4;
  return `(${ddd}) ${rest.slice(0, cut)}-${rest.slice(cut)}`;
}
function normalizeName(value2) {
  if (value2 == null) return null;
  const n = value2.replace(/\s+/g, " ").trim();
  return n.length > 0 ? n : null;
}
var CONNECTORS = /* @__PURE__ */ new Set(["de", "da", "do", "das", "dos", "e"]);
function properName(value2) {
  const n = normalizeName(value2);
  if (n === null) return null;
  return n.toLocaleLowerCase("pt-BR").split(" ").map(
    (word, i) => i > 0 && CONNECTORS.has(word) ? word : word.split("-").map((part) => part.charAt(0).toLocaleUpperCase("pt-BR") + part.slice(1)).join("-")
  ).join(" ");
}
function vendorUpperCase(value2) {
  if (value2 == null) return null;
  return /[a-z]/.test(value2) ? value2 : value2.toLocaleUpperCase("pt-BR");
}
function normalizeEmail(value2) {
  if (value2 == null) return null;
  const e = value2.trim().toLowerCase();
  return e.length > 0 ? e : null;
}
function maskCpfInternal(cpf) {
  if (cpf === null) return null;
  const digits = digitsOnly(cpf);
  if (digits === null || digits.length === 0) return null;
  if (digits.length !== 11) {
    return `${"*".repeat(Math.max(digits.length - 2, 0))}${digits.slice(-2)}`;
  }
  return `***.***.${digits.slice(6, 9)}-${digits.slice(9)}`;
}
function mirrorPhoneNumbers(l) {
  const pairs = [
    [l.dddCelular, l.telefoneCelular],
    [l.dddCelularAux, l.telefoneCelularAux],
    [l.ddd, l.telefone],
    [l.dddComercial, l.telefoneComercial]
  ];
  const numbers = [];
  for (const [ddd, numero] of pairs) {
    const digits = digitsOnly(numero ?? "") ?? "";
    if (digits.length === 0) continue;
    numbers.push(`${digitsOnly(ddd ?? "") ?? ""}${digits}`);
  }
  return numbers;
}
function mirrorPhone(l) {
  return mirrorPhoneNumbers(l)[0] ?? null;
}
function personTypeOfDocument(document5) {
  if (document5 == null) return null;
  const digits = document5.replace(/\D/g, "");
  if (digits.length === 11) return "F\xCDSICA";
  if (digits.length === 14) return "JUR\xCDDICA";
  return null;
}

// src/deadline.ts
var HOUSE_TIMEZONE = "America/Fortaleza";
var DATE_FORMAT = /^\d{4}-\d{2}-\d{2}$/;
function businessDate(instant2, timezone = HOUSE_TIMEZONE) {
  if (typeof instant2 === "string" && DATE_FORMAT.test(instant2)) return instant2;
  const d = instant2 instanceof Date ? instant2 : new Date(instant2);
  if (Number.isNaN(d.getTime())) {
    throw new Error(`Instante inv\xE1lido para data de neg\xF3cio: ${String(instant2)}`);
  }
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).format(d);
}
function startOfDay(data, sumDays2 = 0, timezone = HOUSE_TIMEZONE) {
  const [year, month, day] = businessDateParts(data);
  const naive = Date.UTC(year, month - 1, day + sumDays2, 0, 0, 0, 0);
  const first = offsetAt(naive, timezone);
  const candidate = naive - first;
  const second = offsetAt(candidate, timezone);
  return new Date(second === first ? candidate : naive - second);
}
function offsetAt(instant2, timezone) {
  const atTimezone = new Date(
    new Date(instant2).toLocaleString("en-US", { timeZone: timezone })
  );
  const atUtc = new Date(new Date(instant2).toLocaleString("en-US", { timeZone: "UTC" }));
  return atTimezone.getTime() - atUtc.getTime();
}
var HOUSE_LOCAL_FORMAT = /^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})$/;
function instantFromHouseLocal(local, timezone = HOUSE_TIMEZONE) {
  const m = HOUSE_LOCAL_FORMAT.exec(local.trim());
  if (!m) return null;
  const hour = Number(m[2]);
  const minute = Number(m[3]);
  if (hour > 23 || minute > 59) return null;
  try {
    businessDateParts(m[1]);
  } catch {
    return null;
  }
  return new Date(
    startOfDay(m[1], 0, timezone).getTime() + (hour * 60 + minute) * 6e4
  );
}
function houseLocalOf(instant2, timezone = HOUSE_TIMEZONE) {
  const d = instant2 instanceof Date ? instant2 : new Date(instant2);
  const hour = new Intl.DateTimeFormat("en-GB", {
    timeZone: timezone,
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
  }).format(d);
  return `${businessDate(d, timezone)}T${hour}`;
}
function businessDateParts(data, caller) {
  const where = caller === void 0 ? "" : `${caller}: `;
  if (!DATE_FORMAT.test(data)) {
    throw new Error(`${where}Data de neg\xF3cio inv\xE1lida: ${data}. Use AAAA-MM-DD.`);
  }
  const [year, month, day] = data.split("-").map(Number);
  const check = new Date(Date.UTC(year, month - 1, day));
  if (check.toISOString().slice(0, 10) !== data) {
    throw new Error(`${where}Data de neg\xF3cio inexistente no calend\xE1rio: ${data}.`);
  }
  return [year, month, day];
}
function deadlineFrom(start, amount, unit = "dias", timezone = HOUSE_TIMEZONE) {
  if (!Number.isInteger(amount) || amount < 0) {
    throw new Error(`Quantidade de prazo inv\xE1lida: ${amount}. Use inteiro n\xE3o negativo.`);
  }
  if (unit === "horas") {
    const departure = start instanceof Date ? start : new Date(start);
    if (Number.isNaN(departure.getTime())) {
      throw new Error(`In\xEDcio inv\xE1lido para prazo em horas: ${String(start)}`);
    }
    return businessDate(new Date(departure.getTime() + amount * 36e5), timezone);
  }
  const tenant = businessDate(start, timezone);
  const d = /* @__PURE__ */ new Date(`${tenant}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + amount);
  return d.toISOString().slice(0, 10);
}
function isOverdue(dueAt, now = /* @__PURE__ */ new Date(), timezone = HOUSE_TIMEZONE) {
  if (!dueAt) return false;
  businessDateParts(dueAt);
  return businessDate(now, timezone) > dueAt;
}
function daysUntil(dueAt, now = /* @__PURE__ */ new Date(), timezone = HOUSE_TIMEZONE) {
  businessDateParts(dueAt);
  const today = /* @__PURE__ */ new Date(`${businessDate(now, timezone)}T12:00:00Z`);
  const target = /* @__PURE__ */ new Date(`${dueAt}T12:00:00Z`);
  return Math.round((target.getTime() - today.getTime()) / 864e5);
}

// src/format.ts
function formatDate(data) {
  return new Intl.DateTimeFormat("pt-BR", { timeZone: HOUSE_TIMEZONE }).format(
    /* @__PURE__ */ new Date(`${data}T12:00:00Z`)
  );
}
function formatDueDate(data) {
  return data === null ? "a preencher pelo Financeiro" : formatDate(data);
}
function formatInstant(iso) {
  return new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "short",
    timeStyle: "short",
    timeZone: HOUSE_TIMEZONE
  }).format(new Date(iso));
}
function count(n, singular, plural) {
  return n === 1 ? `1 ${singular}` : `${n} ${plural}`;
}
var MINUTE = 6e4;
var HOUR = 36e5;
var DAY = 864e5;
function formatAge(ms) {
  if (ms < MINUTE) return "agora h\xE1 pouco";
  if (ms < HOUR) return `h\xE1 ${Math.floor(ms / MINUTE)} min`;
  if (ms < DAY) return `h\xE1 ${Math.floor(ms / HOUR)}h`;
  return `h\xE1 ${count(Math.floor(ms / DAY), "dia", "dias")}`;
}
function formatDocument(document5) {
  if (!document5) return "";
  const d = document5.replace(/\D/g, "");
  if (d.length === 11) {
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
  }
  if (d.length === 14) {
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
  }
  return document5;
}
function documentLabel(document5) {
  const d = (document5 ?? "").replace(/\D/g, "");
  if (d.length === 11) return "CPF";
  if (d.length === 14) return "CNPJ";
  return "Documento";
}

// src/credential-format.ts
var SGA_TOKEN_LENGTH = 288;
var HEX = /^[0-9a-f]+$/i;
function sgaTokenProblem(value2) {
  const clean2 = (value2 ?? "").trim();
  if (clean2.length === 0) return "Informe o token.";
  if (clean2.length !== SGA_TOKEN_LENGTH) {
    return `Token inv\xE1lido: o token do SGA tem ${SGA_TOKEN_LENGTH} caracteres, e este tem ${clean2.length}. Confira se ele foi copiado inteiro.`;
  }
  if (!HEX.test(clean2)) {
    return "Token inv\xE1lido: o token do SGA s\xF3 tem os caracteres 0\u20139 e a\u2013f.";
  }
  return null;
}
function sgaAssociationTokenProblem(value2) {
  return opaqueSecretProblem(value2, "o token da associa\xE7\xE3o");
}
function opaqueSecretProblem(value2, what = "a credencial") {
  const clean2 = (value2 ?? "").trim();
  if (clean2.length === 0) return `Informe ${what}.`;
  if (/\s/.test(clean2)) {
    return `Valor inv\xE1lido: ${what} n\xE3o tem espa\xE7o nem quebra de linha no meio. Confira se colou s\xF3 o valor.`;
  }
  return null;
}
function googleMapsKeyProblem(value2) {
  const problem = opaqueSecretProblem(value2, "a chave do Google Maps");
  if (problem) return problem;
  const clean2 = (value2 ?? "").trim();
  if (!/^AIza[0-9A-Za-z_-]{35}$/.test(clean2)) {
    return 'Isto n\xE3o tem a forma de uma chave do Google Maps: ela come\xE7a com "AIza" e tem 39 caracteres.';
  }
  return null;
}
function sendgridKeyProblem(value2) {
  const problem = opaqueSecretProblem(value2, "a chave do SendGrid");
  if (problem) return problem;
  const clean2 = (value2 ?? "").trim();
  if (!/^SG\.[A-Za-z0-9_-]{22}\.[A-Za-z0-9_-]{43}$/.test(clean2)) {
    return 'Isto n\xE3o tem a forma de uma chave do SendGrid: ela come\xE7a com "SG." e tem 69 caracteres.';
  }
  return null;
}
function credentialProblem(integration, value2) {
  if (integration === "hinova") return sgaTokenProblem(value2);
  if (integration === "googlemaps") return googleMapsKeyProblem(value2);
  if (integration === "sendgrid") return sendgridKeyProblem(value2);
  return opaqueSecretProblem(value2);
}
var BASE64URL = /^[A-Za-z0-9_-]+$/;
var ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
function decodeBase64Url(part) {
  let bits = 0;
  let value2 = 0;
  let hex = "";
  for (const char of part) {
    const index = ALPHABET.indexOf(char);
    if (index < 0) return null;
    value2 = value2 << 6 | index;
    bits += 6;
    if (bits >= 8) {
      bits -= 8;
      hex += `%${(value2 >> bits & 255).toString(16).padStart(2, "0")}`;
    }
  }
  try {
    return decodeURIComponent(hex);
  } catch {
    return null;
  }
}
function jwtExpiry(value2) {
  const parts = (value2 ?? "").trim().split(".");
  if (parts.length !== 3 || !parts.every((p) => p.length > 0 && BASE64URL.test(p))) {
    return null;
  }
  const payload = decodeBase64Url(parts[1]);
  if (payload === null) return null;
  try {
    const claims = JSON.parse(payload);
    return typeof claims.exp === "number" ? claims.exp : null;
  } catch {
    return null;
  }
}
function jwtProblem(value2, now) {
  const clean2 = (value2 ?? "").trim();
  if (clean2.length === 0) return "Informe o access token.";
  const exp = jwtExpiry(clean2);
  if (exp === null) {
    return "Access token inv\xE1lido: ele \xE9 um JWT \u2014 tr\xEAs partes separadas por ponto, com o vencimento dentro. Confira se colou o access token, e n\xE3o o refresh token.";
  }
  if (exp * 1e3 <= now.getTime()) {
    const when = formatInstant(new Date(exp * 1e3).toISOString());
    return `Access token vencido em ${when}. Gere um novo no Conta Azul \u2014 ele vale por 1 hora.`;
  }
  return null;
}

// src/whatsapp.ts
var PERIPHERAL_PI_WHATSAPP = "claims.peripheral_pi";
var PERIPHERAL_PI_ITEM_VARIABLES = (n) => [
  `Item ${n}`,
  `Item ${n} \xB7 fornecedor`,
  `Item ${n} \xB7 marca`,
  `Item ${n} \xB7 origem da pe\xE7a`,
  `Item ${n} \xB7 disponibilidade`
];
var WHATSAPP_PURPOSES = {
  /*
   * Sai quando o acionamento deixa a Aprovação do Supervisor com resultado
   * "Aprovado" — ver `peripheralPiVariables` (`claims-peripherals.ts`). São três
   * itens de cinco posições, e depois a conta e o link.
   */
  [PERIPHERAL_PI_WHATSAPP]: {
    label: "Perif\xE9rico \xB7 envio de PI",
    variables: [
      ...PERIPHERAL_PI_ITEM_VARIABLES(1),
      ...PERIPHERAL_PI_ITEM_VARIABLES(2),
      ...PERIPHERAL_PI_ITEM_VARIABLES(3),
      "Valor total aprovado",
      "Cobertura (%)",
      "Participa\xE7\xE3o (%)",
      "Participa\xE7\xE3o (R$)",
      "Link de pagamento"
    ]
  }
};
function whatsappPurpose(purpose) {
  return Object.hasOwn(WHATSAPP_PURPOSES, purpose) ? WHATSAPP_PURPOSES[purpose] : null;
}
function templateVariables(text) {
  return [...(text ?? "").matchAll(/\{\{\s*([^{}]+?)\s*\}\}/g)].map((match) => match[1]);
}
function templatePlainText(text) {
  return (text ?? "").replace(/<br\s*\/?>/gi, "\n").replace(/<\/p>\s*<p[^>]*>/gi, "\n\n").replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, "&").trim();
}
function whatsappAddress(phone) {
  const clean2 = normalizePhone(phone);
  return clean2 === null ? null : `+55${clean2}`;
}
function opasuiteBaseUrl(value2) {
  const raw = (value2 ?? "").trim();
  if (raw.length === 0 || /\s/.test(raw)) return null;
  const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(raw) ? raw : `https://${raw}`;
  const match = /^([a-z][a-z0-9+.-]*):\/\/([^/?#]*)/i.exec(withScheme);
  if (!match) return null;
  const scheme = match[1].toLowerCase();
  const authority = match[2].toLowerCase();
  const parts = /^([a-z0-9.-]+)(?::(\d{1,5}))?$/.exec(authority);
  if (!parts) return null;
  const host = parts[1];
  const port = parts[2];
  if (host.startsWith(".") || host.endsWith(".") || host.includes("..")) return null;
  const local = host === "localhost" || host === "127.0.0.1";
  if (scheme !== "https" && !(scheme === "http" && local)) return null;
  if (!local && !host.includes(".")) return null;
  const defaultPort = scheme === "https" ? "443" : "80";
  return port === void 0 || port === defaultPort ? `${scheme}://${host}` : `${scheme}://${host}:${Number(port)}`;
}
function opasuiteBaseUrlProblem(value2) {
  if ((value2 ?? "").trim().length === 0) return "Informe o endere\xE7o do OpaSuite.";
  return opasuiteBaseUrl(value2) === null ? "Endere\xE7o inv\xE1lido: use o dom\xEDnio do OpaSuite da casa, com https \u2014 por exemplo, https://evogard.opasuite.com.br." : null;
}

// src/input-mask.ts
var INPUT_MASKS = ["cpf", "cnpj", "document", "phone", "money"];
var INPUT_MASK_PLACEHOLDER = {
  cpf: "077.187.530-42",
  cnpj: "11.222.333/0001-81",
  document: "077.187.530-42",
  phone: "(85) 99999-8888",
  money: "0,00"
};
var INPUT_MASK_MAX_LENGTH = {
  cpf: 14,
  cnpj: 18,
  document: 18,
  phone: 15,
  money: 16
};
function place(d, separators) {
  let out = "";
  for (let i = 0; i < d.length; i++) {
    for (const [at2, sep] of separators) if (i === at2) out += sep;
    out += d[i];
  }
  return out;
}
function typeCpf(d) {
  return place(d.slice(0, 11), [
    [3, "."],
    [6, "."],
    [9, "-"]
  ]);
}
function typeCnpj(d) {
  return place(d.slice(0, 14), [
    [2, "."],
    [5, "."],
    [8, "/"],
    [12, "-"]
  ]);
}
function typePhone(raw) {
  let d = raw;
  if (d.length > 11 && d.startsWith("55")) d = d.slice(2);
  d = d.slice(0, 11);
  if (d.length === 0) return "";
  if (d.length <= 2) return `(${d}`;
  const rest = d.slice(2);
  const cut = rest.length === 9 ? 5 : 4;
  return rest.length <= 4 ? `(${d.slice(0, 2)}) ${rest}` : `(${d.slice(0, 2)}) ${rest.slice(0, cut)}-${rest.slice(cut)}`;
}
function typeMoney(raw) {
  if (raw.length === 0) return "";
  const d = raw.replace(/^0+/, "").slice(0, 12).padStart(3, "0");
  const whole = d.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${whole},${d.slice(-2)}`;
}
function applyInputMask(mask, value2) {
  const d = digitsOnly(value2) ?? "";
  switch (mask) {
    case "cpf":
      return typeCpf(d);
    case "cnpj":
      return typeCnpj(d);
    case "document":
      return d.length <= 11 ? typeCpf(d) : typeCnpj(d);
    case "phone":
      return typePhone(d);
    case "money":
      return typeMoney(d);
  }
}
var countDigits = (s) => s.replace(/\D/g, "").length;
function typeMasked(mask, input) {
  let digits = input.value.replace(/\D/g, "");
  let before = countDigits(input.value.slice(0, input.caret));
  const onlySeparatorGone = input.value.length < input.previous.length && digits === input.previous.replace(/\D/g, "");
  if (onlySeparatorGone) {
    if (input.inputType === "deleteContentForward") {
      digits = digits.slice(0, before) + digits.slice(before + 1);
    } else if (before > 0) {
      digits = digits.slice(0, before - 1) + digits.slice(before);
      before -= 1;
    }
  }
  if (mask === "money") {
    const deleting = input.value.length < input.previous.length;
    const value3 = deleting && /^0*$/.test(digits) ? "" : applyInputMask(mask, digits);
    return { value: value3, caret: caretBeforeLastDigits(value3, digits.length - before) };
  }
  const value2 = applyInputMask(mask, digits);
  return { value: value2, caret: caretAfterDigits(value2, before) };
}
function caretBeforeLastDigits(value2, n) {
  if (n <= 0) return value2.length;
  let seen = 0;
  for (let i = value2.length - 1; i >= 0; i--) {
    if (/\d/.test(value2[i])) seen += 1;
    if (seen === n) return i;
  }
  return 0;
}
function caretAfterDigits(value2, n) {
  if (n <= 0) return 0;
  let seen = 0;
  for (let i = 0; i < value2.length; i++) {
    if (/\d/.test(value2[i])) seen += 1;
    if (seen === n) return i + 1;
  }
  return value2.length;
}

// src/session.ts
var BLOCKED_CODE = "ACESSO_BLOQUEADO";
function classifySignInFailure(status, code) {
  if (status === void 0 || status === null || status === 0) return "sem_resposta";
  if (status === 403) return code === BLOCKED_CODE ? "bloqueado" : "servidor";
  if (status === 429) return "excesso_de_tentativas";
  if (status >= 500) return "servidor";
  if (status === 401 || status === 400 || status === 422) return "credenciais";
  return "servidor";
}
var MESSAGES = {
  credenciais: "E-mail ou senha incorretos.",
  bloqueado: "Este acesso est\xE1 bloqueado. Procure quem administra a plataforma.",
  excesso_de_tentativas: "Tentativas demais. Espere um instante e tente de novo.",
  servidor: "A plataforma n\xE3o conseguiu responder agora. Tente de novo em instantes.",
  sem_resposta: "N\xE3o foi poss\xEDvel falar com a plataforma. Verifique sua conex\xE3o."
};
function signInFailureMessage(status, code) {
  return MESSAGES[classifySignInFailure(status, code)];
}
function classifyLoadFailure(status) {
  if (status === void 0 || status === null || status === 0) return "sem_resposta";
  if (status === 401) return "sem_sessao";
  if (status === 403) return "sem_permissao";
  if (status === 404) return "nao_existe";
  if (status === 429) return "excesso_de_tentativas";
  return "servidor";
}
function loadFailureMessage(status, subject) {
  switch (classifyLoadFailure(status)) {
    case "sem_sessao":
      return "Sua sess\xE3o expirou. Entre de novo.";
    case "sem_permissao":
      return `Voc\xEA n\xE3o tem permiss\xE3o para ver ${subject}. Quem administra a plataforma concede em Grupos.`;
    case "nao_existe":
      return `N\xE3o encontramos ${subject} nesta base.`;
    case "excesso_de_tentativas":
      return "Tentativas demais. Espere um instante e tente de novo.";
    case "sem_resposta":
      return "N\xE3o foi poss\xEDvel falar com a plataforma. Verifique sua conex\xE3o.";
    case "servidor":
      return `N\xE3o foi poss\xEDvel carregar ${subject} agora. Tente de novo em instantes.`;
  }
}
function safeReturnPath(target) {
  if (typeof target !== "string") return null;
  const value2 = target.trim();
  if (value2 === "" || value2.length > 2e3) return null;
  if (!value2.startsWith("/")) return null;
  if (value2.startsWith("//") || value2.startsWith("/\\")) return null;
  for (const ch of value2) {
    const code = ch.charCodeAt(0);
    if (code < 32 || code === 127 || ch === "\\") return null;
  }
  const path = value2.split(/[?#]/)[0];
  if (path === "/sign-in" || path.startsWith("/sign-in/")) return null;
  return value2;
}

// src/freshness.ts
var UNIDADES = {
  ms: 1,
  s: 1e3,
  min: 6e4,
  h: 36e5,
  d: 864e5
};
var FORMAT = /^(\d+)(ms|s|min|h|d)$/;
function ageInMs(maxAge) {
  if (maxAge === 0) return 0;
  const matched = FORMAT.exec(maxAge);
  if (!matched) {
    throw new Error(
      `Frescor inv\xE1lido: "${maxAge}". Use n\xFAmero + unidade (ms, s, min, h, d) \u2014 por exemplo '15min' \u2014 ou 0 para ir \xE0 origem.`
    );
  }
  const [, amount, unit] = matched;
  return Number(amount) * UNIDADES[unit];
}
function isFresh(syncedAt, maxAge, now) {
  if (maxAge === 0) return false;
  if (!syncedAt) return false;
  const age = now.getTime() - syncedAt.getTime();
  if (age < 0) return true;
  return age <= ageInMs(maxAge);
}
function mirrorAge(syncedAt, now) {
  if (!syncedAt) return null;
  return Math.max(0, now.getTime() - syncedAt.getTime());
}
function resolveMaxAge(request, pattern) {
  return request === void 0 ? pattern : request;
}
function entityFreshness(padroes, entity, request) {
  const pattern = padroes[entity];
  if (pattern === void 0) {
    throw new Error(
      `Frescor: a entidade "${entity}" n\xE3o tem padr\xE3o declarado. Declare-a na tabela de frescor da integra\xE7\xE3o, junto das outras \u2014 cair num padr\xE3o de conveni\xEAncia \xE9 como n\xFAmero velho chega \xE0 tela sem erro.`
    );
  }
  return resolveMaxAge(request, pattern);
}

// src/breaker.ts
var DEFAULT_RULE = {
  failures: 5,
  windowMs: 10 * 6e4,
  waitMs: 6e4
};
var INITIAL_STATE = { failures: [], openUntil: null };
function breakerStatus(estado, now) {
  if (estado.openUntil === null) return "fechado";
  if (now < estado.openUntil) return "aberto";
  return "meio-aberto";
}
function isAllowed(estado, now) {
  return breakerStatus(estado, now) !== "aberto";
}
var withinWindow = (failures, now, windowMs) => failures.filter((t) => now - t < windowMs);
function afterFailure(estado, now, rule = DEFAULT_RULE) {
  const failures = [...withinWindow(estado.failures, now, rule.windowMs), now];
  if (failures.length >= rule.failures || estado.openUntil !== null) {
    return { failures, openUntil: now + rule.waitMs };
  }
  return { failures, openUntil: null };
}
function afterSuccess(estado, now, rule = DEFAULT_RULE) {
  return {
    failures: withinWindow(estado.failures, now, rule.windowMs),
    openUntil: null
  };
}

// src/code.ts
var SPEAKABLE_ALPHABET = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ";
var AMBIGUOUS_CHARS = ["0", "O", "1", "I"];
var environment = globalThis;
function randomize(amount) {
  const source = environment.crypto;
  if (!source?.getRandomValues) {
    throw new Error(
      "crypto.getRandomValues n\xE3o existe neste ambiente. C\xF3digo curto n\xE3o \xE9 sorteado com Math.random()."
    );
  }
  return source.getRandomValues(new Uint8Array(amount));
}
function generateCode(prefix, size = 4) {
  if (!/^[A-Z]{1,4}$/.test(prefix)) {
    throw new Error(`Prefixo de c\xF3digo inv\xE1lido: "${prefix}". Use de 1 a 4 letras mai\xFAsculas.`);
  }
  if (!Number.isInteger(size) || size < 3) {
    throw new Error(`Tamanho de c\xF3digo inv\xE1lido: ${size}. M\xEDnimo 3.`);
  }
  let body = "";
  for (const byte of randomize(size)) {
    body += SPEAKABLE_ALPHABET[byte % SPEAKABLE_ALPHABET.length];
  }
  return `${prefix}-${body}`;
}
function generateNumericCode(prefix, size = 5) {
  if (!/^[A-Z]{1,4}$/.test(prefix)) {
    throw new Error(`Prefixo de c\xF3digo inv\xE1lido: "${prefix}". Use de 1 a 4 letras mai\xFAsculas.`);
  }
  if (!Number.isInteger(size) || size < 3) {
    throw new Error(`Tamanho de c\xF3digo inv\xE1lido: ${size}. M\xEDnimo 3.`);
  }
  let body = "";
  while (body.length < size) {
    for (const byte of randomize(size)) {
      if (byte >= 250 || body.length === size) continue;
      body += String(byte % 10);
    }
  }
  return `${prefix}-${body}`;
}
function normalizeCode(raw, prefix, size = 4) {
  const sizes = typeof size === "number" ? [size] : size;
  const clean2 = raw.trim().toUpperCase().replace(/[^A-Z0-9]/g, "");
  const target = prefix.toUpperCase();
  const body = sizes.some((s) => clean2.length === target.length + s) && clean2.startsWith(target) ? clean2.slice(target.length) : clean2;
  return `${target}-${body}`;
}

// src/business-days.ts
var SLA_DAY_KINDS = ["corridos", "uteis"];
var SLA_DAY_KIND_LABEL = {
  corridos: "Dias corridos",
  uteis: "Dias \xFAteis"
};
function plusDays(date, n) {
  const [y, m, d] = date.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
}
function isHoliday(date, holidays) {
  const monthDay = date.slice(5);
  return holidays.some(
    (h) => h.recurring ? h.date.slice(5) === monthDay : h.date === date
  );
}
function isBusinessDay(date, holidays) {
  const [y, m, d] = date.split("-").map(Number);
  const weekday = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
  return weekday !== 0 && weekday !== 6 && !isHoliday(date, holidays);
}
function addBusinessDays(from, days, holidays, timezone = HOUSE_TIMEZONE) {
  if (!Number.isInteger(days) || days < 0) {
    throw new Error(
      `Dias \xFAteis inv\xE1lidos: ${String(days)}. Use um inteiro n\xE3o negativo.`
    );
  }
  const start = businessDate(from, timezone);
  const timeOfDay = from.getTime() - startOfDay(start, 0, timezone).getTime();
  let date = start;
  for (let left = days; left > 0; left -= 1) {
    do {
      date = plusDays(date, 1);
    } while (!isBusinessDay(date, holidays));
  }
  return new Date(startOfDay(date, 0, timezone).getTime() + timeOfDay);
}

// src/competence-closing.ts
var AUTOMATIC_CLOSING_SINCE = "2026-10";
var FIXED_BANK_HOLIDAYS = [
  "01-01",
  // Confraternização Universal
  "04-21",
  // Tiradentes
  "05-01",
  // Dia do Trabalho
  "09-07",
  // Independência
  "10-12",
  // Nossa Senhora Aparecida
  "11-02",
  // Finados
  "11-15",
  // Proclamação da República
  "11-20",
  // Consciência Negra
  "12-25"
  // Natal
];
function plusDays2(date, n) {
  const [y, m, d] = date.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
}
function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = (h + l - 7 * m + 114) % 31 + 1;
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
function nationalBankHolidays(year) {
  const easter = easterSunday(year);
  return [
    ...FIXED_BANK_HOLIDAYS.map((monthDay) => `${year}-${monthDay}`),
    plusDays2(easter, -48),
    // segunda de Carnaval
    plusDays2(easter, -47),
    // terça de Carnaval
    plusDays2(easter, -2),
    // Sexta-feira Santa
    plusDays2(easter, 60)
    // Corpus Christi
  ].map((date) => ({ date, recurring: false }));
}
function competenceClosingDate(period) {
  const [year, month] = period.split("-").map(Number);
  let date = new Date(Date.UTC(year, month, 5)).toISOString().slice(0, 10);
  const holidays = nationalBankHolidays(Number(date.slice(0, 4)));
  while (!isBusinessDay(date, holidays) || isFriday(date)) {
    date = plusDays2(date, 1);
  }
  return date;
}
function closesAutomatically(period) {
  return period >= AUTOMATIC_CLOSING_SINCE;
}
function isFriday(date) {
  const [y, m, d] = date.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d)).getUTCDay() === 5;
}

// src/hierarchy.ts
function inForceAt(link, data) {
  return !link.archived && link.validFrom <= data && (link.validUntil === null || link.validUntil >= data);
}
function supervisorAt(links, userId, data) {
  businessDateParts(data, "supervisorAt");
  const valid2 = links.filter((v) => v.userId === userId && inForceAt(v, data));
  if (valid2.length === 0) return null;
  if (valid2.length > 1) {
    throw new Error(
      `supervisorAt: ${userId} tem ${valid2.length} superiores vigentes em ${data} (${valid2.map((v) => v.supervisorId).join(", ")}). O banco recusa vig\xEAncias sobrepostas pelo EXCLUDE de app.hierarchy; se elas chegaram at\xE9 aqui, a restri\xE7\xE3o foi perdida numa gera\xE7\xE3o de migration.`
    );
  }
  return valid2[0].supervisorId;
}
function supervisorChainAt(links, userId, data) {
  const chain = [];
  const seen = /* @__PURE__ */ new Set([userId]);
  let current = userId;
  for (; ; ) {
    const supervisor = supervisorAt(links, current, data);
    if (supervisor === null) return chain;
    if (seen.has(supervisor)) {
      throw new Error(
        `supervisorChainAt: ciclo na hierarquia em ${data} \u2014 ${[...seen, supervisor].join(" \u2192 ")}. O banco s\xF3 recusa o ciclo de tamanho 1; este \xE9 maior e precisa ser corrigido no cadastro.`
      );
    }
    chain.push(supervisor);
    seen.add(supervisor);
    current = supervisor;
  }
}
function subordinatesAt(links, userId, data) {
  businessDateParts(data, "subordinatesAt");
  const directly = /* @__PURE__ */ new Map();
  for (const link of links) {
    if (!inForceAt(link, data)) continue;
    const current = directly.get(link.supervisorId);
    if (current === void 0) directly.set(link.supervisorId, [link.userId]);
    else current.push(link.userId);
  }
  const below = /* @__PURE__ */ new Map();
  const queue = [{ userId, level: 0 }];
  while (queue.length > 0) {
    const current = queue.shift();
    for (const person of directly.get(current.userId) ?? []) {
      if (person === userId || below.has(person)) {
        throw new Error(
          `subordinatesAt: ${person} foi alcan\xE7ado duas vezes ao descer de ${userId} em ${data}. Ou h\xE1 vig\xEAncias sobrepostas \u2014 e o EXCLUDE de app.hierarchy foi perdido numa gera\xE7\xE3o de migration \u2014, ou h\xE1 um ciclo, que o check do banco s\xF3 recusa no tamanho 1. O cadastro precisa ser corrigido: seguir daqui misturaria dois ramos.`
        );
      }
      below.set(person, current.level + 1);
      queue.push({ userId: person, level: current.level + 1 });
    }
  }
  return below;
}
function supervisorFromTeams(userId, teamOf, teams) {
  const teamId = teamOf.get(userId) ?? null;
  if (teamId === null) return null;
  const leader = teams.find((t) => t.id === teamId)?.leaderUserId ?? null;
  return leader === null || leader === userId ? null : leader;
}
function teamCycle(teamOf, teams) {
  for (const start of teamOf.keys()) {
    const path = [start];
    const seen = /* @__PURE__ */ new Set([start]);
    let current = start;
    for (; ; ) {
      const next = supervisorFromTeams(current, teamOf, teams);
      if (next === null) break;
      if (seen.has(next)) return [...path.slice(path.indexOf(next)), next];
      path.push(next);
      seen.add(next);
      current = next;
    }
  }
  return null;
}
function dayAfter(date) {
  const [year, month, day] = businessDateParts(date, "dayAfter");
  return new Date(Date.UTC(year, month - 1, day + 1)).toISOString().slice(0, 10);
}
function dayBefore(date) {
  const [year, month, day] = businessDateParts(date, "dayBefore");
  return new Date(Date.UTC(year, month - 1, day - 1)).toISOString().slice(0, 10);
}
function linkTransition(open, desired, from, previousUntil = null) {
  businessDateParts(from, "linkTransition");
  if (open !== null && open.supervisorId === desired) {
    const floor = previousUntil === null ? from : dayAfter(previousUntil);
    const start = from > floor ? from : floor;
    if (from > open.validFrom) {
      return { estado: "pronto", steps: [{ kind: "advance", linkId: open.id, from }] };
    }
    return start < open.validFrom ? { estado: "pronto", steps: [{ kind: "extend", linkId: open.id, from: start }] } : { estado: "pronto", steps: [] };
  }
  const steps = [];
  if (open !== null) {
    if (from < open.validFrom) return { estado: "recusado", openSince: open.validFrom };
    steps.push(
      from === open.validFrom ? { kind: "archive", linkId: open.id } : { kind: "close", linkId: open.id, until: dayBefore(from) }
    );
  }
  if (desired !== null) steps.push({ kind: "open", supervisorId: desired, from });
  return { estado: "pronto", steps };
}

// src/preferences.ts
var THEMES = ["sistema", "claro", "escuro"];
var DEFAULT_THEME = "sistema";
function isTheme(value2) {
  return typeof value2 === "string" && THEMES.includes(value2);
}
function validTheme(value2) {
  return isTheme(value2) ? value2 : DEFAULT_THEME;
}
function resolveDefaultTenant(preferred, links) {
  if (links.length === 0) return null;
  const hasAPreferida = preferred !== null && preferred !== void 0 && links.some((v) => v.tenantId === preferred);
  return hasAPreferida ? preferred : links[0].tenantId;
}

// src/csv.ts
var CSV_SEPARATOR = ";";
function csvCell(text) {
  return `"${text.replaceAll('"', '""')}"`;
}
function csvDecimal(value2) {
  return /^-?\d+(\.\d{1,2})?$/.test(value2) ? value2.replace(".", ",") : value2;
}
function csvContent(rows) {
  return rows.map((row) => row.join(CSV_SEPARATOR)).join("\r\n");
}
function csvFileNamePart(text) {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "base";
}

// src/navigation.ts
function within(path, prefix) {
  if (prefix === "/") return path === "/";
  return path === prefix || path.startsWith(`${prefix}/`);
}
function activeRoute(path, alvos) {
  let best = null;
  for (const target of alvos) {
    if (!within(path, target)) continue;
    if (best === null || target.length > best.length) best = target;
  }
  return best;
}

// src/statuses.ts
function validTransitions(current, map) {
  return map[current] ?? [];
}
function isValidTransition(current, next, map) {
  return validTransitions(current, map).includes(next);
}
function isFinalState(current, map) {
  return validTransitions(current, map).length === 0;
}

// src/vehicle-situation.ts
var VEHICLE_SITUATION_TONES = ["erro", "alerta", "sucesso", "neutro"];
function vehicleSituationTone(input) {
  if (input.canceled || input.deleted) return "erro";
  const label = (input.label ?? "").trim().toUpperCase();
  if (input.blocksCancellation || label.includes("INADIMPLENTE")) return "alerta";
  if (label.startsWith("ATIVO")) return "sucesso";
  return "neutro";
}

// src/tone.ts
var TONES = [
  "sucesso",
  "erro",
  "alerta",
  "neutro",
  "informacao",
  /**
   * O que está ANDANDO — nasceu em 17/09/2026 porque `aberta` e `em_andamento`
   * dividiam `informacao`, e numa mesa a cor é a primeira coisa que se lê.
   *
   * Sexto tom e não um remapeamento dos cinco: os quatro outros já significam
   * coisas que não são esta, e trocar `aguardando_solicitante` de lugar
   * desfaria a decisão escrita em `tickets.ts` (o âmbar está ali porque é a
   * situação que PARECE resolvida e não está).
   */
  "progresso"
];

// src/tickets.ts
var TICKET_STATUSES = [
  "aberta",
  "em_andamento",
  "aguardando_solicitante",
  "concluida",
  "cancelada"
];
var TICKET_PRIORITIES = ["baixa", "normal", "alta"];
var TICKET_TRANSITIONS = {
  aberta: ["em_andamento", "aguardando_solicitante", "concluida", "cancelada"],
  em_andamento: ["aguardando_solicitante", "concluida", "cancelada"],
  aguardando_solicitante: ["em_andamento", "concluida", "cancelada"],
  concluida: [],
  cancelada: []
};
var OPEN_STATUSES = [
  "aberta",
  "em_andamento",
  "aguardando_solicitante"
];
var LABELS = {
  aberta: "Aberta",
  em_andamento: "Em andamento",
  aguardando_solicitante: "Aguardando solicitante",
  concluida: "Conclu\xEDda",
  cancelada: "Cancelada"
};
function ticketStatusLabel(situacao) {
  return LABELS[situacao];
}
var TONES2 = {
  aberta: "informacao",
  em_andamento: "progresso",
  aguardando_solicitante: "alerta",
  concluida: "sucesso",
  cancelada: "neutro"
};
function ticketStatusTone(situacao) {
  return TONES2[situacao];
}
var LABELS_PRIORITY = {
  baixa: "Baixa",
  normal: "Normal",
  alta: "Alta"
};
function ticketPriorityLabel(priority) {
  return LABELS_PRIORITY[priority];
}
function isValidTicketStatus(value2) {
  return TICKET_STATUSES.includes(value2);
}
function canSeeTicketDetail(ticket, viewer) {
  return refusalToActOnTicket("read", ticket, viewer) === null;
}
function refusalToActOnTicket(act, ticket, viewer) {
  const requester = ticket.requesterUserId === viewer.userId || ticket.onBehalfOfUserId === viewer.userId;
  const assignee = ticket.assigneeId === viewer.userId;
  const inDepartment = ticket.departmentId !== null && viewer.departmentIds.includes(ticket.departmentId);
  const leads = ticket.departmentId !== null && viewer.leads.includes(ticket.departmentId);
  const open = OPEN_STATUSES.includes(ticket.situacao);
  const commonQueue = ticket.departmentId === null;
  if (viewer.consultant) {
    const own = ticket.requesterUserId === viewer.userId;
    if (!own) return "Quem \xE9 consultor acompanha s\xF3 as demandas que abriu.";
    if (act === "read" || act === "copyLink" || act === "reply") return null;
    return "Quem \xE9 consultor abre e acompanha a demanda; quem atende \xE9 a equipe.";
  }
  switch (act) {
    /*
     * Ler e copiar o link respondem à MESMA pergunta — "posso entregar esta
     * conversa a alguém?" —, e por isso compartilham o braço. O link abre a
     * demanda sem login para quem o receber: separar os dois conjuntos seria
     * dar por uma porta o que a outra nega.
     */
    case "read":
    case "copyLink":
      if (viewer.seesAny || requester || assignee || leads) return null;
      return inDepartment ? "Esta demanda \xE9 do seu setor e est\xE1 com outra pessoa. Adira a ela para ler a conversa." : "S\xF3 quem abriu, o solicitante, quem est\xE1 com a demanda e quem lidera o setor dela podem ler a conversa.";
    /*
     * Responder é do responsável **ou do líder do setor** — e de mais ninguém.
     *
     * O líder entrou em 18/09/2026: ele responde sem aderir, porque intervir na
     * fila que lidera é o trabalho dele, e obrigá-lo a assumir a demanda de
     * outra pessoa para dizer uma frase trocaria o responsável só para permitir
     * a fala.
     *
     * Quem continua de fora é o SOLICITANTE, e isso não mudou: quem abriu lê a
     * conversa e não escreve nela pela interna. O associado responde pelo
     * portal, que é rota à parte.
     *
     * `ver_qualquer` também não abre exceção — ela é permissão de VER. Quem
     * audita não fala pela equipe.
     */
    case "reply":
      if (assignee || leads) return null;
      return ticket.assigneeId === null ? "Ningu\xE9m est\xE1 com esta demanda ainda. Adira a ela para responder." : "Responde quem est\xE1 com a demanda, ou quem lidera o setor dela. Adira a ela para responder.";
    case "claim":
      if (!open) return "A demanda n\xE3o est\xE1 aberta.";
      if (ticket.assigneeId !== null) return "Esta demanda j\xE1 est\xE1 com algu\xE9m.";
      if (commonQueue || leads || inDepartment || viewer.seesAny) return null;
      return "Esta demanda \xE9 de outro setor.";
    /*
     * Encaminhar é do RESPONSÁVEL e do LÍDER do setor, e de mais ninguém —
     * decisão do dono em 23/09/2026. Saíram a fila comum (qualquer um
     * encaminhava a demanda sem setor) e `ver_qualquer`, que é permissão de
     * VER: quem audita não passa a demanda dos outros adiante. Quem está na
     * fila comum adere primeiro, e aí encaminha como responsável.
     */
    case "transfer":
      if (!open) return "A demanda n\xE3o est\xE1 aberta.";
      if (assignee || leads) return null;
      return "S\xF3 quem est\xE1 com a demanda, ou quem lidera o setor dela, pode encaminhar.";
    /*
     * Escolher o responsável de outra pessoa é ato de quem responde pela fila —
     * o líder. O próprio responsável NÃO entra: passar a demanda adiante por
     * conta própria é `transfer`, que existe para isso e grava o motivo.
     */
    case "assign":
      if (!open) return "A demanda n\xE3o est\xE1 aberta.";
      if (viewer.seesAny || leads) return null;
      return "S\xF3 quem lidera o setor da demanda pode escolher o respons\xE1vel.";
    case "close":
      if (viewer.seesAny || assignee || leads) return null;
      return "S\xF3 quem est\xE1 com a demanda, ou quem lidera o setor dela, pode conclu\xED-la.";
  }
}
function refusalToOpenTicketCategory(category, opener) {
  if (opener.kind === "member") {
    return category.portalEnabled ? null : "Esta categoria n\xE3o est\xE1 dispon\xEDvel para o portal do associado.";
  }
  if (!category.restricted) return null;
  const allowed = opener.departmentIds.some(
    (id) => category.requesterDepartmentIds.includes(id)
  );
  if (allowed) return null;
  return opener.departmentIds.length === 0 ? "Esta categoria \xE9 restrita a setores, e voc\xEA n\xE3o est\xE1 em nenhum setor." : "Esta categoria \xE9 restrita a outros setores.";
}
function ticketDeadline(openAt, deadlineDays) {
  if (deadlineDays === null || deadlineDays === void 0) return null;
  return deadlineFrom(openAt, deadlineDays, "dias");
}
var TICKET_CODE_PREFIX = "EV";
var TICKET_CODE_SIZE = 5;
var TICKET_CODE_READ_SIZES = [TICKET_CODE_SIZE, 4];
function generateTicketCode() {
  return generateNumericCode(TICKET_CODE_PREFIX, TICKET_CODE_SIZE);
}
function normalizeTicketCode(raw) {
  return normalizeCode(raw, TICKET_CODE_PREFIX, TICKET_CODE_READ_SIZES);
}

// src/core.ts
var MEMBER_CODE_PREFIX = "AS";
var VEHICLE_CODE_PREFIX = "VE";
var VOLUNTEER_CODE_PREFIX = "VO";
var CORE_CODE_SIZE = 6;
var CORE_CODE_READ_SIZES = [CORE_CODE_SIZE, 7, 8];
function memberCodeOf(id) {
  return `${MEMBER_CODE_PREFIX}-${String(id).padStart(CORE_CODE_SIZE, "0")}`;
}
function vehicleCodeOf(id) {
  return `${VEHICLE_CODE_PREFIX}-${String(id).padStart(CORE_CODE_SIZE, "0")}`;
}
function volunteerCodeOf(id) {
  return `${VOLUNTEER_CODE_PREFIX}-${String(id).padStart(CORE_CODE_SIZE, "0")}`;
}
function normalizeMemberCode(raw) {
  return normalizeCode(raw, MEMBER_CODE_PREFIX, CORE_CODE_READ_SIZES);
}
function normalizeVehicleCode(raw) {
  return normalizeCode(raw, VEHICLE_CODE_PREFIX, CORE_CODE_READ_SIZES);
}
function normalizeVolunteerCode(raw) {
  return normalizeCode(raw, VOLUNTEER_CODE_PREFIX, CORE_CODE_READ_SIZES);
}
function boletoPayment(row) {
  if (row.paidAt !== null || row.paidAmount !== null) {
    return { paidAt: row.paidAt, paidAmount: row.paidAmount, source: "coleta" };
  }
  if (row.erpPaid !== true) return { paidAt: null, paidAmount: null, source: null };
  return { paidAt: row.erpPaidAt, paidAmount: row.erpPaidAmount, source: "erp" };
}

// src/portal.ts
function canEnterPortal(member, links) {
  if (member.blockedAt) return { can: false, reason: "bloqueado" };
  if (!member.active) return { can: false, reason: "inativo" };
  const active = links.filter((v) => !v.archivedAt);
  if (active.length > 0) return { can: true, links: active };
  return {
    can: false,
    reason: links.length > 0 ? "vinculo_arquivado" : "sem_vinculo"
  };
}
function isInviteUsable(invite, now = /* @__PURE__ */ new Date()) {
  if (invite.archivedAt) return { usable: false, reason: "arquivado" };
  if (invite.acceptedAt) return { usable: false, reason: "ja_aceito" };
  const expires = invite.expiresAt instanceof Date ? invite.expiresAt : new Date(invite.expiresAt);
  if (Number.isNaN(expires.getTime())) {
    return { usable: false, reason: "expirado" };
  }
  if (expires.getTime() <= now.getTime()) {
    return { usable: false, reason: "expirado" };
  }
  return { usable: true };
}
function maskCpf(cpf) {
  if (!cpf) return "";
  const digits = cpf.replace(/\D/g, "");
  if (digits.length !== 11) return cpf;
  return `\u2022\u2022\u2022.${digits.slice(3, 6)}.${digits.slice(6, 9)}-\u2022\u2022`;
}
function maskEmail(email) {
  if (!email) return "";
  const atSign = email.lastIndexOf("@");
  if (atSign < 1) return email;
  const user = email.slice(0, atSign);
  const domain = email.slice(atSign);
  const visible = user.slice(0, Math.min(2, user.length));
  return `${visible}${"\u2022".repeat(Math.max(user.length - visible.length, 1))}${domain}`;
}
function maskPhone(telefone) {
  if (!telefone) return "";
  const digits = telefone.replace(/\D/g, "");
  if (digits.length < 10) return telefone;
  const ddd = digits.slice(0, 2);
  const end = digits.slice(-4);
  return `(${ddd}) \u2022\u2022\u2022\u2022\u2022-${end}`;
}

// src/erp-window.ts
var SGA_WINDOWS = {
  "/listar/alteracao-associados/": {
    days: 7,
    provenance: "declarada pelo fornecedor"
  },
  "/listar/alteracao-veiculos": {
    days: 7,
    provenance: "declarada pelo fornecedor"
  },
  "/listar/alteracao-voluntario/": {
    days: 7,
    provenance: "declarada pelo fornecedor"
  },
  "/listar/boleto-associado/periodo": {
    days: 31,
    provenance: "declarada pelo fornecedor"
  },
  "/listar/boleto-associado-veiculo": {
    days: 200,
    provenance: "MEDIDA contra o SGA em 2026-09-13",
    caveat: 'A documenta\xE7\xE3o do fornecedor declara 90, e a MEDI\xC7\xC3O de 2026-09-13 desmente: com 255 dias ele responde 406 ["O intervalo de tempo m\xE1ximo \xE9 de 200 dias"], e com 196 responde 200 com a lista. O n\xFAmero est\xE1 na mensagem de erro dele, n\xE3o numa suposi\xE7\xE3o nossa. Vale a medi\xE7\xE3o, pela regra 13 \u2014 a documenta\xE7\xE3o da API do SGA j\xE1 errou sobre este endpoint em outro ponto (o filtro de situa\xE7\xE3o \xE9 OPCIONAL: sem ele v\xEAm todas as situa\xE7\xF5es, com `codigo_situacao_boleto` vem s\xF3 aquela).'
  },
  "/listar/boleto": {
    days: 638,
    provenance: "MEDIDA contra o SGA em 2026-09-30",
    caveat: "A medi\xE7\xE3o de 2026-09-07 dizia que este endpoint N\xC3O RECEBE data, e estava errada: ele recebe `data_vencimento_original_inicial`/`_final` em dd/mm/aaaa, e a data filtrada \xE9 a do vencimento ORIGINAL \u2014 o boleto prorrogado fica fora da janela do vencimento corrente. `codigo_situacao` e `codigo_associado` filtram de verdade, e `codigo_situacao` \xE9 OPCIONAL: sem ele v\xEAm todas as situa\xE7\xF5es. ATEN\xC7\xC3O ao n\xFAmero: 638 dias foram ACEITOS, e o teto n\xE3o foi sondado \u2014 ningu\xE9m procurou onde ele recusa. Quem fatiar por este n\xFAmero est\xE1 no limite do que se mediu, e n\xE3o dentro de um limite conhecido. \xC9 por isso que a esteira fatia por uma constante PR\xD3PRIA, menor, em `synchronization.service.ts`."
  },
  "/listar/boleto/periodo": {
    days: 90,
    provenance: "MEDIDA contra o SGA em 2026-09-07",
    caveat: 'A frase \xE9 do fornecedor: 406 com error["O intervalo de tempo m\xE1ximo \xE9 de 90 dias"] para 199 e para 240 dias. Duas coisas mais, medidas junto e que o chamador precisa saber: o m\xE9todo \xE9 POST (o GET devolve 404) e a data vai em **dd/mm/yyyy** \u2014 ISO devolve "O campo DATA est\xE1 em um formato inv\xE1lido". Os nomes aceitos s\xE3o data_vencimento_inicial/final e data_emissao_inicial/final. ESTE ENDPOINT DEIXOU DE RESPONDER: medido em 2026-09-30 contra a CE, ele devolve 406 "Par\xE2metros Inv\xE1lidos!" a TODA varia\xE7\xE3o \u2014 inclusive \xE0 que aceitava em 07/09. A entrada fica como registro da medi\xE7\xE3o antiga e do tamanho de janela que a casa herdou dela; quem lista boleto usa `/listar/boleto`.'
  }
};
var INCREMENTAL_WINDOW_DAYS = SGA_WINDOWS["/listar/alteracao-associados/"].days;
function windowOfEndpoint(endpoint) {
  return SGA_WINDOWS[endpoint].days;
}
function asDateString(day) {
  return /* @__PURE__ */ new Date(`${day}T12:00:00Z`);
}
function somandoDays(day, days) {
  const d = asDateString(day);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}
function vendorDay(day) {
  const [year, month, dayOfMonth] = day.split("-");
  return `${dayOfMonth}/${month}/${year}`;
}
function splitPeriod(start, end, maxDays) {
  if (maxDays < 1) {
    throw new Error(`fatiarPeriodo: maxDias precisa ser ao menos 1, recebeu ${maxDays}`);
  }
  if (asDateString(end).getTime() < asDateString(start).getTime()) return [];
  const windows = [];
  let current = start;
  const CAP = 1e4;
  while (asDateString(current).getTime() <= asDateString(end).getTime()) {
    if (windows.length >= CAP) {
      throw new Error(
        `fatiarPeriodo: mais de ${CAP} janelas entre ${start} e ${end} \u2014 a janela parou de avan\xE7ar`
      );
    }
    const limit = somandoDays(current, maxDays - 1);
    const windowEnd = asDateString(limit).getTime() < asDateString(end).getTime() ? limit : end;
    windows.push({ start: current, end: windowEnd });
    current = somandoDays(windowEnd, 1);
  }
  return windows;
}

// src/erp-outcome.ts
function decideOutcome(candidates, markedAt, classification) {
  const existing = candidates.filter((c) => !classification.deleted(c.situacao));
  if (existing.length === 0) return { tipo: "gerar" };
  const block = existing.filter(
    (c) => classification.canceled(c.situacao) || classification.pago(c.situacao)
  );
  const adoptable = existing.filter((c) => !block.includes(c));
  if (adoptable.length === 0) {
    return {
      tipo: "revisao_manual",
      reason: `A consulta achou ${block.length} registro(s), todos pagos ou cancelados. Nenhum deles pode ser adotado, e gerar por cima \xE9 como nasce a duplicata.`
    };
  }
  const markerAfter = adoptable.filter(
    (c) => c.emitidoAt !== null && c.emitidoAt.getTime() >= markedAt.getTime()
  );
  if (markerAfter.length === 1) {
    return { tipo: "adotar", candidate: markerAfter[0] };
  }
  if (markerAfter.length > 1) {
    return {
      tipo: "revisao_manual",
      reason: `${markerAfter.length} registros foram emitidos depois da tentativa de escrita. Escolher um deles \xE9 adivinhar.`
    };
  }
  return {
    tipo: "revisao_manual",
    reason: `Existe ${adoptable.length} registro(s) em aberto, mas nenhum emitido depois da tentativa de escrita. N\xE3o d\xE1 para saber se a escrita chegou.`
  };
}

// src/worker-pulse.ts
var WORKER_BEAT_MS = 3e4;
var WORKER_STALE_MS = 2 * 6e4;
var WORKER_BOOT_LIMIT_MS = 3 * 6e4;
var SGA_QUEUE_STALL_MS = 10 * 6e4;
function workerState(pulse, queue, now) {
  if (!pulse?.beatAt) return { estado: "nao_medido" };
  const age = (d) => now.getTime() - d.getTime();
  if (age(pulse.beatAt) > WORKER_STALE_MS) {
    return { estado: "parado", since: pulse.beatAt };
  }
  const ready = pulse.readyAt !== null && pulse.readyAt >= pulse.bootedAt;
  if (!ready) {
    if (age(pulse.bootedAt) > WORKER_BOOT_LIMIT_MS) {
      return {
        estado: "travado_na_partida",
        since: pulse.bootedAt,
        step: pulse.bootStep
      };
    }
    return { estado: "subindo", since: pulse.bootedAt, step: pulse.bootStep };
  }
  const waitedTooLong = queue.oldestWaitingSince !== null && age(queue.oldestWaitingSince) > SGA_QUEUE_STALL_MS;
  const idleTooLong = pulse.lastJobAt === null || age(pulse.lastJobAt) > SGA_QUEUE_STALL_MS;
  if (!queue.active && waitedTooLong && idleTooLong) {
    return {
      estado: "fila_parada",
      since: queue.oldestWaitingSince,
      lastJobAt: pulse.lastJobAt
    };
  }
  return {
    estado: "de_pe",
    beatAt: pulse.beatAt,
    readyAt: pulse.readyAt,
    lastJobAt: pulse.lastJobAt
  };
}

// src/pipeline-progress.ts
var PROGRESS_STALE_MS = 10 * 6e4;
function progressPercent(p) {
  const pageFraction = p.page && p.page.total !== null && p.page.total > 0 ? Math.min(p.page.done / p.page.total, 1) : null;
  let fraction = null;
  if (p.step && p.step.total > 0) {
    fraction = (Math.min(p.step.done, p.step.total) + (pageFraction ?? 0)) / p.step.total;
  } else if (pageFraction !== null) {
    fraction = pageFraction;
  }
  if (fraction === null) return null;
  return Math.max(0, Math.min(99, Math.floor(fraction * 100)));
}
function progressLabel(p) {
  const parts = [];
  if (p.step) parts.push(p.step.label);
  if (p.page) {
    parts.push(
      p.page.total !== null && p.page.total > 0 ? `p\xE1gina ${p.page.done} de ~${p.page.total}` : `p\xE1gina ${p.page.done}`
    );
  }
  return parts.length > 0 ? parts.join(" \xB7 ") : "abrindo a passagem";
}

// src/retention.ts
function canRequestCancellation(situacao) {
  if (situacao.estado === "ausente") {
    return {
      response: "nao_da_para_saber",
      code: null,
      reason: "O espelho do ERP n\xE3o traz a situa\xE7\xE3o deste ve\xEDculo. Sem ela n\xE3o d\xE1 para dizer se o cancelamento \xE9 permitido."
    };
  }
  if (situacao.estado === "nao_classificada") {
    return {
      response: "nao_da_para_saber",
      code: situacao.code,
      reason: `Esta base ainda n\xE3o classificou a situa\xE7\xE3o de c\xF3digo "${situacao.code}". Enquanto ningu\xE9m disser o que ela significa, o cancelamento n\xE3o \xE9 liberado nem recusado.`
    };
  }
  if (situacao.blocksCancellation) {
    return {
      response: "nao_pode",
      code: situacao.code,
      reason: `A situa\xE7\xE3o de c\xF3digo "${situacao.code}" impede o cancelamento deste ve\xEDculo nesta base.`
    };
  }
  return { response: "pode" };
}
function phaseDeadline(signedInAt, deadlineHours) {
  if (deadlineHours === null || deadlineHours === void 0) return null;
  if (!Number.isFinite(deadlineHours) || deadlineHours < 0) {
    throw new Error(
      `Prazo de fase inv\xE1lido: ${String(deadlineHours)}. Use horas em n\xFAmero n\xE3o negativo.`
    );
  }
  return new Date(
    instant(signedInAt, "Entrada na fase").getTime() + deadlineHours * 36e5
  );
}
function isPhaseOverdue(dueAt, now = /* @__PURE__ */ new Date()) {
  if (dueAt === null || dueAt === void 0) return false;
  return instant(now, "Agora").getTime() >= instant(dueAt, "Prazo da fase").getTime();
}
var ONLY_O_DAY = /^\d{4}-\d{2}-\d{2}$/;
function instant(value2, what) {
  if (typeof value2 === "string" && ONLY_O_DAY.test(value2)) {
    throw new Error(
      `${what} inv\xE1lido: "${value2}" \xE9 data de neg\xF3cio, n\xE3o instante. O prazo da fase \xE9 contado em horas e precisa da hora de entrada.`
    );
  }
  const d = value2 instanceof Date ? value2 : new Date(value2);
  if (Number.isNaN(d.getTime())) {
    throw new Error(`${what} inv\xE1lido: ${String(value2)} n\xE3o \xE9 um instante.`);
  }
  return d;
}
var RETENTION_REFERENCE_PREFIX = "CA";
var RETENTION_PHASES = [
  "inicio",
  "em_atendimento",
  "atendimento_48h",
  "envio_email_72h",
  "retido",
  "cancelado",
  "divergencia_documentacao"
];
var RETENTION_PHASE_LABELS = {
  inicio: "In\xEDcio",
  em_atendimento: "Em atendimento",
  atendimento_48h: "48 horas",
  envio_email_72h: "72 horas - Envio de e-mail",
  retido: "Retidos",
  cancelado: "Cancelados",
  divergencia_documentacao: "Diverg\xEAncia de documenta\xE7\xE3o"
};
var RETENTION_WORKING_PHASES = ["em_atendimento", "atendimento_48h"];
var RETENTION_FINAL_PHASES = [
  "retido",
  "cancelado",
  "divergencia_documentacao"
];
var RETENTION_ACTIVE_PHASES = [
  "inicio",
  "em_atendimento",
  "atendimento_48h",
  "envio_email_72h"
];
function isRetentionWorkingPhase(phase) {
  return RETENTION_WORKING_PHASES.includes(phase);
}
function isRetentionFinalPhase(phase) {
  return RETENTION_FINAL_PHASES.includes(phase);
}
function isRetentionActivePhase(phase) {
  return RETENTION_ACTIVE_PHASES.includes(phase);
}
var RETENTION_FIRST_WINDOW_HOURS = 48;
var RETENTION_SECOND_WINDOW_HOURS = 24;
function retentionTimerMove(phase, phaseSince, now) {
  const elapsed = instant(now, "Agora").getTime() - instant(phaseSince, "Entrada na fase").getTime();
  if (phase === "em_atendimento" && elapsed >= RETENTION_FIRST_WINDOW_HOURS * 36e5) {
    return "atendimento_48h";
  }
  if (phase === "atendimento_48h" && elapsed >= RETENTION_SECOND_WINDOW_HOURS * 36e5) {
    return "envio_email_72h";
  }
  return null;
}
function retentionPhaseAgeTone(phaseSince, now) {
  const hours = (instant(now, "Agora").getTime() - instant(phaseSince, "Entrada na fase").getTime()) / 36e5;
  if (hours < 24) return "verde";
  if (hours < 48) return "amarelo";
  return "vermelho";
}
function retentionColumnOf(card) {
  if (card.phase === "inicio") return { kind: "inicio" };
  if (card.phase === "envio_email_72h") return { kind: "envio_email_72h" };
  if (isRetentionFinalPhase(card.phase)) return { kind: "final", phase: card.phase };
  if (isRetentionWorkingPhase(card.phase) && card.operatorId !== null) {
    return { kind: "operador", operatorId: card.operatorId, phase: card.phase };
  }
  return null;
}
function retentionColumnKey(column) {
  switch (column.kind) {
    case "inicio":
      return "inicio";
    case "envio_email_72h":
      return "envio_email_72h";
    case "final":
      return `final:${column.phase}`;
    case "operador":
      return `operador:${column.operatorId}:${column.phase}`;
  }
}
function parseRetentionColumnKey(key) {
  if (key === "inicio") return { kind: "inicio" };
  if (key === "envio_email_72h") return { kind: "envio_email_72h" };
  const final = /^final:(.+)$/.exec(key);
  if (final) {
    const phase = final[1];
    return isRetentionFinalPhase(phase) ? { kind: "final", phase } : null;
  }
  const operator = /^operador:([^:]+):(.+)$/.exec(key);
  if (operator) {
    const phase = operator[2];
    if (isRetentionWorkingPhase(phase)) {
      return { kind: "operador", operatorId: operator[1], phase };
    }
  }
  return null;
}
var RETENTION_FINISH_FIELDS = {
  ourNumber: "Nosso n\xFAmero",
  chatProtocol: "Protocolo do chat",
  handling: "Tratativa com cliente",
  lastContactOn: "Data de \xFAltimo contato"
};
function missingRetentionFinishFields(target, fields) {
  if (target === "divergencia_documentacao") return [];
  return Object.keys(RETENTION_FINISH_FIELDS).filter(
    (f) => (fields[f] ?? "").trim() === ""
  );
}
function canFinishRetention(card, actorId) {
  return isRetentionWorkingPhase(card.phase) && card.operatorId === actorId;
}
function canRetainRetentionFrom72h(card) {
  return card.phase === "envio_email_72h" && !card.retainedIn72h;
}
function canPullRetention(card, actorId) {
  return isRetentionWorkingPhase(card.phase) && card.operatorId !== null && card.operatorId !== actorId;
}
function canTransferRetention(card) {
  return isRetentionWorkingPhase(card.phase);
}
function canEditRetention(card, actorId, wide) {
  if (wide) return true;
  return isRetentionWorkingPhase(card.phase) && card.operatorId === actorId;
}
var RETENTION_LEGACY_BLOCKED_STATUS_CODES = {
  ce: ["5", "6", "8", "15", "16", "20"],
  go: ["5", "6", "8", "18"]
};
var RETENTION_BLOCKED_STATUS_NAMES = [
  /PLACA\s*EXCLU/,
  /^(?!ATIVO).*TROCA\s*DE\s*TITULARIDADE/
];
function retentionCancellationBlock(vehicle) {
  const name = (vehicle.statusName ?? "").normalize("NFD").replace(/[̀-ͯ]/g, "").toUpperCase().trim();
  const legacy = RETENTION_LEGACY_BLOCKED_STATUS_CODES[vehicle.tenantSlug] ?? [];
  if (vehicle.statusCode !== null && legacy.includes(vehicle.statusCode) || vehicle.classificationBlocks === true || name !== "" && RETENTION_BLOCKED_STATUS_NAMES.some((re) => re.test(name))) {
    const label = vehicle.statusName?.trim() || `de c\xF3digo ${vehicle.statusCode ?? "?"}`;
    return `O ve\xEDculo est\xE1 na situa\xE7\xE3o ${label}, que n\xE3o aceita pedido de cancelamento.`;
  }
  return null;
}
var RETENTION_TENANT_PRECEDENCE = ["go", "ce"];
function dedupeRetentionVehicles(vehicles, precedence) {
  const rank = (slug) => {
    const i = precedence.indexOf(slug);
    return i === -1 ? precedence.length : i;
  };
  const key = (v) => {
    const plate = (v.plate ?? "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    if (plate !== "") return `P:${plate}`;
    const chassis = (v.chassis ?? "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    return chassis === "" ? null : `C:${chassis}`;
  };
  const seen = /* @__PURE__ */ new Set();
  const kept = [];
  const ordered = vehicles.map((v, i) => ({ v, i })).sort((a, b) => rank(a.v.tenantSlug) - rank(b.v.tenantSlug) || a.i - b.i);
  for (const { v } of ordered) {
    const k = key(v);
    if (k !== null && seen.has(k)) continue;
    if (k !== null) seen.add(k);
    kept.push(v);
  }
  return kept;
}

// src/billing.ts
function daysOverdue(dueDateOriginal, today = /* @__PURE__ */ new Date(), timezone = HOUSE_TIMEZONE) {
  const missing = daysUntil(dueDateOriginal, today, timezone);
  return missing === 0 ? 0 : -missing;
}
function stageOf(days, tiers) {
  if (!Number.isInteger(days)) {
    throw new Error(
      `Dia de atraso inv\xE1lido: ${String(days)}. A r\xE9gua \xE9 medida em dias inteiros.`
    );
  }
  const matched = tiers.filter(
    (f) => (f.minDay === null || days >= f.minDay) && (f.maxDay === null || days <= f.maxDay)
  );
  if (matched.length === 0) return null;
  if (matched.length > 1) {
    throw new Error(
      `O dia ${days} cai em ${matched.length} faixas da r\xE9gua (${matched.map((f) => f.step).join(", ")}). O banco recusa faixas sobrepostas pelo EXCLUDE billing_tiers_no_overlap; se elas chegaram at\xE9 aqui, a restri\xE7\xE3o foi perdida numa gera\xE7\xE3o de migration.`
    );
  }
  return matched[0].step;
}
var SGA_BOLETO_PROVIDER = "hinovapay";
function isPaid(boleto) {
  const { paidAt } = boleto;
  if (paidAt === null || paidAt === void 0) return false;
  businessDate(paidAt);
  return true;
}
var DISPATCH_DISCARD_REASONS = [
  /** O contato pediu para não ser contatado — vale toda base e todo canal. */
  "contato_bloqueado",
  /** Há gente da casa negociando com o associado neste momento. */
  "atendimento_com_operador",
  /** Esta mensagem já saiu: a chave de idempotência está usada. */
  "contato_ja_enviado",
  /** O atraso não cai em faixa nenhuma da régua desta base. */
  "fora_da_regua",
  /** Está fora do horário em que esta etapa pode enviar. */
  "fora_da_janela"
];
function canDispatch(facts) {
  if (facts.blocked) {
    return refusal(
      "contato_bloqueado",
      "Este contato pediu para n\xE3o ser contatado. O bloqueio vale para toda base e todo canal, e nenhuma mudan\xE7a de r\xE9gua o destrava."
    );
  }
  if (facts.hasOperatorAssigned) {
    return refusal(
      "atendimento_com_operador",
      "H\xE1 atendimento aberto com operador atribu\xEDdo. Enquanto algu\xE9m da casa estiver negociando, a esteira n\xE3o escreve para o associado."
    );
  }
  if (facts.keyIdemAlreadyUsada) {
    return refusal(
      "contato_ja_enviado",
      "Esta mensagem j\xE1 saiu: a chave de idempot\xEAncia deste contato j\xE1 foi usada."
    );
  }
  if (facts.step === null) {
    return refusal(
      "fora_da_regua",
      "O atraso deste boleto n\xE3o cai em nenhuma faixa da r\xE9gua desta base."
    );
  }
  if (!facts.withinWindow) {
    return refusal(
      "fora_da_janela",
      "Fora da janela de hor\xE1rio desta etapa. A janela \xE9 hora local da pra\xE7a, n\xE3o do servidor."
    );
  }
  return { response: "dispara", step: facts.step };
}
function refusal(reason, explanation) {
  return { response: "nao_dispara", reason, explanation };
}

// src/billing-desk.ts
var DESK_DUE_BANDS = [
  "vencimento_5",
  "vencimento_10",
  "vencimento_15",
  "vencimento_20",
  "vencimento_25",
  "vencimento_30"
];
var DESK_BANDS = [...DESK_DUE_BANDS, "atraso_6_30", "atraso_31_mais"];
var DESK_BAND_LABELS = {
  vencimento_5: "Vencimento 5 \u2014 dia 1 a 5",
  vencimento_10: "Vencimento 10 \u2014 dia 6 a 10",
  vencimento_15: "Vencimento 15 \u2014 dia 11 a 15",
  vencimento_20: "Vencimento 20 \u2014 dia 16 a 20",
  vencimento_25: "Vencimento 25 \u2014 dia 21 a 25",
  vencimento_30: "Vencimento 30 \u2014 dia 26 a 31",
  atraso_6_30: "Atraso de 6 a 30 dias",
  atraso_31_mais: "31 dias ou mais de atraso"
};
function deskBand(dueDateOriginal, today = /* @__PURE__ */ new Date(), timezone = HOUSE_TIMEZONE) {
  if (dueDateOriginal === null) return "vencimento_5";
  const late = daysOverdue(dueDateOriginal, today, timezone);
  if (late >= 31) return "atraso_31_mais";
  if (late > 5) return "atraso_6_30";
  const [, , day] = businessDateParts(dueDateOriginal, "deskBand");
  if (day <= 5) return "vencimento_5";
  if (day <= 10) return "vencimento_10";
  if (day <= 15) return "vencimento_15";
  if (day <= 20) return "vencimento_20";
  if (day <= 25) return "vencimento_25";
  return "vencimento_30";
}
function deskBandRank(band) {
  if (band === "atraso_31_mais") return 2;
  if (band === "atraso_6_30") return 1;
  return 0;
}
var DESK_FLOWS = ["ativa", "receptiva"];
var DESK_OUTCOMES = ["pago_automatico", "pago_cobranca", "excluido"];
function ownerExpired(card, now = /* @__PURE__ */ new Date(), timezone = HOUSE_TIMEZONE) {
  if (card.flow !== "ativa") return false;
  if (card.operatorId === null || card.assignedAt === null) return false;
  if (card.dueDateOriginal === null) return false;
  const atAssignment = deskBand(card.dueDateOriginal, card.assignedAt, timezone);
  const today = deskBand(card.dueDateOriginal, now, timezone);
  return deskBandRank(atAssignment) < deskBandRank(today);
}
var DESK_PAID_STATUS_LABELS = ["BAIXADO C/ DESCONTO"];
function deskBoletoPaid(b) {
  const payment = boletoPayment(b);
  if (payment.source !== null) return { paid: true, paidOn: payment.paidAt };
  const label = (b.statusLabel ?? "").trim().toUpperCase();
  if (DESK_PAID_STATUS_LABELS.includes(label)) {
    return { paid: true, paidOn: b.erpPaidAt };
  }
  return { paid: false, paidOn: null };
}
var DESK_OPERATOR_GROUPS = [
  "vencimento",
  "atraso_6_30",
  "atraso_31_mais",
  "receptiva"
];
var DESK_PAID_OUTCOMES = ["pago_automatico", "pago_cobranca"];
function deskOperatorGroup(band) {
  if (band === "atraso_6_30" || band === "atraso_31_mais") return band;
  return "vencimento";
}
function deskColumnKey(column) {
  if (column.kind === "fila") return `fila:${column.band}`;
  if (column.kind === "pago") return `pago:${column.outcome}`;
  return `operador:${column.operatorId}:${column.group}`;
}
function parseDeskColumnKey(key) {
  const [kind, ...rest] = key.split(":");
  if (kind === "fila" && rest.length === 1) {
    const band = rest[0];
    return DESK_BANDS.includes(band) ? { kind: "fila", band } : null;
  }
  if (kind === "pago" && rest.length === 1) {
    const outcome4 = rest[0];
    return DESK_PAID_OUTCOMES.includes(outcome4) ? { kind: "pago", outcome: outcome4 } : null;
  }
  if (kind === "operador" && rest.length >= 2) {
    const group = rest[rest.length - 1];
    const operatorId = rest.slice(0, -1).join(":");
    if (operatorId === "" || !DESK_OPERATOR_GROUPS.includes(group)) {
      return null;
    }
    return { kind: "operador", operatorId, group };
  }
  return null;
}
function deskColumnOf(card, today = /* @__PURE__ */ new Date(), timezone = HOUSE_TIMEZONE) {
  if (card.closed) {
    return card.outcome === "pago_automatico" || card.outcome === "pago_cobranca" ? { kind: "pago", outcome: card.outcome } : null;
  }
  if (card.flow === "receptiva") {
    return card.operatorId === null ? null : { kind: "operador", operatorId: card.operatorId, group: "receptiva" };
  }
  const band = deskBand(card.dueDateOriginal, today, timezone);
  if (card.operatorId === null) return { kind: "fila", band };
  return { kind: "operador", operatorId: card.operatorId, group: deskOperatorGroup(band) };
}
function mergeDeskStreams(streams, order) {
  const before = (a, b) => order === "cadastro" ? a.id - b.id : (b.closedAt ?? "").localeCompare(a.closedAt ?? "") || b.id - a.id;
  const all = streams.flatMap((s) => [...s.items]).sort(before);
  const pending = streams.filter((s) => s.next !== null && s.items.length > 0);
  if (pending.length === 0) {
    return { visible: all, hasMore: streams.some((s) => s.next !== null) };
  }
  const mark = pending.map((s) => s.items[s.items.length - 1]).sort(before)[0];
  return { visible: all.filter((c) => before(c, mark) <= 0), hasMore: true };
}
function equalShares(total, parts) {
  if (!Number.isInteger(total) || total < 0) {
    throw new Error(`equalShares: total inv\xE1lido: ${total}. Use inteiro n\xE3o negativo.`);
  }
  if (!Number.isInteger(parts) || parts < 0) {
    throw new Error(`equalShares: quantidade de pessoas inv\xE1lida: ${parts}.`);
  }
  if (parts === 0) return [];
  const each = Math.floor(total / parts);
  const rest = total % parts;
  return Array.from({ length: parts }, (_, i) => each + (i < rest ? 1 : 0));
}
function contactedToday(contactedAt, now = /* @__PURE__ */ new Date(), timezone = HOUSE_TIMEZONE) {
  if (contactedAt === null) return false;
  return businessDate(contactedAt, timezone) === businessDate(now, timezone);
}
var DESK_IMPORT_DUE_DAYS = [5, 10, 15, 20, 25, 30];
function previousMonthSameDay(date) {
  const [year, month, day] = businessDateParts(date, "previousMonthSameDay");
  return monthBefore(year, month, day);
}
function importTargetDate(day, today = /* @__PURE__ */ new Date(), timezone = HOUSE_TIMEZONE) {
  if (!DESK_IMPORT_DUE_DAYS.includes(day)) {
    throw new Error(
      `importTargetDate: dia ${day} n\xE3o \xE9 dia de vencimento. Use ${DESK_IMPORT_DUE_DAYS.join(", ")}.`
    );
  }
  const [year, month, todayDay] = businessDateParts(businessDate(today, timezone));
  if (day < todayDay) return isoOf(year, month, day);
  return monthBefore(year, month, day);
}
function deskAutoImportDueDate(today = /* @__PURE__ */ new Date(), timezone = HOUSE_TIMEZONE) {
  for (const day of DESK_IMPORT_DUE_DAYS) {
    const target = importTargetDate(day, today, timezone);
    if (daysOverdue(target, today, timezone) === 1) return target;
  }
  return null;
}
var DESK_ERP_CHECK_SLACK_MS = 6e4;
function deskErpCheckDue(lastRunAt, hours, now) {
  if (lastRunAt === null) return true;
  return now.getTime() - lastRunAt.getTime() >= hours * 36e5 - DESK_ERP_CHECK_SLACK_MS;
}
function deskImportDiscard(boleto, rules) {
  if (boleto.amount === null || !withinImportRange(boleto.amount, rules.range)) return "valor";
  if (boleto.vehicleIds.some((id) => rules.earlierVehicles.has(id))) return "boleto_anterior";
  return null;
}
var DESK_IMPORT_ORIGINS = ["manual", "automatica"];
var DESK_AUTO_IMPORT_FROM_HOUR = 7;
var DESK_AUTO_IMPORT_REQUEST_FROM_HOUR = 6;
function deskAutoImportRequests(state, now = /* @__PURE__ */ new Date(), timezone = HOUSE_TIMEZONE) {
  if (state === "nucleo_desatualizado") return true;
  if (state !== "antes_do_horario") return false;
  const [, clock] = houseLocalOf(now, timezone).split("T");
  return Number(clock.slice(0, 2)) >= DESK_AUTO_IMPORT_REQUEST_FROM_HOUR;
}
var DESK_AUTO_IMPORT_STATES = [
  "desligada",
  "sem_vencimento",
  "antes_do_horario",
  "feita",
  "retida",
  "nucleo_desatualizado",
  "pronta"
];
function deskAutoImportState(input, now = /* @__PURE__ */ new Date(), timezone = HOUSE_TIMEZONE) {
  if (!input.enabled) return "desligada";
  if (input.dueDate === null) return "sem_vencimento";
  if (input.held) return "retida";
  if (input.done) return "feita";
  const [, clock] = houseLocalOf(now, timezone).split("T");
  if (Number(clock.slice(0, 2)) < DESK_AUTO_IMPORT_FROM_HOUR) return "antes_do_horario";
  const midnight = startOfDay(businessDate(now, timezone), 0, timezone);
  if (input.readAt === null || new Date(input.readAt).getTime() < midnight.getTime()) {
    return "nucleo_desatualizado";
  }
  return "pronta";
}
var DESK_IMPORT_MIN_AMOUNT = cents(15e3);
var DESK_IMPORT_MAX_AMOUNT = cents(1e7);
function withinImportRange(amount, range) {
  return amount >= range.min && amount <= range.max;
}
function importRangeProblem(range) {
  if (range.min < 0) return "O valor m\xEDnimo n\xE3o pode ser negativo.";
  if (range.max <= 0) return "O valor m\xE1ximo precisa ser maior que zero.";
  if (range.max < range.min) return "O valor m\xE1ximo n\xE3o pode ser menor que o m\xEDnimo.";
  return null;
}
function vehicleStatusAccepted(label) {
  const s = (label ?? "").trim().toUpperCase();
  if (s.includes("MIGRADO")) return false;
  return s.startsWith("ATIVO") || s.includes("INADIMPLENTE");
}
function dueMonth(date) {
  businessDateParts(date, "dueMonth");
  return date.slice(0, 7);
}
function deskPlateMatch(candidates) {
  const live = candidates.filter((c) => !c.missing);
  if (live.length === 1) return { kind: "cadastro", vehicleId: live[0].id };
  if (live.length === 0) return { kind: "fora" };
  return { kind: "ambigua", count: live.length };
}
var DESK_TOUCH_EVENTS = [
  "puxado",
  "transferido",
  "devolvido_a_fila",
  "distribuido",
  "pago"
];
var DESK_BLOCKS = ["vencimento", "atraso_6_30", "atraso_31_mais"];
function deskBlock(dueDateOriginal, paidAt, timezone = HOUSE_TIMEZONE) {
  const band = deskBand(dueDateOriginal, paidAt, timezone);
  return band === "atraso_6_30" || band === "atraso_31_mais" ? band : "vencimento";
}
function deskEfficiency(paidTouched, touched) {
  if (touched <= 0) return null;
  return Math.round(Math.min(paidTouched, touched) / touched * 100);
}
function monthBefore(year, month, day) {
  const prevYear = month === 1 ? year - 1 : year;
  const prevMonth = month === 1 ? 12 : month - 1;
  const lastDay = new Date(Date.UTC(prevYear, prevMonth, 0)).getUTCDate();
  return isoOf(prevYear, prevMonth, Math.min(day, lastDay));
}
function isoOf(year, month, day) {
  return `${String(year).padStart(4, "0")}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

// src/billing-desk-moves.ts
function deskOperatorColumnTitle(group, name) {
  if (group === "receptiva") return `Receptiva \u2014 ${name}`;
  if (group === "atraso_6_30") return `Atraso 6-30 \u2014 ${name}`;
  if (group === "atraso_31_mais") return `31+ dias \u2014 ${name}`;
  return `Vencimento \u2014 ${name}`;
}
function deskColumnTitle(key, operatorName) {
  const column = key === null ? null : parseDeskColumnKey(key);
  if (column === null) return "Fora do quadro";
  if (column.kind === "fila") return `Fila m\xE3e \u2014 ${DESK_BAND_LABELS[column.band]}`;
  if (column.kind === "pago") {
    return column.outcome === "pago_cobranca" ? "Pago cobran\xE7a" : "Pago automaticamente";
  }
  return deskOperatorColumnTitle(column.group, operatorName ?? "quem est\xE1 com ele");
}
var VIA_LABELS = {
  varredura: "atualiza\xE7\xE3o dos boletos com o ERP",
  relogio: "verifica\xE7\xE3o de 30 em 30 minutos",
  manual: "verifica\xE7\xE3o pedida na configura\xE7\xE3o"
};
var OUTCOME_LABELS = {
  pago_automatico: "Pago automaticamente",
  pago_cobranca: "Pago cobran\xE7a",
  excluido: "Fora do quadro"
};
var FIELD_LABELS = {
  note: "observa\xE7\xE3o",
  phone: "telefone",
  contactPhone: "telefone",
  conversationRef: "protocolo",
  name: "nome",
  manualName: "nome",
  document: "documento",
  manualDocument: "documento",
  plate: "placa",
  manualPlate: "placa",
  dueDate: "vencimento",
  manualDueDate: "vencimento",
  amount: "valor",
  manualAmount: "valor",
  consultant: "consultor",
  manualConsultant: "consultor",
  vehicleId: "ve\xEDculo do cadastro"
};
var DESK_EDIT_EVENTS = /* @__PURE__ */ new Set([
  "contato_hoje",
  "etiquetas_alteradas",
  "editado",
  "ligado_ao_cadastro"
]);
function describeDeskEvent(type, data, nameOf) {
  const d = data ?? {};
  const text = (key) => typeof d[key] === "string" ? d[key] : null;
  const person = (key) => {
    const id = text(key);
    return id === null ? null : nameOf(id) ?? "pessoa sem cadastro";
  };
  const band = (key) => {
    const value2 = text(key);
    return value2 !== null && DESK_BANDS.includes(value2) ? DESK_BAND_LABELS[value2] : null;
  };
  const kind = DESK_EDIT_EVENTS.has(type) ? "edicao" : "movimento";
  const blank = { from: null, to: null, details: null, via: null, kind };
  const joined = (parts, separator) => parts.filter((p) => p !== null && p !== "").join(separator) || null;
  switch (type) {
    case "cadastrado":
      return {
        ...blank,
        title: "Cadastrado na Mesa",
        to: person("owner") ?? "Fila m\xE3e",
        details: text("flow") === "receptiva" ? "receptiva \u2014 quem ligou" : null
      };
    case "importado":
      return { ...blank, title: "Importado da pr\xE9via de inadimplentes", to: "Fila m\xE3e" };
    case "importado_do_kanban": {
      const column = text("legacyColumn");
      return {
        ...blank,
        title: "Trazido do Kanban",
        details: column === null ? null : `estava em ${kanbanColumnLabel(column)}`,
        via: "migra\xE7\xE3o do Kanban"
      };
    }
    case "puxado":
      return { ...blank, title: "Puxou o atendimento", from: "Fila m\xE3e", to: person("to") };
    case "transferido":
      return {
        ...blank,
        title: "Passado a outra pessoa",
        from: person("from") ?? "Fila m\xE3e",
        to: person("to")
      };
    case "devolvido_a_fila":
      return { ...blank, title: "Devolvido \xE0 fila m\xE3e", from: person("from"), to: "Fila m\xE3e" };
    case "distribuido": {
      const column = text("column");
      return {
        ...blank,
        title: "Distribu\xEDdo",
        from: person("from") ?? (column === null ? "Fila m\xE3e" : deskColumnTitle(column, void 0)),
        to: person("to")
      };
    }
    case "pago": {
      const outcome4 = text("outcome");
      const credited = person("credited");
      const proof = d.proof !== void 0 && d.proof !== null;
      return {
        ...blank,
        title: outcome4 === "pago_cobranca" ? "Dado como pago cobran\xE7a" : "Dado como pago autom\xE1tico",
        to: outcome4 === null ? null : OUTCOME_LABELS[outcome4] ?? outcome4,
        details: joined(
          [credited ? `cr\xE9dito de ${credited}` : "sem cr\xE9dito para ningu\xE9m", proof ? "com comprovante" : null],
          ", "
        )
      };
    }
    case "pago_automatico": {
      const status = text("status");
      const paidOn = text("paidOn");
      const owner = person("owner");
      const fromBand = band("band");
      return {
        ...blank,
        title: "Pago autom\xE1tico",
        from: owner ?? (fromBand === null ? "Fila m\xE3e" : `Fila m\xE3e \u2014 ${fromBand}`),
        to: "Pago automaticamente",
        details: status === null ? null : paidOn === null ? `boleto ${status}` : `boleto ${status} em ${formatDate(paidOn)}`,
        via: VIA_LABELS[text("via") ?? ""] ?? "verifica\xE7\xE3o"
      };
    }
    case "creditado":
      return {
        ...blank,
        title: "Cr\xE9dito do pagamento",
        from: person("from"),
        to: person("to"),
        details: joined(
          [
            text("previousOutcome") === "pago_automatico" ? "passou de pago autom\xE1tico a pago cobran\xE7a" : null,
            d.newProof === true ? "novo comprovante" : null
          ],
          ", "
        )
      };
    case "reaberto": {
      const previous = text("previousOutcome");
      return {
        ...blank,
        title: "Devolvido ao quadro",
        from: previous === null ? null : OUTCOME_LABELS[previous] ?? previous
      };
    }
    case "excluido":
      return { ...blank, title: "Tirado do quadro", to: "Fora do quadro" };
    case "envelhecido": {
      const toBand = band("to");
      return {
        ...blank,
        title: "Mudou de faixa",
        from: joined([band("from"), person("previousOperator")], " \u2014 "),
        to: toBand === null ? "Fila m\xE3e" : `Fila m\xE3e \u2014 ${toBand}`,
        via: "mudan\xE7a de faixa pelo vencimento"
      };
    }
    case "contato_hoje":
      return {
        ...blank,
        title: d.done === false ? "Desmarcou o contato do dia" : "Marcou o contato do dia"
      };
    case "etiquetas_alteradas": {
      const added = Array.isArray(d.added) ? d.added.length : 0;
      const removed = Array.isArray(d.removed) ? d.removed.length : 0;
      return {
        ...blank,
        title: "Etiquetas trocadas",
        details: `${added} inclu\xEDda(s), ${removed} retirada(s)`
      };
    }
    case "editado": {
      const fields = Array.isArray(d.fields) ? d.fields.filter((f) => typeof f === "string") : [];
      const note = d.note;
      const after = typeof note?.after === "string" ? note.after : null;
      return {
        ...blank,
        title: "Dados editados",
        details: joined(
          [
            fields.length > 0 ? fields.map((f) => FIELD_LABELS[f] ?? f).join(", ") : null,
            after === null ? null : `observa\xE7\xE3o agora: "${after}"`
          ],
          " \u2014 "
        )
      };
    }
    /*
     * O card sem boleto que passou a apontar para o veículo do núcleo, ao fim
     * de uma projeção — `BillingDeskAutomationService.linkVehicles`. O que o
     * operador tinha digitado fica no `data` (`typed`), e a tela não o repete.
     */
    case "ligado_ao_cadastro": {
      const plate = text("plate");
      return {
        ...blank,
        title: "Ligado ao cadastro do ve\xEDculo",
        details: joined(
          [
            plate === null ? null : `placa ${plate}`,
            text("vehicleCode"),
            "nome, documento e consultor passam a vir do cadastro"
          ],
          " \u2014 "
        ),
        via: "atualiza\xE7\xE3o do cadastro com o ERP"
      };
    }
    default:
      return { ...blank, title: type };
  }
}
var KANBAN_COLUMN_LABELS = {
  vencimento_5: "Vencimento 5 \u2014 dia 1 a 5",
  vencimento_10: "Vencimento 10 \u2014 dia 6 a 10",
  vencimento_15: "Vencimento 15 \u2014 dia 11 a 15",
  vencimento_20: "Vencimento 20 \u2014 dia 16 a 20",
  vencimento_25: "Vencimento 25 \u2014 dia 21 a 25",
  vencimento_30: "Vencimento 30 \u2014 dia 26 a 31",
  atraso_6_30: "Atraso de 6 a 30 dias",
  atraso_31_59: "Clientes para Negociar (31 a 59 dias)",
  retencao_60_mais: "Reten\xE7\xE3o (60+ dias)",
  em_atendimento: "Em Atendimento",
  receptiva: "Receptiva",
  pago_automaticamente: "Pago Automaticamente",
  pago_cobranca: "Pago Cobran\xE7a",
  em_negociacao_juridico: "Jur\xEDdico \u2014 Clientes em Negocia\xE7\xE3o",
  notificados_juridico: "Jur\xEDdico \u2014 Notificados",
  juridico_negativacao: "Jur\xEDdico \u2014 Negativados",
  pago_juridico: "Pago Jur\xEDdico"
};
function kanbanColumnLabel(value2) {
  return KANBAN_COLUMN_LABELS[value2] ?? value2;
}
var KANBAN_ROUTINES = {
  "Sistema (Autom\xE1tico)": "rotina autom\xE1tica do Kanban",
  "Sistema (Importa\xE7\xE3o SGA)": "importa\xE7\xE3o do SGA, no Kanban",
  "Sistema (SGA Sync)": "verifica\xE7\xE3o no SGA, no Kanban"
};
var TRANSFER = /^(.*?)\s*\(Transferido de (.*?) para (.*?)\)\s*$/;
function describeKanbanMove(origin, destination, actorName, details) {
  const transfer = TRANSFER.exec(actorName);
  const name = (transfer ? transfer[1] : actorName).trim();
  const routine = name.startsWith("Sistema");
  const actor = routine ? null : name;
  const via = routine ? KANBAN_ROUTINES[name] ?? name : null;
  const owner = (who) => who === void 0 ? null : who.trim() === "Desconhecido" ? "Fila m\xE3e" : who.trim();
  const extra = (details ?? "").trim() || null;
  const blank = { actor, via, details: extra };
  if (destination === "Transfer\xEAncia" || origin === "Transfer\xEAncia") {
    return {
      ...blank,
      title: "Passado a outra pessoa",
      from: owner(transfer?.[2]),
      to: owner(transfer?.[3]),
      kind: "movimento"
    };
  }
  if (destination === "Observa\xE7\xE3o" || destination === "Valor do Boleto" || origin === "Edi\xE7\xE3o" || origin === destination) {
    return {
      ...blank,
      title: destination === "Observa\xE7\xE3o" ? "Observa\xE7\xE3o editada" : destination === "Valor do Boleto" ? "Valor do boleto editado" : "Dados editados",
      from: null,
      to: null,
      kind: "edicao"
    };
  }
  const handover = transfer ? `atendimento de ${owner(transfer[2])} para ${owner(transfer[3])}` : null;
  const created = origin === "Novo Cadastro" || origin === "sga_import";
  const title = origin === "Novo Cadastro" ? "Cadastrado no Kanban" : origin === "sga_import" ? "Importado do SGA, no Kanban" : destination === "pago_cobranca" ? "Pago cobran\xE7a" : destination === "pago_automaticamente" ? "Pago autom\xE1tico" : "Mudou de coluna";
  return {
    ...blank,
    title,
    from: created ? null : kanbanColumnLabel(origin),
    to: kanbanColumnLabel(destination),
    details: [handover, extra].filter(Boolean).join(" \u2014 ") || null,
    kind: "movimento"
  };
}

// src/billing-awards.ts
var BILLING_AWARD_LINK_STATUSES = ["monitorando", "retido", "cancelado", "expirado"];
var BILLING_AWARD_KINDS = ["diaria", "semanal", "mensal", "lideranca"];
var BILLING_AWARD_OPERATOR_KINDS = ["diaria", "semanal", "mensal"];
var BILLING_AWARD_KIND_LABELS = {
  diaria: "Meta di\xE1ria",
  semanal: "Meta semanal",
  mensal: "Meta mensal",
  lideranca: "Lideran\xE7a"
};
var BILLING_AWARD_BOLETO_CATEGORIES = [
  "mensalidade",
  "primeiro_boleto",
  "negociacao",
  "campanha",
  "campanha_primeiro_boleto"
];
var BILLING_AWARD_BOLETO_CATEGORY_LABELS = {
  mensalidade: "Mensalidade",
  primeiro_boleto: "1\xBA boleto",
  negociacao: "Negocia\xE7\xE3o",
  campanha: "Campanha",
  campanha_primeiro_boleto: "Campanha \u2014 1\xBA boleto"
};
var BILLING_AWARD_LINK_STATUS_LABELS = {
  monitorando: "Monitorando",
  retido: "Pago",
  cancelado: "Cancelado",
  expirado: "Expirado"
};
var BILLING_AWARD_LINK_DEADLINE_DAYS = 8;
var BILLING_AWARD_CANDIDATE_STATUS_CODES = ["1", "2", "4", "5"];
var BILLING_AWARD_CANCELED_STATUS_CODE = "3";
var BILLING_AWARD_DISCOUNT_STATUS_CODE = "5";
function billingAwardPeriodOf(date) {
  businessDateParts(date, "billingAwardPeriodOf");
  return date.slice(0, 7);
}
function billingAwardPeriodBounds(period) {
  const [year, month] = periodParts(period);
  const last = new Date(Date.UTC(year, month, 0)).toISOString().slice(0, 10);
  return { first: `${period}-01`, last };
}
function previousBillingAwardPeriod(period) {
  const [year, month] = periodParts(period);
  return new Date(Date.UTC(year, month - 2, 1)).toISOString().slice(0, 7);
}
function periodParts(period) {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(period)) {
    throw new Error(`Compet\xEAncia inv\xE1lida: ${period}. Use AAAA-MM.`);
  }
  return [Number(period.slice(0, 4)), Number(period.slice(5, 7))];
}
function shift(date, days) {
  const [year, month, day] = businessDateParts(date, "awardWeek");
  return new Date(Date.UTC(year, month - 1, day + days)).toISOString().slice(0, 10);
}
function billingAwardWeekOf(date) {
  const [year, month, day] = businessDateParts(date, "billingAwardWeekOf");
  const weekday = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  const start = shift(date, -(weekday === 0 ? 6 : weekday - 1));
  return { start, end: shift(start, 6) };
}
function billingAwardWeeksOf(period) {
  const { first, last } = billingAwardPeriodBounds(period);
  const weeks = [];
  for (let d = first; d <= last; d = shift(d, 1)) {
    const [year, month, day] = businessDateParts(d, "billingAwardWeeksOf");
    if (new Date(Date.UTC(year, month - 1, day)).getUTCDay() !== 0) continue;
    weeks.push({ start: shift(d, -6), end: d });
  }
  return weeks;
}
function billingAwardBoletoPayment(b) {
  const payment = boletoPayment(b);
  if (payment.source !== null) {
    return { paid: true, paidOn: payment.paidAt, recovered: payment.paidAmount ?? b.amount };
  }
  if (b.statusCode === BILLING_AWARD_DISCOUNT_STATUS_CODE) {
    return { paid: true, paidOn: b.erpPaidAt, recovered: b.erpPaidAmount ?? b.amount };
  }
  return { paid: false, paidOn: null, recovered: b.amount };
}
function isBillingAwardCandidate(b) {
  return !b.missing && b.vehicleId !== null && b.typeCode !== null && b.statusCode !== null && BILLING_AWARD_CANDIDATE_STATUS_CODES.includes(b.statusCode);
}
function matchBillingAwards(input) {
  const operatorOf = /* @__PURE__ */ new Map();
  for (const c of input.operatorCodes) operatorOf.set(`${c.tenantId}|${c.erpUserCode}`, c.operatorId);
  const typeOf = /* @__PURE__ */ new Map();
  for (const t of input.boletoTypes) {
    if (!t.countsForAward || !t.active || t.operatorId === null) continue;
    typeOf.set(`${t.tenantId}|${t.typeCode}`, { operatorId: t.operatorId, boletoTypeId: t.id });
  }
  const takenRecords = input.taken?.recordIds ?? /* @__PURE__ */ new Set();
  const locked = new Set(input.taken?.boletoIds ?? []);
  const pool = /* @__PURE__ */ new Map();
  for (const b of input.boletos) {
    if (!isBillingAwardCandidate(b) || billingAwardPeriodOf(b.dueDate) !== input.period) continue;
    const owner = typeOf.get(`${b.tenantId}|${b.typeCode}`);
    if (owner === void 0) continue;
    const target = billingAwardBoletoPayment(b).paidOn ?? b.dueDate;
    const key = `${b.tenantId}|${owner.operatorId}|${b.vehicleId}`;
    const list = pool.get(key) ?? [];
    list.push({ boleto: b, target, boletoTypeId: owner.boletoTypeId });
    pool.set(key, list);
  }
  const records = input.records.filter(
    (r) => r.servedOn !== null && r.vehicleId !== null && r.erpUserCode !== null && billingAwardPeriodOf(r.servedOn) === input.period && !takenRecords.has(r.id)
  ).sort((a, b) => a.servedOn.localeCompare(b.servedOn) || a.id - b.id);
  const matches = [];
  for (const r of records) {
    const operatorId = operatorOf.get(`${r.tenantId}|${r.erpUserCode}`);
    if (operatorId === void 0) continue;
    const best = (pool.get(`${r.tenantId}|${operatorId}|${r.vehicleId}`) ?? []).filter((c) => c.target === r.servedOn && !locked.has(c.boleto.id)).sort((a, b) => compareMoney(b.boleto.amount, a.boleto.amount) || a.boleto.id - b.boleto.id)[0];
    if (best === void 0) continue;
    locked.add(best.boleto.id);
    matches.push({
      tenantId: r.tenantId,
      recordId: r.id,
      boletoId: best.boleto.id,
      operatorId,
      boletoTypeId: best.boletoTypeId
    });
  }
  return matches;
}
function billingAwardLinkDeadline(matchedAt) {
  return new Date(matchedAt.getTime() + BILLING_AWARD_LINK_DEADLINE_DAYS * 24 * 60 * 60 * 1e3);
}
function nextBillingAwardLinkStatus(current, observed, deadline, now) {
  if (current !== "monitorando") return current;
  if (now.getTime() > deadline.getTime()) return "expirado";
  if (observed.payment.paid) return "retido";
  if (observed.missing || observed.statusCode === BILLING_AWARD_CANCELED_STATUS_CODE) return "cancelado";
  return "monitorando";
}
function billingAwardLinkCounts(status, override) {
  return status === "retido" && (override?.valid ?? true);
}
function billingAwardTier(value2, tiers) {
  return [...tiers].filter((t) => compareMoney(t.minAmount, value2) <= 0).sort((a, b) => compareMoney(b.minAmount, a.minAmount) || compareMoney(b.bonus, a.bonus))[0] ?? null;
}
function tierOf(rule, kind, value2) {
  return rule.enabled[kind] ? billingAwardTier(value2, rule.tiers[kind]) : null;
}
function ruleShape(rule) {
  return JSON.stringify(
    BILLING_AWARD_KINDS.map((kind) => [
      kind,
      rule.enabled[kind],
      [...rule.tiers[kind]].map((t) => [t.minAmount, t.bonus]).sort((a, b) => a[0] - b[0] || a[1] - b[1])
    ])
  );
}
function billingAwardRuleProblem(rules) {
  if (rules.length === 0) return "Nenhuma base tem a r\xE9gua da premia\xE7\xE3o.";
  const [first, ...rest] = rules;
  const different = rest.filter((r) => ruleShape(r.rule) !== ruleShape(first.rule));
  if (different.length === 0) return null;
  return `A r\xE9gua da premia\xE7\xE3o de ${[first.tenant, ...different.map((r) => r.tenant)].join(" e ")} n\xE3o \xE9 a mesma. A faixa vale sobre a soma das bases, ent\xE3o as duas precisam ter as mesmas faixas e as mesmas modalidades ligadas.`;
}
function grouped(items, keyOf) {
  const map = /* @__PURE__ */ new Map();
  for (const item of items) {
    const key = keyOf(item);
    const list = map.get(key) ?? [];
    list.push(item);
    map.set(key, list);
  }
  return map;
}
var recoveredOf = (links) => sum(...links.map((l) => l.recovered));
function billingAwardsOf(input) {
  const weeks = billingAwardWeeksOf(input.period);
  const byOperator = grouped(input.links, (l) => l.operatorId);
  const operators = input.operatorIds.map((operatorId) => {
    const mine = byOperator.get(operatorId) ?? [];
    const current = mine.filter((l) => l.period === input.period);
    const days = [...grouped(current, (l) => l.settledOn)].sort(([a], [b]) => a.localeCompare(b)).map(([date, links]) => {
      const recovered2 = recoveredOf(links);
      const tier = tierOf(input.rule, "diaria", recovered2);
      return { date, recovered: recovered2, tier, bonus: tier?.bonus ?? ZERO };
    });
    const weekResults = weeks.map((week) => {
      const recovered2 = recoveredOf(mine.filter((l) => l.settledOn >= week.start && l.settledOn <= week.end));
      const tier = tierOf(input.rule, "semanal", recovered2);
      return { ...week, recovered: recovered2, tier, bonus: tier?.bonus ?? ZERO };
    });
    const recovered = recoveredOf(current);
    const monthlyTier = tierOf(input.rule, "mensal", recovered);
    const dailyBonus = sum(...days.map((d) => d.bonus));
    const weeklyBonus = sum(...weekResults.map((w) => w.bonus));
    const monthlyBonus = monthlyTier?.bonus ?? ZERO;
    return {
      operatorId,
      recovered,
      paidCount: current.length,
      byTenant: [...grouped(current, (l) => l.tenantId)].sort(([a], [b]) => a - b).map(([tenantId, links]) => ({ tenantId, count: links.length, recovered: recoveredOf(links) })),
      byType: [...grouped(current, (l) => l.typeLabel)].map(([typeLabel, links]) => ({ typeLabel, count: links.length, recovered: recoveredOf(links) })).sort((a, b) => compareMoney(b.recovered, a.recovered) || a.typeLabel.localeCompare(b.typeLabel)),
      days,
      dailyBonus,
      weeks: weekResults,
      weeklyBonus,
      monthlyTier,
      monthlyBonus,
      total: sum(dailyBonus, weeklyBonus, monthlyBonus)
    };
  });
  const team = sum(...operators.map((o) => o.recovered));
  const leadershipTier = tierOf(input.rule, "lideranca", team);
  return {
    operators,
    leadership: input.rule.enabled.lideranca ? { recovered: team, tier: leadershipTier, bonus: leadershipTier?.bonus ?? ZERO } : null
  };
}
function billingAwardProtocolOf(description) {
  if (description === null) return null;
  const m = /\[([^\]]+)\]|\{([^}]+)\}/.exec(description);
  const found = (m?.[1] ?? m?.[2] ?? "").trim();
  return found === "" ? null : found;
}
var VIA_LABELS2 = {
  relogio: "rotina das 03:30",
  varredura: "depois da atualiza\xE7\xE3o com o ERP",
  manual: "pedido na tela"
};
var periodText = (v) => typeof v === "string" && /^\d{4}-\d{2}$/.test(v) ? `${v.slice(5, 7)}/${v.slice(0, 4)}` : null;
var count2 = (v) => typeof v === "number" ? v : 0;
function describeBillingAwardEvent(type, data) {
  const period = periodText(data.period);
  switch (type) {
    case "vinculos_recalculados": {
      const s = data.byStatus ?? {};
      const via = typeof data.via === "string" ? VIA_LABELS2[data.via] : void 0;
      return {
        title: "V\xEDnculos recalculados",
        details: `${period ?? "Compet\xEAncia"}: ${count2(data.links)} v\xEDnculos \u2014 ${count2(s.retido)} pagos, ${count2(s.monitorando)} monitorando, ${count2(s.cancelado)} cancelados. ${count2(data.records)} atendimentos e ${count2(data.boletos)} boletos lidos` + (via ? ` (${via}).` : ".")
      };
    }
    case "boletos_conferidos":
      return {
        title: "Boletos conferidos no SGA",
        details: `${count2(data.checked)} conferidos: ${count2(data.settled)} pagos, ${count2(data.canceled)} cancelados. ${count2(data.expired)} v\xEDnculos expiraram pelo prazo; ${count2(data.failed)} sem resposta do SGA.`
      };
    case "vinculo_invalidado":
      return { title: "V\xEDnculo invalidado", details: typeof data.reason === "string" ? data.reason : null };
    case "vinculo_revalidado":
      return { title: "V\xEDnculo revalidado", details: "Voltou \xE0 regra autom\xE1tica: conta quando est\xE1 pago." };
    case "competencia_fechada":
      return { title: "Compet\xEAncia fechada", details: period };
    case "competencia_importada": {
      const text = (v) => typeof v === "string" ? v : "\u2014";
      return {
        title: "Compet\xEAncia trazida fechada do sistema antigo",
        details: `${period ?? "Compet\xEAncia"}: o valor que ele mostrava, congelado \u2014 recuperado ${text(data.recovered)}, comiss\xE3o do time ${text(data.commission)}, lideran\xE7a ${text(data.leadership)}. ` + (count2(data.links) > 0 ? `${count2(data.links)} v\xEDnculos de detalhe.` : "Os v\xEDnculos de detalhe entram quando o n\xFAcleo tiver os atendimentos e os boletos do m\xEAs.")
      };
    }
    case "vinculos_historicos_importados":
      return {
        title: "V\xEDnculos de detalhe do hist\xF3rico trazidos",
        details: `${period ?? "Compet\xEAncia"}: ${count2(data.links)} v\xEDnculos. O valor do m\xEAs n\xE3o muda.`
      };
    case "competencia_reaberta":
      return {
        title: "Compet\xEAncia reaberta",
        details: [period, typeof data.reason === "string" ? data.reason : null].filter(Boolean).join(" \u2014 ") || null
      };
    case "operadores_premiacao_alterados":
      return { title: "Operadores alterados", details: null };
    case "tipos_premiacao_alterados":
      return { title: "Tipos de boleto alterados", details: null };
    case "regua_premiacao_alterada":
      return { title: "Faixas, metas e departamentos alterados", details: null };
    case "configuracao_importada":
      return {
        title: "Configura\xE7\xE3o trazida do sistema antigo",
        details: `${count2(data.operators)} operadores, ${count2(data.boletoTypes)} tipos de boleto e ${count2(data.tiers)} faixas.`
      };
    default:
      return { title: type, details: null };
  }
}

// src/claims.ts
var CLAIM_TYPES = ["associado", "terceiro"];
var CLAIM_DEPARTMENTS = ["analise", "reparo", "indenizacao"];
var CLAIM_DEPARTMENT_LABELS = {
  analise: "An\xE1lise",
  reparo: "Reparo",
  indenizacao: "Indeniza\xE7\xE3o"
};
var CLAIM_EVENT_TYPE_LABELS = {
  atropelamento_de_animal: "Atropelamento de animal",
  atropelamento_de_pessoas: "Atropelamento de pessoas",
  capotamento: "Capotamento",
  choque: "Choque",
  colisao: "Colis\xE3o",
  fenomenos_da_natureza: "Fen\xF4menos da natureza",
  roubo_ou_furto: "Roubo ou furto",
  queda: "Queda",
  tombamento: "Tombamento",
  incendio: "Inc\xEAndio"
};
var ANALYSIS_WORK_STAGES = [
  "entrada",
  "documentacao",
  "analise_de_evento",
  "sindicancia",
  "negativas_a_enviar"
];
var ANALYSIS_STAGE_COLORS = {
  entrada: "azul",
  documentacao: "ciano",
  analise_de_evento: "roxo",
  sindicancia: "laranja",
  negativas_a_enviar: "vermelho"
};
var ANALYSIS_HANDOFF_PHASES = ["aprovado_para_reparo", "indenizacao"];
var ANALYSIS_GENERAL_PHASES = [
  "desistencia",
  "negados_com_posse",
  "negados_com_posse_juridico",
  "negado",
  "concluido_somente_terceiro"
];
var ANALYSIS_OUTCOMES = [
  ...ANALYSIS_HANDOFF_PHASES,
  ...ANALYSIS_GENERAL_PHASES
];
var ANALYSIS_STAGES = [...ANALYSIS_WORK_STAGES, ...ANALYSIS_OUTCOMES];
var REPAIR_WORK_STAGES = [
  "orcamentacao_oficina",
  "aprovacao_supervisor",
  "negociacao_para_acordo",
  "aguardando_parada",
  "pagamento_associado",
  "compra_de_pecas",
  "reparo_oficina",
  "vistoria_de_entrega",
  "aguardando_faturamento",
  "retorno_garantia"
];
var REPAIR_SUPERVISION_STAGES = [
  "aprovacao_supervisor"
];
function isRepairSupervisionStage(phase) {
  return REPAIR_SUPERVISION_STAGES.includes(phase);
}
var REPAIR_STAGE_COLORS = {
  orcamentacao_oficina: "turquesa",
  aprovacao_supervisor: "roxo",
  negociacao_para_acordo: "rosa",
  aguardando_parada: "amarelo",
  pagamento_associado: "rosa",
  compra_de_pecas: "laranja",
  reparo_oficina: "turquesa",
  vistoria_de_entrega: "verde",
  aguardando_faturamento: "amarelo",
  retorno_garantia: "vermelho"
};
var REPAIR_HANDOFF_PHASES = ["indenizados"];
var REPAIR_GENERAL_PHASES = ["desistencia", "concluidos"];
var REPAIR_OUTCOMES = [
  ...REPAIR_HANDOFF_PHASES,
  ...REPAIR_GENERAL_PHASES
];
var REPAIR_STAGES = [...REPAIR_WORK_STAGES, ...REPAIR_OUTCOMES];
var COMPENSATION_WORK_STAGES = [
  "comunicado_indenizacao",
  "aguardando_documentacao",
  "pagamento_debito",
  "aguardando_pagamento"
];
var COMPENSATION_STAGE_COLORS = {
  comunicado_indenizacao: "azul",
  aguardando_documentacao: "ciano",
  pagamento_debito: "laranja",
  aguardando_pagamento: "verde"
};
var COMPENSATION_HANDOFF_PHASES = ["acordo"];
var COMPENSATION_GENERAL_PHASES = ["desistencia", "concluidos"];
var COMPENSATION_OUTCOMES = [
  ...COMPENSATION_HANDOFF_PHASES,
  ...COMPENSATION_GENERAL_PHASES
];
var COMPENSATION_STAGES = [
  ...COMPENSATION_WORK_STAGES,
  ...COMPENSATION_OUTCOMES
];
var CLAIM_PHASES = {
  analise: ANALYSIS_STAGES,
  reparo: REPAIR_STAGES,
  indenizacao: COMPENSATION_STAGES
};
function isClaimPhase(department, phase) {
  return CLAIM_PHASES[department].includes(phase);
}
var INITIAL_CLAIM_POSITION = {
  department: "analise",
  phase: "entrada"
};
var REPAIR_OPENING_PHASE = "aprovado_para_reparo";
var PERIPHERAL_WORK_STAGES = [
  "entrada",
  "cotacao",
  "aprovacao_do_supervisor",
  "franquia",
  "acordo",
  "compra",
  "agendamento"
];
var PERIPHERAL_OUTCOMES = ["concluidos", "desistencia", "negados"];
var PERIPHERAL_STAGES = [
  ...PERIPHERAL_WORK_STAGES,
  ...PERIPHERAL_OUTCOMES
];
var PERIPHERAL_OPENING_STAGE = "entrada";
var PERIPHERAL_STAGE_COLORS = {
  entrada: "azul",
  cotacao: "ciano",
  aprovacao_do_supervisor: "roxo",
  franquia: "amarelo",
  acordo: "rosa",
  compra: "laranja",
  agendamento: "verde"
};
var PERIPHERAL_COVERAGE_PERCENTS = [60, 80];
var EXPENSE_REQUEST_STAGES = [
  "aviso",
  "analise",
  "reparo",
  "indenizacao",
  "perifericos"
];
var CLAIM_EXPENSE_STAGES = [
  "aviso",
  "analise",
  "reparo",
  "indenizacao"
];
function cardExpenseStages(stage) {
  return stage === "perifericos" ? ["perifericos"] : CLAIM_EXPENSE_STAGES;
}
var EXPENSE_REQUEST_RESOURCES = {
  aviso: "claims.notices",
  analise: "claims.analyses",
  reparo: "claims.repairs",
  indenizacao: "claims.compensations",
  perifericos: "claims.peripherals"
};
var EXPENSE_REQUEST_STAGE_LABELS = {
  aviso: "Aviso",
  analise: "An\xE1lise",
  reparo: "Reparo",
  indenizacao: "Indeniza\xE7\xE3o",
  perifericos: "Perif\xE9ricos"
};
var EXPENSE_LAUNCH_ACTION = "lancar_despesa";
var EXPENSE_SUPERVISE_ACTION = "supervisionar_despesa";
function thirdPartyQuestions(answers) {
  const withVehicle = answers.reportedThirdPartyVehicle === "sim";
  return {
    asksVehicle: withVehicle,
    asksInsurance: withVehicle,
    asksDamageType: answers.reportedThirdPartyVehicle === "nao"
  };
}
function asksThirdPartyNotices(reportedThirdParties) {
  return reportedThirdParties === "sim";
}
var COMPANY_TYPES = [
  "oficina",
  "prestador_servicos",
  "fornecedor_pecas",
  "instituicao_financeira",
  "orgao_publico"
];
var COMPANY_TYPE_LABELS = {
  oficina: "Oficina",
  prestador_servicos: "Prestador de servi\xE7os",
  fornecedor_pecas: "Fornecedor de pe\xE7as",
  instituicao_financeira: "Institui\xE7\xE3o financeira",
  orgao_publico: "\xD3rg\xE3o p\xFAblico"
};
var COMPANY_CATEGORIES = ["prestadores", "instituicoes"];
var COMPANY_TYPES_BY_CATEGORY = {
  prestadores: ["oficina", "prestador_servicos", "fornecedor_pecas"],
  instituicoes: ["instituicao_financeira", "orgao_publico"]
};
function companyCategoryOf(type) {
  return COMPANY_TYPES_BY_CATEGORY.instituicoes.includes(type) ? "instituicoes" : "prestadores";
}
var COMPANY_DOCUMENT_TYPES_BY_CATEGORY = {
  prestadores: ["cpf", "cnpj"],
  instituicoes: ["cnpj"]
};

// src/finance.ts
var EXPENSE_STAGES = [
  "aguardando_aprovacao_lider",
  "pendente_lider",
  "reprovado_lider",
  "aprovacao_financeiro",
  "pendente",
  "aguardando_pagamento",
  "pagamento_atrasado",
  "pagamento_efetuado",
  "pagamento_recusado"
];
var EXPENSE_STAGE_LABELS = {
  aguardando_aprovacao_lider: "Solicita\xE7\xE3o",
  pendente_lider: "Pendente interno",
  reprovado_lider: "Reprovado pelo supervisor",
  aprovacao_financeiro: "Aprova\xE7\xE3o Financeiro",
  pendente: "Pendente",
  aguardando_pagamento: "Aguardando Pagamento",
  pagamento_atrasado: "Pagamento Atrasado",
  pagamento_efetuado: "Pagamento Efetuado",
  pagamento_recusado: "Pagamento Recusado"
};
var SUPERVISOR_EXPENSE_STAGES = [
  "aguardando_aprovacao_lider",
  "pendente_lider",
  "reprovado_lider",
  "aprovacao_financeiro",
  "pendente",
  "aguardando_pagamento",
  "pagamento_efetuado",
  "pagamento_recusado"
];
var SUPERVISOR_EXPENSE_STAGE_LABELS = {
  aguardando_aprovacao_lider: "Solicita\xE7\xE3o",
  pendente_lider: "Pendente interno",
  reprovado_lider: "Reprovado pelo supervisor",
  aprovacao_financeiro: "Solicita\xE7\xE3o Efetuada",
  pendente: "Pendente financeiro",
  aguardando_pagamento: "Aguardando pagamento",
  pagamento_efetuado: "Pgt Efetuado",
  pagamento_recusado: "Reprovado"
};
function supervisorStage(stage) {
  return stage === "pagamento_atrasado" ? "aguardando_pagamento" : stage;
}
function expenseStageLabel(stage, board) {
  return board === "supervisor" ? SUPERVISOR_EXPENSE_STAGE_LABELS[supervisorStage(stage)] : EXPENSE_STAGE_LABELS[stage];
}
var EXPENSE_STAGE_TONES = {
  aguardando_aprovacao_lider: "neutro",
  pendente_lider: "alerta",
  reprovado_lider: "erro",
  aprovacao_financeiro: "informacao",
  pendente: "alerta",
  aguardando_pagamento: "progresso",
  pagamento_atrasado: "erro",
  pagamento_efetuado: "sucesso",
  pagamento_recusado: "erro"
};
var FINAL_EXPENSE_STAGES = [
  "reprovado_lider",
  "pagamento_efetuado",
  "pagamento_recusado"
];
var EXPENSE_SOURCE_TYPES = ["sinistro", "premiacao", "assistencia"];
var EXPENSE_SOURCE_LABELS = {
  sinistro: "Sinistro",
  premiacao: "Premia\xE7\xE3o",
  assistencia: "Assist\xEAncia 24h"
};
var EXPENSE_RESULTS = ["aprovado", "reprovado", "pendente"];
var SUPERVISED_MOVES = [
  ["aguardando_aprovacao_lider", "aprovacao_financeiro", "supervisor"],
  ["aguardando_aprovacao_lider", "pendente_lider", "supervisor"],
  ["aguardando_aprovacao_lider", "reprovado_lider", "supervisor"],
  ["pendente_lider", "aguardando_aprovacao_lider", "supervisor"],
  ["pendente_lider", "reprovado_lider", "supervisor"],
  ["pendente", "aprovacao_financeiro", "supervisor"],
  ["aprovacao_financeiro", "aguardando_pagamento", "financeiro"],
  ["aprovacao_financeiro", "pendente", "financeiro"],
  ["aprovacao_financeiro", "pagamento_recusado", "financeiro"],
  ["aguardando_pagamento", "aprovacao_financeiro", "financeiro"],
  ["aguardando_pagamento", "pagamento_efetuado", "job"],
  ["aguardando_pagamento", "pagamento_atrasado", "job"],
  ["pagamento_atrasado", "pagamento_efetuado", "job"]
];
var EXPENSE_FLOWS = {
  sinistro: {
    initial: "aguardando_aprovacao_lider",
    stages: EXPENSE_STAGES,
    moves: SUPERVISED_MOVES
  },
  assistencia: {
    initial: "aguardando_aprovacao_lider",
    entries: ["aprovacao_financeiro", "aguardando_pagamento"],
    stages: EXPENSE_STAGES,
    moves: SUPERVISED_MOVES
  },
  premiacao: {
    initial: "aprovacao_financeiro",
    stages: [
      "aprovacao_financeiro",
      "pendente",
      "aguardando_pagamento",
      "pagamento_efetuado",
      "pagamento_recusado"
    ],
    moves: [
      ["aprovacao_financeiro", "aguardando_pagamento", "financeiro"],
      ["aprovacao_financeiro", "pendente", "financeiro"],
      ["aguardando_pagamento", "pendente", "financeiro"],
      ["pendente", "aprovacao_financeiro", "financeiro"],
      ["aguardando_pagamento", "pagamento_efetuado", "financeiro"],
      ["aprovacao_financeiro", "pagamento_recusado", "financeiro"],
      ["aguardando_pagamento", "pagamento_recusado", "financeiro"]
    ]
  }
};
function initialExpenseStage(source) {
  return EXPENSE_FLOWS[source].initial;
}
function expenseEntryAllowed(source, stage) {
  const flow = EXPENSE_FLOWS[source];
  return stage === flow.initial || (flow.entries ?? []).includes(stage);
}
function expenseMoveActor(source, from, to) {
  const move = EXPENSE_FLOWS[source].moves.find(([a, b]) => a === from && b === to);
  return move ? move[2] : null;
}
function expenseMoveAllowed(source, from, to) {
  return expenseMoveActor(source, from, to) !== null;
}
var EXPENSE_SUPERVISOR_ACTS = [
  "aprovar",
  "pendenciar",
  "reprovar",
  "resolver",
  "resolver_financeiro"
];
var SUPERVISOR_TRANSITIONS = {
  aprovar: [["aguardando_aprovacao_lider"], "aprovacao_financeiro"],
  pendenciar: [["aguardando_aprovacao_lider"], "pendente_lider"],
  reprovar: [["aguardando_aprovacao_lider", "pendente_lider"], "reprovado_lider"],
  resolver: [["pendente_lider"], "aguardando_aprovacao_lider"],
  resolver_financeiro: [["pendente"], "aprovacao_financeiro"]
};
var EXPENSE_SUPERVISOR_ACT_LABELS = {
  aprovar: "Aprovar",
  pendenciar: "Pendenciar",
  reprovar: "Reprovar",
  resolver: "Resolver pend\xEAncia",
  resolver_financeiro: "Resolver pend\xEAncia"
};
var EXPENSE_ACTS_WITH_REASON = [
  "pendenciar",
  "reprovar"
];
function supervisorTransition(from, act) {
  const [origins, to] = SUPERVISOR_TRANSITIONS[act];
  return origins.includes(from) ? to : null;
}
function supervisorActsFor(stage) {
  return EXPENSE_SUPERVISOR_ACTS.filter(
    (act) => supervisorTransition(stage, act) !== null
  );
}
var FINANCE_BOARD_STAGES = [
  "aprovacao_financeiro",
  "pendente",
  "aguardando_pagamento",
  "pagamento_atrasado",
  "pagamento_efetuado",
  "pagamento_recusado"
];
var FINANCE_BOARD_SOURCES = [
  "sinistro",
  "assistencia"
];
var EXPENSE_FINANCE_ACTS = [
  "autorizar",
  "pendenciar",
  "recusar",
  "devolver"
];
var FINANCE_TRANSITIONS = {
  autorizar: ["aprovacao_financeiro", "aguardando_pagamento"],
  pendenciar: ["aprovacao_financeiro", "pendente"],
  recusar: ["aprovacao_financeiro", "pagamento_recusado"],
  devolver: ["aguardando_pagamento", "aprovacao_financeiro"]
};
var EXPENSE_FINANCE_ACT_LABELS = {
  autorizar: "Autorizar",
  pendenciar: "Pendenciar",
  recusar: "Recusar",
  devolver: "Devolver para Aprova\xE7\xE3o"
};
var FINANCE_ACTS_WITH_REASON = [
  "pendenciar",
  "recusar"
];
function financeTransition(from, act) {
  const [origin, to] = FINANCE_TRANSITIONS[act];
  return origin === from ? to : null;
}
function financeActsFor(stage) {
  return EXPENSE_FINANCE_ACTS.filter((act) => financeTransition(stage, act) !== null);
}
function expenseAlreadyPaid(expense) {
  return expense.paidAt !== null && expense.status !== "pagamento_efetuado";
}
function readMoney(text) {
  try {
    return fromColumn(text);
  } catch {
    return null;
  }
}
function expenseTotals(expenses) {
  const launched = [];
  const paid = [];
  for (const e of expenses) {
    if (e.status === "reprovado_lider" || e.status === "pagamento_recusado") continue;
    const amount = readMoney(e.amount);
    if (amount === null) return null;
    launched.push(amount);
    if (e.status === "pagamento_efetuado") {
      const value2 = e.paidAmount === null ? amount : readMoney(e.paidAmount);
      if (value2 === null) return null;
      paid.push(value2);
    }
  }
  const l = sum(...launched);
  const p = sum(...paid);
  return { launched: l, paid: p, open: subtract(l, p) };
}
var EXPENSE_PAYMENT_METHODS = [
  "DINHEIRO",
  "CARTAO_CREDITO",
  "BOLETO_BANCARIO",
  "CARTAO_CREDITO_VIA_LINK",
  "CHEQUE",
  "CARTAO_DEBITO",
  "TRANSFERENCIA_BANCARIA",
  "OUTRO",
  "CARTEIRA_DIGITAL",
  "CASHBACK",
  "CREDITO_LOJA",
  "CREDITO_VIRTUAL",
  "DEPOSITO_BANCARIO",
  "PIX_PAGAMENTO_INSTANTANEO",
  "PROGRAMA_FIDELIDADE",
  "SEM_PAGAMENTO",
  "VALE_ALIMENTACAO",
  "VALE_COMBUSTIVEL",
  "VALE_PRESENTE",
  "VALE_REFEICAO",
  "PIX_COBRANCA",
  "DEBITO_AUTOMATICO"
];
var EXPENSE_PAYMENT_METHOD_LABELS = {
  DINHEIRO: "Dinheiro",
  CARTAO_CREDITO: "Cart\xE3o de cr\xE9dito",
  BOLETO_BANCARIO: "Boleto banc\xE1rio",
  CARTAO_CREDITO_VIA_LINK: "Cart\xE3o de cr\xE9dito via link",
  CHEQUE: "Cheque",
  CARTAO_DEBITO: "Cart\xE3o de d\xE9bito",
  TRANSFERENCIA_BANCARIA: "Transfer\xEAncia banc\xE1ria",
  OUTRO: "Outro",
  CARTEIRA_DIGITAL: "Carteira digital",
  CASHBACK: "Cashback",
  CREDITO_LOJA: "Cr\xE9dito loja",
  CREDITO_VIRTUAL: "Cr\xE9dito virtual",
  DEPOSITO_BANCARIO: "Dep\xF3sito banc\xE1rio",
  PIX_PAGAMENTO_INSTANTANEO: "PIX",
  PROGRAMA_FIDELIDADE: "Programa de fidelidade",
  SEM_PAGAMENTO: "Sem pagamento",
  VALE_ALIMENTACAO: "Vale-alimenta\xE7\xE3o",
  VALE_COMBUSTIVEL: "Vale-combust\xEDvel",
  VALE_PRESENTE: "Vale-presente",
  VALE_REFEICAO: "Vale-refei\xE7\xE3o",
  PIX_COBRANCA: "PIX cobran\xE7a",
  DEBITO_AUTOMATICO: "D\xE9bito autom\xE1tico"
};
var BENEFICIARY_REF_TYPES = [
  "associado",
  "terceiro",
  "companhia",
  "consultor"
];
var BENEFICIARY_REF_TYPE_LABELS = {
  associado: "Associado",
  terceiro: "Terceiro",
  companhia: "Prestador ou institui\xE7\xE3o",
  consultor: "Consultor"
};
function beneficiaryKindLabel(refType, companyType) {
  if (refType === "companhia" && companyType) return COMPANY_TYPE_LABELS[companyType];
  return BENEFICIARY_REF_TYPE_LABELS[refType];
}
function contaAzulExpenseDescription(parts) {
  return [
    parts.marker,
    beneficiaryKindLabel(parts.refType, parts.companyType),
    parts.beneficiaryName?.trim() || null,
    parts.plate?.trim() || null
  ].filter(Boolean).join(" - ");
}
var BENEFICIARY_ACCOUNT_TYPES = ["corrente", "poupanca"];
var PIX_KEY_TYPES = ["cpf", "cnpj", "email", "telefone", "aleatoria"];
var EMAIL_KEY = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var RANDOM_KEY = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
function checkPixKey(type, value2) {
  const raw = value2.trim();
  if (raw === "") return { valid: false, message: "Informe a chave PIX." };
  switch (type) {
    case "cpf": {
      const digits = digitsOnly(raw);
      return digits && isValidCpf(digits) ? { valid: true, normalized: digits } : { valid: false, message: "CPF inv\xE1lido: confira os 11 d\xEDgitos." };
    }
    case "cnpj": {
      const digits = digitsOnly(raw);
      return digits && isValidCnpj(digits) ? { valid: true, normalized: digits } : { valid: false, message: "CNPJ inv\xE1lido: confira os 14 d\xEDgitos." };
    }
    case "email": {
      const email = raw.toLowerCase();
      return EMAIL_KEY.test(email) && email.length <= 77 ? { valid: true, normalized: email } : { valid: false, message: "E-mail inv\xE1lido." };
    }
    case "telefone": {
      const phone = normalizePhone(raw);
      return phone ? { valid: true, normalized: `+55${phone}` } : { valid: false, message: "Telefone inv\xE1lido: informe o DDD e o n\xFAmero." };
    }
    case "aleatoria": {
      const key = raw.toLowerCase();
      return RANDOM_KEY.test(key) ? { valid: true, normalized: key } : {
        valid: false,
        message: "Chave aleat\xF3ria inv\xE1lida: s\xE3o 32 letras e n\xFAmeros, no formato do banco."
      };
    }
  }
}
function pixKeyTypeOf(stored) {
  if (!stored) return null;
  const key = stored.trim();
  if (/^\+55\d{10,11}$/.test(key)) return "telefone";
  if (RANDOM_KEY.test(key)) return "aleatoria";
  if (EMAIL_KEY.test(key)) return "email";
  if (/^\d{11}$/.test(key)) return "cpf";
  if (/^\d{14}$/.test(key)) return "cnpj";
  return null;
}
function checkPaymentData(input) {
  const errors = {};
  const account = {
    bankCode: input.bankCode.trim(),
    agency: input.agency.trim(),
    accountNumber: input.accountNumber.trim(),
    accountType: input.accountType
  };
  const hasAccount = Object.values(account).some((v) => v !== "");
  const hasPix = input.pixKeyType !== "" || input.pixKey.trim() !== "";
  if (!hasAccount && !hasPix) {
    errors.payment = "Informe a conta banc\xE1ria, a chave PIX, ou as duas.";
    return errors;
  }
  if (hasAccount) {
    if (account.bankCode === "") errors.bankCode = "Escolha o banco.";
    if (account.agency === "") errors.agency = "Informe a ag\xEAncia.";
    else if (!/^\d{1,5}(-[\dxX])?$/.test(account.agency)) {
      errors.agency = "Ag\xEAncia: at\xE9 5 n\xFAmeros, com o d\xEDgito depois do tra\xE7o, se houver.";
    }
    if (account.accountNumber === "") errors.accountNumber = "Informe a conta.";
    else if (!/^\d{1,13}(-?[\dxX])?$/.test(account.accountNumber)) {
      errors.accountNumber = "Conta: s\xF3 n\xFAmeros, com o d\xEDgito depois do tra\xE7o.";
    }
    if (account.accountType === "") errors.accountType = "Escolha o tipo de conta.";
  }
  if (hasPix) {
    if (input.pixKeyType === "") errors.pixKeyType = "Escolha o tipo da chave.";
    else {
      const check = checkPixKey(input.pixKeyType, input.pixKey);
      if (!check.valid) errors.pixKey = check.message;
    }
  }
  return errors;
}
function maskBankNumber(value2, visible = 2) {
  if (value2 == null) return null;
  const total = (value2.match(/[0-9a-zA-Z]/g) ?? []).length;
  let seen = 0;
  return value2.replace(/[0-9a-zA-Z]/g, (ch) => {
    seen += 1;
    return seen > total - visible - (value2.includes("-") ? 1 : 0) ? ch : "\u2022";
  });
}

// src/payment.ts
var PAYMENT_STATUSES = [
  "aguardando_nf",
  "aguardando_lancamento",
  "aprovacao_financeiro",
  "pendente",
  "aguardando_pagamento",
  "pagamento_efetuado",
  "pagamento_recusado"
];
var BOARD_STATUSES = PAYMENT_STATUSES.filter(
  (s) => s !== "aguardando_nf" && s !== "aguardando_lancamento"
);
function preExpenseStatus(invoiceRequired) {
  return invoiceRequired ? "aguardando_nf" : "aguardando_lancamento";
}
var PAYMENT_STATUS_LABELS = {
  aguardando_nf: "Aguardando NF",
  aguardando_lancamento: "Aguardando lan\xE7amento",
  aprovacao_financeiro: EXPENSE_STAGE_LABELS.aprovacao_financeiro,
  pendente: EXPENSE_STAGE_LABELS.pendente,
  aguardando_pagamento: EXPENSE_STAGE_LABELS.aguardando_pagamento,
  pagamento_efetuado: EXPENSE_STAGE_LABELS.pagamento_efetuado,
  pagamento_recusado: EXPENSE_STAGE_LABELS.pagamento_recusado
};
var PAYMENT_STATUS_TONES = {
  aguardando_nf: "neutro",
  aguardando_lancamento: "neutro",
  aprovacao_financeiro: EXPENSE_STAGE_TONES.aprovacao_financeiro,
  pendente: EXPENSE_STAGE_TONES.pendente,
  aguardando_pagamento: EXPENSE_STAGE_TONES.aguardando_pagamento,
  pagamento_efetuado: EXPENSE_STAGE_TONES.pagamento_efetuado,
  pagamento_recusado: EXPENSE_STAGE_TONES.pagamento_recusado
};
var TRANSITIONS = {
  enviar_nf: [["aguardando_nf", "pendente"], "aprovacao_financeiro"],
  aprovar: [["aprovacao_financeiro"], "aguardando_pagamento"],
  solicitar_correcao: [["aprovacao_financeiro", "aguardando_pagamento"], "pendente"],
  pagar: [["aguardando_pagamento"], "pagamento_efetuado"],
  recusar: [["aprovacao_financeiro", "aguardando_pagamento"], "pagamento_recusado"],
  retomar: [["pendente"], "aprovacao_financeiro"]
};
var PAYMENT_ACT_ACTIONS = {
  aprovar: "movimentar",
  solicitar_correcao: "devolver",
  pagar: "anexar_comprovante",
  recusar: "recusar",
  retomar: "movimentar"
};
function paymentTransition(from, act) {
  const [origins, to] = TRANSITIONS[act];
  return origins.includes(from) ? to : null;
}
function actFitsLot(act, invoiceRequired) {
  if (act === "enviar_nf") return invoiceRequired;
  if (act === "retomar") return !invoiceRequired;
  return true;
}
function boardAct(from, to, invoiceRequired) {
  const acts = ["aprovar", "solicitar_correcao", "pagar", "recusar", "retomar"];
  for (const act of acts) {
    if (!actFitsLot(act, invoiceRequired)) continue;
    if (paymentTransition(from, act) === to) return act;
  }
  return null;
}
function isFinalPaymentStatus(status) {
  return status === "pagamento_efetuado" || status === "pagamento_recusado";
}
var AWARD_DEFAULT_PAYMENT_METHOD = "PIX_PAGAMENTO_INSTANTANEO";
var REOPEN_LOCKED_REASON = "J\xE1 h\xE1 nota fiscal enviada nesta compet\xEAncia. A reabertura depois do envio ainda n\xE3o foi decidida.";
function isValidWindow(w) {
  return Number.isInteger(w.opensDay) && Number.isInteger(w.closesDay) && w.opensDay >= 1 && w.closesDay <= 31 && w.opensDay <= w.closesDay;
}
function windowState(period, window, today) {
  if (window === null) return { estado: "sem_janela" };
  const [year, month] = period.split("-").map(Number);
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const day = (d) => `${year}-${String(month).padStart(2, "0")}-${String(Math.min(d, lastDay)).padStart(2, "0")}`;
  const opensOn = day(window.opensDay);
  const closesOn = day(window.closesDay);
  const estado = today < opensOn ? "antes" : today > closesOn ? "encerrada" : "aberta";
  return { estado, opensOn, closesOn };
}
var NO_INVOICE_SEND = "Consultor interno n\xE3o envia nota fiscal: a premia\xE7\xE3o \xE9 lan\xE7ada no Financeiro no dia 11.";
var REOPENED_SEND = "A compet\xEAncia est\xE1 reaberta no comercial. O envio volta quando ela fechar de novo.";
function sendRefusal(entry) {
  if (!entry.invoiceRequired) return NO_INVOICE_SEND;
  if (entry.status === "pendente") return entry.closed ? null : REOPENED_SEND;
  if (entry.status === "pagamento_recusado") {
    return "O Financeiro recusou o pagamento deste lote. N\xE3o h\xE1 reenvio.";
  }
  if (entry.status !== "aguardando_nf") return "A nota deste lote j\xE1 foi enviada.";
  if (!entry.closed) return REOPENED_SEND;
  switch (entry.window.estado) {
    case "sem_janela":
      return "A janela de envio deste lote ainda n\xE3o foi definida nesta base. Fale com o Financeiro.";
    case "antes":
      return `O envio abre em ${brDate(entry.window.opensOn)}.`;
    case "encerrada":
    case "aberta":
      break;
  }
  if (entry.payDay === null) {
    return "O dia de pagamento deste lote ainda n\xE3o foi definido nesta base. Fale com o Financeiro.";
  }
  if (!entry.hasBeneficiary) {
    return "Seus dados banc\xE1rios ainda n\xE3o est\xE3o cadastrados. Fale com o Financeiro.";
  }
  return null;
}
function lateSend(entry) {
  return entry.status === "aguardando_nf" && entry.window.estado === "encerrada";
}
function paymentDueOn(period, payDay, late) {
  if (payDay === null) return null;
  const [y, m] = period.split("-").map(Number);
  const year = late && m === 12 ? y + 1 : y;
  const month = late ? m === 12 ? 1 : m + 1 : m;
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return `${year}-${String(month).padStart(2, "0")}-${String(Math.min(payDay, lastDay)).padStart(2, "0")}`;
}
var LATE_SEND_LABEL = "Premia\xE7\xE3o lan\xE7ada fora do per\xEDodo, pagamento ser\xE1 efetuado no m\xEAs seguinte";
var AWARD_EXPENSE_STAGES = EXPENSE_FLOWS.premiacao.stages;
function brDate(iso) {
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}
var INTERNAL_AWARD_DAY = 11;
function internalLaunchOn(period) {
  return `${period.slice(0, 7)}-${String(INTERNAL_AWARD_DAY).padStart(2, "0")}`;
}
function internalLaunchRefusal(entry) {
  if (!entry.closed) return REOPENED_SEND;
  const on = internalLaunchOn(entry.period);
  if (entry.today < on) return `A premia\xE7\xE3o \xE9 lan\xE7ada no Financeiro em ${brDate(on)}.`;
  if (entry.payDay === null) {
    return "O dia de pagamento deste lote ainda n\xE3o foi definido nesta base. Fale com o Financeiro.";
  }
  if (!entry.hasBeneficiary) {
    return "Seus dados banc\xE1rios n\xE3o est\xE3o cadastrados, e a premia\xE7\xE3o n\xE3o pode ser lan\xE7ada. Fale com o Financeiro.";
  }
  return null;
}

// src/payment-stages.ts
var STAGE_COLORS = [
  "cinza",
  "azul",
  "ciano",
  "turquesa",
  "verde",
  "amarelo",
  "laranja",
  "vermelho",
  "rosa",
  "roxo"
];
var PAYMENT_STAGE_DEFAULT_COLORS = {
  // @valor
  aprovacao_financeiro: "azul",
  pendente: "laranja",
  aguardando_pagamento: "amarelo",
  pagamento_efetuado: "verde",
  pagamento_recusado: "vermelho"
};
var PAYMENT_STAGE_EVENT_TYPES = ["conta_a_pagar", "baixa", "situacao"];
var PAYMENT_STAGE_EVENT_RUNS = {
  // @valor
  conta_a_pagar: true,
  baixa: true,
  situacao: false
};
var PAYMENT_STAGE_EVENT_LABELS = {
  // @valor
  conta_a_pagar: "Lan\xE7ar conta a pagar",
  baixa: "Dar baixa",
  situacao: "Atualizar situa\xE7\xE3o"
};
var PAYMENT_STAGE_NAME_MAX = 60;
function resolvePaymentStages(saved, defaultNames) {
  return BOARD_STATUSES.map((status) => {
    const row = saved.find((s) => s.status === status);
    return row ? { status, name: row.name, color: row.color, customized: true } : {
      status,
      name: defaultNames[status],
      color: PAYMENT_STAGE_DEFAULT_COLORS[status],
      customized: false
    };
  });
}
function paymentStageRefusal(stages, status, input) {
  const name = input.name.trim();
  if (!name) return "Informe o nome da fase.";
  if (name.length > PAYMENT_STAGE_NAME_MAX) {
    return `O nome da fase tem no m\xE1ximo ${PAYMENT_STAGE_NAME_MAX} caracteres.`;
  }
  const key = name.toLocaleLowerCase("pt-BR");
  const taken = stages.some(
    (s) => s.status !== status && s.name.trim().toLocaleLowerCase("pt-BR") === key
  );
  if (taken) return "J\xE1 existe uma fase com esse nome neste quadro.";
  const seen = /* @__PURE__ */ new Set();
  for (const e of input.events) {
    const pair2 = `${e.type}\0${e.accountId}`;
    if (seen.has(pair2)) return "A fase tem o mesmo evento duas vezes para a mesma conta.";
    seen.add(pair2);
  }
  return null;
}

// src/useful-links.ts
var USEFUL_LINK_ICONS = [
  "documento",
  "livro",
  "calendario",
  "relogio",
  "dinheiro",
  "cobranca",
  "percentual",
  "grafico",
  "comercial",
  "carrinho",
  "etiqueta",
  "pessoa",
  "pessoas",
  "cracha",
  "telefone",
  "email",
  "demandas",
  "sino",
  "veiculo",
  "mapa",
  "escudo",
  "chave",
  "nuvem",
  "quadro",
  "grade",
  "erp",
  "gestao",
  "retencao",
  "plataforma",
  "bandeira",
  "imagem",
  "video",
  "camera",
  "clipe",
  "informacao",
  "inicio"
];
function usefulLinkUrl(raw) {
  const text = raw.trim();
  if (text === "") return null;
  const withProtocol = /^[a-z][a-z0-9+.-]*:/i.test(text) ? text : `https://${text}`;
  const match = /^(https?):\/\/([^\s/?#]+)(\S*)$/i.exec(withProtocol);
  if (!match) return null;
  const [, protocol, host, rest] = match;
  const hostname = host.replace(/:\d{1,5}$/, "");
  if (!/^[a-z0-9-]+(\.[a-z0-9-]+)*$/i.test(hostname)) return null;
  if (!hostname.includes(".") && hostname.toLowerCase() !== "localhost") return null;
  return `${protocol.toLowerCase()}://${host}${rest}`;
}

// src/sale-expenses.ts
var SALE_EXPENSES_DISABLED_REASON = "Pendente alinhar com o time respons\xE1vel do CRM da Evogard como as informa\xE7\xF5es ser\xE3o cadastradas em tempo real na plataforma.";
var SALE_EXPENSE_TYPES = [
  "indicacao",
  "proporcional_troca",
  "vistoria_extra",
  "inativo",
  "reembolso"
];
var SALE_EXPENSE_TYPE_LABELS = {
  indicacao: "Despesa de Indica\xE7\xE3o",
  proporcional_troca: "Despesa de Proporcional de Troca",
  vistoria_extra: "Despesa de Vistoria Extra",
  inativo: "Despesa de Inativo",
  reembolso: "Despesa de Reembolso"
};
var SALE_EXPENSE_TYPE_SHORT_LABELS = {
  indicacao: "Indica\xE7\xE3o",
  proporcional_troca: "Proporcional de troca",
  vistoria_extra: "Vistoria extra",
  inativo: "Inativo",
  reembolso: "Reembolso"
};
var SALE_EXPENSE_FORMS = {
  indicacao: {
    dateLabel: "Data da demanda",
    dateDefaultsToToday: true,
    personLabel: "Nome do indicador",
    personFromMember: false,
    amountLabel: "Valor da indica\xE7\xE3o",
    pix: true,
    contact: false,
    cancellationReason: false,
    attachmentLabel: "Comprovante"
  },
  proporcional_troca: {
    dateLabel: "Data da despesa",
    dateDefaultsToToday: true,
    personLabel: "Nome do associado",
    personFromMember: true,
    amountLabel: "Valor proporcional",
    pix: false,
    contact: false,
    cancellationReason: false,
    attachmentLabel: "Comprovante"
  },
  vistoria_extra: {
    dateLabel: "Data da demanda",
    dateDefaultsToToday: true,
    personLabel: "Nome do vistoriador",
    personFromMember: false,
    amountLabel: "Valor da vistoria",
    pix: true,
    contact: false,
    cancellationReason: false,
    attachmentLabel: "Comprovante"
  },
  inativo: {
    dateLabel: "Data da demanda",
    dateDefaultsToToday: true,
    personLabel: "Nome do associado",
    personFromMember: true,
    amountLabel: "Valor do inativo",
    pix: false,
    contact: false,
    cancellationReason: false,
    attachmentLabel: "Comprovante"
  },
  reembolso: {
    dateLabel: "Data da venda",
    dateDefaultsToToday: false,
    personLabel: "Nome",
    personFromMember: true,
    amountLabel: "Valor do reembolso",
    pix: true,
    contact: true,
    cancellationReason: true,
    attachmentLabel: "Comprovante de ades\xE3o"
  }
};
var SALE_EXPENSE_STATUSES = [
  "recebida",
  "em_conferencia",
  "pendente_correcao",
  "aguardando_pagamento",
  "paga"
];
var SALE_EXPENSE_STATUS_LABELS = {
  recebida: "Despesas Recebidas",
  em_conferencia: "Em Confer\xEAncia",
  pendente_correcao: "Pendente de Corre\xE7\xE3o",
  aguardando_pagamento: "Aguardando Pagamento",
  paga: "Pago"
};
var SALE_EXPENSE_STATUS_TONES = {
  recebida: "informacao",
  em_conferencia: "progresso",
  pendente_correcao: "alerta",
  aguardando_pagamento: "progresso",
  paga: "sucesso"
};
var SALE_EXPENSE_STATUS_COLORS = {
  recebida: "azul",
  em_conferencia: "roxo",
  pendente_correcao: "laranja",
  aguardando_pagamento: "amarelo",
  paga: "verde"
};
function resolveSaleExpenseStages(saved) {
  return SALE_EXPENSE_STATUSES.map((status) => {
    const row = saved.find((s) => s.status === status);
    return row ? { status, name: row.name, color: row.color, customized: true } : {
      status,
      name: SALE_EXPENSE_STATUS_LABELS[status],
      color: SALE_EXPENSE_STATUS_COLORS[status],
      customized: false
    };
  });
}
var SALE_EXPENSE_ACTS = ["conferir", "aprovar", "devolver", "corrigir", "pagar"];
var SALE_EXPENSE_MOVES = {
  conferir: ["recebida", "em_conferencia"],
  aprovar: ["em_conferencia", "aguardando_pagamento"],
  devolver: ["em_conferencia", "pendente_correcao"],
  corrigir: ["pendente_correcao", "em_conferencia"],
  pagar: ["aguardando_pagamento", "paga"]
};
var SALE_EXPENSE_ACT_ACTIONS = {
  conferir: "conferir",
  aprovar: "conferir",
  devolver: "devolver",
  corrigir: "lancar",
  pagar: "pagar"
};
function saleExpenseTransition(from, act) {
  const [a, b] = SALE_EXPENSE_MOVES[act];
  return a === from ? b : null;
}
function saleExpenseActFor(from, to) {
  for (const act of SALE_EXPENSE_ACTS) {
    if (act === "corrigir") continue;
    const [a, b] = SALE_EXPENSE_MOVES[act];
    if (a === from && b === to) return act;
  }
  return null;
}
var SALE_EXPENSE_TEXT_MAX = 200;
var SALE_EXPENSE_REASON_MAX = 2e3;
function checkSaleExpense(input) {
  const form = SALE_EXPENSE_FORMS[input.type];
  const errors = {};
  if (!/^\d{4}-\d{2}-\d{2}$/.test(input.referenceDate.trim())) {
    errors.referenceDate = `Informe a ${form.dateLabel.toLowerCase()}.`;
  }
  if (normalizePlate(input.plate) === null) {
    errors.plate = "Placa inv\xE1lida: use o padr\xE3o antigo (ABC1234) ou o Mercosul (ABC1D23).";
  }
  if (input.personName.trim() === "") {
    errors.personName = `Informe o ${form.personLabel.toLowerCase()}.`;
  } else if (input.personName.trim().length > SALE_EXPENSE_TEXT_MAX) {
    errors.personName = `At\xE9 ${SALE_EXPENSE_TEXT_MAX} caracteres.`;
  }
  if (input.amountCents === null || input.amountCents <= 0) {
    errors.amount = "Informe um valor maior que zero.";
  }
  if (form.pix) {
    if (input.pixKeyType === null) {
      if (input.pixKey.trim() === "") errors.pixKey = "Informe a chave PIX.";
    } else if (input.pixKeyType === "") {
      errors.pixKeyType = "Escolha o tipo da chave.";
    } else {
      const check = checkPixKey(input.pixKeyType, input.pixKey);
      if (!check.valid) errors.pixKey = check.message;
    }
    if (input.pixKey.trim().length > SALE_EXPENSE_TEXT_MAX) {
      errors.pixKey = `At\xE9 ${SALE_EXPENSE_TEXT_MAX} caracteres.`;
    }
    if (!/^\d{3}$/.test(input.pixBankCode.trim())) {
      errors.pixBankCode = "Escolha o banco de origem do PIX.";
    }
  }
  if (form.contact) {
    if (input.contact.trim() === "") errors.contact = "Informe o contato.";
    else if (input.contact.trim().length > SALE_EXPENSE_TEXT_MAX) {
      errors.contact = `At\xE9 ${SALE_EXPENSE_TEXT_MAX} caracteres.`;
    }
  }
  if (form.cancellationReason) {
    if (input.cancellationReason.trim().length < 3) {
      errors.cancellationReason = "Informe o motivo do cancelamento.";
    } else if (input.cancellationReason.trim().length > SALE_EXPENSE_REASON_MAX) {
      errors.cancellationReason = `At\xE9 ${SALE_EXPENSE_REASON_MAX} caracteres.`;
    }
  }
  return errors;
}
var MB = 1024 * 1024;
var SALE_EXPENSE_ATTACHMENT = {
  imageTypes: ["image/jpeg", "image/png", "image/webp"],
  imageMaxBytes: 8 * MB,
  pdfMaxBytes: 2 * MB,
  pdfMaxPages: 2
};
var SALE_EXPENSE_ATTACHMENT_HELP = "Foto (JPG, PNG ou WebP) at\xE9 8 MB, ou PDF de at\xE9 2 p\xE1ginas e 2 MB.";
function checkSaleExpenseAttachment(file) {
  const type = (file.typeMime.split(";")[0] ?? "").trim().toLowerCase();
  const a = SALE_EXPENSE_ATTACHMENT;
  if (a.imageTypes.includes(type)) {
    return file.sizeBytes > a.imageMaxBytes ? "A foto passa de 8 MB." : null;
  }
  if (type === "application/pdf") {
    if (file.sizeBytes > a.pdfMaxBytes) return "O PDF passa de 2 MB.";
    if (file.pages === null) {
      return "N\xE3o foi poss\xEDvel contar as p\xE1ginas deste PDF. Gere o arquivo de novo ou envie uma foto.";
    }
    if (file.pages !== void 0 && file.pages > a.pdfMaxPages) {
      return `O PDF tem ${file.pages} p\xE1ginas; o limite \xE9 ${a.pdfMaxPages}.`;
    }
    return null;
  }
  return "O anexo precisa ser uma foto (JPG, PNG ou WebP) ou um PDF.";
}

// src/technology-fee.ts
var TECHNOLOGY_FEE_LOTS = ["maior", "1x", "2x"];
var TECHNOLOGY_FEE_LOT_LABELS = {
  maior: "No maior lote (padr\xE3o)",
  "1x": "Sempre no lote 1x",
  "2x": "Sempre no lote 2x"
};
var TECHNOLOGY_FEE_DEFAULT_TIERS = [
  { from: fromReais(0), fee: fromReais(0) },
  { from: fromReais(500), fee: fromReais(50) },
  { from: fromReais(1e3), fee: fromReais(100) },
  { from: fromReais(2e3), fee: fromReais(200) },
  { from: fromReais(2500), fee: fromReais(250) }
];
function technologyFeeTiersRefusal(tiers) {
  if (tiers.length === 0) return "Cadastre ao menos uma faixa, a partir de R$ 0,00.";
  const sorted = [...tiers].sort((a, b) => compareMoney(a.from, b.from));
  if (sorted[0].from !== ZERO) {
    return "A primeira faixa precisa come\xE7ar em R$ 0,00 \u2014 sen\xE3o um lote pequeno fica sem faixa.";
  }
  for (let i = 0; i < sorted.length; i++) {
    const t = sorted[i];
    if (t.from < 0 || t.fee < 0) return "Faixa e taxa n\xE3o podem ser negativas.";
    if (i > 0 && t.from === sorted[i - 1].from) {
      return "Duas faixas come\xE7am no mesmo valor.";
    }
    if (t.fee > t.from) {
      return "A taxa de uma faixa n\xE3o pode passar do valor em que ela come\xE7a \u2014 o lote ficaria negativo.";
    }
  }
  return null;
}
function technologyFeeOf(tiers, amount) {
  let fee = ZERO;
  let floor = null;
  for (const t of tiers) {
    if (t.from <= amount && (floor === null || t.from > floor)) {
      floor = t.from;
      fee = t.fee;
    }
  }
  return fee;
}
function technologyFeeTarget(choice, totals) {
  if (choice !== "maior") return choice;
  return (totals["2x"] ?? ZERO) > (totals["1x"] ?? ZERO) ? "2x" : "1x";
}
function technologyFeeByLot({
  pays,
  choice,
  tiers,
  totals
}) {
  const fees = { "1x": ZERO, "2x": ZERO };
  if (!pays) return fees;
  const target = technologyFeeTarget(choice, totals);
  fees[target] = technologyFeeOf(tiers, totals[target] ?? ZERO);
  return fees;
}
function technologyFeeLine(fee, net) {
  if (fee.state === "faixas_nao_definidas") {
    return "As faixas desta pra\xE7a n\xE3o foram cadastradas \u2014 o valor acima \xE9 o apurado, sem desconto, e a nota n\xE3o pode ser enviada.";
  }
  if (fee.state !== "aplicada" || fee.amount === null) return null;
  const amount = fromColumn(fee.amount);
  if (amount === ZERO) return "sem desconto neste lote";
  const gross = sum(fromColumn(net), amount);
  return `\u2212 ${format(amount)}, j\xE1 descontada do apurado de ${format(gross)}`;
}

// src/sales.ts
var dateParts = businessDateParts;
function weekDay(data, caller) {
  const [year, month, day] = dateParts(data, caller);
  return new Date(Date.UTC(year, month - 1, day)).getUTCDay();
}
function sumDays(data, n, caller) {
  const [year, month, day] = dateParts(data, caller);
  return new Date(Date.UTC(year, month - 1, day + n)).toISOString().slice(0, 10);
}
function weekSunday(data, caller) {
  return sumDays(data, -weekDay(data, caller), caller);
}
function monthOf(data) {
  return data.slice(0, 7);
}
function isDayUtil(data, caller) {
  const d = weekDay(data, caller);
  return d >= 1 && d <= 5;
}
var PLATE_CLASSIFICATIONS = ["venda", "troca", "bronze", "reativacao"];
function plateClassificationOf(facts) {
  if (facts.canceled) return null;
  if (facts.adhesion === "desconhecida") return null;
  if (facts.bronze) return "bronze";
  if (facts.adhesion === "troca") return "troca";
  if (facts.adhesion === "reativacao" || facts.adhesion === "titularidade") {
    return "reativacao";
  }
  return "venda";
}
var RANKING_SEGMENTS = ["interno", "externo"];
var CONSULTANT_PROFILE_RULES = {
  /* Chaves CITADAS: são valores de `app.sales_consultant_profile`, dado
   * gravado, e por isso continuam em português — a régua da tradução cobra
   * identificador, e valor de enum não é um. */
  /*
   * `interno` e `externo` só diferem no quadro do ranking e no pagamento. O
   * resto é igual, e é pendência — ver "O que ela ainda NÃO carrega".
   */
  "interno": {
    targetCounts: ["venda"],
    ladder: "padrao",
    bonus: true,
    entersRanking: true,
    rankingSegment: "interno",
    invoiceRequired: false,
    awardLots: ["1x"],
    paysTechnologyFee: false
  },
  "externo": {
    targetCounts: ["venda"],
    ladder: "padrao",
    bonus: true,
    entersRanking: true,
    rankingSegment: "externo",
    invoiceRequired: true,
    awardLots: ["1x", "2x"],
    /* Só o externo paga a taxa de tecnologia (05/10/2026). */
    paysTechnologyFee: true
  },
  /*
   * Só reativação conta para a meta dela, e a P5 a mantém fora do ranking. As
   * duas coisas vêm da mesma leitura: quem vive de reativação medido pela
   * contagem do consultor comum aparece com realizado ~0 — uma afirmação sobre
   * o desempenho de uma pessoa que a casa sabe ser falsa.
   */
  "base_reativacao": {
    targetCounts: ["reativacao"],
    ladder: "reativacao",
    bonus: false,
    entersRanking: false,
    rankingSegment: null,
    /* O pagamento de hoje: nada em 25/09 mudou a base de reativação. */
    invoiceRequired: true,
    awardLots: ["1x", "2x"],
    paysTechnologyFee: false
  }
  /*
   * A anotação `Record<ConsultantProfile, ...>` está na declaração, e não como
   * `satisfies` no fim: as duas obrigam todo perfil a responder tudo, mas só a
   * anotação dá ao acesso por chave o tipo da INTERFACE. Com `satisfies`, cada
   * perfil guarda a sua tupla literal (`['venda']`, `['reativacao']`), e
   * `CONSULTANT_PROFILE_RULES[profile].targetCounts` com `profile` em união vira a
   * união das duas — cujo `.includes` pede a interseção dos elementos, que é
   * `never`. `countsForSalesTarget` não compilava.
   */
};
function checkTiers(tiers, which) {
  const floors = /* @__PURE__ */ new Set();
  for (const f of tiers) {
    if (!Number.isInteger(f.platesMin) || f.platesMin < 0) {
      throw new Error(
        `${which}: piso de faixa inv\xE1lido: ${String(f.platesMin)}. Placas s\xE3o inteiras e n\xE3o negativas.`
      );
    }
    if (f.amountPerPlate < 0) {
      throw new Error(`${which}: faixa com valor negativo no piso ${f.platesMin}.`);
    }
    if (floors.has(f.platesMin)) {
      throw new Error(
        `${which}: o piso ${f.platesMin} aparece duas vezes. A r\xE9gua ficaria amb\xEDgua.`
      );
    }
    floors.add(f.platesMin);
  }
}
function tierFor(plates, tiers) {
  let chosen = null;
  for (const f of tiers) {
    if (plates >= f.platesMin && (chosen === null || f.platesMin > chosen.platesMin)) {
      chosen = f;
    }
  }
  return chosen;
}
function settleCommission(periodPlates, profile, rule) {
  checkTiers(rule.tiers, "comissaoDaCompetencia (faixas)");
  checkTiers(
    rule.tenantDeReactivationTiers,
    "comissaoDaCompetencia (faixas da base de reativa\xE7\xE3o)"
  );
  if (rule.valueByPlateBronze < 0) {
    throw new Error("comissaoDaCompetencia: o valor da placa Bronze \xE9 negativo.");
  }
  const seen = /* @__PURE__ */ new Set();
  for (const p of periodPlates) {
    if (seen.has(p.reference)) {
      throw new Error(
        `comissaoDaCompetencia: a placa ${p.reference} aparece duas vezes na compet\xEAncia. Placa repetida empurra a faixa e paga o que ningu\xE9m vendeu.`
      );
    }
    seen.add(p.reference);
  }
  if (CONSULTANT_PROFILE_RULES[profile].ladder === "reativacao") {
    const counted2 = periodPlates.filter((p) => p.classification === "reativacao").length;
    const tier2 = tierFor(counted2, rule.tenantDeReactivationTiers);
    const platesValue2 = tier2 === null ? ZERO : multiply(tier2.amountPerPlate, counted2);
    return {
      profile,
      platesCounted: counted2,
      platesBronze: 0,
      platesIgnoradas: periodPlates.length - counted2,
      amountPerPlate: tier2 === null ? null : tier2.amountPerPlate,
      platesValue: platesValue2,
      bronzeValue: ZERO,
      total: platesValue2
    };
  }
  const countedList = periodPlates.filter((p) => p.classification !== "reativacao");
  const counted = countedList.length;
  const bronze = countedList.filter((p) => p.classification === "bronze").length;
  const tier = tierFor(counted, rule.tiers);
  const platesValue = tier === null ? ZERO : multiply(tier.amountPerPlate, counted - bronze);
  const bronzeValue = multiply(rule.valueByPlateBronze, bronze);
  return {
    profile,
    platesCounted: counted,
    platesBronze: bronze,
    platesIgnoradas: periodPlates.length - counted,
    amountPerPlate: tier === null ? null : tier.amountPerPlate,
    platesValue,
    bronzeValue,
    total: sum(platesValue, bronzeValue)
  };
}
function settleBonus(consultant, timeframe, rules) {
  const where = "bonificacaoDe";
  const [, , periodDay] = dateParts(timeframe.period, `${where} (compet\xEAncia)`);
  if (periodDay !== 1) {
    throw new Error(
      `${where}: compet\xEAncia precisa ser o primeiro dia do m\xEAs; veio ${timeframe.period}.`
    );
  }
  if (!CONSULTANT_PROFILE_RULES[consultant.profile].bonus) {
    return { response: "nao_se_aplica", reason: "perfil_base_reativacao", total: ZERO };
  }
  dateParts(timeframe.daysCobertos.de, `${where} (diasCobertos.de)`);
  dateParts(timeframe.daysCobertos.until, `${where} (diasCobertos.ate)`);
  if (timeframe.daysCobertos.until < timeframe.daysCobertos.de) {
    throw new Error(`${where}: diasCobertos com fim antes do in\xEDcio.`);
  }
  const byData = /* @__PURE__ */ new Map();
  for (const d of timeframe.days) {
    dateParts(d.data, `${where} (dias)`);
    if (!Number.isInteger(d.sales) || d.sales < 0) {
      throw new Error(
        `${where}: ${d.data} tem ${String(d.sales)} vendas. Vendas s\xE3o inteiras e n\xE3o negativas.`
      );
    }
    if (byData.has(d.data)) {
      throw new Error(
        `${where}: o dia ${d.data} aparece duas vezes. Dia repetido paga bloco di\xE1rio a mais.`
      );
    }
    if (d.data < timeframe.daysCobertos.de || d.data > timeframe.daysCobertos.until) {
      throw new Error(
        `${where}: o dia ${d.data} est\xE1 fora de diasCobertos. A cobertura declarada n\xE3o bate com os dias.`
      );
    }
    byData.set(d.data, d.sales);
  }
  const missingInputs = [];
  if (timeframe.daysCobertos.de > timeframe.period) {
    missingInputs.push(
      `dias do in\xEDcio da compet\xEAncia (cobertos a partir de ${timeframe.daysCobertos.de}, a compet\xEAncia come\xE7a em ${timeframe.period})`
    );
  }
  const lastSunday = monthLastSunday(timeframe.period, where);
  const lastWeekEnd = sumDays(lastSunday, 6, where);
  if (timeframe.daysCobertos.until < lastWeekEnd) {
    missingInputs.push(
      `dias at\xE9 ${lastWeekEnd} (a semana de ${lastSunday} pertence a esta compet\xEAncia e os dias s\xF3 v\xE3o at\xE9 ${timeframe.daysCobertos.until})`
    );
  }
  if (consultant.salesTarget.estado === "nao_informado") {
    missingInputs.push(
      `meta de vendas da compet\xEAncia (${consultant.salesTarget.because})`
    );
  }
  if (timeframe.trafficNoClosing.estado === "nao_informado") {
    missingInputs.push(
      `tr\xE1fego pago no fechamento (${timeframe.trafficNoClosing.because})`
    );
  }
  if (timeframe.referralsNoClosing.estado === "nao_informado") {
    missingInputs.push(
      `indica\xE7\xF5es no fechamento (${timeframe.referralsNoClosing.because})`
    );
  }
  if (timeframe.dayPlacementsNoTop.estado === "nao_informado") {
    missingInputs.push(
      `coloca\xE7\xF5es no top do dia (${timeframe.dayPlacementsNoTop.because})`
    );
  }
  if (timeframe.rulesCultural.estado === "nao_informado") {
    missingInputs.push(`regras culturais do m\xEAs (${timeframe.rulesCultural.because})`);
  }
  if (missingInputs.length > 0) {
    return { response: "nao_apuravel", missingInputs };
  }
  const target = valueKnown(consultant.salesTarget);
  const trafficNoClosing = valueKnown(timeframe.trafficNoClosing);
  const referralsNoClosing = valueKnown(timeframe.referralsNoClosing);
  const placements = valueKnown(timeframe.dayPlacementsNoTop);
  const cultural = valueKnown(timeframe.rulesCultural);
  const periodMonth = monthOf(timeframe.period);
  const monthSales = timeframe.days.filter((d) => monthOf(d.data) === periodMonth).reduce((t, d) => t + d.sales, 0);
  const portsReprovadas = [];
  if (timeframe.trafficPaidNoMonth < rules.eligibility.trafficPaidMin) {
    portsReprovadas.push("trafego_pago");
  }
  if (!consultant.portDeReferraldispensado && timeframe.referralsNoMonth < rules.eligibility.referralMin) {
    portsReprovadas.push("indicacao");
  }
  if (monthSales < target) {
    portsReprovadas.push("meta_pessoal");
  }
  const average = timeframe.netOperations > 0 ? cents(Math.ceil(timeframe.netSum / timeframe.netOperations)) : ZERO;
  const passedNoNet = average >= rules.eligibility.netMinAverage || timeframe.netOperations >= rules.eligibility.operationsMin;
  if (!passedNoNet) {
    portsReprovadas.push("media_do_liquido");
  }
  if (cultural.some((r) => !r.fulfilled)) {
    portsReprovadas.push("regra_cultural");
  }
  if (portsReprovadas.length > 0) {
    return { response: "inelegivel", portsReprovadas, total: ZERO };
  }
  if (!Number.isInteger(rules.daily.salesByBlock) || rules.daily.salesByBlock <= 0) {
    throw new Error(
      `${where}: vendasPorBloco inv\xE1lido: ${String(rules.daily.salesByBlock)}.`
    );
  }
  const blocks = timeframe.days.filter((d) => monthOf(d.data) === periodMonth).reduce((t, d) => t + Math.floor(d.sales / rules.daily.salesByBlock), 0);
  const daily = multiply(rules.daily.valueByBlock, blocks);
  const byWeek = /* @__PURE__ */ new Map();
  for (const d of timeframe.days) {
    const sunday = weekSunday(d.data, where);
    byWeek.set(sunday, (byWeek.get(sunday) ?? 0) + d.sales);
  }
  let weekly = ZERO;
  for (const [sunday, sales] of byWeek) {
    if (monthOf(sunday) !== periodMonth) continue;
    for (const f of rules.weekly) {
      if (sales >= f.salesMin) weekly = sum(weekly, f.value);
    }
  }
  let monthly = ZERO;
  let floorMonthly = -1;
  for (const f of rules.monthly) {
    if (monthSales >= f.salesMin && f.salesMin > floorMonthly) {
      floorMonthly = f.salesMin;
      monthly = f.value;
    }
  }
  let daytop = ZERO;
  const daysAlreadyPremiados = /* @__PURE__ */ new Set();
  for (const c of placements) {
    dateParts(c.data, `${where} (coloca\xE7\xF5es)`);
    if (daysAlreadyPremiados.has(c.data)) {
      throw new Error(
        `${where}: duas coloca\xE7\xF5es no mesmo dia (${c.data}) para o mesmo consultor.`
      );
    }
    daysAlreadyPremiados.add(c.data);
    if (monthOf(c.data) !== periodMonth) {
      throw new Error(
        `${where}: coloca\xE7\xE3o em ${c.data}, fora da compet\xEAncia ${timeframe.period}.`
      );
    }
    if (!isDayUtil(c.data, where)) {
      throw new Error(
        `${where}: coloca\xE7\xE3o em ${c.data}, que n\xE3o \xE9 dia \xFAtil. O top do dia \xE9 de segunda a sexta.`
      );
    }
    const rule = rules.daytop.find((r) => r.position === c.position);
    if (rule === void 0) {
      throw new Error(
        `${where}: coloca\xE7\xE3o na posi\xE7\xE3o ${c.position} em ${c.data}, e n\xE3o h\xE1 regra para essa posi\xE7\xE3o.`
      );
    }
    const daySales = byData.get(c.data);
    if (daySales === void 0) {
      throw new Error(
        `${where}: coloca\xE7\xE3o em ${c.data} e nenhuma venda do consultor nesse dia.`
      );
    }
    if (daySales >= rule.salesMin) {
      daytop = sum(daytop, rule.value);
    }
  }
  const sniper = trafficNoClosing >= rules.sniper.salesMin ? rules.sniper.value : ZERO;
  const highPerformance = referralsNoClosing >= rules.highPerformance.salesMin ? rules.highPerformance.value : ZERO;
  const installments = {
    daily,
    weekly,
    monthly,
    daytop,
    sniper,
    highPerformance
  };
  return {
    response: "apurada_sem_a_quinzena",
    installments,
    total: sum(daily, weekly, monthly, daytop, sniper, highPerformance)
  };
}
function valueKnown(input) {
  if (input.estado === "nao_informado") {
    throw new Error("bonificacaoDe: insumo n\xE3o informado alcan\xE7ou o c\xE1lculo.");
  }
  return input.value;
}
function monthLastSunday(period, where) {
  const [year, month] = dateParts(period, where);
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const last = `${period.slice(0, 8)}${String(lastDay).padStart(2, "0")}`;
  return weekSunday(last, where);
}
var RANKING_COUNTINGS = ["venda_troca_bronze"];
var RANKING_COUNTING = "venda_troca_bronze";
var RANKING_ORDERS = ["quantidade", "faturamento"];
function entersRanking(profile) {
  return CONSULTANT_PROFILE_RULES[profile].entersRanking;
}
function rankingSegmentOf(profile) {
  return CONSULTANT_PROFILE_RULES[profile].rankingSegment;
}
function seesConsultant(viewer, target) {
  if (viewer === null) return true;
  return target !== null && rankingSegmentOf(target) === viewer;
}
function countsForRanking(classification) {
  return classification !== "reativacao";
}
function rankingTallyOf(plates) {
  const seen = /* @__PURE__ */ new Set();
  for (const p of plates) {
    if (seen.has(p.reference)) {
      throw new Error(
        `rankingTallyOf: a placa ${p.reference} aparece duas vezes na compet\xEAncia. Placa repetida p\xF5e algu\xE9m em primeiro lugar por uma venda que n\xE3o existe.`
      );
    }
    seen.add(p.reference);
  }
  const counted = plates.filter((p) => countsForRanking(p.classification));
  const withoutAmount = counted.filter((p) => p.amount === null).length;
  return {
    achieved: counted.length,
    /* Ver `RankingTally.value`: a soma parcial não sai daqui como se fosse a soma. */
    value: withoutAmount > 0 ? null : sum(...counted.map((p) => p.amount)),
    ignored: plates.length - counted.length,
    withoutAmount
  };
}
function platesByClassification(plates) {
  const counts = Object.fromEntries(
    PLATE_CLASSIFICATIONS.map((c) => [c, 0])
  );
  for (const plate of plates) counts[plate.classification] += 1;
  return counts;
}
function positionInRanking(entries, order) {
  const keys = /* @__PURE__ */ new Set();
  for (const e of entries) {
    if (keys.has(e.key)) {
      throw new Error(
        `positionInRanking: a chave de desempate ${e.key} aparece duas vezes. Ela precisa ser \xFAnica para a ordem ser a mesma em dois carregamentos.`
      );
    }
    keys.add(e.key);
  }
  const ordered = [...entries].sort(
    (a, b) => order === "quantidade" ? b.achieved - a.achieved || compareMoney(b.value, a.value) || a.key.localeCompare(b.key) : compareMoney(b.value, a.value) || b.achieved - a.achieved || a.key.localeCompare(b.key)
  );
  const places = [];
  for (const [index, entry] of ordered.entries()) {
    const previous = places[index - 1];
    const tied = previous !== void 0 && previous.achieved === entry.achieved && previous.value === entry.value;
    places.push({ ...entry, position: tied ? previous.position : index + 1 });
  }
  return places;
}
function rankingPodiumOf(entries) {
  const byPlace = /* @__PURE__ */ new Map();
  for (const entry of entries) {
    const group = byPlace.get(entry.position);
    if (group) group.push(entry);
    else byPlace.set(entry.position, [entry]);
  }
  const alone = (place2) => {
    const group = byPlace.get(place2);
    return group?.length === 1 ? group[0] : void 0;
  };
  const first = alone(1);
  if (!first || first.achieved === 0) return null;
  const steps = [first];
  for (const place2 of [2, 3]) {
    const next = alone(place2);
    if (!next) break;
    steps.push(next);
  }
  return steps;
}
function countsForSalesTarget(classification, profile) {
  return CONSULTANT_PROFILE_RULES[profile].targetCounts.includes(classification);
}
function salesTargetTallyOf(plates, profile) {
  const seen = /* @__PURE__ */ new Set();
  for (const p of plates) {
    if (seen.has(p.reference)) {
      throw new Error(
        `salesTargetTallyOf: a placa ${p.reference} aparece duas vezes na compet\xEAncia. Placa repetida faz algu\xE9m bater uma meta que n\xE3o bateu.`
      );
    }
    seen.add(p.reference);
  }
  const counted = plates.filter((p) => countsForSalesTarget(p.classification, profile));
  const withoutAmount = counted.filter((p) => p.amount === null).length;
  return {
    achieved: counted.length,
    /*
     * Uma placa sem valor torna a SOMA desconhecida, e não menor. O `sum` das
     * que têm sairia daqui parecendo o realizado da competência — e a meta
     * apareceria mais longe do que está, sem nada dizendo por quê.
     */
    value: withoutAmount > 0 ? null : sum(...counted.map((p) => p.amount)),
    ignored: plates.length - counted.length,
    withoutAmount
  };
}
function salesTargetProgressOf(target, achieved) {
  if (target.quantity !== null && target.quantity > 0) {
    return {
      dimension: "quantidade",
      achieved: achieved.quantity,
      target: target.quantity,
      ratio: achieved.quantity / target.quantity
    };
  }
  if (target.value !== null && target.value > 0) {
    return {
      dimension: "valor",
      achieved: achieved.value,
      target: target.value,
      ratio: achieved.value / target.value
    };
  }
  return null;
}
function canSeeRankingSales(reach, viewerTeamId, targetTeamId) {
  if (reach.any) return true;
  if (!reach.team) return false;
  return viewerTeamId !== null && viewerTeamId === targetTeamId;
}

// src/contaazul-catalog.ts
var CONTAAZUL_CATALOGS = {
  /* Cobertura Total — resolvido em 26/10/2026. */
  ce: {
    categories: [
      {
        id: "0d487ae2-6181-467d-a8bf-e5d4c5364e60",
        name: "Assist\xEAncia 24 Horas \u2014 Residencial \u2014 Chaveiro - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "5c8c272c-cb4a-4665-8458-235a34112b1e",
        name: "Assist\xEAncia 24 Horas \u2014 Residencial \u2014 Desentupimento - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "63d84672-547f-42a4-9d15-d82e0dc1f701",
        name: "Assist\xEAncia 24 Horas \u2014 Residencial \u2014 Eletricista - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "c2038325-6027-413c-b98c-144b3c72348b",
        name: "Assist\xEAncia 24 Horas \u2014 Residencial \u2014 Encanador - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "9e97b868-95df-4440-9a88-96c58a4b51fa",
        name: "Assist\xEAncia 24 Horas \u2014 Residencial \u2014 Limpeza de Ar Condicionado - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "65b38776-11ed-47d1-ac2d-cd4fda4440e7",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Carga de Bateria - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "f7da3fce-220b-4a60-aa2c-680a6319ad4f",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Chaveiro - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "f81d6e56-f8b3-4f15-a2b3-0ec74f3a201e",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Hospedagem Emergencial - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "fe45deff-2a8c-48d6-b3af-4d36747c8c72",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Motorista Substituto - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "9c51caa1-8bb9-4932-94c9-0be89eab9133",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Outros Servi\xE7os de Assist\xEAncia - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "f3b7fa68-fa52-43af-ba0c-58c1faa4ad3f",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Pane Seca - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "746dec2a-6fa5-44ed-bdb7-8c689ae97c7e",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Reboque para Terceiro - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "b749979c-8f8b-4182-8ebf-fb99cf94a9d9",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Reboque por Pane - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "131d434e-7d74-44b4-9dd7-2aa6a6c4ab44",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Reboque por Sinistro (Associado) - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "8526a8a7-3146-4077-a6f2-4ebf29a5f2c8",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Transporte Alternativo (T\xE1xi) - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "eaba7c3c-ffa6-43a1-bc08-bb1ae855c51f",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Troca de Pneu - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "1045e535-dde0-4ca0-930a-224616c99479",
        name: "Assist\xEAncia 24 Horas \u2014 Sistema - Cobertura Total",
        group: "assistencia"
      },
      {
        id: "72f93554-ba90-45ed-8b1c-6ad82f6b50a9",
        name: "An\xE1lise e Sindic\xE2ncia \u2014 Deslocamentos e Dilig\xEAncias - Cobertura Total",
        group: "analise"
      },
      {
        id: "2b2f263f-bb8b-4db9-b989-03d50bb11fb7",
        name: "An\xE1lise e Sindic\xE2ncia \u2014 Laudos e Per\xEDcias \u2014 Associado - Cobertura Total",
        group: "analise"
      },
      {
        id: "f99c3ffc-d09b-4a75-a137-24b5b8afb900",
        name: "An\xE1lise e Sindic\xE2ncia \u2014 Laudos e Per\xEDcias \u2014 Terceiro - Cobertura Total",
        group: "analise"
      },
      {
        id: "ed1d0c16-6a2d-4b9d-8ee4-b41cda306035",
        name: "An\xE1lise e Sindic\xE2ncia \u2014 Reboque - Cobertura Total",
        group: "analise"
      },
      {
        id: "1b88382b-48c4-4121-b04b-87b27d0062d6",
        name: "An\xE1lise e Sindic\xE2ncia \u2014 Sindicante (PF/PJ) - Cobertura Total",
        group: "analise"
      },
      {
        id: "145d2be7-4cca-4eab-9b2c-800476c1c00c",
        name: "An\xE1lise e Sindic\xE2ncia \u2014 Sistema - Cobertura Total",
        group: "analise"
      },
      {
        id: "70410620-7646-4182-899f-8569945b1aac",
        name: "Reparo \u2014 Acordo \u2014 Associado - Cobertura Total",
        group: "reparo"
      },
      {
        id: "d8d59887-4b43-4ee2-a2fa-6fb323372394",
        name: "Reparo \u2014 Acordo \u2014 Terceiro - Cobertura Total",
        group: "reparo"
      },
      {
        id: "3c49ff1b-70dd-4769-8b4a-4c83ec689a81",
        name: "Reparo \u2014 Aux\xEDlio GARD \u2014 Associado - Cobertura Total",
        group: "reparo"
      },
      {
        id: "25d1bf35-7a8c-4095-9872-46ae981ed508",
        name: "Reparo \u2014 Aux\xEDlio GARD \u2014 Terceiro - Cobertura Total",
        group: "reparo"
      },
      {
        id: "b640fe2b-218e-49d0-a9da-8066cee9c30f",
        name: "Reparo \u2014 Carro Reserva \u2014 Associado - Cobertura Total",
        group: "reparo"
      },
      {
        id: "94e624ee-8f52-4244-964a-4c1301431742",
        name: "Reparo \u2014 Carro Reserva \u2014 Terceiro - Cobertura Total",
        group: "reparo"
      },
      {
        id: "b0a9fb2c-1522-438a-9e24-abf834d580a2",
        name: "Reparo \u2014 Deslocamentos e Dilig\xEAncias - Cobertura Total",
        group: "reparo"
      },
      {
        id: "f81ec1e2-35e6-4941-af92-6bee62c9095b",
        name: "Reparo \u2014 Oficina \u2014 Associado - Cobertura Total",
        group: "reparo"
      },
      {
        id: "5789f178-e137-4dcb-9104-9a6b0aa1e42c",
        name: "Reparo \u2014 Oficina \u2014 Terceiro - Cobertura Total",
        group: "reparo"
      },
      {
        id: "7024a27c-05b4-42c9-8a85-e92924b9e75b",
        name: "Reparo \u2014 Pe\xE7as \u2014 Associado - Cobertura Total",
        group: "reparo"
      },
      {
        id: "751fbda0-d0fb-47ab-be9e-e11ae44c1a11",
        name: "Reparo \u2014 Pe\xE7as \u2014 Terceiro - Cobertura Total",
        group: "reparo"
      },
      {
        id: "086d7aca-b0b5-40c8-942c-16531b96e8d7",
        name: "Reparo \u2014 Reboque \u2014 Associado - Cobertura Total",
        group: "reparo"
      },
      {
        id: "f47eb4e2-d7b4-4ef5-a6a7-03f45665b1af",
        name: "Reparo \u2014 Reboque \u2014 Terceiro - Cobertura Total",
        group: "reparo"
      },
      {
        id: "65c98edb-ba33-4af5-96f8-511e3e916ad7",
        name: "Reparo \u2014 Sistema - Cobertura Total",
        group: "reparo"
      },
      {
        id: "78d8112c-76da-4d15-a460-aa922960fe1c",
        name: "Indeniza\xE7\xE3o \u2014 D\xE9bitos (IPVA, Licenc., Multas, D\xEDvida Ativa, Gravame) - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "535e590f-bad3-42f5-acfa-c80fd1f522d1",
        name: "Indeniza\xE7\xE3o  \u2014 Declara\xE7\xE3o \u2014 Reconhecimento de Assinaturas - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "78373768-a45e-4218-9666-c3a77998abe3",
        name: "Indeniza\xE7\xE3o \u2014 DUT Eletr\xF4nico - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "bbc3a98b-3fc7-436f-807f-49e74f54f46c",
        name: "Indeniza\xE7\xE3o  \u2014 Quita\xE7\xE3o de Ve\xEDculo - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "f2fefd9d-3e38-43ee-bf04-bae6ef5003a4",
        name: "Indeniza\xE7\xE3o \u2014 Pagamento Final \u2014 Associado - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "616bb864-adbf-46d5-a0fe-12fff2821219",
        name: "Indeniza\xE7\xE3o \u2014 Pagamento Final \u2014 Terceiro - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "00ef9ac2-7f78-4dca-82da-9398d984e719",
        name: "Indeniza\xE7\xE3o \u2014 Reboque \u2014 Base a Base - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "f601d830-c491-486a-80b8-f3f7ae58ba48",
        name: "Indeniza\xE7\xE3o \u2014 Recupera\xE7\xE3o \u2014 Deslocamentos e Dilig\xEAncias - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "d1961c4d-b88a-4ad7-aac8-18822638788a",
        name: "Indeniza\xE7\xE3o \u2014 Recuperados de Roubo \u2014 Advogado/Dilig\xEAncias - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "097dafba-689e-4efa-8234-1065390855aa",
        name: "Indeniza\xE7\xE3o \u2014 Recuperados de Roubo \u2014 D\xE9bitos a Regularizar - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "7d57a3cd-5089-4c96-9df9-d6cc6dc72465",
        name: "Indeniza\xE7\xE3o \u2014 Recuperados de Roubo \u2014 Despachante - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "83be8dfe-f3b9-4a53-89d5-2ec18418097d",
        name: "Indeniza\xE7\xE3o \u2014 Recuperados de Roubo \u2014 DUT Eletr\xF4nico (Frota) - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "b9a049aa-8a84-443f-aa1a-3e2a28976bdc",
        name: "Indeniza\xE7\xE3o \u2014 Recuperados de Roubo \u2014 Reboque (Delegacia/Detran) - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "b8991c09-a018-4e6f-a148-a873f055604c",
        name: "Indeniza\xE7\xE3o \u2014 Despachante \u2014 Servi\xE7o - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "6132e530-8570-4440-a80b-a9371d03d613",
        name: "Indeniza\xE7\xE3o  \u2014 Regulariza\xE7\xE3o \u2014 Taxas e Despachantes - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "19279ba6-90e2-4e49-8878-4ef6c7b53852",
        name: "Indeniza\xE7\xE3o\u2014 Sistema - Cobertura Total",
        group: "indenizacao"
      },
      {
        id: "319537fb-e54e-4b0c-a8aa-3d8fd764d736",
        name: "Perif\xE9ricos e Benef\xEDcios \u2014 Aux\xEDlio de Prote\xE7\xE3o \xE0 Vida - Cobertura Total",
        group: "perifericos"
      },
      {
        id: "e4122702-be90-4501-ac2b-637dbfa7f1bb",
        name: "Perif\xE9ricos e Benef\xEDcios \u2014 Aux\xEDlio GARD - Cobertura Total",
        group: "perifericos"
      },
      {
        id: "f96930ce-3a25-4f9e-9138-94fe4231c2a0",
        name: "Perif\xE9ricos e Benef\xEDcios \u2014 Carro Reserva - Cobertura Total",
        group: "perifericos"
      },
      {
        id: "5eadd26c-3e61-422d-9d2f-0187eafff64f",
        name: "Perif\xE9ricos e Benef\xEDcios \u2014 Perif\xE9ricos (Demais) - Cobertura Total",
        group: "perifericos"
      },
      {
        id: "65371816-7c1e-479d-91cc-55cf7ed71a22",
        name: "Perif\xE9ricos e Benef\xEDcios \u2014Sistema - Cobertura Total",
        group: "perifericos"
      },
      {
        id: "3edcfcaf-fb78-411c-9496-896e4ee130a7",
        name: "Administrativo \u2014 Log\xEDstica \u2014 Custo com Frota - Cobertura Total",
        group: "geral"
      },
      {
        id: "9a1d84a9-0462-4626-a5f4-7cd63598abbc",
        name: "Administrativo \u2014 Sistema - Cobertura Total",
        group: "geral"
      },
      {
        id: "d3bf9713-65b2-4376-99de-76e742112078",
        name: "Outras Despesas de Sinistro \u2014 Avarias Causadas por Fornecedores - Cobertura Total",
        group: "geral"
      }
    ],
    costCenters: [
      { id: "d7b198f6-3acf-11ef-95d8-9742f5c59d93", name: "PROTE\xC7\xC3O AUTO" },
      { id: "ed7eee68-3acf-11ef-a65f-27bd9d3da782", name: "PLANO BEAUTY" },
      { id: "f4310dd6-3acf-11ef-8c45-3f25e916b6f9", name: "PLANO PROGRAMADO" },
      { id: "fd247202-3acf-11ef-9482-d701e259e06a", name: "INVESTIMENTO" },
      { id: "053f589e-3ad0-11ef-ab5b-fbe7306a4c09", name: "EVOGARD PAY" },
      { id: "0bc97cee-3ad0-11ef-a2af-6be9dc161f87", name: "CUSTOS COMPARTILHADOS" },
      { id: "1ffbd6c6-3ad0-11ef-a552-cb6febf71305", name: "CLINICA" },
      { id: "b223c842-3ad0-11ef-ae88-43d5ab987905", name: "BANCO - CASH" },
      { id: "b6411a6a-3ad0-11ef-95ac-c3aebdd1511f", name: "CONQUIZ" },
      { id: "be397fdc-3ad0-11ef-a6bf-0b21691a571c", name: "TRANSFER\xCANCIAS" }
    ],
    paymentAccounts: [
      { id: "8944c2b2-38d5-4f77-8f2f-a4c50c704d6e", name: "teste" },
      {
        id: "0a88b9ca-071a-4732-a2f9-122d3aa96358",
        name: "01 - Ita\xFA - Associa\xE7\xE3o - 1589 31700-5"
      },
      {
        id: "5ba6c7b4-5073-4ba9-bee6-1a4fc78fd0e7",
        name: "02.1 - Aplica\xE7\xE3o Santander - Associa\xE7\xE3o -"
      },
      {
        id: "455da984-0db3-45de-a6b8-d038612cc688",
        name: "02 - Santander - Associa\xE7\xE3o -"
      },
      { id: "09fa89f5-8fb1-4f8d-be72-1884ad8febfd", name: "03 - Bradesco- Associa\xE7\xE3o" },
      { id: "948dcc16-11d1-4e99-8533-c7d2cde166fd", name: "04- Stone - Associa\xE7\xE3o" },
      {
        id: "61ca7db4-2242-40d0-aa0e-c6d68e382591",
        name: "05- Hinova Pay -  Associa\xE7\xE3o"
      },
      {
        id: "e729b8ed-94be-4e07-8661-c0c37cf997af",
        name: "Itau - Assist\xEAncia 24 horas -  1589 99252-6"
      },
      {
        id: "cb0f95dc-b1b2-4a2d-898e-ea5f974b60b4",
        name: "Ita\xFA- Sinistro - Associa\xE7\xE3o- 1589 99210-4"
      }
    ]
  },
  /* Meu Veículo — resolvido em 26/10/2026. */
  go: {
    categories: [
      {
        id: "a7122040-ec06-4a17-bfc8-4c57b1979746",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Carga de Bateria - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "a33652b9-8b36-4954-a5fe-1abc4b4426fa",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Chaveiro - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "379732de-1b61-492b-a11d-6ceb86dbb756",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Hospedagem Emergencial - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "8ff7532f-1348-4100-bdf2-04a653394683",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Motorista Substituto - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "713dae77-717c-4d48-9770-0123249830f5",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Outros Servi\xE7os de Assist\xEAncia - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "fbd7855f-9512-4be9-b5fc-eda1744bbd3a",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Pane Seca - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "de674a03-e88a-4d1c-94b8-cf93971647cb",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Reboque para Terceiro - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "07e44f77-a2f0-4f3a-9acc-474c495121f2",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Reboque por Pane - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "a9c94718-16e3-4169-92a5-c5d925d25b9e",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Reboque por Sinistro (Associado) - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "36fd3721-0cec-45f3-a461-ddc620e97b14",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Transporte Alternativo (T\xE1xi) - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "c1fe5378-9e78-4c1a-b342-dded903e7fa0",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Troca de Pneu - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "9e3da8d8-fbf2-4c0a-b668-51622367d002",
        name: "Assist\xEAncia 24 Horas \u2014 Veicular \u2014 Sistema - Meu ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "8cc0a0e1-c35d-486e-a78d-27cb243bcf98",
        name: "Assist\xEAncia 24 Horas \u2014 Residencial \u2014 Chaveiro - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "7b706e1d-c745-44df-b969-bc485db2600a",
        name: "Assist\xEAncia 24 Horas \u2014 Residencial \u2014 Desentupimento - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "74396e95-6de7-485c-920c-80e09a606ad3",
        name: "Assist\xEAncia 24 Horas \u2014 Residencial \u2014 Eletricista - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "d1f30ccb-bd8b-44ac-b4b6-eb57b1f371b1",
        name: "Assist\xEAncia 24 Horas \u2014 Residencial \u2014 Encanador - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "d2ed97f7-4070-4b9f-b3eb-297f1294d99b",
        name: "Assist\xEAncia 24 Horas \u2014 Residencial \u2014 Limpeza de Ar Condicionado - Meu Ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "5c3d3389-f020-43e0-8c74-5a65114be3cf",
        name: "Assist\xEAncia 24 Horas \u2014 Residencial \u2014 Sistema - Meu ve\xEDculo",
        group: "assistencia"
      },
      {
        id: "91fcf9fb-f971-49d0-ad6e-6da2e9674f80",
        name: "An\xE1lise e Sindic\xE2ncia \u2014 Deslocamentos e Dilig\xEAncias - Meu Ve\xEDculo",
        group: "analise"
      },
      {
        id: "8bcaa890-9986-4d54-841f-fec692accaa8",
        name: "An\xE1lise e Sindic\xE2ncia \u2014 Laudos e Per\xEDcias \u2014 Associado - Meu Ve\xEDculo",
        group: "analise"
      },
      {
        id: "98520af4-2bb6-44e5-a223-75621af9f229",
        name: "An\xE1lise e Sindic\xE2ncia \u2014 Laudos e Per\xEDcias \u2014 Terceiro - Meu Ve\xEDculo",
        group: "analise"
      },
      {
        id: "1349a2ea-eacf-45bd-891e-1c5e6b9c89ec",
        name: "An\xE1lise e Sindic\xE2ncia \u2014 Reboque - Meu Ve\xEDculo",
        group: "analise"
      },
      {
        id: "4e36b5a2-5970-4d72-93a6-1400395622a2",
        name: "An\xE1lise e Sindic\xE2ncia \u2014 Sindicante (PF/PJ) - Meu Ve\xEDculo",
        group: "analise"
      },
      {
        id: "c6f28ce5-d871-445c-aa8e-ef8fe891c753",
        name: "An\xE1lise e Sindic\xE2ncia \u2014 Sistema - Meu ve\xEDculo",
        group: "analise"
      },
      {
        id: "590a5a01-cb44-4bfb-8e0d-9fdd31592d27",
        name: "Reparo \u2014 Acordo \u2014 Associado - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "296f6a67-d1ef-4940-9e69-1d4a28fe7cb2",
        name: "Reparo \u2014 Acordo \u2014 Terceiro - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "9003093f-a67a-4b2e-8814-a036b139173f",
        name: "Reparo \u2014 Aux\xEDlio GARD \u2014 Associado - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "f36e98e7-0039-42e4-87d0-302038243250",
        name: "Reparo \u2014 Aux\xEDlio GARD \u2014 Terceiro - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "a733350b-5d53-4826-867e-d09319b4dbe9",
        name: "Reparo \u2014 Carro Reserva \u2014 Associado - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "7f1c9e33-76be-4d39-ba30-da342f8dc2d8",
        name: "Reparo \u2014 Carro Reserva \u2014 Terceiro - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "edd76699-b38b-4a14-9ca2-a2905d8f3d54",
        name: "Reparo \u2014 Deslocamentos e Dilig\xEAncias - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "207d954d-629f-4d77-b6e9-6de63f708154",
        name: "Reparo \u2014 Oficina \u2014 Associado - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "3e625d53-97cb-4cfe-af33-8d99591fcca5",
        name: "Reparo \u2014 Oficina \u2014 Terceiro - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "04268c47-3ae5-445f-9f57-9c6fa300afed",
        name: "Reparo \u2014 Pe\xE7as \u2014 Associado - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "bda15b61-c3f1-49f1-b0bc-6397875349dd",
        name: "Reparo \u2014 Pe\xE7as \u2014 Terceiro - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "5da1387f-03ff-402a-9564-6fbe840d2ee4",
        name: "Reparo \u2014 Reboque \u2014 Associado - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "b2a4ca27-3043-4e93-9581-e1a97de9250b",
        name: "Reparo \u2014 Reboque \u2014 Terceiro - Meu Ve\xEDculo",
        group: "reparo"
      },
      {
        id: "b37ed546-5000-4092-a471-703ddfbf84c9",
        name: "Reparo \u2014 Sistema - Meu ve\xEDculo",
        group: "reparo"
      },
      {
        id: "e942f802-b4b2-40c6-809c-afb14dc8787b",
        name: "Indeniza\xE7\xE3o \u2014 D\xE9bitos (IPVA, Licenc., Multas, D\xEDvida Ativa, Gravame) - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "8b5bbf6d-7253-4ad6-a609-df7488e99f65",
        name: "Indeniza\xE7\xE3o \u2014 Declara\xE7\xE3o \u2014 Reconhecimento de Assinaturas - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "259f6ffc-59d1-405c-9be5-f11cb1951c1a",
        name: "Indeniza\xE7\xE3o \u2014 Despachante \u2014 Servi\xE7o - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "09180d4c-2d0d-4123-9a8c-9b0c2a3d585b",
        name: "Indeniza\xE7\xE3o \u2014 DUT Eletr\xF4nico - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "7166cf32-2d80-4d60-b2c3-1fc9457fd45a",
        name: "Indeniza\xE7\xE3o \u2014 Quita\xE7\xE3o de Ve\xEDculo - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "2d1eac64-aa52-4aee-91de-12c2979f6766",
        name: "Indeniza\xE7\xE3o - Pagamento Final - Associado - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "14616aeb-faf4-4c22-8112-02246607db89",
        name: "Indeniza\xE7\xE3o -  Pagamento Final - Terceiros - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "76ab7559-9962-4a9f-992d-49d6e5299890",
        name: "Indeniza\xE7\xE3o \u2014 Reboque \u2014 Base a Base - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "4c47c450-e085-4222-adbf-b4d0591e5664",
        name: "Indeniza\xE7\xE3o \u2014 Recupera\xE7\xE3o \u2014 Deslocamentos e Dilig\xEAncias - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "db1714b3-938e-4e23-8e92-c147de0c6aee",
        name: "Indeniza\xE7\xE3o \u2014 Recuperados de Roubo \u2014 Advogado/Dilig\xEAncias - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "a91a540c-bd36-4a10-88cf-b07fd6aafc65",
        name: "Indeniza\xE7\xE3o \u2014 Recuperados de Roubo \u2014 D\xE9bitos a Regularizar - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "2cba421b-3384-45bd-b1be-733eb6ecde5d",
        name: "Indeniza\xE7\xE3o \u2014 Recuperados de Roubo \u2014 Despachante - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "208abed0-b480-4aa4-9cf8-60ba7bffd110",
        name: "Indeniza\xE7\xE3o \u2014 Recuperados de Roubo \u2014 DUT Eletr\xF4nico (Frota) - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "86a2e989-5671-4b35-b066-d8dfbf173235",
        name: "Indeniza\xE7\xE3o \u2014 Recuperados de Roubo \u2014 Reboque (Delegacia/Detran) - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "46e9ce07-31f8-48aa-8812-005b37a2c39d",
        name: "Indeniza\xE7\xE3o \u2014 Regulariza\xE7\xE3o \u2014 Taxas e Despachantes - Meu Ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "d9e6558c-7968-4426-8059-e0c58983cf5b",
        name: "Indeniza\xE7\xE3o \u2014 Sistema - Meu ve\xEDculo",
        group: "indenizacao"
      },
      {
        id: "6df47948-c01e-476b-bf39-ce01843421ff",
        name: "Perif\xE9ricos e Benef\xEDcios \u2014 Aux\xEDlio de Prote\xE7\xE3o \xE0 Vida - Meu Ve\xEDculo",
        group: "perifericos"
      },
      {
        id: "80fe7dd2-47d1-45c7-8680-68578df04482",
        name: "Perif\xE9ricos e Benef\xEDcios \u2014 Aux\xEDlio GARD - Meu Ve\xEDculo",
        group: "perifericos"
      },
      {
        id: "b7a2e6c6-c461-4994-8cdd-9353a2299f8e",
        name: "Perif\xE9ricos e Benef\xEDcios \u2014 Carro Reserva - Meu Ve\xEDculo",
        group: "perifericos"
      },
      {
        id: "ea929590-9992-48bb-a096-4f6056ab9599",
        name: "Perif\xE9ricos e Benef\xEDcios \u2014 Perif\xE9ricos (Demais) - Meu Ve\xEDculo",
        group: "perifericos"
      },
      {
        id: "287d7c1c-b10c-40da-af26-94f0e02ae593",
        name: "Perif\xE9ricos e Benef\xEDcios \u2014 Sistema - Meu ve\xEDculo",
        group: "perifericos"
      },
      {
        id: "f1621414-129b-4c3c-8db0-0ca2a436f960",
        name: "Administrativo \u2014 Log\xEDstica \u2014 Custo com Frota - Meu Ve\xEDculo",
        group: "geral"
      },
      {
        id: "efe2639b-57e2-44c3-af76-d8f59210c8ee",
        name: "Administrativo \u2014 Sistema - Meu ve\xEDculo",
        group: "geral"
      },
      {
        id: "61c3a0a9-2790-4bed-b3d8-65a82cd04130",
        name: "Outras Despesas de Sinistro \u2014 Avarias Causadas por Fornecedores - Meu Ve\xEDculo",
        group: "geral"
      }
    ],
    costCenters: [
      { id: "39ed6094-0b2c-11f1-9089-53eafbb15c39", name: "PROTE\xC7\xC3O AUTO" },
      { id: "45316838-0b2c-11f1-b9bc-a3e67549696e", name: "CUSTOS COMPARTILHADOS" },
      { id: "4ea971c4-5ad9-11f1-a7ce-c30122002431", name: "TRANSFER\xCANCIAS" },
      { id: "285e284e-5b8c-11f1-bfd5-237656fb829b", name: "EVOGARD SA\xDADE - CEMIT\xC9RIO" },
      { id: "6a1c2000-5ad9-11f1-ab4a-6f11bdf127de", name: "ESTORNO" }
    ],
    paymentAccounts: [
      { id: "67656782-f056-45c9-a392-a5c35d91ec92", name: "01 - Bradesco - Meu Ve\xEDculo" },
      {
        id: "a191480a-04e9-4bc1-b8b9-11cb8af9a38a",
        name: "02 - Santander - Meu Ve\xEDculo - "
      },
      { id: "76900a8a-11fb-4f89-87c2-f1f6279883d2", name: "CONTA TESTE" },
      { id: "5512b515-4017-4d8d-9619-01fd17307505", name: "Goi\xE2nia - Hinova Pay - " },
      { id: "6ac9a09a-c367-456d-888c-8d52ecb2310a", name: "Meu Ve\xEDculo - Stone" }
    ]
  }
};
var STAGE_GROUP = {
  aviso: null,
  analise: "analise",
  reparo: "reparo",
  indenizacao: "indenizacao",
  perifericos: "perifericos",
  assistencia: "assistencia"
};
function contaAzulCatalogOf(tenantSlug) {
  return CONTAAZUL_CATALOGS[tenantSlug] ?? null;
}
function contaAzulCategoriesFor(tenantSlug, stage) {
  const catalog = contaAzulCatalogOf(tenantSlug);
  if (!catalog) return [];
  const own = STAGE_GROUP[stage];
  return catalog.categories.filter((c) => c.group === "geral" || c.group === own);
}
var ASSISTANCE_CATEGORY_PARTS = {
  "reboque:pane": "Veicular \u2014 Reboque por Pane",
  "reboque:sinistro": "Veicular \u2014 Reboque por Sinistro (Associado)",
  "reboque:terceiro": "Veicular \u2014 Reboque para Terceiro",
  bateria: "Veicular \u2014 Carga de Bateria",
  pneu: "Veicular \u2014 Troca de Pneu",
  pane_seca: "Veicular \u2014 Pane Seca",
  chaveiro: "Veicular \u2014 Chaveiro",
  "residencial:chaveiro": "Residencial \u2014 Chaveiro",
  "residencial:desentupimento": "Residencial \u2014 Desentupimento",
  "residencial:eletricista": "Residencial \u2014 Eletricista",
  "residencial:encanador": "Residencial \u2014 Encanador",
  "residencial:ar_condicionado": "Residencial \u2014 Limpeza de Ar Condicionado",
  taxi: "Veicular \u2014 Transporte Alternativo (T\xE1xi)",
  hospedagem: "Veicular \u2014 Hospedagem Emergencial"
};
function assistanceCategoryOf(tenantSlug, serviceType, serviceVariant) {
  const part = ASSISTANCE_CATEGORY_PARTS[serviceVariant === null ? serviceType : `${serviceType}:${serviceVariant}`];
  if (!part) return null;
  const prefix = `Assist\xEAncia 24 Horas \u2014 ${part} - `;
  return contaAzulCatalogOf(tenantSlug)?.categories.find(
    (c) => c.group === "assistencia" && c.name.startsWith(prefix)
  ) ?? null;
}
function assistanceCategoryShortName(name) {
  return name.replace(/^Assistência 24 Horas — /, "").replace(/ - [^-]+$/, "");
}
var ASSISTANCE_PAYMENT_NAMES = {
  ce: { costCenter: "PROTE\xC7\xC3O AUTO", paymentAccount: "04- Stone - Associa\xE7\xE3o" },
  go: { costCenter: "PROTE\xC7\xC3O AUTO", paymentAccount: "Meu Ve\xEDculo - Stone" }
};
function assistancePaymentDefaultsOf(tenantSlug) {
  const names = ASSISTANCE_PAYMENT_NAMES[tenantSlug];
  const catalog = contaAzulCatalogOf(tenantSlug);
  if (!names || !catalog) return null;
  const costCenter = catalog.costCenters.find((c) => c.name === names.costCenter);
  const paymentAccount = catalog.paymentAccounts.find(
    (a) => a.name === names.paymentAccount
  );
  return costCenter && paymentAccount ? { costCenter, paymentAccount } : null;
}
var CONTAAZUL_LAUNCH_ACCOUNTS = {
  ce: ["teste"],
  go: ["CONTA TESTE"]
};
function contaAzulLaunchAllowed(tenantSlug, accountId) {
  const names = CONTAAZUL_LAUNCH_ACCOUNTS[tenantSlug] ?? [];
  const account = contaAzulCatalogOf(tenantSlug)?.paymentAccounts.find(
    (a) => a.id === accountId
  );
  return account !== void 0 && names.includes(account.name);
}
var CONTAAZUL_COMPANIES = {
  ce: { id: "2956478", name: "Cobertura Total" },
  go: { id: "3138533", name: "Meu Ve\xEDculo" }
};
var CONTAAZUL_AWARD_CATALOGS = {
  ce: {
    tokenKey: "COBERTURA_TOTAL",
    categories: {
      "1x": { id: "c3c5f243-594b-4bab-90cc-3b39af584a19", name: "Recorr\xEAncia 1x" },
      "2x": { id: "10dc1b2d-ee6a-466a-8b1e-a5a06ba89d1a", name: "Recorr\xEAncia 2x" }
    },
    costCenter: { id: "fbe96a76-a63b-11f1-8279-e39fe83af3fb", name: "RECORR\xCANCIAS" },
    paymentAccount: { id: "8944c2b2-38d5-4f77-8f2f-a4c50c704d6e", name: "teste" }
  },
  go: {
    tokenKey: "MEU_VEICULO",
    categories: {
      "1x": {
        id: "b7fa3d27-ee4c-486f-9a49-ca4b6fbcba4d",
        name: "Comercial - Recorr\xEAncia 1x - Meu Ve\xEDculo"
      },
      "2x": {
        id: "414317e4-86a9-4605-82c6-e0ac353bd2c0",
        name: "Comercial - Recorr\xEAncia 2x - Meu Ve\xEDculo"
      }
    },
    costCenter: { id: "dded6f9e-ac40-11f1-a3d0-7bc8bc3f09f9", name: "RECORR\xCANCIA" },
    paymentAccount: { id: "76900a8a-11fb-4f89-87c2-f1f6279883d2", name: "CONTA TESTE" }
  }
};
function contaAzulAwardCatalogOf(tenantSlug) {
  return CONTAAZUL_AWARD_CATALOGS[tenantSlug] ?? null;
}
function awardPayableDescription(category, marker) {
  return `Despesa: Pagamento de Recorr\xEAncia ${category} \xB7 ${marker}`;
}
var CONTAAZUL_REVENUE_CATEGORIES = {
  ce: [
    {
      id: "5eadf8a6-d3d3-4aca-93e8-6c724e715eb9",
      name: "Receitas de Servi\xE7os - Receita Hinova - Boleto - Cobertura Total",
      group: "servicos"
    },
    {
      id: "5a11b8ce-7a5c-4dda-bb86-2c792aec973f",
      name: "Receitas de Servi\xE7os - Receita Hinova - Pix - Cobertura Total",
      group: "servicos"
    },
    {
      id: "00edb677-c13a-4bb0-a6d0-c090eaaae004",
      name: "Receitas de Servi\xE7os - Receita Outras Contas - Pix - Cobertura Total",
      group: "servicos"
    },
    {
      id: "24693b5d-944a-4b0d-9bb2-661513fb9599",
      name: "Receitas de Sinistro \u2014 Cobran\xE7a de Terceiro \u2014 Extrajudicial - Cobertura Total",
      group: "sinistro"
    },
    {
      id: "c3ee7a6e-1724-4411-8d0d-b09e9ba1b7d0",
      name: "Receitas de Sinistro \u2014 Cobran\xE7a de Terceiro \u2014 Judicial - Cobertura Total",
      group: "sinistro"
    },
    {
      id: "dd42a8df-128d-4de9-8854-90e741015b5b",
      name: "Receitas de Sinistro \u2014 Ganhos de Processos Ativos - Cobertura Total",
      group: "sinistro"
    },
    {
      id: "256ac6ac-f903-49a2-8255-9f3adfd67c18",
      name: "Receitas de Sinistro \u2014 Mensalidades Descontadas da Indeniza\xE7\xE3o - Cobertura Total",
      group: "sinistro"
    },
    {
      id: "92866260-6a20-47de-9c4e-6e49f5a8d0cf",
      name: "Receitas de Sinistro \u2014 PI Indeniza\xE7\xE3o - Cobertura Total",
      group: "sinistro"
    },
    {
      id: "f12c4ee2-bf1c-4b00-922b-7fe75a0e990d",
      name: "Receitas de Sinistro \u2014 PI Perif\xE9ricos - Cobertura Total",
      group: "sinistro"
    },
    {
      id: "eb1dfbd4-f1bc-4b22-b607-4667c6845b9e",
      name: "Receitas de Sinistro \u2014 PI Reparo - Cobertura Total",
      group: "sinistro"
    },
    {
      id: "fc2a8eee-4e08-4df6-bddf-8f8987139a53",
      name: "Receitas de Sinistro \u2014 Salvados - Cobertura Total",
      group: "sinistro"
    },
    {
      id: "93ee0416-38d0-4756-9cea-a8796decf9f9",
      name: "Receitas de Sinistro \u2014 Sucata de Pe\xE7as - Cobertura Total",
      group: "sinistro"
    },
    {
      id: "ce4b8933-31be-4b51-b9ce-d31617d824f7",
      name: "Outras Receitas de Sinistro \u2014 Ressarcimento de Fornecedores - Cobertura Total",
      group: "outras_sinistro"
    },
    {
      id: "2f85de2a-ab76-49e4-bf02-ea186c7901c5",
      name: "Outras Receitas e Entradas - Estornos Banc\xE1rios - Cobertura Total",
      group: "outras_entradas"
    },
    {
      id: "60430655-cc85-4223-8a2e-bc4b27345c37",
      name: "Receitas Financeiras - Rendimentos de Aplica\xE7\xF5es - Cobertura Total",
      group: "financeiras"
    },
    {
      id: "4bb736b9-6c03-4a1c-837b-fe92b92cc0b7",
      name: "Transfer\xEAncia entre Contas - Outros CNPJs - Entradas - Cobertura Total",
      group: "transferencias"
    }
  ],
  go: [
    {
      id: "ce28391f-62c2-4936-8113-f1dbf978418b",
      name: "Receitas de Servi\xE7os - Receita Hinova - Boleto - Meu Ve\xEDculo",
      group: "servicos"
    },
    {
      id: "dd85de3f-e773-4e05-8754-024e973c4802",
      name: "Receitas de Servi\xE7os - Receita Hinova - Pix - Meu Ve\xEDculo",
      group: "servicos"
    },
    {
      id: "d0befaa6-3af6-4aca-8e1a-61df9ba10caf",
      name: "Receitas de Servi\xE7os - Receita Outras Contas - Pix - Meu Ve\xEDculo",
      group: "servicos"
    },
    {
      id: "3b56c529-8eb5-4391-8ddd-4661d3227538",
      name: "Receitas de Sinistro \u2014 Cobran\xE7a de Terceiro \u2014 Extrajudicial - Meu Ve\xEDculo",
      group: "sinistro"
    },
    {
      id: "99145f6b-d935-458e-9e06-417a42f75ce9",
      name: "Receitas de Sinistro \u2014 Cobran\xE7a de Terceiro \u2014 Judicial - Meu Ve\xEDculo",
      group: "sinistro"
    },
    {
      id: "e1b663cb-6bc7-4d39-b421-8984d255bcf9",
      name: "Receitas de Sinistro \u2014 Ganhos de Processos Ativos - Meu Ve\xEDculo",
      group: "sinistro"
    },
    {
      id: "2a3349eb-2b65-4085-8922-20877c4da57e",
      name: "Receitas de Sinistro \u2014 Mensalidades Descontadas da Indeniza\xE7\xE3o - Meu Ve\xEDculo",
      group: "sinistro"
    },
    {
      id: "b423d9da-12e7-4bcf-bb0d-b49516b5a2d4",
      name: "Receitas de Sinistro \u2014 PI Indeniza\xE7\xE3o - Meu Ve\xEDculo",
      group: "sinistro"
    },
    {
      id: "33b34c3f-4c8a-4943-8ef8-eafc92a071a2",
      name: "Receitas de Sinistro \u2014 PI Perif\xE9ricos - Meu Ve\xEDculo",
      group: "sinistro"
    },
    {
      id: "201d0270-cff4-40a9-9385-3fa225d117bf",
      name: "Receitas de Sinistro \u2014 PI Reparo - Meu Ve\xEDculo",
      group: "sinistro"
    },
    {
      id: "1cc2596e-a1ee-4941-a9bd-38f50d588028",
      name: "Receitas de Sinistro \u2014 Salvados - Meu Ve\xEDculo",
      group: "sinistro"
    },
    {
      id: "f54019de-005a-4854-bb5c-85f5bd558011",
      name: "Receitas de Sinistro \u2014 Sucata de Pe\xE7as - Meu Ve\xEDculo",
      group: "sinistro"
    },
    {
      id: "37f8f3e0-9456-49b6-83b8-c1505d083525",
      name: "Outras Receitas de Sinistro \u2014 Ressarcimento de Fornecedores - Meu Ve\xEDculo",
      group: "outras_sinistro"
    },
    {
      id: "c6e86e8c-80a1-42b7-b00f-bc435400e7a4",
      name: "Outras Receitas e Entradas - Estornos Banc\xE1rios - Meu Ve\xEDculo",
      group: "outras_entradas"
    },
    {
      id: "bcaab0d1-35dc-4b59-a214-09119c8b4d4e",
      name: "Receitas Financeiras - Rendimentos de Aplica\xE7\xF5es - Meu Ve\xEDculo",
      group: "financeiras"
    },
    {
      id: "35baaac3-811b-4cd1-a963-e51df4cd7719",
      name: "Transfer\xEAncia entre Contas - Outros CNPJs - Entradas - Meu Ve\xEDculo",
      group: "transferencias"
    }
  ]
};
function contaAzulRevenueCategoriesOf(tenantSlug) {
  return CONTAAZUL_REVENUE_CATEGORIES[tenantSlug] ?? [];
}
function contaAzulPiPeripheralsCategoryOf(tenantSlug) {
  return contaAzulRevenueCategoriesOf(tenantSlug).find(
    (c) => c.name.startsWith("Receitas de Sinistro \u2014 PI Perif\xE9ricos")
  )?.id ?? null;
}

// src/claims-caf.ts
var CAF_TEMPLATE_KEYS = {
  associado: {
    templateId: "caf.associado.template",
    transactionTemplateId: "caf.associado.consulta"
  },
  terceiro: {
    templateId: "caf.terceiro.template",
    transactionTemplateId: "caf.terceiro.consulta"
  }
};
var CAF_TEMPLATE_DEFAULTS = {
  associado: {
    templateId: "6970d6b2b01e46000208e550",
    transactionTemplateId: "6970d818dbb419000253e276"
  },
  terceiro: {
    templateId: "69496f47a2e9fc0002c2a030",
    transactionTemplateId: "694971be05b74300025e22e0"
  }
};
var CAF_TEMPLATE_ID = /^[0-9a-f]{24}$/;
var CAF_WEBHOOK_KEY = "caf.webhook";
var ADDRESS = /^(https?:\/\/[^\s/?#]+)([/?#]\S*)?$/i;
function addressParts(value2) {
  const match = ADDRESS.exec(value2);
  return match ? { origin: match[1], rest: match[2] ?? "" } : null;
}
function pathOf(value2) {
  return (addressParts(value2)?.rest ?? "").split(/[?#]/)[0] || "/";
}
function isCafWebhookAddress(value2) {
  return value2 === "" || addressParts(value2) !== null;
}
function cafCallbackUrl(written, own) {
  const value2 = written.trim();
  if (value2 === "") return own;
  const parts = addressParts(value2);
  if (parts && (parts.rest === "" || parts.rest === "/")) {
    return `${parts.origin}${addressParts(own)?.rest ?? ""}`;
  }
  return value2;
}
function cafCallbackReceivesHere(url, own) {
  return pathOf(url) === pathOf(own);
}
var CAF_LINK_COOLDOWN_MS = 5 * 60 * 1e3;
function cafLinkAvailableAt(lastGeneratedAt, now) {
  if (!lastGeneratedAt) return null;
  const at2 = new Date(lastGeneratedAt.getTime() + CAF_LINK_COOLDOWN_MS);
  return at2 > now ? at2 : null;
}
var CAF_STATUSES = {
  em_processamento: "Em processamento na CAF",
  aprovado: "Aprovado pela CAF",
  reprovado: "Reprovado pela CAF",
  em_analise: "Em an\xE1lise manual na CAF",
  documento_ilegivel: "A CAF n\xE3o conseguiu ler o documento"
};
function cafStatusOf(vendorStatus) {
  switch (vendorStatus) {
    case "PROCESSING":
      return "em_processamento";
    case "APPROVED":
      return "aprovado";
    case "REPROVED":
      return "reprovado";
    case "PENDING":
      return "em_analise";
    case "PENDING_OCR":
      return "documento_ilegivel";
    default:
      return null;
  }
}
function cafStatusLabel(status) {
  return CAF_STATUSES[status] ?? status;
}
function cafStatusNeedsAction(status) {
  return status === "reprovado" || status === "documento_ilegivel";
}
var CAF_RESULT_KIND = "resultado_caf";
var CAF_UNMAPPED_KIND = "documento_caf";
var CAF_FILE_KINDS = {
  "Comprovante de resid\xEAncia": "comprovante_endereco",
  CRLV: "crlv",
  "Boletim de ocorr\xEAncia": "boletim_ocorrencia",
  CNH: "cnh",
  "CNH - Frente": "cnh",
  "CNH - Verso": "cnh",
  "Prontu\xE1rio M\xE9dico": "prontuario_medico",
  "Fotos complementares do Ve\xEDculo": "foto_veiculo",
  "Comprovante de Chamada Pelo App": "comprovante_chamada_app",
  "Foto de Chave de Uso do Ve\xEDculo (Furto)": "foto_chave_uso"
};
var fold = (text) => text.normalize("NFD").replace(/[̀-ͯ]/g, "").trim().toLowerCase();
var FOLDED_FILE_KINDS = new Map(
  Object.entries(CAF_FILE_KINDS).map(([name, kind]) => [fold(name), kind])
);
function cafFileKind(name) {
  return FOLDED_FILE_KINDS.get(fold(name)) ?? CAF_UNMAPPED_KIND;
}
function cafImageKind(documentType) {
  if (typeof documentType !== "string") return CAF_UNMAPPED_KIND;
  const type = fold(documentType);
  if (type.startsWith("cnh")) return "cnh";
  if (type.startsWith("crlv")) return "crlv";
  return CAF_UNMAPPED_KIND;
}
var CAF_RULE_LABELS = {
  has_document: "Documento identificado",
  valid_issue_date: "Data de emiss\xE3o v\xE1lida",
  documentscopy_approved: "Documentoscopia",
  is_readable: "Documento leg\xEDvel",
  is_cnh: "\xC9 CNH",
  valid_cnh_registration_number: "N\xFAmero de registro da CNH v\xE1lido",
  ocr_equals_receita: "Dados do documento iguais aos da Receita Federal",
  facematch_has_selfie_photo: "Possui selfie",
  facematch_is_equal: "Selfie confere com o documento",
  over_18: "Maior de idade"
};
function cafRuleLabel(code, description) {
  return CAF_RULE_LABELS[code] ?? (description?.trim() || code);
}
function cafTransactionFacts(transaction) {
  const t = record(transaction);
  const type = filled(t.type);
  const history = Array.isArray(t.history) ? t.history : [];
  const dates = history.map((h) => filled(record(h).date)).filter((d) => d !== null).sort();
  const ocr = record(record(t.sections).ocr);
  const score = record(t.fraudScore).total;
  return {
    documentType: type?.toUpperCase() ?? null,
    startedAt: filled(t.createdAt),
    lastEventAt: dates.at(-1) ?? null,
    fraud: typeof t.fraud === "boolean" ? t.fraud : null,
    fraudScore: typeof score === "number" && Number.isFinite(score) ? score : null,
    license: type && fold(type).startsWith("cnh") ? { category: filled(ocr.category), expiresOn: filled(ocr.expirationDate) } : null
  };
}
function record(value2) {
  return value2 && typeof value2 === "object" && !Array.isArray(value2) ? value2 : {};
}
function filled(value2) {
  return typeof value2 === "string" && value2.trim() !== "" ? value2.trim() : null;
}

// src/sendgrid.ts
var SENDGRID_SETTING_KEYS = {
  sender: "sendgrid.remetente",
  senderName: "sendgrid.nome"
};
var SENDGRID_SENDER_NAME_DEFAULT = "Evogard";
var SENDGRID_SETTING_PREFIX = "sendgrid.";
function isEmailAddress(value2) {
  return /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(value2.trim());
}

// src/claims-catalog.ts
function catalogOptionCode(label) {
  return label.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
}
function catalogOptions(...labels) {
  return labels.map((label) => ({ value: catalogOptionCode(label), label }));
}
function catalogChecklistValues(value2) {
  return typeof value2 === "string" ? value2.split(",").map((v) => v.trim()).filter(Boolean) : [];
}
function catalogConditionHolds(condition, state, context) {
  if ("any" in condition) {
    return condition.any.some((c) => catalogConditionHolds(c, state, context));
  }
  if ("claimType" in condition) return context.claimType === condition.claimType;
  if ("claimEvent" in condition) {
    return context.claimEvent != null && condition.claimEvent.includes(context.claimEvent);
  }
  const value2 = state[condition.field];
  if ("notIn" in condition) {
    return typeof value2 !== "string" || !condition.notIn.includes(value2);
  }
  return typeof value2 === "string" && condition.in.includes(value2);
}
function visibleCatalogFields(phase) {
  return phase.fields.filter((f) => f.binding.subject !== "excluded");
}
function shownCatalogFields(phase, state, context) {
  return visibleCatalogFields(phase).filter(
    (f) => !f.showWhen || catalogConditionHolds(f.showWhen, state, context)
  );
}
function isCatalogFieldRequired(field4, state, context) {
  if (!field4.required || field4.binding.subject === "deferred") return false;
  return !field4.requiredWhen || catalogConditionHolds(field4.requiredWhen, state, context);
}
function isCatalogFieldFilled(field4, state) {
  if (!field4.key) return false;
  const value2 = state[field4.key];
  if (field4.type === "attachment" || field4.type === "number" || field4.binding.subject === "comment") {
    if (typeof value2 === "string" && field4.binding.subject === "comment") {
      return value2.trim() !== "";
    }
    return typeof value2 === "number" ? value2 > 0 : Number(value2) > 0;
  }
  if (field4.type === "connector" && typeof value2 === "number") return value2 > 0;
  return typeof value2 === "string" ? value2.trim() !== "" : value2 != null;
}
function missingCatalogFields(phase, state, context) {
  return shownCatalogFields(phase, state, context).filter(
    (f) => isCatalogFieldRequired(f, state, context) && !isCatalogFieldFilled(f, state)
  );
}
function catalogValueText(field4, value2) {
  const label = (code) => field4.options?.find((o) => o.value === code)?.label ?? code;
  switch (field4.type) {
    case "select":
    case "radio_vertical":
      return label(value2);
    case "checklist_vertical":
      return catalogChecklistValues(value2).map(label).join(", ");
    case "currency": {
      const money2 = /^\d+(\.\d{1,2})?$/.test(value2) ? fromColumn(value2) : null;
      return money2 === null ? value2 : format(money2);
    }
    case "date":
    case "datetime":
    case "due_date": {
      const m = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}:\d{2}))?$/.exec(value2);
      if (!m) return value2;
      return `${m[3]}/${m[2]}/${m[1]}${m[4] ? `, ${m[4]}` : ""}`;
    }
    default:
      return value2;
  }
}
function catalogMoveDirection(order, from, to) {
  return order.indexOf(to) > order.indexOf(from) ? "avancar" : "voltar";
}
function catalogMoveNeedsForm(catalog, from, to) {
  return catalogMoveDirection(catalog.order, from, to) === "avancar" && !catalog.phases[to]?.detour;
}
function catalogMovesOf(catalog, phase, hold = null, context) {
  if (hold === "pre_desistencia") {
    return { forward: [], handoffs: [], outcomes: [catalog.withdrawal], back: [] };
  }
  if (hold) return { forward: [], handoffs: [], outcomes: [], back: [] };
  const kindOf = (to) => catalog.phases[to].kind;
  const allowed = catalog.phases[phase].moves.filter((to) => {
    const only = catalog.phases[to].onlyFor;
    return !context || !only || only === context.claimType;
  });
  const byOrder = [...allowed].sort(
    (a, b) => catalog.order.indexOf(a) - catalog.order.indexOf(b)
  );
  const ahead = byOrder.filter(
    (to) => catalogMoveDirection(catalog.order, phase, to) === "avancar"
  );
  return {
    forward: ahead.filter((to) => kindOf(to) === "stage"),
    handoffs: ahead.filter((to) => kindOf(to) === "handoff"),
    outcomes: ahead.filter((to) => kindOf(to) === "general"),
    back: byOrder.filter(
      (to) => catalogMoveDirection(catalog.order, phase, to) === "voltar"
    )
  };
}

// src/claims-management-repair-money.ts
var REFUSED_EXPENSE_STAGES = [
  "reprovado_lider",
  "pagamento_recusado"
];
var APPROVED_EXPENSE_STAGES = [
  "aguardando_pagamento",
  "pagamento_atrasado",
  "pagamento_efetuado"
];
var add = (into, value2) => {
  into.count++;
  into.total = sum(into.total, value2);
};
var empty = () => ({ count: 0, total: ZERO });
var orZero = (m) => m ?? ZERO;
function summarizeRepairMoney(expenses, quotes) {
  const requested = empty();
  const approved = empty();
  const paid = empty();
  const refused = empty();
  const byStage = /* @__PURE__ */ new Map();
  for (const e of expenses) {
    const stage = byStage.get(e.stage) ?? empty();
    add(stage, e.amount);
    byStage.set(e.stage, stage);
    if (REFUSED_EXPENSE_STAGES.includes(e.stage)) {
      add(refused, e.amount);
      continue;
    }
    add(requested, e.amount);
    if (APPROVED_EXPENSE_STAGES.includes(e.stage)) add(approved, e.amount);
    if (e.stage === "pagamento_efetuado") add(paid, e.paidAmount ?? e.amount);
  }
  const latest = /* @__PURE__ */ new Map();
  for (const q of quotes) {
    const current = latest.get(q.claimId);
    if (!current || q.id > current.id) latest.set(q.claimId, q);
  }
  const chosen = [...latest.values()];
  return {
    expenses: {
      requested,
      approved,
      paid,
      refused,
      byStage: EXPENSE_STAGES.flatMap((stage) => {
        const s = byStage.get(stage);
        return s ? [{ stage, ...s }] : [];
      })
    },
    quotes: {
      claims: chosen.length,
      withoutAmount: chosen.filter((q) => q.grossTotal === null).length,
      gross: sum(ZERO, ...chosen.map((q) => orZero(q.grossTotal))),
      approved: sum(ZERO, ...chosen.map((q) => orZero(q.approvedTotal))),
      parts: sum(ZERO, ...chosen.map((q) => orZero(q.partsTotal))),
      labor: sum(ZERO, ...chosen.map((q) => orZero(q.laborTotal))),
      associationShare: sum(ZERO, ...chosen.map((q) => orZero(q.associationShare))),
      memberShare: sum(ZERO, ...chosen.map((q) => orZero(q.memberShare)))
    }
  };
}

// src/claims-compensation.ts
var THEFT_CLAIM_EVENT = "roubo_ou_furto";
var COMPENSATION_DOCUMENTS = [
  { kind: "crv_atpve", label: "CRV ou ATPV-e" },
  { kind: "cnh_proprietario", label: "CNH ou RG/CPF do propriet\xE1rio" },
  { kind: "comprovante_endereco_proprietario", label: "Comprovante de endere\xE7o" },
  { kind: "livro_presenca", label: "Livro de presen\xE7a" },
  { kind: "cartao_autografo", label: "Cart\xE3o de aut\xF3grafo" },
  { kind: "rps_crdo", label: "RPS/CRDO" },
  { kind: "procuracao", label: "Procura\xE7\xE3o p\xFAblica", only: "furto_ou_terceiro" },
  { kind: "chave_reserva", label: "Chave reserva" },
  { kind: "manual_veiculo", label: "Manual do ve\xEDculo" },
  { kind: "procuracao_valores", label: "Procura\xE7\xE3o de valores", only: "terceiro" }
];
function isCompensationDocumentRequired(kind, context) {
  const doc = COMPENSATION_DOCUMENTS.find((d) => d.kind === kind);
  if (!("only" in doc)) return true;
  if (doc.only === "terceiro") return context.claimType === "terceiro";
  return context.claimType === "terceiro" || context.claimEvent === THEFT_CLAIM_EVENT;
}
function compensationChecklist(files, context) {
  const items = COMPENSATION_DOCUMENTS.map((d) => {
    const f = files[d.kind];
    const state = !isCompensationDocumentRequired(
      d.kind,
      context
    ) ? "nao_se_aplica" : f?.validated ? "validado" : (f?.files ?? 0) > 0 ? "recebido" : "falta";
    return { kind: d.kind, label: d.label, state };
  });
  const applicable = items.filter((i) => i.state !== "nao_se_aplica");
  return {
    items,
    required: applicable.length,
    validated: applicable.filter((i) => i.state === "validado").length,
    received: applicable.filter((i) => i.state !== "falta").length
  };
}
function compensationDocumentationSituation(files, context) {
  const c = compensationChecklist(files, context);
  if (c.validated === c.required) return "entrega_completa";
  return c.received === 0 ? "aguardando" : "entrega_parcial";
}
var COMPENSATION_ACTIVE_DEDUCTION_STATUSES = ["apurado", "quitado"];
function compensationDebtsBlocking(debts) {
  return debts.filter(
    (d) => d.kind !== "participacao" && COMPENSATION_ACTIVE_DEDUCTION_STATUSES.includes(d.status) && d.creditorCompanyId !== null && d.receipts === 0
  );
}
var PARTICIPATION_DEDUCTION = "participacao";
var COMPENSATION_DEBT_KINDS = {
  mensalidade: "Mensalidade",
  licenciamento: "Licenciamento",
  ipva: "IPVA",
  multa: "Multa",
  gravame: "Gravame",
  despachante: "Despachante",
  quitacao: "Quita\xE7\xE3o",
  depreciacao: "Deprecia\xE7\xE3o",
  outros: "Outros"
};
function isCompensationDebtKind(kind) {
  return Object.hasOwn(COMPENSATION_DEBT_KINDS, kind);
}
var COMPENSATION_PAID_DEBT_KINDS = [
  "licenciamento",
  "ipva",
  "multa",
  "gravame",
  "quitacao",
  "outros"
];
var COMPENSATION_DISCOUNT_KINDS = [
  "mensalidade",
  "despachante",
  "depreciacao"
];
function isCompensationPaidDebtKind(kind) {
  return COMPENSATION_PAID_DEBT_KINDS.includes(kind);
}
function isCompensationDiscountKind(kind) {
  return COMPENSATION_DISCOUNT_KINDS.includes(kind);
}
function deductionKindLabel(kind) {
  if (kind === PARTICIPATION_DEDUCTION) return "PI (participa\xE7\xE3o)";
  return isCompensationDebtKind(kind) ? COMPENSATION_DEBT_KINDS[kind] : kind;
}
var DEPRECIATION_REASONS = {
  leilao: "Leil\xE3o",
  chassi_remarcado: "Chassi remarcado",
  pcd: "PCD",
  taxi: "T\xE1xi",
  aluguel: "Aluguel"
};
var COMPENSATION_DEBT_STATUSES = {
  apurado: "Apurado",
  pago_pelo_associado: "Pago pelo associado",
  dispensado: "Dispensado"
};
function isCompensationDebtStatus(status) {
  return Object.hasOwn(COMPENSATION_DEBT_STATUSES, status);
}
function compensationDebtProblem(input) {
  if (!isCompensationDebtKind(input.kind)) {
    return { field: "kind", message: "Escolha o tipo do d\xE9bito." };
  }
  if (input.amount <= 0) {
    return { field: "amount", message: "O valor do d\xE9bito \xE9 maior que zero." };
  }
  if (input.kind === "outros" && !input.description?.trim()) {
    return { field: "description", message: "Descreva o d\xE9bito." };
  }
  if (input.kind === "depreciacao") {
    if (input.reason === null || !Object.hasOwn(DEPRECIATION_REASONS, input.reason)) {
      return { field: "reason", message: "Escolha o motivo da deprecia\xE7\xE3o." };
    }
  } else if (input.reason !== null) {
    return { field: "reason", message: "S\xF3 a deprecia\xE7\xE3o tem motivo." };
  }
  return null;
}
function isActiveDeduction(status) {
  return COMPENSATION_ACTIVE_DEDUCTION_STATUSES.includes(status);
}
function deductionCounts(d) {
  if (d.expenseStage) return !REFUSED_EXPENSE_STAGES.includes(d.expenseStage);
  return isActiveDeduction(d.status);
}
function compensationAccount(fipe, deductions) {
  const deducted = sum(...deductions.filter(deductionCounts).map((d) => d.amount));
  return { deducted, net: fipe === null ? null : subtract(fipe, deducted) };
}
var COMPENSATION_DEADLINE_FIPE_LIMIT = fromReais(7e4);
var COMPENSATION_DEADLINE_DAYS = {
  upTo: { due: 90, target: 45 },
  above: { due: 120, target: 75 }
};
var DAY_MS = 24 * 60 * 60 * 1e3;
function compensationDeadlines(completedAt, fipe, claimEvent) {
  if (fipe === null) return null;
  const days = compareMoney(fipe, COMPENSATION_DEADLINE_FIPE_LIMIT) > 0 ? COMPENSATION_DEADLINE_DAYS.above : COMPENSATION_DEADLINE_DAYS.upTo;
  const after = (n) => new Date(completedAt.getTime() + n * DAY_MS);
  return {
    dueAt: after(days.due),
    targetAt: claimEvent === THEFT_CLAIM_EVENT ? after(days.target) : null
  };
}
var COMPENSATION_SITUATIONS = {
  aguardando: "Aguardando documentos",
  entrega_parcial: "Entrega parcial",
  entrega_completa: "Entrega completa",
  em_analise: "Em an\xE1lise",
  aguardando_financeiro: "Aguardando financeiro",
  sem_comprovacao: "Sem comprova\xE7\xE3o"
};
function compensationSituationLabel(code) {
  return COMPENSATION_SITUATIONS[code] ?? code;
}
var COMPENSATION_PENDENCY_KINDS = {
  aguardando_declaracao: "Aguardando declara\xE7\xE3o",
  juridica: "Jur\xEDdica",
  administrativa: "Administrativa",
  financeira_embargo: "Financeira (embargo)"
};
var COMPENSATION_HANDOFFS = {
  acordo: { department: "reparo", phase: "negociacao_para_acordo" }
};
function compensationHandoffOf(phase) {
  return COMPENSATION_HANDOFFS[phase];
}
var COMPENSATION_WITHDRAWAL_OUTCOME = "desistencia";
var COMPENSATION_PIPE_COLUMNS = {
  "Comunicado de Indeniza\xE7\xE3o": { as: "stage", code: "comunicado_indenizacao" },
  "Recuperado de Roubo": {
    as: "out",
    reason: "\xE9 a Restitui\xE7\xE3o (\xA75.10), fora do de-para de 09/10/2026"
  },
  "Aguardando Documenta\xE7\xE3o": { as: "stage", code: "aguardando_documentacao" },
  "Em Acordo": { as: "handoff", code: "acordo" },
  Jur\u00EDdico: {
    as: "out",
    reason: "o Jur\xEDdico ter\xE1 esteira pr\xF3pria (se\xE7\xE3o 8); a coluna n\xE3o tinha campo"
  },
  Pend\u00EAncias: { as: "hold", code: "pendencia" },
  "Aguardando Pagamento": { as: "stage", code: "aguardando_pagamento" },
  "Ve\xEDculo Rec. Em Tranfer\xEAncia": {
    as: "out",
    reason: "a esteira de 31/03 tira a fase; quem acompanha a transfer\xEAncia \xE9 a D16"
  },
  Conclu\u00EDdo: { as: "general", code: "concluidos" }
};
var COMPENSATION_PIPE_FIELD_HOMES = {
  "Tipo de Envolvido": "o tipo do sinistro (claims.type), escolhido na abertura do aviso",
  "Valor de Tabela Fipe": "claims.fipe_value, gravado na Entrada da An\xE1lise; a mesa o mostra no bloco da conta",
  "Status de Entrega de Documenta\xE7\xE3o": 'a situa\xE7\xE3o da Aguardando Documenta\xE7\xE3o, que acompanha o checklist (I6); "Pend\xEAncia" \xE9 a parada (D3)',
  "C\xF3digo de rastreio:": "saiu pela esteira de 31/03 (D18, 09/10/2026)",
  "Statement: Check List de Documentos": "texto de tela do Pipefy, n\xE3o dado",
  "CRV ou ATPV-e": 'o radio "recebido?" n\xE3o vira coluna: recebido \xE9 o documento existir (claims_documents), e o checklist cobra',
  "C\xF3pia da CNH do propriet\xE1rio legal do ve\xEDculo (ou RG e CPF)": 'o radio "recebido?" n\xE3o vira coluna: recebido \xE9 o documento existir (claims_documents), e o checklist cobra',
  "C\xF3pia do Comprovante de endere\xE7o do propriet\xE1rio legal": 'o radio "recebido?" n\xE3o vira coluna: recebido \xE9 o documento existir (claims_documents), e o checklist cobra',
  "Livro de Presen\xE7a (Enviado pela Associa\xE7\xE3o)": 'o radio "recebido?" n\xE3o vira coluna: recebido \xE9 o documento existir (claims_documents), e o checklist cobra',
  "Cart\xE3o de Aut\xF3grafo (Enviado pela Associa\xE7\xE3o)": 'o radio "recebido?" n\xE3o vira coluna: recebido \xE9 o documento existir (claims_documents), e o checklist cobra',
  "RPS/CRDO (Enviado pela Associa\xE7\xE3o)": 'o radio "recebido?" n\xE3o vira coluna: recebido \xE9 o documento existir (claims_documents), e o checklist cobra',
  Procura\u00E7\u00E3o: 'o radio "recebido?" n\xE3o vira coluna: recebido \xE9 o documento existir (claims_documents); s\xF3 exigido no furto ou roubo e no terceiro',
  "Procura\xE7\xE3o de Valores": 'o radio "recebido?" n\xE3o vira coluna: recebido \xE9 o documento existir (claims_documents); s\xF3 exigido no terceiro',
  "Chave Reserva": 'o campo "Foto da entrega da chave reserva" (claims_documents, chave_reserva) \u2014 D17',
  "Manual do Ve\xEDculo": 'o campo "Foto da entrega do manual do ve\xEDculo" (claims_documents, manual_veiculo) \u2014 D17',
  "Tipo de Pend\xEAncia": 'a parada "Pend\xEAncia", com o tipo (claims_pendencies.kind) \u2014 I2',
  "Descri\xE7\xE3o de Pend\xEAncia": 'a parada "Pend\xEAncia" \u2014 a mensagem dela (claims_pendencies.message)',
  Parecer: 'a retomada da parada "Pend\xEAncia" \u2014 a resolu\xE7\xE3o (claims_pendencies.resolution)',
  Evid\u00EAncias: "saiu pela esteira de 31/03 (D18, 09/10/2026)",
  "Situa\xE7\xE3o do Ve\xEDculo": 'saiu pela esteira de 31/03: o gravame vira o d\xE9bito "gravame" do Pagamento de D\xE9bito (D18)',
  "Parecer e Alinhamento Financeiro": "saiu: \xE9 do Financeiro (D18, 09/10/2026)",
  "Data de Pagamento": "saiu: \xE9 do Financeiro (D18, 09/10/2026)",
  "Status da Transfer\xEAncia": 'a coluna "Ve\xEDculo Rec. Em Tranfer\xEAncia" saiu pela esteira de 31/03 (D16)',
  "Localiza\xE7\xE3o do Ve\xEDculo": 'a coluna "Ve\xEDculo Rec. Em Tranfer\xEAncia" saiu pela esteira de 31/03 (D16)',
  "Documenta\xE7\xE3o de Transfer\xEAncia": 'a coluna "Ve\xEDculo Rec. Em Tranfer\xEAncia" saiu pela esteira de 31/03 (D16)',
  "Auto de Entrega": 'a coluna "Ve\xEDculo Rec. Em Tranfer\xEAncia" saiu pela esteira de 31/03 (D16)',
  "Avalia\xE7\xE3o NPS": "o NPS \xE9 a pesquisa geral (claims_surveys), como no Reparo \u2014 I7",
  "Observa\xE7\xF5es NPS": "o NPS \xE9 a pesquisa geral (claims_surveys), como no Reparo \u2014 I7",
  "Anexos NPS": "o NPS \xE9 a pesquisa geral (claims_surveys), como no Reparo \u2014 I7",
  "Status avalia\xE7\xE3o NPS": "o NPS \xE9 a pesquisa geral (claims_surveys), como no Reparo \u2014 I7",
  "Registro de Salvado": "o encaminhamento ao Salvado (claims_referrals, target = salvado) \u2014 um registro da mesa, e n\xE3o campo (roteiro, Parte 6)"
};
var options = catalogOptions;
var PIPEFY_CONNECTION = "Conex\xE3o do Pipefy com o Financeiro; a solicita\xE7\xE3o de pagamento ser\xE1 feita futuramente (D6, 09/10/2026; fora do formul\xE1rio desde 22/10/2026).";
var NOTICE = "Envio do comunicado";
var CHECKLIST = "Checklist e prazo";
var OWNER_DOCS = "Documentos do propriet\xE1rio";
var ASSOCIATION_DOCS = "Documentos da associa\xE7\xE3o";
var POWERS_OF_ATTORNEY = "Procura\xE7\xF5es";
var DELIVERED_ITEMS = "Chave reserva e manual";
var NOTES = "Observa\xE7\xF5es";
var DEBTS = "D\xE9bitos e situa\xE7\xE3o";
var PAYMENT = "Pagamento ao benefici\xE1rio";
var field = (key, label, type, required, binding, extra = {}) => ({ key, label, type, required, binding, ...extra });
var document = (key, label, kind, required, extra = {}) => field(key, label, "attachment", required, { subject: "document", kind }, extra);
var comment = (key, label, section) => field(key, label, "long_text", false, { subject: "comment" }, { section });
var derived = (key, label, type, required, source, help, section) => field(key, label, type, required, { subject: "derived", source }, { help, section });
var excluded = (label, type, reason) => ({
  label,
  type,
  required: false,
  binding: { subject: "excluded", reason }
});
var outcome = (code, label, kind, extra = {}) => ({ code, label, kind, moves: [], fields: [], ...extra });
var THEFT_OR_THIRD_PARTY = {
  any: [{ claimEvent: [THEFT_CLAIM_EVENT] }, { claimType: "terceiro" }]
};
var PHASES = [
  {
    code: "comunicado_indenizacao",
    label: "Comunicado de Indeniza\xE7\xE3o",
    kind: "stage",
    moves: ["aguardando_documentacao"],
    fields: [
      document(
        "communicationNotice",
        "Comunicado de Indeniza\xE7\xE3o",
        "comunicado_indenizacao",
        true,
        { section: NOTICE }
      ),
      field(
        "communicationSentOn",
        "Data de Envio de Comunica\xE7\xE3o",
        "date",
        true,
        { subject: "communication_date" },
        {
          section: NOTICE,
          help: "O dia em que o comunicado e a lista de documentos foram enviados."
        }
      ),
      field(
        "sgaStatus",
        'SGA: status "Paralisado Indeniza\xE7\xE3o" e evento "Indeniza\xE7\xE3o" lan\xE7ados?',
        "select",
        true,
        { subject: "decision", kind: "sga_status", column: "result" },
        {
          section: NOTICE,
          options: options("Sim", "N\xE3o"),
          /* D9, 09/10/2026: enquanto a plataforma não escreve no SGA, a
             analista confirma aqui que lançou à mão. */
          help: "A plataforma ainda n\xE3o escreve no SGA: o lan\xE7amento \xE9 feito l\xE1, e confirmado aqui."
        }
      )
    ]
  },
  {
    code: "aguardando_documentacao",
    label: "Aguardando Documenta\xE7\xE3o",
    kind: "stage",
    moves: ["pagamento_debito", "acordo", "comunicado_indenizacao"],
    situations: ["aguardando", "entrega_parcial", "entrega_completa"],
    fields: [
      /* As duas datas sobem para junto do checklist, antes dele, e dividem a
         fileira (22/10/2026); nada muda no que é exigido. */
      derived(
        "targetAt",
        "Data Prevista",
        "due_date",
        false,
        "target_at",
        "A meta interna, s\xF3 da equipe \u2014 calculada quando a documenta\xE7\xE3o fica completa.",
        CHECKLIST
      ),
      derived(
        "dueAt",
        "Data Limite",
        "due_date",
        false,
        "due_at",
        "O prazo comunicado ao associado \u2014 calculado quando a documenta\xE7\xE3o fica completa.",
        CHECKLIST
      ),
      derived(
        "documentsChecklist",
        "Checklist de documentos do evento",
        "short_text",
        true,
        "documents_checklist",
        "Todo documento exigido pelo evento validado. O checklist fica no bloco do alto da mesa.",
        CHECKLIST
      ),
      document("crvAtpve", "Documento - CRV ou ATPV-e", "crv_atpve", false, {
        section: OWNER_DOCS
      }),
      document(
        "ownerLicense",
        "Documento - CNH do propriet\xE1rio legal do ve\xEDculo (ou RG e CPF)",
        "cnh_proprietario",
        false,
        { section: OWNER_DOCS }
      ),
      document(
        "ownerProofOfAddress",
        "Documento - Comprovante de endere\xE7o do propriet\xE1rio legal",
        "comprovante_endereco_proprietario",
        false,
        { section: OWNER_DOCS }
      ),
      document(
        "attendanceBook",
        "Documento Livro de Presen\xE7a (Enviado pela Associa\xE7\xE3o)",
        "livro_presenca",
        false,
        { section: ASSOCIATION_DOCS }
      ),
      document(
        "signatureCard",
        "Documento - Cart\xE3o de Aut\xF3grafo (Enviado pela Associa\xE7\xE3o)",
        "cartao_autografo",
        false,
        { section: ASSOCIATION_DOCS }
      ),
      document(
        "rpsCrdo",
        "Documento - RPS/CRDO (Enviado pela Associa\xE7\xE3o)",
        "rps_crdo",
        false,
        { section: ASSOCIATION_DOCS }
      ),
      document("powerOfAttorney", "Documento - Procura\xE7\xE3o", "procuracao", false, {
        section: POWERS_OF_ATTORNEY,
        showWhen: THEFT_OR_THIRD_PARTY
      }),
      document(
        "paymentPowerOfAttorney",
        "Documento - Procura\xE7\xE3o de Valores",
        "procuracao_valores",
        false,
        { section: POWERS_OF_ATTORNEY, showWhen: { claimType: "terceiro" } }
      ),
      document(
        "spareKeyPhoto",
        "Foto da entrega da chave reserva",
        "chave_reserva",
        false,
        {
          section: DELIVERED_ITEMS,
          help: "A chave \xE9 um objeto: o recebimento \xE9 a foto da entrega (D17)."
        }
      ),
      document(
        "manualPhoto",
        "Foto da entrega do manual do ve\xEDculo",
        "manual_veiculo",
        false,
        {
          section: DELIVERED_ITEMS,
          help: "O manual \xE9 um objeto: o recebimento \xE9 a foto da entrega (D17)."
        }
      ),
      comment("documentationNotes", "Observa\xE7\xF5es gerais", NOTES)
    ]
  },
  {
    code: "pagamento_debito",
    label: "Pagamento de D\xE9bito",
    kind: "stage",
    moves: ["aguardando_pagamento", "aguardando_documentacao"],
    situations: ["em_analise", "aguardando_financeiro", "sem_comprovacao"],
    fields: [
      derived(
        "debtsReady",
        "D\xE9bitos a pagar com valor e comprovante",
        "short_text",
        true,
        "debts_ready",
        "Todo d\xE9bito pago a um credor com o valor e o comprovante. Os d\xE9bitos ficam na conta, no alto da mesa.",
        DEBTS
      ),
      excluded(
        "Conex\xE3o com o Financeiro (um pedido por d\xE9bito pago a credor)",
        "connector",
        PIPEFY_CONNECTION
      ),
      field(
        "debtSituation",
        "Situa\xE7\xE3o na fase",
        "select",
        false,
        { subject: "passage_status" },
        {
          section: DEBTS,
          options: options("Em an\xE1lise", "Aguardando financeiro", "Sem comprova\xE7\xE3o")
        }
      ),
      comment("debtNotes", "Observa\xE7\xF5es gerais", DEBTS)
    ]
  },
  {
    code: "aguardando_pagamento",
    label: "Aguardando Pagamento",
    kind: "stage",
    moves: ["concluidos"],
    fields: [
      derived(
        "paymentDueAt",
        "Prazo de Pagamento",
        "due_date",
        false,
        "payment_due_at",
        "A data limite, contada da entrega completa da documenta\xE7\xE3o.",
        PAYMENT
      ),
      /* O pagamento ao beneficiário — D6: implementação futura. */
      excluded("Conex\xE3o Financeiro", "connector", PIPEFY_CONNECTION),
      document(
        "paymentReceipt",
        "Comprovante de Pagamento",
        "comprovante_pagamento",
        true,
        { section: PAYMENT }
      ),
      /* I7, 09/10/2026: o Concluído virou desfecho, sem formulário, e o termo
         passou para cá — obrigatório para concluir. */
      document("dischargeTerm", "Termo de quita\xE7\xE3o", "termo_quitacao", true, {
        section: PAYMENT
      }),
      comment("paymentNotes", "Observa\xE7\xF5es Gerais", PAYMENT)
    ]
  },
  /* Desvio (I5): mandar ao acordo não pede o checklist. */
  outcome("acordo", "Acordo", "handoff", { detour: true }),
  outcome("desistencia", "Desist\xEAncia", "general"),
  outcome("concluidos", "Conclu\xEDdos", "general")
];
var COMPENSATION_PHASES = Object.fromEntries(PHASES.map((p) => [p.code, p]));
var COMPENSATION_PIPE_ORDER = PHASES.map(
  (p) => p.code
);
function compensationPhaseOf(phase) {
  return COMPENSATION_PHASES[phase];
}
function compensationPhaseLabel(phase) {
  return compensationPhaseOf(phase)?.label ?? phase;
}
function isCompensationOutcome(phase) {
  return COMPENSATION_OUTCOMES.includes(phase);
}
function isCompensationGeneralPhase(phase) {
  return compensationPhaseOf(phase)?.kind === "general";
}
var CATALOG = {
  order: COMPENSATION_PIPE_ORDER,
  phases: COMPENSATION_PHASES,
  withdrawal: COMPENSATION_WITHDRAWAL_OUTCOME
};
function compensationMoveDirection(from, to) {
  return catalogMoveDirection(COMPENSATION_PIPE_ORDER, from, to);
}
function compensationMoveNeedsForm(from, to) {
  return catalogMoveNeedsForm(CATALOG, from, to);
}
function compensationMovesOf(phase, hold = null, context) {
  return catalogMovesOf(CATALOG, phase, hold, context);
}
function isCompensationMoveAllowed(from, to, hold, context) {
  const m = compensationMovesOf(from, hold, context);
  return [...m.forward, ...m.handoffs, ...m.outcomes, ...m.back].includes(to);
}
function visibleCompensationFields(phase) {
  return visibleCatalogFields(COMPENSATION_PHASES[phase]);
}
function shownCompensationFields(phase, state, context) {
  return shownCatalogFields(COMPENSATION_PHASES[phase], state, context);
}
function isCompensationFieldRequired(field4, state, context) {
  return isCatalogFieldRequired(field4, state, context);
}
function isCompensationFieldFilled(field4, state) {
  return isCatalogFieldFilled(field4, state);
}
function missingCompensationFields(phase, state, context) {
  return missingCatalogFields(COMPENSATION_PHASES[phase], state, context);
}
function isDerivedCompensationField(field4) {
  return field4.binding.subject === "derived";
}
function isPassageBoundCompensationField(field4) {
  return field4.binding.subject === "passage_status";
}
function isCompensationCorrectablePhase(phase, current, visited) {
  return phase !== current && COMPENSATION_WORK_STAGES.includes(phase) && visited.includes(phase);
}
function compensationValueText(field4, value2) {
  return catalogValueText(field4, value2);
}

// src/claims-analysis.ts
var ANALYSIS_PIPE_ORDER = [
  "entrada",
  "documentacao",
  "analise_de_evento",
  "sindicancia",
  "negativas_a_enviar",
  "aprovado_para_reparo",
  "indenizacao",
  "desistencia",
  "negados_com_posse",
  "negados_com_posse_juridico",
  "negado",
  "concluido_somente_terceiro"
];
function analysisOptionCode(label) {
  return catalogOptionCode(label);
}
var options2 = catalogOptions;
var YES_NO = options2("Sim", "N\xE3o");
var MESSAGES_TAB = "Na aba Mensagens da mesa (claims.caf_script / claims.zapsign_script) \u2014 decis\xE3o de 15/10/2026.";
var OUT_OF_FLOW_1510 = "Fora do fluxo por decis\xE3o do dono em 15/10/2026.";
var OUT_OF_FLOW_0510 = "Fora do fluxo por decis\xE3o do dono em 05/10/2026.";
var excluded2 = (label, type, reason, required = false) => ({ label, type, required, binding: { subject: "excluded", reason } });
var FIPE = "Tabela FIPE e participa\xE7\xE3o";
var CONTACT = "Contato e acionamento";
var LINKS = "Links e documenta\xE7\xE3o complementar";
var CUSTOMER_NOTICE = "Comunica\xE7\xE3o ao cliente";
var MEMBER_DOCS = "Documentos do sinistro";
var TERMS = "Termos de acionamento";
var ANALYST = "Parecer t\xE9cnico";
var RESPONSIBILITY = "Responsabilidade pelo evento";
var INVESTIGATION = "Apura\xE7\xE3o da sindic\xE2ncia";
var RECOVERY = "Recupera\xE7\xE3o do ve\xEDculo";
var DENIAL = "Fundamenta\xE7\xE3o da negativa";
var YARD = "Localiza\xE7\xE3o do ve\xEDculo";
var DISPATCH = "Envio da carta de negativa";
var RETURN = "Devolu\xE7\xE3o do ve\xEDculo";
var document2 = (key, label, kind, required = false) => ({
  key,
  label,
  type: "attachment",
  required,
  binding: { subject: "document", kind }
});
var DENIAL_REASONS = options2(
  "Conduta do Condutor",
  "Infra\xE7\xE3o de Tr\xE2nsito",
  "Situa\xE7\xE3o do Ve\xEDculo",
  "Descumprimento Contratual",
  "Fraude ou Il\xEDcito",
  "Nexo Causal"
);
var denialDetail = (key, label, reason, detailOptions) => ({
  key,
  label,
  type: "select",
  required: true,
  options: options2(...detailOptions),
  showWhen: { field: "denialReason", in: [analysisOptionCode(reason)] },
  section: DENIAL,
  binding: { subject: "decision", kind: "negativa", column: "reason" }
});
var causedBy = {
  key: "causedBy",
  label: "Causador:",
  type: "select",
  required: true,
  options: options2("Associado", "Terceiro"),
  binding: { subject: "decision", kind: "causador", column: "result" }
};
var thirdPartyIdentified = {
  key: "thirdPartyIdentified",
  label: "Terceiro identificado?",
  type: "select",
  required: true,
  options: YES_NO,
  binding: { subject: "decision", kind: "terceiro_identificado", column: "result" }
};
var ANALYSIS_SITUATIONS = {
  aguardando_retorno: "Aguardando retorno",
  aguardando_documentos: "Aguardando documentos",
  entrega_parcial: "Entrega parcial",
  em_validacao: "Em valida\xE7\xE3o",
  carta_em_elaboracao: "Carta em elabora\xE7\xE3o",
  enviada_ao_associado: "Enviada ao associado",
  cliente_ciente: "Cliente ciente"
};
function analysisSituationLabel(code) {
  return ANALYSIS_SITUATIONS[code] ?? code;
}
var ANALYSIS_HOLDS = {
  pendencia: "Pend\xEAncia",
  pre_desistencia: "Pedido de desist\xEAncia",
  negado_com_posse: "Negado com posse",
  juridico: "Jur\xEDdico"
};
function analysisHoldLabel(code) {
  return ANALYSIS_HOLDS[code] ?? code;
}
var WITHDRAWAL_OUTCOME = "desistencia";
var ANALYSIS_HANDOFFS = {
  /* Chega na Orçamentação, a entrada do Reparo desde 03/11/2026 — até
     então chegava na Supervisão (de-para do Reparo, 07/10/2026). */
  aprovado_para_reparo: { department: "reparo", phase: "orcamentacao_oficina" },
  indenizacao: { department: "indenizacao", phase: "comunicado_indenizacao" }
};
function analysisHandoffOf(phase) {
  return ANALYSIS_HANDOFFS[phase];
}
var ANALYSIS_PIPE_COLUMNS = {
  Entrada: { as: "stage", code: "entrada" },
  "Aguardando Retorno": { as: "situation", stage: "entrada", code: "aguardando_retorno" },
  "Ag. Docs e Ass. Termo": {
    as: "situation",
    stage: "documentacao",
    code: "aguardando_documentos"
  },
  "Valida\xE7\xE3o de Documentos": {
    as: "situation",
    stage: "documentacao",
    code: "em_validacao"
  },
  "An\xE1lise de Evento": { as: "stage", code: "analise_de_evento" },
  "Paralisados - Pend\xEAncia": { as: "hold", code: "pendencia" },
  "Aprovado para Reparo": { as: "handoff", code: "aprovado_para_reparo" },
  Sindic\u00E2ncia: { as: "stage", code: "sindicancia" },
  "Negativas a Enviar": { as: "stage", code: "negativas_a_enviar" },
  Indeniza\u00E7\u00E3o: { as: "handoff", code: "indenizacao" },
  "Pr\xE9-desistente": { as: "hold", code: "pre_desistencia" },
  Desist\u00EAncia: { as: "general", code: "desistencia" },
  "Negados com Posse": { as: "general", code: "negados_com_posse" },
  "Negados com Posse Jur\xEDdico": { as: "general", code: "negados_com_posse_juridico" },
  Negado: { as: "general", code: "negado" },
  "Conclu\xEDdo Somente Terceiro": { as: "general", code: "concluido_somente_terceiro" }
};
var ANALYSIS_PIPE_FIELD_HOMES = {
  "Especificar nexo casual": 'o mesmo campo de Negativas a Enviar, com o r\xF3tulo corrigido para "Especificar nexo causal" (27/10/2026) \u2014 o "casual" era erro de digita\xE7\xE3o do pipe',
  "Link ZapSign": "a Documenta\xE7\xE3o, nos termos de acionamento \u2014 o termo s\xF3 \xE9 criado no ZapSign depois que o associado envia a documenta\xE7\xE3o (20/10/2026); a mesma coluna (claims.zapsign_link)",
  "Data do \xFAltimo contato": 'o registro "Tentativa de contato" (claims_contacts.happened_at); a contagem aparece na Entrada',
  "Houve retorno do cliente pelo chat?": 'o registro "Tentativa de contato" \u2014 "Respondeu" ou "Sem resposta" (claims_contacts.answered); a Entrada exige ao menos uma (15/10/2026)',
  "Print do chat ou tentativa de liga\xE7\xE3o": 'o anexo opcional da "Tentativa de contato" (claims_documents, print_contato, com contact_id)',
  "Valor de Tabela Fipe Terceiro": 'o "Valor Tabela Fipe" da Entrada, obrigat\xF3rio no sinistro do terceiro \u2014 a mesma coluna (claims.fipe_value)',
  "Descri\xE7\xE3o de Pend\xEAncia - An\xE1lise de Evento": 'a parada "Pend\xEAncia" \u2014 a mensagem dela (claims_pendencies.message)',
  "Data de Comunica\xE7\xE3o de Pend\xEAncia": 'a parada "Pend\xEAncia" \u2014 quando ela foi aberta (claims_pendencies.communicated_at)',
  "Mensagem de Pend\xEAncia": 'a parada "Pend\xEAncia" \u2014 a mensagem dela (claims_pendencies.message)',
  "Hist\xF3rico de Pend\xEAncias": "a Atividade do sinistro: cada pend\xEAncia aberta e resolvida \xE9 um evento",
  "Justificativa da desist\xEAncia:": 'a parada "Pedido de desist\xEAncia" \u2014 a decis\xE3o desistencia (claims_decisions.reason)',
  Anexos: "os anexos do pedido de desist\xEAncia (claims_documents, anexo_desistencia) \u2014 ainda sem campo no pedido"
};
var TO_INVESTIGATION = analysisOptionCode("Enviar para Sindic\xE2ncia");
var THEFT_ONLY = { claimEvent: [THEFT_CLAIM_EVENT] };
var PHASES2 = [
  {
    code: "entrada",
    label: "Entrada",
    kind: "stage",
    moves: ["documentacao", "sindicancia"],
    situations: ["aguardando_retorno"],
    fields: [
      {
        key: "fipeReferenceDate",
        label: "Data de Refer\xEAncia FIPE",
        type: "date",
        required: true,
        section: FIPE,
        binding: { subject: "claim", column: "fipeReferenceDate" }
      },
      /* Os dois valores do formulário inicial do pipe — na Entrada por decisão
         do dono em 06/10/2026. */
      {
        key: "fipeValue",
        label: "Valor Tabela Fipe",
        type: "currency",
        /* O formulário inicial a tem opcional; no sinistro do terceiro ela é a
           "Valor de Tabela Fipe Terceiro", que era obrigatória em Aguardando
           Retorno — a mesma coluna (decisões de 06/10/2026). */
        required: true,
        requiredWhen: { claimType: "terceiro" },
        origin: "start_form",
        section: FIPE,
        binding: { subject: "claim", column: "fipeValue" }
      },
      {
        key: "participationAmount",
        label: "Valor Participa\xE7\xE3o",
        type: "currency",
        required: false,
        origin: "start_form",
        /* "Somente para cards do Tipo Associado." — a descrição do campo no pipe. */
        showWhen: { claimType: "associado" },
        section: FIPE,
        binding: { subject: "deduction", kind: "participacao" }
      },
      {
        ...document2(
          "fipeDocument",
          "Documento de Consulta Tabela Fipe",
          "documentacao_fipe",
          true
        ),
        section: FIPE
      },
      {
        key: "firstContact",
        label: "Primeiro acionamento?",
        type: "select",
        required: false,
        options: YES_NO,
        section: CONTACT,
        binding: { subject: "claim", column: "firstContact" }
      },
      {
        key: "lastActivationDate",
        label: "Data do \xFAltimo acionamento",
        type: "date",
        /* De volta ao fluxo em 15/10/2026, opcional, e só quando não é o
           primeiro acionamento. */
        required: false,
        showWhen: { field: "firstContact", in: ["nao"] },
        section: CONTACT,
        binding: { subject: "claim", column: "lastActivationDate" }
      },
      excluded2("Link do atendimento do Chat", "short_text", OUT_OF_FLOW_0510, true),
      /* O que era de "Aguardando Retorno", que virou situação da Entrada
         (decisão de 06/10/2026). O "Link CAF Documentação" da Entrada, fora do
         fluxo desde 05/10, é este mesmo campo. */
      {
        key: "lastContactDue",
        label: "Vencimento do \xFAltimo contato",
        type: "due_date",
        required: false,
        /* Calculado (decisão do dono em 15/10/2026): a última tentativa + 1 dia
           útil, gravado no prazo da passagem a cada tentativa nova. */
        help: "Calculado: a \xFAltima tentativa de contato + 1 dia \xFAtil.",
        section: CONTACT,
        binding: { subject: "contact_due" }
      },
      {
        key: "contactAttempts",
        label: "Tentativas de contato",
        type: "number",
        /* Pelo menos uma para sair da Entrada (decisão do dono em 15/10/2026):
           é ela que guarda se o cliente respondeu e o print do contato, que
           eram dois campos desta fase. */
        required: true,
        help: 'Calculado: as tentativas registradas em "Tentativa de contato" nesta fase.',
        section: CONTACT,
        binding: { subject: "contact_count" }
      },
      {
        key: "cafLink",
        label: "Link CAF Documenta\xE7\xE3o",
        type: "short_text",
        required: false,
        /* Só consulta (15/10/2026): quem o preenche é a integração com a CAF,
           que ainda não existe. */
        help: "Preenchido pela integra\xE7\xE3o com a CAF.",
        section: LINKS,
        binding: { subject: "integration", column: "cafLink" }
      },
      {
        key: "requestExtraDocuments",
        label: "Solicitar Documenta\xE7\xE3o Complementar",
        type: "select",
        required: true,
        options: YES_NO,
        section: LINKS,
        binding: {
          subject: "decision",
          kind: "documentacao_complementar",
          column: "result"
        }
      },
      {
        key: "extraDocuments",
        label: "Lista de Documenta\xE7\xE3o Complementar",
        type: "checklist_vertical",
        required: true,
        options: options2(
          "Prontu\xE1rio M\xE9dico",
          "Fotos complementares do Ve\xEDculo",
          "Comprovante de Chamada Pelo App",
          "Foto de Chave de Uso do Ve\xEDculo (Furto)"
        ),
        showWhen: { field: "requestExtraDocuments", in: ["sim"] },
        section: LINKS,
        binding: { subject: "pendency_list", kind: "documentacao_complementar" }
      },
      excluded2("Script CAF", "long_text", MESSAGES_TAB),
      excluded2("Script do ZapSing", "long_text", MESSAGES_TAB)
    ]
  },
  {
    code: "documentacao",
    label: "Documenta\xE7\xE3o",
    kind: "stage",
    moves: ["entrada", "analise_de_evento"],
    situations: ["aguardando_documentos", "entrega_parcial", "em_validacao"],
    fields: [
      /* O que era de "Ag. Docs e Ass. Termo"… */
      {
        key: "customerNotifiedAt",
        section: CUSTOMER_NOTICE,
        label: "Data de Comunica\xE7\xE3o ao Cliente",
        type: "datetime",
        required: false,
        /* "Data de quando o card entrou nesta fase", diz o pipe. */
        help: "Calculado: quando o sinistro entrou na Documenta\xE7\xE3o.",
        binding: { subject: "passage_entered" }
      },
      excluded2("Script do ZapSing", "long_text", MESSAGES_TAB),
      {
        ...document2("driverLicense", "CNH - Carteira Nacional de Habilita\xE7\xE3o", "cnh"),
        section: MEMBER_DOCS
      },
      {
        ...document2("proofOfAddress", "Comprovante de Endere\xE7o", "comprovante_endereco"),
        section: MEMBER_DOCS
      },
      {
        ...document2("vehicleRegistration", "Documento do Ve\xEDculo - CRLV", "crlv"),
        section: MEMBER_DOCS
      },
      {
        ...document2("policeReport", "Boletim de Ocorr\xEAncia", "boletim_ocorrencia"),
        section: MEMBER_DOCS
      },
      {
        ...document2("medicalRecord", "Prontu\xE1rio M\xE9dico", "prontuario_medico"),
        section: MEMBER_DOCS
      },
      {
        ...document2(
          "extraVehiclePhotos",
          "Fotos complementares do Ve\xEDculo",
          "foto_veiculo"
        ),
        section: MEMBER_DOCS
      },
      {
        ...document2(
          "appCallProof",
          "Comprovante de Chamada Pelo App",
          "comprovante_chamada_app"
        ),
        section: MEMBER_DOCS
      },
      {
        ...document2(
          "keyPhoto",
          "Foto de Chave de Uso do Ve\xEDculo (Furto)",
          "foto_chave_uso"
        ),
        section: MEMBER_DOCS
      },
      /* …e de "Validação de Documentos": duas colunas, uma etapa (06/10/2026). */
      excluded2("Motivo de Sugest\xE3o de Negativa", "long_text", OUT_OF_FLOW_1510),
      {
        key: "zapsignLink",
        label: "Link ZapSign",
        type: "short_text",
        required: false,
        /* Veio da Entrada em 20/10/2026: o departamento só cria o termo de
           acionamento no ZapSign e manda o link depois que o associado envia
           a documentação. */
        section: TERMS,
        binding: { subject: "claim", column: "zapsignLink" }
      },
      {
        ...document2(
          "thirdPartyTerm",
          "Termo de Acionamento de Sinistro - Terceiros",
          "termo_acionamento_terceiro",
          true
        ),
        /* Cada tipo tem o seu termo, e só o seu (decisão do dono em
           16/10/2026): o terceiro vê e entrega o dele, o associado o dele.
           Até então o do terceiro aparecia sempre e o do associado era
           exigido também no sinistro do terceiro. */
        showWhen: { claimType: "terceiro" },
        section: TERMS
      },
      {
        ...document2(
          "memberTerm",
          "Termo de Acionamento de Sinistro - Associado",
          "termo_acionamento_associado",
          true
        ),
        showWhen: { claimType: "associado" },
        section: TERMS
      },
      excluded2("Resultado de Valida\xE7\xE3o", "select", OUT_OF_FLOW_1510, true)
    ]
  },
  {
    code: "analise_de_evento",
    label: "An\xE1lise de Evento",
    kind: "stage",
    moves: [
      "entrada",
      "documentacao",
      "aprovado_para_reparo",
      "sindicancia",
      "negativas_a_enviar",
      "concluido_somente_terceiro"
    ],
    fields: [
      {
        ...document2(
          "regulationDocuments",
          "Documenta\xE7\xE3o An\xE1lise de Regulagem",
          "documentacao_regulagem",
          true
        ),
        /* Some — e deixa de ser exigida — quando o resultado é Sindicância
           (decisão do dono em 16/10/2026). Sem resultado, aparece. */
        showWhen: { field: "analystResult", notIn: [TO_INVESTIGATION] },
        section: ANALYST
      },
      {
        key: "analystOpinion",
        section: ANALYST,
        label: "Parecer do Analista",
        type: "long_text",
        required: true,
        binding: { subject: "decision", kind: "resultado_analista", column: "notes" }
      },
      {
        key: "analystResult",
        section: ANALYST,
        label: "Resultado Analista",
        type: "select",
        required: true,
        options: options2(
          "Aprovado para Reparo",
          "Enviar para Sindic\xE2ncia",
          "Pend\xEAncia de Documentos",
          "Sugest\xE3o de Negativa",
          "Negativas a Enviar",
          "Desist\xEAncia",
          "Conclu\xEDdo somente terceiro"
        ),
        binding: { subject: "decision", kind: "resultado_analista", column: "result" }
      },
      {
        key: "inspectionNeeded",
        /* Só quando o resultado é Sindicância (decisão do dono em 16/10/2026). */
        showWhen: { field: "analystResult", in: [TO_INVESTIGATION] },
        section: ANALYST,
        label: "Ser\xE1 necess\xE1rio per\xEDcia?",
        type: "select",
        required: true,
        options: YES_NO,
        binding: { subject: "decision", kind: "pericia_necessaria", column: "result" }
      },
      { ...causedBy, section: RESPONSIBILITY },
      { ...thirdPartyIdentified, section: RESPONSIBILITY }
    ]
  },
  {
    code: "aprovado_para_reparo",
    label: "Aprovado para Reparo",
    kind: "handoff",
    moves: [],
    fields: []
  },
  {
    code: "sindicancia",
    label: "Sindic\xE2ncia",
    kind: "stage",
    moves: [
      "entrada",
      "analise_de_evento",
      "aprovado_para_reparo",
      "negativas_a_enviar",
      "indenizacao"
    ],
    fields: [
      {
        ...document2("collectedEvidence", "Evid\xEAncias Coletadas", "evidencia"),
        section: INVESTIGATION
      },
      {
        key: "vehicleSituation",
        showWhen: THEFT_ONLY,
        section: RECOVERY,
        label: "Situa\xE7\xE3o do Ve\xEDculo",
        type: "select",
        required: false,
        options: options2(
          "N\xE3o Recuperado / Seguir para Indeniza\xE7\xE3o",
          "Recuperado (Avariado - Enviar para Reparo)",
          "Recuperado (Perta Total - Enviar para Indeniza\xE7\xE3o)",
          "Recuperado (Sem Reparo/Devolver ao Associado)"
        ),
        binding: { subject: "decision", kind: "situacao_veiculo", column: "result" }
      },
      {
        key: "recoveredOn",
        showWhen: THEFT_ONLY,
        section: RECOVERY,
        label: "Data da Recupera\xE7\xE3o",
        type: "datetime",
        required: false,
        dateOnly: true,
        binding: { subject: "recovery", column: "recoveredOn" }
      },
      {
        key: "recoveryNotes",
        showWhen: THEFT_ONLY,
        section: RECOVERY,
        label: "Observa\xE7\xE3o/Avarias da Recupera\xE7\xE3o",
        type: "long_text",
        required: false,
        binding: { subject: "recovery", column: "notes" }
      },
      {
        ...document2(
          "recoveredVehiclePhotos",
          "Fotos do Ve\xEDculo Recuperado",
          "foto_veiculo_recuperado"
        ),
        showWhen: THEFT_ONLY,
        section: RECOVERY
      },
      {
        ...document2(
          "recoveryReport",
          "Auto de Entrega / BO de Recupera\xE7\xE3o",
          "auto_entrega"
        ),
        showWhen: THEFT_ONLY,
        section: RECOVERY
      },
      {
        key: "investigatorReport",
        section: INVESTIGATION,
        label: "Relat\xF3rio do Sindicante",
        type: "long_text",
        required: false,
        binding: { subject: "decision", kind: "conclusao_analise", column: "notes" }
      },
      {
        key: "investigationConclusion",
        section: INVESTIGATION,
        label: "Conclus\xE3o da An\xE1lise",
        type: "select",
        required: false,
        options: options2("Procedente (Aprovar)", "Improcedente (Negar/Jur\xEDdico)"),
        binding: { subject: "decision", kind: "conclusao_analise", column: "result" }
      },
      {
        key: "investigationDue",
        section: INVESTIGATION,
        label: "Vencimento Sindic\xE2ncia",
        type: "date",
        required: false,
        binding: { subject: "passage", column: "dueAt" }
      },
      { ...causedBy, section: RESPONSIBILITY },
      { ...thirdPartyIdentified, section: RESPONSIBILITY }
    ]
  },
  {
    code: "negativas_a_enviar",
    label: "Negativas a Enviar",
    kind: "stage",
    /* Negados com Posse não é mais destino: virou a parada `negado_com_posse`
       (16/10/2026) — ver `ANALYSIS_POSSESSION`. */
    moves: ["sindicancia", "negado"],
    situations: ["carta_em_elaboracao", "enviada_ao_associado", "cliente_ciente"],
    fields: [
      {
        key: "legalAnalyst",
        section: DENIAL,
        label: "Analista jur\xEDdico",
        type: "assignee_select",
        required: false,
        binding: { subject: "passage", column: "assignedTo" }
      },
      {
        key: "denialReason",
        section: DENIAL,
        label: "Motivo da Negativa",
        type: "select",
        required: true,
        options: DENIAL_REASONS,
        binding: { subject: "decision", kind: "negativa", column: "result" }
      },
      denialDetail(
        "driverConductDetail",
        "Especificar conduta do condutor",
        "Conduta do Condutor",
        [
          "Excesso de velocidade",
          "Embriaguez comprovada",
          "Sinais de embriaguez",
          "Recusa ao teste do etil\xF4metro",
          "Influ\xEAncia de subst\xE2ncia psicoativa",
          "Uso de telefone celular",
          "Dire\xE7\xE3o perigosa",
          "Manobra perigosa",
          "Participa\xE7\xE3o em competi\xE7\xE3o/racha",
          "Fadiga ou sono ao volante",
          "Condutor n\xE3o habilitado",
          "CNH vencida",
          "Categoria da CNH incompat\xEDvel",
          "Omiss\xE3o do real condutor",
          "Abandono do local do acidente",
          "Outros"
        ]
      ),
      denialDetail(
        "trafficViolationDetail",
        "Especificar infra\xE7\xE3o de tr\xE2nsito",
        "Infra\xE7\xE3o de Tr\xE2nsito",
        [
          "Avan\xE7o de sinal vermelho",
          "Desrespeito \xE0 prefer\xEAncia de passagem",
          "Convers\xE3o em local proibido",
          "Retorno em local proibido",
          "Ultrapassagem em local proibido",
          "Transitar na contram\xE3o",
          "Mudan\xE7a de faixa sem seguran\xE7a",
          "Falta de dist\xE2ncia de seguran\xE7a",
          "Transposi\xE7\xE3o de canteiro central",
          "Trafegar pelo acostamento",
          "Estacionamento irregular",
          "Parada irregular",
          "Marcha \xE0 r\xE9 em local proibido",
          "Outros"
        ]
      ),
      denialDetail(
        "vehicleConditionDetail",
        "Especificar situa\xE7\xE3o do ve\xEDculo",
        "Situa\xE7\xE3o do Ve\xEDculo",
        [
          "Falta de manuten\xE7\xE3o",
          "Defeito mec\xE2nico preexistente",
          "Defeito el\xE9trico preexistente",
          "Pneus em condi\xE7\xF5es inadequadas",
          "Excesso de carga",
          "Transporte irregular de carga",
          "Altera\xE7\xE3o das caracter\xEDsticas do ve\xEDculo",
          "Modifica\xE7\xE3o n\xE3o informada",
          "Cal\xE7o hidr\xE1ulico",
          "Inc\xEAndio sem cobertura contratual",
          "Dano preexistente",
          "Acess\xF3rio n\xE3o coberto",
          "Ve\xEDculo sem condi\xE7\xF5es de circula\xE7\xE3o",
          "Outros"
        ]
      ),
      denialDetail(
        "contractBreachDetail",
        "Especificar descumprimento contratual",
        "Descumprimento Contratual",
        [
          "Inadimpl\xEAncia",
          "Evento n\xE3o coberto pelo regulamento",
          "Descumprimento de cl\xE1usula regulamentar",
          "Agravamento intencional do risco",
          "Agravamento dos danos",
          "Omiss\xE3o de informa\xE7\xF5es",
          "Declara\xE7\xE3o falsa",
          "Comunica\xE7\xE3o intempestiva do sinistro",
          "Aus\xEAncia de documentos obrigat\xF3rios",
          "Descumprimento do dever de mitiga\xE7\xE3o dos preju\xEDzos",
          "Grau de parentesco",
          "Outros"
        ]
      ),
      denialDetail("fraudDetail", "Especificar fraude ou il\xEDcito", "Fraude ou Il\xEDcito", [
        "Fraude",
        "Tentativa de fraude",
        "Simula\xE7\xE3o de sinistro",
        "Apropria\xE7\xE3o ind\xE9bita",
        "Estelionato",
        "Desaparecimento sem comprova\xE7\xE3o",
        "Adultera\xE7\xE3o documental",
        "Outros"
      ]),
      denialDetail("causalLinkDetail", "Especificar nexo causal", "Nexo Causal", [
        "Aus\xEAncia de nexo causal",
        "Laudo pericial inconclusivo",
        "Impossibilidade de comprova\xE7\xE3o do evento",
        "Diverg\xEAncia entre documentos e danos",
        "Outros"
      ]),
      {
        key: "legalOpinion",
        section: DENIAL,
        label: "Parecer Analista Jur\xEDdico",
        type: "long_text",
        required: false,
        binding: { subject: "decision", kind: "negativa", column: "notes" }
      },
      {
        ...document2("supportingEvidence", "Evid\xEAncias Comprobat\xF3rias", "evidencia"),
        section: DENIAL
      },
      {
        ...document2("analysisReport", "Laudo de An\xE1lise", "laudo_analise"),
        section: DENIAL
      },
      {
        key: "vehicleInYard",
        section: YARD,
        label: "Ve\xEDculo est\xE1 em base?",
        type: "select",
        required: true,
        options: YES_NO,
        binding: { subject: "decision", kind: "veiculo_em_base", column: "result" }
      },
      {
        key: "yardName",
        section: YARD,
        label: "Nome da base",
        type: "short_text",
        required: true,
        showWhen: { field: "vehicleInYard", in: ["sim"] },
        binding: { subject: "decision", kind: "veiculo_em_base", column: "reason" }
      },
      {
        key: "yardAddress",
        section: YARD,
        label: "Endere\xE7o da base",
        type: "short_text",
        required: true,
        showWhen: { field: "vehicleInYard", in: ["sim"] },
        binding: { subject: "decision_address", kind: "veiculo_em_base" }
      },
      {
        key: "dispatchStatus",
        section: DISPATCH,
        label: "Status do Envio",
        type: "select",
        required: false,
        options: options2("Carta em Elabora\xE7\xE3o", "Enviada ao Associado", "Cliente Ciente"),
        binding: { subject: "passage_status" }
      },
      {
        key: "dispatchedAt",
        section: DISPATCH,
        label: "Data do Envio",
        type: "datetime",
        required: false,
        binding: { subject: "dispatch_date" }
      },
      {
        key: "dispatchChannels",
        section: DISPATCH,
        label: "Canal de Envio",
        type: "checklist_vertical",
        required: false,
        /* O código é o de `claims_contacts.channel`. */
        options: [
          { value: "email", label: "E-mail" },
          { value: "whatsapp", label: "WhatsApp" },
          { value: "correios", label: "Correios" }
        ],
        binding: { subject: "dispatch_channels" }
      },
      {
        ...document2("denialLetter", "Carta de Negativa", "carta_negativa"),
        section: DISPATCH
      }
    ]
  },
  {
    code: "indenizacao",
    label: "Indeniza\xE7\xE3o",
    kind: "handoff",
    moves: [],
    fields: []
  },
  {
    code: "desistencia",
    label: "Desist\xEAncia",
    kind: "general",
    moves: [],
    fields: []
  },
  {
    code: "negados_com_posse",
    label: "Negados com Posse",
    kind: "general",
    moves: [],
    fields: [
      {
        key: "vehicleReturned",
        section: RETURN,
        label: "Ve\xEDculo devolvido:",
        type: "select",
        required: true,
        options: options2("Sim", "Recusa do Associado."),
        binding: { subject: "decision", kind: "veiculo_devolvido", column: "result" }
      },
      {
        key: "returnJustification",
        section: RETURN,
        label: "Justificativa:",
        type: "long_text",
        required: false,
        binding: { subject: "decision", kind: "veiculo_devolvido", column: "reason" }
      },
      {
        ...document2("possessionEvidence", "Evid\xEAncias", "evidencia", true),
        section: RETURN
      },
      {
        key: "possessionNotes",
        section: RETURN,
        label: "Observa\xE7\xF5es",
        type: "long_text",
        required: true,
        /* Era a coluna `notes` da decisão; observação é comentário (20/10/2026). */
        binding: { subject: "comment" }
      }
    ]
  },
  {
    code: "negados_com_posse_juridico",
    label: "Negados com Posse Jur\xEDdico",
    kind: "general",
    moves: [],
    fields: []
  },
  {
    code: "negado",
    label: "Negado",
    kind: "general",
    moves: [],
    fields: []
  },
  {
    code: "concluido_somente_terceiro",
    label: "Conclu\xEDdo Somente Terceiro",
    kind: "general",
    moves: [],
    fields: []
  }
];
var ANALYSIS_PHASES = Object.fromEntries(PHASES2.map((p) => [p.code, p]));
function analysisPhaseOf(phase) {
  return ANALYSIS_PHASES[phase];
}
function analysisPhaseLabel(phase) {
  return analysisPhaseOf(phase)?.label ?? phase;
}
function analysisMoveDirection(from, to) {
  return catalogMoveDirection(ANALYSIS_PIPE_ORDER, from, to);
}
function isAnalysisOutcome(phase) {
  const kind = analysisPhaseOf(phase)?.kind;
  return kind === "handoff" || kind === "general";
}
function isAnalysisGeneralPhase(phase) {
  return analysisPhaseOf(phase)?.kind === "general";
}
function analysisMovesOf(phase, hold = null, state = {}) {
  const catalog = {
    order: ANALYSIS_PIPE_ORDER,
    phases: ANALYSIS_PHASES,
    withdrawal: WITHDRAWAL_OUTCOME
  };
  if (hold === ANALYSIS_POSSESSION.hold) {
    return {
      forward: [],
      handoffs: [],
      outcomes: [...ANALYSIS_POSSESSION.outcomes],
      back: catalogMovesOf(catalog, phase).back
    };
  }
  const moves = catalogMovesOf(catalog, phase, hold);
  if (!hold && isVehicleInYard(phase, state)) {
    moves.outcomes = moves.outcomes.filter((to) => to !== "negado");
  }
  return moves;
}
function isAnalysisMoveAllowed(from, to, hold, state = {}) {
  const m = analysisMovesOf(from, hold, state);
  return [...m.forward, ...m.handoffs, ...m.outcomes, ...m.back].includes(to);
}
var ANALYSIS_POSSESSION = {
  hold: "negado_com_posse",
  /** Onde a parada é oferecida. */
  phase: "negativas_a_enviar",
  /** O formulário que se preenche ao encerrar. */
  form: "negados_com_posse",
  outcomes: ["negado", "negados_com_posse_juridico"]
};
function isVehicleInYard(phase, state) {
  return phase === ANALYSIS_POSSESSION.phase && state.vehicleInYard === "sim";
}
function possessionOutcomeOf(state) {
  switch (state.vehicleReturned) {
    case "sim":
      return "negado";
    case "recusa_do_associado":
      return "negados_com_posse_juridico";
    default:
      return null;
  }
}
function visibleAnalysisFields(phase) {
  return visibleCatalogFields(ANALYSIS_PHASES[phase]);
}
function isDerivedAnalysisField(field4) {
  const s = field4.binding.subject;
  return s === "contact_count" || s === "contact_due" || s === "integration" || s === "passage_entered";
}
function isPassageBoundAnalysisField(field4) {
  const s = field4.binding.subject;
  return s === "passage" || s === "passage_status";
}
function isAnalysisCorrectablePhase(phase, current, visited) {
  return phase !== current && ANALYSIS_WORK_STAGES.includes(phase) && visited.includes(phase);
}
function analysisChecklistValues(value2) {
  return catalogChecklistValues(value2);
}
function analysisConditionHolds(condition, state, context) {
  return catalogConditionHolds(condition, state, context);
}
function shownAnalysisFields(phase, state, context) {
  return shownCatalogFields(ANALYSIS_PHASES[phase], state, context);
}
function isAnalysisFieldRequired(field4, state, context) {
  return isCatalogFieldRequired(field4, state, context);
}
function isAnalysisFieldFilled(field4, state) {
  return isCatalogFieldFilled(field4, state);
}
function missingAnalysisFields(phase, state, context) {
  return missingCatalogFields(ANALYSIS_PHASES[phase], state, context);
}
function documentationSituation(files, context) {
  const attachments = shownAnalysisFields("documentacao", {}, context).filter(
    (f) => f.type === "attachment" && f.key
  );
  const has = (f) => (files[f.key] ?? 0) > 0;
  if (!attachments.some(has)) return "aguardando_documentos";
  const required = attachments.filter((f) => isAnalysisFieldRequired(f, {}, context));
  return required.every(has) ? "em_validacao" : "entrega_parcial";
}
function moneyInputText(value2) {
  return (value2 / 100).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
function analysisValueText(field4, value2) {
  return catalogValueText(field4, value2);
}

// src/labels.ts
var LABEL_COLORS = STAGE_COLORS;
var LABEL_NAME_MAX = 40;
function labelChanges(current, next, mine) {
  const has = new Set(current);
  const wants = new Set(next);
  const own = new Set(mine.map((l) => l.id));
  const placeable = new Set(mine.filter((l) => !l.archived).map((l) => l.id));
  return {
    add: [...wants].filter((id) => !has.has(id) && placeable.has(id)),
    remove: [...has].filter((id) => own.has(id) && !wants.has(id)),
    refused: [...wants].filter((id) => !has.has(id) && !placeable.has(id))
  };
}

// src/claims-deadlines.ts
var MINUTE2 = 6e4;
var HOUR2 = 60 * MINUTE2;
var DAY2 = 24 * HOUR2;
var CLAIM_DUE_SOON_MS = DAY2;
var PHASE_SLA_SOON_RATIO = 0.8;
var MAX_DEADLINE_HOURS = 24 * 365;
function slaDeadline(enteredAt, deadlineHours, dayKind, holidays) {
  if (deadlineHours === null || deadlineHours === void 0) return null;
  if (dayKind === "uteis") {
    return addBusinessDays(enteredAt, Math.round(deadlineHours / 24), holidays);
  }
  return new Date(enteredAt.getTime() + deadlineHours * HOUR2);
}
var CONTACT_DUE_BUSINESS_DAYS = 1;
var SLA_DEPARTMENTS = [
  "analise",
  "reparo",
  "indenizacao",
  "perifericos"
];
var SLA_PHASES = {
  analise: ANALYSIS_WORK_STAGES,
  reparo: REPAIR_WORK_STAGES,
  indenizacao: COMPENSATION_WORK_STAGES,
  perifericos: PERIPHERAL_WORK_STAGES
};
function isSlaPhase(department, phase) {
  return SLA_DEPARTMENTS.includes(department) && SLA_PHASES[department].includes(phase);
}
function isDueDepartment(department) {
  return CLAIM_DEPARTMENTS.includes(department);
}
var at = (value2) => value2 instanceof Date ? value2 : new Date(value2);
function claimDueState(dueAt, now = /* @__PURE__ */ new Date()) {
  if (dueAt === null || dueAt === void 0) return null;
  const left = at(dueAt).getTime() - at(now).getTime();
  if (left <= 0) return "vencido";
  if (left <= CLAIM_DUE_SOON_MS) return "vence_em_breve";
  return "no_prazo";
}
function phaseSlaState(enteredAt, deadlineAt, now = /* @__PURE__ */ new Date()) {
  if (deadlineAt === null || deadlineAt === void 0) return null;
  const start = at(enteredAt).getTime();
  const end = at(deadlineAt).getTime();
  const current = at(now).getTime();
  if (current >= end) return "expirado";
  const span = end - start;
  if (span > 0 && (current - start) / span >= PHASE_SLA_SOON_RATIO) {
    return "expira_em_breve";
  }
  return "no_prazo";
}
function formatSpan(ms) {
  const value2 = Math.max(0, ms);
  if (value2 < HOUR2) return `${Math.max(1, Math.floor(value2 / MINUTE2))} min`;
  if (value2 < DAY2) return `${Math.floor(value2 / HOUR2)}h`;
  return count(Math.floor(value2 / DAY2), "dia", "dias");
}

// src/claims-rotations.ts
var ROTATION_DEPARTMENTS = SLA_DEPARTMENTS;
var ROTATION_PHASES = SLA_PHASES;
var ROTATION_NAME_MAX = 60;
function isRotationDepartment(value2) {
  return ROTATION_DEPARTMENTS.includes(value2);
}
function isRotationPhase(department, phase) {
  return isRotationDepartment(department) && ROTATION_PHASES[department].includes(phase);
}
function isSupervisionPhase(department, phase) {
  return department === "reparo" && isRepairSupervisionStage(phase);
}
function nextInRotation(seats, lastUserId) {
  const ordered = [...seats].sort((a, b) => a.position - b.position);
  const eligible = ordered.filter((s) => s.eligible);
  if (eligible.length === 0) return null;
  const last = ordered.find((s) => s.userId === lastUserId);
  if (!last) return eligible[0].userId;
  return (eligible.find((s) => s.position > last.position) ?? eligible[0]).userId;
}
function rotationOutcome(input) {
  const { rotationId, fromRotationId, current, previous, seats, lastUserId } = input;
  if (rotationId === null) return { kind: "manter" };
  if (fromRotationId === rotationId && current !== null) return { kind: "manter" };
  const canReceive = (userId) => seats.some((s) => s.userId === userId && s.eligible);
  if (previous !== null && canReceive(previous)) {
    return previous === current ? { kind: "manter" } : { kind: "voltar", userId: previous };
  }
  const next = nextInRotation(seats, lastUserId);
  if (next === null) return { kind: "sem_pessoa" };
  return next === current ? { kind: "manter" } : { kind: "rodizio", userId: next };
}
function rotationProblems(department, rotations) {
  const problems = [];
  const names = /* @__PURE__ */ new Set();
  const phases = /* @__PURE__ */ new Map();
  rotations.forEach((r, index) => {
    const name = r.name.trim();
    const label = name || `O rod\xEDzio ${index + 1}`;
    if (!name) problems.push(`O rod\xEDzio ${index + 1} precisa de um nome.`);
    else if (name.length > ROTATION_NAME_MAX) {
      problems.push(`"${name}": o nome tem no m\xE1ximo ${ROTATION_NAME_MAX} caracteres.`);
    } else if (names.has(name.toLocaleLowerCase("pt-BR"))) {
      problems.push(`H\xE1 dois rod\xEDzios chamados "${name}".`);
    }
    names.add(name.toLocaleLowerCase("pt-BR"));
    for (const phase of r.phases) {
      if (!isRotationPhase(department, phase)) {
        problems.push(`${label}: a fase "${phase}" n\xE3o \xE9 etapa deste departamento.`);
        continue;
      }
      const owner = phases.get(phase);
      if (owner !== void 0) {
        problems.push(`A fase "${phase}" est\xE1 em "${owner}" e em "${label}".`);
      }
      phases.set(phase, label);
    }
    const supervised = r.phases.filter((p) => isSupervisionPhase(department, p));
    if (supervised.length > 0 && supervised.length < r.phases.length) {
      problems.push(
        `${label}: as fases do supervisor ficam num rod\xEDzio s\xF3 delas, sem as do operador.`
      );
    }
    const seen = /* @__PURE__ */ new Set();
    for (const m of r.members) {
      if (seen.has(m.userId))
        problems.push(`${label}: a mesma pessoa aparece duas vezes.`);
      seen.add(m.userId);
    }
  });
  return problems;
}

// src/claims-messages.ts
var CLAIM_MESSAGES = [
  {
    department: "analise",
    kind: "caf",
    label: "Script CAF",
    source: "o link da CAF",
    column: "cafScript"
  },
  {
    department: "analise",
    kind: "zapsign",
    label: "Script do ZapSign",
    source: "o link do ZapSign",
    column: "zapsignScript"
  },
  {
    department: "reparo",
    kind: "encaminhamento",
    label: "Mensagem de encaminhamento",
    source: 'o campo "Oficina Credenciada"'
  }
];
function messageRecipient(name) {
  const trimmed = name?.trim();
  return trimmed ? trimmed : "Cliente";
}
var CLOSING = `

Desde j\xE1 agradecemos.
Em caso de d\xFAvidas, estamos \xE0 disposi\xE7\xE3o.
`;
function zapsignMessage(input) {
  const link = input.link?.trim();
  if (!link) return null;
  return `Prezado ${messageRecipient(input.name)},

Informamos que a sua solicita\xE7\xE3o de Sinistro encontra-se na fase de \u{1F4C2} *Assinatura do Termo de Acionamento*.

Solicitamos que acesse os links abaixo e siga o passo a passo para a Assinatura do Termo de Acionamento.


\u{1F449} *Passo 1\uFE0F\u20E3 \u2013 Assinatura do Termo de Acionamento:*
${link}
${CLOSING}`;
}
function cafMessage(input) {
  const link = input.link?.trim();
  if (!link) return null;
  let message = `Prezado ${messageRecipient(input.name)},

Informamos que a sua solicita\xE7\xE3o de Sinistro encontra-se na fase de \u{1F4C2} *Envio de Documentos*.

Solicitamos que acesse os links abaixo e siga o passo a passo para o Envio de Documenta\xE7\xE3o.


\u{1F449} *Passo 1\uFE0F\u20E3 \u2013 Envio de Documentos:*
${link}
`;
  if (input.extraDocuments.length > 0) {
    message += `

\u26A0\uFE0F *Aten\xE7\xE3o!*
\xC9 obrigat\xF3rio o envio dos seguintes documentos complementares no processo:

${input.extraDocuments.map((d) => `\u2022 ${d}`).join("\n")}
`;
  }
  return message + CLOSING;
}
function upperWithoutAccents(text) {
  return text.normalize("NFD").replace(/[̀-ͯ]/g, "").toUpperCase();
}
var BENEFIT_PRODUCTS = [
  { kind: "carro_reserva", pattern: /\bCARRO\s+RESERVA\b/ },
  { kind: "auxilio_gard", pattern: /\bAUXILIO\s+GARD\b/ }
];
var BENEFIT_DAYS = /(\d{1,3})\s*DIAS?\b/;
function repairBenefitsOf(products) {
  const out = [];
  for (const { kind, pattern } of BENEFIT_PRODUCTS) {
    const product = products.find(
      (p) => p.label !== null && pattern.test(upperWithoutAccents(p.label)) && upperWithoutAccents(p.erpStatus ?? "").trim() === "ATIVO"
    );
    if (!product) continue;
    const days = BENEFIT_DAYS.exec(upperWithoutAccents(product.label));
    out.push({ kind, days: days ? Number(days[1]) : null });
  }
  return out;
}
function workshopAddress(w) {
  const parts = [
    w.street,
    w.number ? `N\xB0${w.number}` : null,
    w.neighborhood,
    w.city && w.state ? `${w.city}-${w.state}` : w.city
  ].filter((p) => !!p && p.trim() !== "");
  return parts.length > 0 ? parts.join(", ") : "N\xE3o informado";
}
function benefitLine(b) {
  const period = b.days !== null ? `${b.days} dias` : "per\xEDodo n\xE3o informado";
  return b.kind === "carro_reserva" ? `\u{1F697} Carro reserva por at\xE9 ${period}` : `\u{1F6E1}\uFE0F Aux\xEDlio Gard por ${period}`;
}
var WORKSHOP_HOURS = "\u{1F552} Atendimento: segunda a sexta, das 08h \xE0s 17h.";
var QUOTE_DEADLINE = "\u{1F4CB} Ap\xF3s a entrada do ve\xEDculo na oficina, ela ter\xE1 at\xE9 05 dias \xFAteis para realizar a vistoria, elaborar o or\xE7amento e cotar as pe\xE7as. Esse prazo n\xE3o corresponde ao prazo de conclus\xE3o do reparo.";
var REPAIR_DEADLINE = "\u23F3 O prazo do reparo pode variar conforme a disponibilidade de pe\xE7as, a complexidade dos danos e a necessidade de servi\xE7os adicionais.";
var REFERRAL_CLOSING = `Em caso de d\xFAvidas, fale com a oficina ou com nossa equipe.
Agradecemos a confian\xE7a! \u{1F697}`;
function repairReferralMessage(input) {
  const w = input.workshop;
  if (!w) return null;
  const name = messageRecipient(input.name);
  const workshop = `\u{1F6E0}\uFE0F Oficina: ${w.name}
\u{1F4DE} Telefone: ${w.phone?.trim() || "N\xE3o informado"}
\u{1F4CD} Endere\xE7o: ${workshopAddress(w)}
${WORKSHOP_HOURS}`;
  if (input.claimType !== "associado") {
    return `Ol\xE1 ${name}! Tudo bem? \u{1F60A}

Seu evento foi aprovado \u2705

\u{1F3C1} *Pr\xF3ximo passo*
O ve\xEDculo dever\xE1 ser deixado na oficina credenciada para vistoria e elabora\xE7\xE3o do or\xE7amento.

${workshop}

${QUOTE_DEADLINE}

${REPAIR_DEADLINE}

${REFERRAL_CLOSING}`;
  }
  const participation = input.participation != null ? format(input.participation) : "valor a consultar na oficina";
  const benefits = input.benefits ?? [];
  const benefitsBlock = benefits.length > 0 ? `

\u{1F381} *Benef\xEDcios dispon\xEDveis:*
${benefits.map((b) => `\u2022 ${benefitLine(b)}`).join("\n")}` : "";
  return `Ol\xE1 ${name}! Tudo bem? \u{1F60A}

\u2705 Seu evento foi *APROVADO*!

\u{1F697} Ve\xEDculo: ${input.model?.trim() || "N\xE3o informado"}
\u{1F516} Placa: ${input.plate?.trim() || "N\xE3o informada"}

\u{1F3C1} *Pr\xF3ximo passo*
O ve\xEDculo dever\xE1 ser deixado na oficina credenciada para vistoria e elabora\xE7\xE3o do or\xE7amento.
Se o ve\xEDculo estiver com voc\xEA, leve-o \xE0 oficina;
Se estiver em nossa base, nossa equipe providenciar\xE1 o transporte.

${workshop}

${QUOTE_DEADLINE}

\u{1F4B3} Ap\xF3s a aprova\xE7\xE3o do or\xE7amento, a Participa\xE7\xE3o Individual (PI) de ${participation} dever\xE1 ser paga diretamente \xE0 oficina.
\u2705 A compra das pe\xE7as e o in\xEDcio do reparo ocorrer\xE3o somente ap\xF3s a confirma\xE7\xE3o do pagamento da PI.

${REPAIR_DEADLINE}${benefitsBlock}

${REFERRAL_CLOSING}`;
}

// src/claims-repair.ts
var REPAIR_QUOTE_MONEY_COLUMNS = /* @__PURE__ */ new Set([
  "partsTotal",
  "laborTotal",
  "grossTotal",
  "netTotal",
  "salvagePurchaseAmount",
  "associationRepairCost",
  "associationSaleCost",
  "associationAgreement10Cost",
  "associationAgreementAvCost",
  "invoiceAmount"
]);
var REPAIR_SITUATIONS = {
  /* Da Entrada, que saiu em 21/10/2026 — fica pelo texto das passagens fechadas. */
  aguardando_retorno: "Aguardando retorno",
  aguardando_cliente_agendar: "Aguardando cliente agendar",
  agendado_data_definida: "Agendado",
  cliente_nao_compareceu_reagendar: "Cliente n\xE3o compareceu",
  veiculo_em_oficina_mover_para_orcamento: "Ve\xEDculo em oficina",
  em_regulagem: "Em regulagem",
  em_negociacao: "Em negocia\xE7\xE3o",
  aguardando_assinatura_do_termo_de_acordo: "Aguardando assinatura do termo",
  termo_de_acordo_assinado: "Termo assinado",
  aguardando_chegada_das_pecas: "Aguardando chegada das pe\xE7as",
  aguardando_parada_para_reparo: "Aguardando parada para reparo",
  pagamento_fornecedor_de_pecas: "Pagamento ao fornecedor de pe\xE7as"
};
function repairSituationLabel(code) {
  return REPAIR_SITUATIONS[code] ?? code;
}
var REPAIR_HANDOFFS = {
  indenizados: { department: "indenizacao", phase: "comunicado_indenizacao" }
};
function repairHandoffOf(phase) {
  return REPAIR_HANDOFFS[phase];
}
var REPAIR_WITHDRAWAL_OUTCOME = "desistencia";
var REPAIR_PIPE_COLUMNS = {
  /* A Entrada saiu em 21/10/2026: as duas colunas são Aguardando Parada. */
  Entrada: { as: "stage", code: "aguardando_parada" },
  "Aguardando Retorno": { as: "stage", code: "aguardando_parada" },
  "Aguardando Parada": { as: "stage", code: "aguardando_parada" },
  "Or\xE7amenta\xE7\xE3o - Oficina": { as: "stage", code: "orcamentacao_oficina" },
  "Regulagem de Or\xE7amento": {
    as: "situation",
    stage: "orcamentacao_oficina",
    code: "em_regulagem"
  },
  "Aprova\xE7\xE3o Supervisor": { as: "stage", code: "aprovacao_supervisor" },
  "Aprovado Supervisor": { as: "result", stage: "aprovacao_supervisor" },
  "Negocia\xE7\xE3o Para Acordo": { as: "stage", code: "negociacao_para_acordo" },
  "Pagamento Associado": { as: "stage", code: "pagamento_associado" },
  "Compra de Pe\xE7as": { as: "stage", code: "compra_de_pecas" },
  "Chegada das Pe\xE7as": {
    as: "situation",
    stage: "compra_de_pecas",
    code: "aguardando_chegada_das_pecas"
  },
  "Aguardando Parada para Reparo": {
    as: "situation",
    stage: "reparo_oficina",
    code: "aguardando_parada_para_reparo"
  },
  "Reparo - Oficina": { as: "stage", code: "reparo_oficina" },
  "Vistoria de Entrega": { as: "stage", code: "vistoria_de_entrega" },
  "Aguardando Faturamento": { as: "stage", code: "aguardando_faturamento" },
  "Fornecedor de Pe\xE7as": {
    as: "situation",
    stage: "aguardando_faturamento",
    code: "pagamento_fornecedor_de_pecas"
  },
  "Retorno/Garantia": { as: "stage", code: "retorno_garantia" },
  "Paralisados - Pend\xEAncia": { as: "hold", code: "pendencia" },
  "Pr\xE9-desistente": { as: "hold", code: "pre_desistencia" },
  Desist\u00EAncia: { as: "general", code: "desistencia" },
  Conclu\u00EDdos: { as: "general", code: "concluidos" },
  Indenizados: { as: "handoff", code: "indenizados" }
};
var REPAIR_PIPE_FIELD_HOMES = {
  "Protocolo OPA": 'Aguardando Parada, Negocia\xE7\xE3o Para Acordo e Retorno/Garantia: o registro "Tentativa de contato" (claims_contacts.opa_suite_protocol), no topo do formul\xE1rio \u2014 obrigat\xF3rio na Negocia\xE7\xE3o e na Garantia (21/10/2026)',
  "Solicita\xE7\xE3o da Garantia": "o momento da tentativa de contato do Retorno/Garantia (claims_contacts.happened_at), que \xE9 obrigat\xF3ria (21/10/2026)",
  "Envio do Or\xE7amento:": "os marcos do bloco do reparo, no alto da mesa \u2014 a data \xE9 da Or\xE7amenta\xE7\xE3o (claims_quotes.sent_on), 21/10/2026",
  "Aprova\xE7\xE3o do Or\xE7amento:": 'os marcos do bloco do reparo, no alto da mesa \u2014 o "Aprovado" da Aprova\xE7\xE3o Supervisor (claims_quotes.approved_at), 21/10/2026',
  "Pagamento da PI (se Associado):": "os marcos do bloco do reparo, no alto da mesa \u2014 a data \xE9 do Pagamento Associado (claims_deductions.resolved_at), 21/10/2026",
  "Chegada das Pe\xE7as:": "os marcos do bloco do reparo, no alto da mesa \u2014 a data \xE9 da Compra de Pe\xE7as (claims_parts.arrived_on), 21/10/2026",
  "Supervisor de Oficinas": 'o respons\xE1vel do card, no alto da mesa \u2014 o rod\xEDzio da Aprova\xE7\xE3o Supervisor o atribui; quem marca "Aprovado" fica em claims_quotes.approved_by (21/10/2026)',
  Valor: 'o "Valor de compra" da Proposta de salvados, na Or\xE7amenta\xE7\xE3o (claims_quotes.salvage_purchase_amount) \u2014 21/10/2026',
  "Data de Vencimento Geral": "o vencimento geral do card, no bot\xE3o do alto da mesa (claims_phase_passages.due_at) \u2014 a Entrada saiu em 21/10/2026",
  "Agendamento 01 - Protocolo OPA": 'o registro "Tentativa de contato", como na An\xE1lise (claims_contacts.opa_suite_protocol) \u2014 Q10',
  "Agendamento 02 - Protocolo OPA": 'o registro "Tentativa de contato", como na An\xE1lise (claims_contacts.opa_suite_protocol) \u2014 Q10',
  "Agendamento 03 - Protocolo OPA": 'o registro "Tentativa de contato", como na An\xE1lise (claims_contacts.opa_suite_protocol) \u2014 Q10',
  "Agendamento 01 - Data do Agendamento": 'o campo da data da parada da etapa (claims_schedulings.scheduled_for) \u2014 "Data da parada para or\xE7amento" na Aguardando Parada, "Data da parada para o reparo" no Reparo - Oficina \u2014 Q13',
  "Agendamento 02 - Data do Agendamento": 'o campo da data da parada da etapa ("para or\xE7amento" ou "para o reparo"): o reagendamento atualiza a data \u2014 Q13',
  "Agendamento 03 - Data do Agendamento": 'o campo da data da parada da etapa ("para or\xE7amento" ou "para o reparo"): o reagendamento atualiza a data \u2014 Q13',
  "Observa\xE7\xF5es relevantes sobre a compra das pe\xE7as:": 'o campo "Observa\xE7\xF5es" da Compra de Pe\xE7as \u2014 um coment\xE1rio (claims_comments), Q3',
  "Observa\xE7\xF5es relevantes sobre a chegada das pe\xE7as:": 'o campo "Observa\xE7\xF5es" da Compra de Pe\xE7as \u2014 um coment\xE1rio (claims_comments), Q3',
  Motivo: 'a parada "Pend\xEAncia", igual \xE0 da An\xE1lise: o texto do pedido (claims_pendencies.message)',
  "Descri\xE7\xE3o da Pend\xEAncia": 'a parada "Pend\xEAncia", igual \xE0 da An\xE1lise \u2014 a mensagem dela (claims_pendencies.message)',
  Resolu\u00E7\u00E3o: 'a retomada da parada "Pend\xEAncia" \u2014 a resolu\xE7\xE3o (claims_pendencies.resolution)',
  Evid\u00EAncias: "a parada da An\xE1lise n\xE3o recebe anexo; o Reparo segue igual (07/10/2026)",
  "Justificativa da desist\xEAncia:": 'a parada "Pedido de desist\xEAncia" \u2014 a decis\xE3o desistencia (claims_decisions.reason)',
  Anexos: "o pedido de desist\xEAncia da An\xE1lise ainda n\xE3o tem campo de anexo; o Reparo segue igual",
  "Data de Comunica\xE7\xE3o de Desist\xEAncia": "a confirma\xE7\xE3o da desist\xEAncia, igual \xE0 da An\xE1lise: o momento fica no evento",
  "Motivo de Desist\xEAncia": "a justificativa do pedido de desist\xEAncia (claims_decisions.reason), igual \xE0 An\xE1lise",
  "Avalia\xE7\xE3o NPS": "saiu pela R8: o NPS do Reparo \xE9 a pesquisa geral (claims_surveys)",
  "Observa\xE7\xF5es NPS": "saiu pela R8: o NPS do Reparo \xE9 a pesquisa geral (claims_surveys)",
  "Anexos NPS": "saiu pela R8: o NPS do Reparo \xE9 a pesquisa geral (claims_surveys)",
  "Status avalia\xE7\xE3o NPS": "saiu pela R8: o NPS do Reparo \xE9 a pesquisa geral (claims_surveys)"
};
var options3 = catalogOptions;
var YES_NO2 = options3("Sim", "N\xE3o");
var PAYMENT_LATER = "O pedido de pagamento ao Financeiro fica de fora por ora (Q6, decis\xE3o de 07/10/2026).";
var PIPEFY_PARTS_AI = "Era do fluxo da IA do Pipefy, que gravava as pe\xE7as extra\xEDdas do documento do Cilia (decis\xE3o de 21/10/2026).";
var WORKSHOP = "Oficina e prazo";
var ROUTING = "Encaminhamento";
var SCHEDULING = "Agendamento da parada";
var QUOTE = "Or\xE7amento da oficina";
var QUOTE_DOCS = "Documentos do or\xE7amento";
var REGULAGEM = "Regulagem";
var SALVAGE_PROPOSAL = "Proposta de salvados";
var COST_ANALYSIS = "An\xE1lise de custo";
var QUOTE_REVIEW = "Supervis\xE3o do or\xE7amento";
var DESTINATION = "Destino do sinistro";
var SPENDING = "Saldo do sinistro";
var NEGOTIATION = "Negocia\xE7\xE3o do acordo";
var AGREEMENT_TERM = "Termo de acordo";
var PARTICIPATION = "Pagamento da participa\xE7\xE3o";
var PARTS_ORDER = "Pedido das pe\xE7as";
var CHEGADA = "Chegada das pe\xE7as";
var TIMELINE = "Parada para o reparo";
var REPAIR_PROGRESS = "Andamento do reparo";
var INSPECTION = "Vistoria";
var DELIVERY = "Parecer, decis\xE3o e entrega";
var INSPECTION_PHOTOS = "Fotos da vistoria";
var BILLING_DOCS = "Documentos do faturamento";
var REGULATOR = "Valida\xE7\xE3o do regulador";
var WARRANTY = "Garantia";
var field2 = (key, label, type, required, binding, extra = {}) => ({ key, label, type, required, binding, ...extra });
var document3 = (key, label, kind, required) => field2(key, label, "attachment", required, { subject: "document", kind });
var comment2 = (key, label, required = false) => field2(key, label, "long_text", required, { subject: "comment" });
var deferred = (label, type, required, reason, extra = {}) => ({
  label,
  type,
  required,
  binding: { subject: "deferred", reason },
  ...extra
});
var excluded3 = (label, type, reason, options5) => ({
  label,
  type,
  required: false,
  binding: { subject: "excluded", reason },
  ...options5 ? { options: options5 } : {}
});
var contactAttempts = (required, section) => field2(
  "contactAttempts",
  "Tentativas de contato",
  "number",
  required,
  { subject: "contact_count" },
  {
    section,
    help: 'Calculado: as tentativas registradas em "Tentativa de contato" nesta etapa.'
  }
);
var scheduledFor = (required, label, help) => field2(
  "scheduledFor",
  label,
  "date",
  required,
  { subject: "scheduling", kind: "parada_oficina", column: "scheduledFor" },
  { section: SCHEDULING, help }
);
var outcome2 = (code, label, kind) => ({ code, label, kind, moves: [], fields: [] });
var PHASES3 = [
  {
    code: "orcamentacao_oficina",
    /* "Orçamentação - Oficina" no pipe; só "Orçamentação" desde 03/11/2026,
       quando ela passou a montar o orçamento próprio (decisão do dono). */
    label: "Or\xE7amenta\xE7\xE3o",
    kind: "stage",
    /* O atalho do pipe para a execução — Pagamento Associado, Compra de Peças
       e Reparo - Oficina — saiu em 29/10/2026: o orçamento passa pela
       Aprovação Supervisor, e a única saída sem ela é a Negociação Para Acordo
       (decisão do dono). As paradas e a desistência não são movimento. */
    moves: ["aguardando_parada", "aprovacao_supervisor", "negociacao_para_acordo"],
    situations: ["em_regulagem"],
    fields: [
      /* O formulário inicial do pipe, que era da Supervisão até 03/11/2026: a
         Orçamentação é a entrada do Reparo, e é nela que a oficina é escolhida. */
      field2(
        "workshopCompanyId",
        "Oficina Credenciada",
        "connector",
        false,
        { subject: "repair", column: "workshopCompanyId" },
        {
          origin: "start_form",
          companyTypes: ["oficina"],
          section: WORKSHOP,
          /* Opcional, como no pipe (Q2 do de-para, 07/10/2026). */
          help: "Uma empresa do tipo oficina, do cadastro de Empresas."
        }
      ),
      field2(
        "quoteDueAt",
        "Prazo de Or\xE7amenta\xE7\xE3o",
        "due_date",
        true,
        { subject: "passage", column: "dueAt" },
        {
          origin: "start_form",
          section: WORKSHOP,
          /* Na passagem da Orçamentação desde 03/11/2026 — era a da
             Supervisão (Q1 do de-para). */
          help: "O prazo que a oficina tem para mandar o or\xE7amento. Aparece no bloco do reparo, no alto da mesa."
        }
      ),
      field2(
        "agreementAttempt",
        "Realizar Tentativa de Acordo",
        "select",
        false,
        { subject: "decision", kind: "tentativa_acordo", column: "result" },
        { origin: "start_form", section: ROUTING, options: YES_NO2 }
      ),
      field2(
        "vehicleInWorkshop",
        "Ve\xEDculo em Oficina",
        "select",
        true,
        { subject: "decision", kind: "veiculo_em_oficina", column: "result" },
        { origin: "start_form", section: ROUTING, options: options3("SIM", "N\xC3O") }
      ),
      {
        ...comment2("supervisorComments", "Coment\xE1rios do Supervisor"),
        origin: "start_form",
        section: ROUTING
      },
      field2(
        "quoteKind",
        "Tipo de Or\xE7amenta\xE7\xE3o:",
        "radio_vertical",
        true,
        { subject: "quote", source: "oficina", column: "kind" },
        {
          section: QUOTE,
          options: options3(
            "Completa com ve\xEDculo parado em oficina (Ve\xEDculo desmontado)",
            "Parcial com ve\xEDculo parado em oficina (Ve\xEDculo n\xE3o foi desmontado)",
            "Parcial ve\xEDculo com cliente (Ve\xEDculo n\xE3o foi desmontado)"
          )
        }
      ),
      field2(
        "quoteSentOn",
        "Data do envio do or\xE7amento:",
        "date",
        true,
        { subject: "quote", source: "oficina", column: "sentOn" },
        { section: QUOTE }
      ),
      {
        ...document3("ciliaQuote", "Or\xE7amento do CILIA", "orcamento_cilia", true),
        section: QUOTE_DOCS
      },
      field2(
        "ciliaNumber",
        "N\xFAmero do Or\xE7amento no Cilia",
        "short_text",
        true,
        { subject: "quote", source: "cilia", column: "externalNumber" },
        { section: QUOTE }
      ),
      {
        ...document3(
          "quotePhotos",
          "Fotos do Ve\xEDculo em Or\xE7amento",
          "fotos_orcamento",
          true
        ),
        section: QUOTE_DOCS
      },
      { ...comment2("quoteNotes", "Observa\xE7\xF5es"), section: QUOTE },
      excluded3(
        "Mover card para",
        "select",
        "Gatilho do Pipefy: quem move \xE9 o painel de movimento.",
        options3("Acordo", "Pr\xE9-desistente")
      ),
      /* A Regulagem de Orçamento — a 2ª seção da etapa. */
      excluded3("Link da Planilha de Cota\xE7\xE3o das Pe\xE7as", "short_text", PIPEFY_PARTS_AI),
      excluded3("Extra\xE7\xE3o de Pe\xE7as", "long_text", PIPEFY_PARTS_AI),
      field2(
        "partsTotal",
        "Total de Pe\xE7as Pela Oficina",
        "currency",
        false,
        { subject: "quote", source: "oficina", column: "partsTotal" },
        { section: REGULAGEM }
      ),
      field2(
        "laborTotal",
        "Total L\xEDquido de M\xE3o de Obra",
        "currency",
        false,
        { subject: "quote", source: "oficina", column: "laborTotal" },
        { section: REGULAGEM }
      ),
      field2(
        "grossTotal",
        "Total Geral",
        "currency",
        false,
        { subject: "quote", source: "oficina", column: "grossTotal" },
        { section: REGULAGEM }
      ),
      field2(
        "netTotal",
        "L\xEDquido Geral",
        "currency",
        false,
        { subject: "quote", source: "oficina", column: "netTotal" },
        { section: REGULAGEM }
      ),
      field2(
        "agreementAv",
        "ACORDO AV",
        "currency",
        false,
        { subject: "agreement", kind: "acordo_av", column: "proposedAmount" },
        { section: REGULAGEM }
      ),
      /* Os campos sem coluna até 21/10/2026, em dois grupos próprios. */
      field2(
        "salvageBuyer",
        "Comprador",
        "short_text",
        false,
        { subject: "quote", source: "oficina", column: "salvageBuyer" },
        { section: SALVAGE_PROPOSAL }
      ),
      field2(
        "salvagePurchaseAmount",
        "Valor de compra",
        "currency",
        false,
        { subject: "quote", source: "oficina", column: "salvagePurchaseAmount" },
        { section: SALVAGE_PROPOSAL }
      ),
      excluded3(
        "An\xE1lise de Or\xE7amento para Indeniza\xE7\xE3o",
        "radio_vertical",
        "\xC9 um bot\xE3o de automa\xE7\xE3o do Pipefy, e n\xE3o dado.",
        options3("Clique para gerar Resultado")
      ),
      field2(
        "agreement10",
        "ACORDO 10%",
        "currency",
        false,
        { subject: "agreement", kind: "acordo_10", column: "proposedAmount" },
        { section: REGULAGEM, help: "90% do valor total do or\xE7amento." }
      ),
      field2(
        "associationRepairCost",
        "Custo Associa\xE7\xE3o - Se Reparo",
        "currency",
        false,
        { subject: "quote", source: "oficina", column: "associationRepairCost" },
        { section: COST_ANALYSIS }
      ),
      field2(
        "associationSaleCost",
        "Custo Associa\xE7\xE3o - Venda",
        "currency",
        false,
        { subject: "quote", source: "oficina", column: "associationSaleCost" },
        { section: COST_ANALYSIS }
      ),
      field2(
        "associationAgreement10Cost",
        "Custo Associa\xE7\xE3o - Se Acordo 10%",
        "currency",
        false,
        { subject: "quote", source: "oficina", column: "associationAgreement10Cost" },
        { section: COST_ANALYSIS }
      ),
      field2(
        "associationAgreementAvCost",
        "Custo Associa\xE7\xE3o - Se Acordo AV",
        "currency",
        false,
        { subject: "quote", source: "oficina", column: "associationAgreementAvCost" },
        { section: COST_ANALYSIS }
      ),
      field2(
        "regulationOpinion",
        "Parecer Analista em Regulagem",
        "select",
        false,
        { subject: "decision", kind: "parecer_regulagem", column: "result" },
        {
          section: REGULAGEM,
          options: options3(
            "De acordo - Solicitar Aprova\xE7\xE3o",
            "Pend\xEAncia - Notificar Oficina"
          )
        }
      )
    ]
  },
  {
    code: "aprovacao_supervisor",
    label: "Aprova\xE7\xE3o Supervisor",
    kind: "stage",
    moves: [
      "orcamentacao_oficina",
      "negociacao_para_acordo",
      /* O reparo aprovado com o veículo ainda com o cliente (A1, 03/11/2026). */
      "aguardando_parada",
      "pagamento_associado",
      "compra_de_pecas",
      "reparo_oficina",
      "indenizados",
      "concluidos"
    ],
    fields: [
      /* "Supervisor de Oficinas" saiu em 21/10/2026: quem supervisiona é o
         responsável do card, que o rodízio atribui. Quem marca "Aprovado"
         fica gravado como quem aprovou (`claims_quotes.approved_by`). */
      field2(
        "supervisionResult",
        "Resultado de Supervis\xE3o de Or\xE7amento",
        "select",
        true,
        { subject: "quote", source: "oficina", column: "approvalResult" },
        {
          section: QUOTE_REVIEW,
          options: options3("Aprovado", "Reprovado"),
          help: "Reprovado volta o sinistro para a Or\xE7amenta\xE7\xE3o."
        }
      ),
      field2(
        "analysisResult",
        "Resultado An\xE1lise",
        "select",
        true,
        { subject: "decision", kind: "resultado_analise_reparo", column: "result" },
        {
          section: DESTINATION,
          options: options3("Reparo", "Indeniza\xE7\xE3o", "Acordo Parcial de Reparo")
        }
      ),
      field2(
        "supervisionDescription",
        "Descri\xE7\xE3o de Supervis\xE3o de Or\xE7amento",
        "long_text",
        false,
        {
          subject: "decision",
          kind: "situacao_veiculo",
          column: "notes"
        },
        { section: QUOTE_REVIEW }
      ),
      field2(
        "vehicleSituation",
        "Situa\xE7\xE3o do Ve\xEDculo",
        "select",
        true,
        { subject: "decision", kind: "situacao_veiculo", column: "result" },
        {
          section: DESTINATION,
          options: options3("Perda Total", "Reparo", "Acordo"),
          /* "Aprovado abre novo campo de situação do veículo" — a descrição do
             campo de resultado, no pipe. */
          showWhen: { field: "supervisionResult", in: ["aprovado"] },
          help: "Decide o destino: perda total vai para a Indeniza\xE7\xE3o; reparo, para o pagamento ou as pe\xE7as; acordo, para a negocia\xE7\xE3o."
        }
      ),
      {
        ...document3(
          "authorizedCiliaQuote",
          "CILIA Autorizado",
          "orcamento_autorizado",
          true
        ),
        section: QUOTE_REVIEW
      },
      /* Qual dos dois orçamentos item a item vale (A3, 03/11/2026): o outro
         fica gravado como comparação. É dele que o saldo confere o líquido,
         e dele que a Compra de Peças lê as peças da associação (A7). */
      field2(
        "approvedQuote",
        "Or\xE7amento aprovado",
        "select",
        true,
        { subject: "decision", kind: "orcamento_aprovado", column: "result" },
        {
          section: QUOTE_REVIEW,
          options: [
            { value: "proprio", label: "Or\xE7amento pr\xF3prio" },
            { value: "cilia", label: "Or\xE7amento CILIA" }
          ],
          requiredWhen: { field: "vehicleSituation", in: ["reparo", "acordo"] },
          help: "O or\xE7amento item a item que vale para a compra das pe\xE7as e para o saldo. O outro fica como compara\xE7\xE3o."
        }
      ),
      /* O saldo do sinistro (A6, 03/11/2026): o máximo que o reparo pode
         gastar, que o supervisor define, mais o que ele liberar depois. A
         aprovação não passa com o líquido do orçamento acima da soma. */
      field2(
        "spendingLimit",
        "Saldo do sinistro",
        "currency",
        true,
        { subject: "claim", column: "spendingLimit" },
        {
          section: SPENDING,
          /* Perda total não tem reparo a limitar: vai à Indenização. */
          requiredWhen: { field: "vehicleSituation", in: ["reparo", "acordo"] },
          help: "O m\xE1ximo que pode ser gasto neste sinistro."
        }
      ),
      field2(
        "additionalSpendingLimit",
        "Saldo adicional liberado",
        "currency",
        false,
        { subject: "claim", column: "additionalSpendingLimit" },
        {
          section: SPENDING,
          help: "O que o supervisor libera al\xE9m do saldo. Soma-se a ele."
        }
      ),
      field2(
        "participationPayment",
        "Pagamento PI",
        "select",
        true,
        { subject: "decision", kind: "pagamento_pi", column: "result" },
        {
          section: DESTINATION,
          options: options3("Direto para Oficina", "Direto para Evogard", "N\xE3o Aplicado"),
          /* A participação é só do associado (R7). */
          showWhen: { claimType: "associado" }
        }
      ),
      /* Depois dos campos curtos do destino, para que eles andem em pares. */
      {
        ...comment2("looseAgreementNotes", "Observa\xE7\xF5es de Acordo Avulso"),
        section: DESTINATION
      }
    ]
  },
  {
    code: "negociacao_para_acordo",
    label: "Negocia\xE7\xE3o Para Acordo",
    kind: "stage",
    moves: [
      "aguardando_parada",
      "orcamentacao_oficina",
      "aprovacao_supervisor",
      "concluidos"
    ],
    situations: [
      "em_negociacao",
      "aguardando_assinatura_do_termo_de_acordo",
      "termo_de_acordo_assinado"
    ],
    fields: [
      /* O "Protocolo OPA" virou a tentativa de contato, obrigatória
         (21/10/2026): o protocolo vai nela, com o canal e a resposta. */
      contactAttempts(true, NEGOTIATION),
      field2(
        "agreementStatus",
        "Status do Acordo",
        "select",
        true,
        { subject: "agreement", kind: "acordo_livre", column: "status", situation: true },
        {
          section: NEGOTIATION,
          options: options3(
            "Em Negocia\xE7\xE3o",
            "Aguardando Assinatura do Termo de Acordo",
            "Termo de Acordo Assinado"
          )
        }
      ),
      field2(
        "proposedAmount",
        "Valor Proposto de Acordo",
        "currency",
        true,
        { subject: "agreement", kind: "acordo_livre", column: "proposedAmount" },
        { section: NEGOTIATION }
      ),
      field2(
        "agreementDescription",
        "Descri\xE7\xE3o de Acordo com Associado",
        "long_text",
        false,
        {
          subject: "agreement",
          kind: "acordo_livre",
          column: "notes"
        },
        { section: NEGOTIATION }
      ),
      {
        ...document3("signedAgreement", "Termo de Acordo Assinado", "termo_acordo", true),
        section: AGREEMENT_TERM,
        requiredWhen: { field: "agreementStatus", in: ["termo_de_acordo_assinado"] }
      },
      deferred("Solicita\xE7\xE3o de Pagamento do Acordo", "connector", true, PAYMENT_LATER, {
        section: AGREEMENT_TERM
      })
    ]
  },
  {
    code: "aguardando_parada",
    label: "Aguardando Parada",
    kind: "stage",
    /* Depois da Negociação desde 03/11/2026 (A1): a parada espera o acordo
       fechado, ou o orçamento feito com o veículo com o cliente. Com o carro
       na oficina, segue para a execução do reparo. */
    moves: [
      "orcamentacao_oficina",
      "negociacao_para_acordo",
      "pagamento_associado",
      "compra_de_pecas",
      "reparo_oficina"
    ],
    situations: [
      "aguardando_cliente_agendar",
      "agendado_data_definida",
      "cliente_nao_compareceu_reagendar",
      "veiculo_em_oficina_mover_para_orcamento"
    ],
    fields: [
      /* O primeiro contato com o associado e as tentativas de agendar a
         parada (21/10/2026): o botão e a lista, no topo. Opcional por ora —
         o departamento ainda vai dizer se trava o avanço. */
      contactAttempts(false, SCHEDULING),
      field2(
        "schedulingStatus",
        "Status do Agendamento",
        "select",
        true,
        { subject: "passage_status" },
        {
          section: SCHEDULING,
          options: options3(
            "Aguardando Cliente Agendar",
            "Agendado (Data Definida)",
            "Cliente n\xE3o compareceu (Reagendar)",
            "Ve\xEDculo em Oficina (Mover para Or\xE7amento)"
          )
        }
      ),
      scheduledFor(
        false,
        "Data da parada para or\xE7amento",
        'A data marcada com a oficina para o carro ser or\xE7ado. As tentativas de agendamento s\xE3o registradas em "Tentativa de contato".'
      ),
      /* A data em que o carro de fato chegou para o orçamento (27/10/2026) —
         o Pipefy não a tinha, e o marco "Parada para orçamento" lê daqui.
         Opcional: o orçamento com o veículo com o cliente não para. */
      field2(
        "vehicleStoppedForQuoteOn",
        "Parada do Ve\xEDculo na Oficina para or\xE7amento",
        "date",
        false,
        { subject: "repair", column: "vehicleStoppedForQuoteOn" },
        {
          section: SCHEDULING,
          help: "O dia em que o carro chegou \xE0 oficina para ser or\xE7ado \u2014 n\xE3o o agendado."
        }
      ),
      { ...comment2("schedulingNotes", "Observa\xE7\xF5es", true), section: SCHEDULING }
    ]
  },
  {
    code: "pagamento_associado",
    label: "Pagamento Associado",
    kind: "stage",
    /* Só o associado paga participação (R7): o terceiro pula esta etapa. */
    onlyFor: "associado",
    moves: [
      "orcamentacao_oficina",
      "aprovacao_supervisor",
      "negociacao_para_acordo",
      "compra_de_pecas"
    ],
    fields: [
      field2(
        "participationPaidOn",
        "Data do Pagamento da PI",
        "date",
        true,
        { subject: "participation_payment", column: "paidOn" },
        { section: PARTICIPATION }
      ),
      field2(
        "participationAmount",
        "Valor Pago da PI",
        "currency",
        true,
        { subject: "participation_payment", column: "paidAmount" },
        {
          section: PARTICIPATION,
          /* Nem sempre o pago é o apurado (21/10/2026; era só leitura pela Q5). */
          help: "Abre com a participa\xE7\xE3o apurada na An\xE1lise. Corrija quando o valor pago for outro."
        }
      ),
      field2(
        "participationNotes",
        "Descri\xE7\xE3o",
        "long_text",
        false,
        { subject: "participation_payment", column: "notes" },
        { section: PARTICIPATION }
      ),
      {
        ...document3(
          "participationReceipt",
          "Comprovante de Pagamento da PI",
          "comprovante_pi",
          true
        ),
        section: PARTICIPATION
      }
    ]
  },
  {
    code: "compra_de_pecas",
    label: "Compra de Pe\xE7as",
    kind: "stage",
    moves: ["orcamentacao_oficina", "aprovacao_supervisor", "reparo_oficina"],
    situations: ["aguardando_chegada_das_pecas"],
    fields: [
      field2(
        "supplyKind",
        "Tipo de Fornecimento de Pe\xE7as:",
        "radio_vertical",
        true,
        { subject: "part", column: "supplyKind" },
        {
          section: PARTS_ORDER,
          options: options3(
            "Oficina Credenciada",
            "Fornecedor de Pe\xE7as (Associa\xE7\xE3o)",
            "Misto (Oficina Credenciada e Associa\xE7\xE3o)"
          )
        }
      ),
      /* Quem fornece, da nossa base (21/10/2026): um fornecedor de peças ou
         uma oficina do cadastro de Empresas. Abre na Oficina Credenciada e no
         Misto; o
         "Fornecedor de Peças (Associação)" é o do associado, que não está na
         nossa base. */
      field2(
        "partsSupplierId",
        "Fornecedor de Pe\xE7as",
        "connector",
        true,
        { subject: "part", column: "companyId" },
        {
          section: PARTS_ORDER,
          /* Uma oficina também fornece peças (21/10/2026). */
          companyTypes: ["fornecedor_pecas", "oficina"],
          showWhen: {
            field: "supplyKind",
            in: ["oficina_credenciada", "misto_oficina_credenciada_e_associacao"]
          },
          help: "Um fornecedor de pe\xE7as ou uma oficina do cadastro de Empresas."
        }
      ),
      /* As duas datas antes da evidência, para que andem em par. */
      field2(
        "partsRequestedOn",
        "Data da Solicita\xE7\xE3o de Compra das Pe\xE7as:",
        "date",
        true,
        { subject: "part", column: "requestedOn" },
        { section: PARTS_ORDER }
      ),
      field2(
        "partsForecastOn",
        "Data de Previs\xE3o de Chegada das Pe\xE7as:",
        "date",
        true,
        { subject: "part", column: "forecastOn" },
        { section: PARTS_ORDER }
      ),
      {
        ...document3(
          "partsOrderEvidence",
          "Evid\xEAncias do pedido de compra de pe\xE7as:",
          "pedido_compra_pecas",
          true
        ),
        section: PARTS_ORDER
      },
      { ...comment2("partsNotes", "Observa\xE7\xF5es"), section: PARTS_ORDER },
      field2(
        "partsArrivedOn",
        "Data da Chegada das Pe\xE7as:",
        "date",
        true,
        { subject: "part", column: "arrivedOn" },
        { section: CHEGADA }
      )
    ]
  },
  {
    code: "reparo_oficina",
    label: "Reparo - Oficina",
    kind: "stage",
    moves: ["negociacao_para_acordo", "compra_de_pecas", "vistoria_de_entrega"],
    /* A Aguardando Parada para Reparo virou situação (21/10/2026): o card
       entra aguardando a parada, até a data agendada ser preenchida. */
    situations: ["aguardando_parada_para_reparo"],
    fields: [
      /* R5: a primeira tentativa de agendamento é obrigatória — aqui, a data.
         Veio da Aguardando Parada para Reparo (21/10/2026). */
      {
        ...scheduledFor(
          true,
          "Data da parada para o reparo",
          'A data marcada com a oficina para o carro entrar em conserto \u2014 n\xE3o \xE9 a da parada para or\xE7amento, da Aguardando Parada. As tentativas de agendamento s\xE3o registradas em "Tentativa de contato".'
        ),
        section: TIMELINE
      },
      field2(
        "vehicleStoppedOn",
        "Parada do Ve\xEDculo na Oficina:",
        "date",
        true,
        { subject: "repair", column: "vehicleStoppedOn" },
        { section: TIMELINE }
      ),
      /* O envio e a aprovação do orçamento, o pagamento da PI e a chegada
         das peças saíram daqui (21/10/2026): repetiam outras etapas, e moram
         nos marcos do bloco do reparo. */
      field2(
        "repairStartedOn",
        "In\xEDcio de Reparo:",
        "date",
        true,
        { subject: "repair", column: "repairStartedOn" },
        { section: REPAIR_PROGRESS }
      ),
      field2(
        "deliveryForecastOn",
        "Previs\xE3o da Entrega:",
        "date",
        true,
        { subject: "repair", column: "deliveryForecastOn" },
        { section: REPAIR_PROGRESS }
      ),
      field2(
        "vehicleReadyOn",
        "Ve\xEDculo Pronto:",
        "date",
        true,
        { subject: "repair", column: "vehicleReadyOn" },
        { section: REPAIR_PROGRESS }
      ),
      { ...comment2("repairNotes", "Observa\xE7\xF5es"), section: REPAIR_PROGRESS }
    ]
  },
  {
    code: "vistoria_de_entrega",
    label: "Vistoria de Entrega",
    kind: "stage",
    moves: ["reparo_oficina", "aguardando_faturamento"],
    fields: [
      field2(
        "inspectedAt",
        "Data de Vistoria",
        "datetime",
        true,
        { subject: "inspection", column: "inspectedAt" },
        { section: INSPECTION }
      ),
      field2(
        "inspectionKind",
        "Tipo de Vistoria Realizada",
        "select",
        true,
        { subject: "inspection", column: "kind" },
        {
          section: INSPECTION,
          options: options3("Digital (Fotos)", "Presencial (Vistoriador)")
        }
      ),
      field2(
        "inspectorName",
        "Nome do Vistoriador Externo",
        "short_text",
        false,
        { subject: "inspection", column: "inspectorName" },
        {
          section: INSPECTION,
          showWhen: { field: "inspectionKind", in: ["presencial_vistoriador"] }
        }
      ),
      {
        ...document3(
          "inspectorReport",
          "Relat\xF3rio/Fotos do Vistoriador Externo",
          "relatorio_vistoriador",
          false
        ),
        section: INSPECTION,
        showWhen: { field: "inspectionKind", in: ["presencial_vistoriador"] }
      },
      field2(
        "inspectionOpinion",
        "Parecer T\xE9cnico",
        "long_text",
        true,
        { subject: "inspection", column: "notes" },
        { section: DELIVERY }
      ),
      field2(
        "inspectionResult",
        "Decis\xE3o da Vistoria",
        "select",
        true,
        { subject: "inspection", column: "result" },
        {
          section: DELIVERY,
          options: options3("Aprovado", "Reprovado (Retornar Oficina)"),
          help: "Reprovado volta o sinistro para o Reparo - Oficina."
        }
      ),
      field2(
        "deliveredAt",
        "Data de Entrega ao Cliente",
        "datetime",
        true,
        { subject: "repair", column: "deliveredAt" },
        { section: DELIVERY }
      ),
      {
        ...document3("dischargeTerm", "Termo de Quita\xE7\xE3o", "termo_quitacao", true),
        section: DELIVERY
      },
      {
        ...document3(
          "qualityPhotos",
          "Fotos da Vistoria de Qualidade",
          "fotos_vistoria",
          true
        ),
        section: INSPECTION_PHOTOS
      },
      /* Opcional: só existe quando houve revistoria (Q7, 07/10/2026). */
      {
        ...document3(
          "reinspectionPhotos",
          "Fotos de Revistoria",
          "fotos_revistoria",
          false
        ),
        section: INSPECTION_PHOTOS
      }
    ]
  },
  {
    code: "aguardando_faturamento",
    label: "Aguardando Faturamento",
    kind: "stage",
    /* Indenizados saiu daqui (23/10/2026): a decisão de indenizar é da
       Aprovação Supervisor, e não do fim do reparo. */
    moves: [
      "orcamentacao_oficina",
      "reparo_oficina",
      "vistoria_de_entrega",
      "retorno_garantia",
      "concluidos"
    ],
    situations: ["pagamento_fornecedor_de_pecas"],
    fields: [
      /* O mesmo número da Orçamentação — a mesma linha do Cilia (R2) —,
         travado: só se lê daqui (21/10/2026). */
      field2(
        "ciliaNumberView",
        "N\xFAmero do Or\xE7amento no Cilia",
        "short_text",
        true,
        { subject: "derived", source: "cilia_number" },
        { section: BILLING_DOCS, help: "Da Or\xE7amenta\xE7\xE3o: corrige-se l\xE1." }
      ),
      excluded3(
        "Or\xE7amento do Cilia",
        "attachment",
        "O or\xE7amento do Cilia \xE9 anexado na Or\xE7amenta\xE7\xE3o (21/10/2026)."
      ),
      {
        ...document3("invoice", "Nota Fiscal", "nota_fiscal", true),
        section: BILLING_DOCS
      },
      field2(
        "invoiceAmount",
        "Valor Total NF",
        "currency",
        true,
        { subject: "quote", source: "oficina", column: "invoiceAmount" },
        { section: BILLING_DOCS }
      ),
      excluded3("An\xE1lise de Nota Fiscal por IA", "long_text", "Removido pela R9 (22/09)."),
      field2(
        "regulatorValidation",
        "Valida\xE7\xE3o de Regulador",
        "select",
        true,
        { subject: "decision", kind: "validacao_regulador", column: "result" },
        { section: REGULATOR, options: options3("Aprovado", "Reprovado") }
      ),
      { ...comment2("invoiceComments", "Coment\xE1rios"), section: REGULATOR },
      excluded3(
        "Solicita\xE7\xE3o de Pagamento da Oficina",
        "connector",
        "Era a conex\xE3o com o pipe do Financeiro: o pedido de pagamento volta quando o m\xF3dulo do Financeiro existir (21/10/2026)."
      ),
      excluded3(
        "Disparo NPS enviado",
        "select",
        "O NPS do Reparo \xE9 a pesquisa geral (R8).",
        YES_NO2
      )
    ]
  },
  {
    code: "retorno_garantia",
    label: "Retorno/Garantia",
    kind: "stage",
    /*
     * A garantia do reparo (explicada pelo dono em 21/10/2026): o associado
     * volta à oficina porque a peça reparada deu problema — veio defeituosa,
     * ou apresentou defeito com pouco tempo de uso. Um card concluído pode
     * voltar para cá quando o associado aciona a garantia.
     *
     * O "Protocolo OPA" e a "Solicitação da Garantia" viraram a tentativa de
     * contato, obrigatória (21/10/2026): o protocolo vai nela, e a data da
     * solicitação é a do registro dela.
     */
    moves: ["concluidos"],
    fields: [
      contactAttempts(true, WARRANTY),
      field2(
        "warrantyReason",
        "Motivo de Retorno",
        "long_text",
        true,
        { subject: "decision", kind: "garantia", column: "reason", result: "solicitada" },
        { section: WARRANTY }
      ),
      field2(
        "warrantySolution",
        "Descreva a Solu\xE7\xE3o",
        "long_text",
        true,
        { subject: "decision", kind: "garantia", column: "notes", result: "solicitada" },
        { section: WARRANTY }
      )
    ]
  },
  outcome2("indenizados", "Indenizados", "handoff"),
  outcome2("desistencia", "Desist\xEAncia", "general"),
  outcome2("concluidos", "Conclu\xEDdos", "general")
];
var REPAIR_PHASES = Object.fromEntries(PHASES3.map((p) => [p.code, p]));
var REPAIR_PIPE_ORDER = PHASES3.map((p) => p.code);
function repairPhaseOf(phase) {
  return REPAIR_PHASES[phase];
}
function repairPhaseLabel(phase) {
  return repairPhaseOf(phase)?.label ?? phase;
}
function isRepairOutcome(phase) {
  return REPAIR_OUTCOMES.includes(phase);
}
function isRepairGeneralPhase(phase) {
  return repairPhaseOf(phase)?.kind === "general";
}
function repairMoveDirection(from, to) {
  return catalogMoveDirection(REPAIR_PIPE_ORDER, from, to);
}
function repairMovesOf(phase, hold = null, context) {
  return catalogMovesOf(
    {
      order: REPAIR_PIPE_ORDER,
      phases: REPAIR_PHASES,
      withdrawal: REPAIR_WITHDRAWAL_OUTCOME
    },
    phase,
    hold,
    context
  );
}
function isRepairMoveAllowed(from, to, hold, context) {
  const m = repairMovesOf(from, hold, context);
  return [...m.forward, ...m.handoffs, ...m.outcomes, ...m.back].includes(to);
}
function visibleRepairFields(phase) {
  return visibleCatalogFields(REPAIR_PHASES[phase]);
}
function shownRepairFields(phase, state, context) {
  return shownCatalogFields(REPAIR_PHASES[phase], state, context);
}
function isRepairFieldRequired(field4, state, context) {
  return isCatalogFieldRequired(field4, state, context);
}
function isRepairFieldFilled(field4, state) {
  return isCatalogFieldFilled(field4, state);
}
function missingRepairFields(phase, state, context) {
  return missingCatalogFields(REPAIR_PHASES[phase], state, context);
}
function isDerivedRepairField(field4) {
  return field4.binding.subject === "derived" || field4.binding.subject === "contact_count";
}
function isPassageBoundRepairField(field4) {
  const b = field4.binding;
  return b.subject === "passage" || b.subject === "passage_status" || b.subject === "agreement" && b.situation === true;
}
function isRepairCorrectablePhase(phase, current, visited) {
  return phase !== current && REPAIR_WORK_STAGES.includes(phase) && visited.includes(phase);
}
function repairValueText(field4, value2) {
  return catalogValueText(field4, value2);
}
function repairSpendingCap(spendingLimit, additionalSpendingLimit) {
  if (spendingLimit === null) return null;
  return sum(spendingLimit, additionalSpendingLimit ?? ZERO);
}
function exceedsRepairSpendingCap(netTotal, cap) {
  return cap !== null && compareMoney(netTotal, cap) > 0;
}

// src/claims-repair-quote.ts
var REPAIR_QUOTE_SOURCES = ["proprio", "cilia"];
var REPAIR_QUOTE_SOURCE_LABELS = {
  proprio: "Or\xE7amento pr\xF3prio",
  cilia: "Or\xE7amento CILIA"
};
var REPAIR_QUOTE_SOURCE_NAMES = {
  proprio: "or\xE7amento pr\xF3prio",
  cilia: "or\xE7amento CILIA"
};
var REPAIR_QUOTE_ITEM_KINDS = ["peca", "servico"];
var REPAIR_PART_ORIGINS = ["genuina", "original", "reposicao", "verde"];
var REPAIR_PART_ORIGIN_LABELS = {
  genuina: "Genu\xEDna",
  original: "Original",
  reposicao: "Reposi\xE7\xE3o",
  verde: "Verde (reuso)"
};
var REPAIR_PART_SUPPLIERS = ["oficina", "associacao"];
var REPAIR_PART_SUPPLIER_LABELS = {
  oficina: "Oficina",
  associacao: "Associa\xE7\xE3o"
};
var REPAIR_QUOTE_COVERAGES = ["impacto", "sem_amparo", "sob_analise"];
var REPAIR_QUOTE_COVERAGE_LABELS = {
  impacto: "Coberto",
  sem_amparo: "Sem amparo",
  sob_analise: "Sob an\xE1lise"
};
function quoteItemNet(item) {
  if (item.unitPrice === null) return ZERO;
  const gross = multiply(item.unitPrice, item.quantity);
  const net = subtract(gross, item.discountAmount ?? ZERO);
  return net < 0 ? ZERO : net;
}
function quoteItemLabor(item, rates) {
  const hours = (n) => n ?? 0;
  return sum(
    multiply(
      rates.labor ?? ZERO,
      hours(item.replaceHours) + hours(item.removeInstallHours)
    ),
    multiply(rates.repair ?? ZERO, hours(item.repairHours)),
    multiply(rates.paint ?? ZERO, hours(item.paintHours))
  );
}
function quoteItemTotal(item, rates) {
  return sum(quoteItemNet(item), quoteItemLabor(item, rates));
}
var roundHours = (n) => Math.round(n * 100) / 100;
function repairQuoteTotals(items, rates, participation) {
  let replaceAndRemove = 0;
  let repairHours = 0;
  let paintHours = 0;
  const labor = { replaceAndRemove: ZERO, repair: ZERO, paint: ZERO };
  let partsByWorkshop = ZERO;
  let partsByAssociation = ZERO;
  let services = ZERO;
  let memberShare = ZERO;
  let underReview = ZERO;
  for (const item of items) {
    if (item.coverage === "sem_amparo") {
      memberShare = sum(memberShare, quoteItemTotal(item, rates));
      continue;
    }
    if (item.coverage === "sob_analise") {
      underReview = sum(underReview, quoteItemTotal(item, rates));
    }
    const tr = (item.replaceHours ?? 0) + (item.removeInstallHours ?? 0);
    replaceAndRemove += tr;
    repairHours += item.repairHours ?? 0;
    paintHours += item.paintHours ?? 0;
    labor.replaceAndRemove = sum(
      labor.replaceAndRemove,
      multiply(rates.labor ?? ZERO, tr)
    );
    labor.repair = sum(
      labor.repair,
      multiply(rates.repair ?? ZERO, item.repairHours ?? 0)
    );
    labor.paint = sum(labor.paint, multiply(rates.paint ?? ZERO, item.paintHours ?? 0));
    const net = quoteItemNet(item);
    if (item.kind === "servico") services = sum(services, net);
    else if (item.supplier === "associacao")
      partsByAssociation = sum(partsByAssociation, net);
    else partsByWorkshop = sum(partsByWorkshop, net);
  }
  const laborTotal = sum(labor.replaceAndRemove, labor.repair, labor.paint, services);
  const grossTotal = sum(partsByWorkshop, partsByAssociation, laborTotal);
  return {
    hours: {
      replaceAndRemove: roundHours(replaceAndRemove),
      repair: roundHours(repairHours),
      paint: roundHours(paintHours)
    },
    labor,
    partsByWorkshop,
    partsByAssociation,
    services,
    laborTotal,
    grossTotal,
    participation,
    netTotal: subtract(grossTotal, participation),
    memberShare,
    underReview
  };
}
function quoteItemKey(item) {
  const code = item.partCode?.trim();
  if (code) return `c:${code.toUpperCase()}`;
  return `t:${item.description.replace(/\s*\(.*\)\s*$/, "").trim().toUpperCase()}`;
}
function compareRepairQuotes(first, second) {
  const index = (items) => {
    const map = /* @__PURE__ */ new Map();
    for (const item of items)
      if (!map.has(quoteItemKey(item))) map.set(quoteItemKey(item), item);
    return map;
  };
  const a = index(first.items);
  const b = index(second.items);
  const keys = [.../* @__PURE__ */ new Set([...a.keys(), ...b.keys()])];
  const out = [];
  for (const key of keys) {
    const x = a.get(key) ?? null;
    const y = b.get(key) ?? null;
    const counted = (i, rates) => i && i.coverage !== "sem_amparo" ? quoteItemTotal(i, rates) : ZERO;
    const tx = counted(x, first.rates);
    const ty = counted(y, second.rates);
    const changes = [];
    if (!x) changes.push("only_second");
    else if (!y) changes.push("only_first");
    else {
      if (quoteItemNet(x) !== quoteItemNet(y)) changes.push("price");
      if (x.partOrigin !== y.partOrigin) changes.push("origin");
      if (x.supplier !== y.supplier) changes.push("supplier");
      if (x.coverage !== y.coverage) changes.push("coverage");
      const hours = (i) => [i.replaceHours, i.removeInstallHours, i.repairHours, i.paintHours].map((h) => h ?? 0).join("|");
      if (hours(x) !== hours(y)) changes.push("hours");
    }
    if (changes.length > 0)
      out.push({ key, first: x, second: y, changes, delta: subtract(ty, tx) });
  }
  return out;
}

// src/claims-peripherals.ts
var PERIPHERAL_SITUATIONS = {
  erro_no_disparo: "Erro no disparo",
  aguardando_pagamento: "Aguardando pagamento",
  pagamento_nao_realizado: "Pagamento n\xE3o realizado",
  comprovante_em_validacao: "Comprovante em valida\xE7\xE3o",
  aguardando_chegada: "Aguardando chegada",
  agendado: "Agendado"
};
function peripheralSituationLabel(code) {
  return PERIPHERAL_SITUATIONS[code] ?? code;
}
var PERIPHERAL_WITHDRAWAL_OUTCOME = "desistencia";
var PERIPHERAL_PIPE_COLUMNS = {
  Entrada: { as: "stage", code: "entrada" },
  "Em Valida\xE7\xE3o": { as: "merged", stage: "entrada" },
  Pendente: { as: "hold", code: "pendencia" },
  Cota\u00E7\u00E3o: { as: "stage", code: "cotacao" },
  "Aprova\xE7\xE3o do Supervisor": { as: "stage", code: "aprovacao_do_supervisor" },
  "Erro no Disparo PI": { as: "situation", stage: "franquia", code: "erro_no_disparo" },
  "Aguardando Recebimento de Franquia": {
    as: "situation",
    stage: "franquia",
    code: "aguardando_pagamento"
  },
  "Pagamento n\xE3o Realizado": {
    as: "situation",
    stage: "franquia",
    code: "pagamento_nao_realizado"
  },
  "Valida\xE7\xE3o de recebimento de Franquia": {
    as: "situation",
    stage: "franquia",
    code: "comprovante_em_validacao"
  },
  Acordo: { as: "stage", code: "acordo" },
  "Em Processo de Compra": { as: "stage", code: "compra" },
  "Aguardando Chegada": { as: "situation", stage: "compra", code: "aguardando_chegada" },
  "Em Tratativa de Agendamento": { as: "stage", code: "agendamento" },
  Agendados: { as: "situation", stage: "agendamento", code: "agendado" },
  Finalizados: { as: "general", code: "concluidos" },
  "Pr\xE9-desistentes": { as: "hold", code: "pre_desistencia" },
  Desistentes: { as: "general", code: "desistencia" },
  Negados: { as: "general", code: "negados" }
};
var FROM_CORE = "lido do n\xFAcleo pelo ve\xEDculo do acionamento (vehicle_id, D10) \u2014 n\xE3o se copia para o card";
var PI_LATER = "a cobran\xE7a da PI fica de fora por enquanto (D9, 08/10/2026): hoje \xE9 outro sistema";
var AUTOMATION = "gatilho ou texto gerado por automa\xE7\xE3o do Pipefy \u2014 n\xE3o \xE9 dado (R9)";
var PERIPHERAL_PIPE_FIELD_HOMES = {
  /* O formulário inicial: os dados do SGA. */
  "ID do card": "o n\xFAmero do acionamento (claims_peripherals.id)",
  "C\xF3digo do ve\xEDculo": `${FROM_CORE}; o c\xF3digo fica em claims_peripherals.vehicle_code, como proced\xEAncia`,
  "Base de Integra\xE7\xE3o da SGA": "a pra\xE7a do acionamento (tenant_id)",
  "Modelo do ve\xEDculo": FROM_CORE,
  "Ano do ve\xEDculo": FROM_CORE,
  "Placa do ve\xEDculo": FROM_CORE,
  Chassi: FROM_CORE,
  "Nome associado": FROM_CORE,
  "CPF Associado": FROM_CORE,
  "Telefone associado": FROM_CORE,
  "E-mail associado": FROM_CORE,
  "Data do contrato": FROM_CORE,
  "C\xF3digo situa\xE7\xE3o": FROM_CORE,
  "Descri\xE7\xE3o da situa\xE7\xE3o": FROM_CORE,
  "Consultor Associado": FROM_CORE,
  "Telefone Consultor": FROM_CORE,
  "E-mail Consultor": FROM_CORE,
  "Cooperativa Consultor": FROM_CORE,
  Respons\u00E1vel: "o respons\xE1vel do card, no topo da mesa, como no sinistro (claims_assignments, department perifericos) \u2014 saiu do formul\xE1rio da Entrada em 15/10/2026",
  "Descri\xE7\xE3o do ocorrido": 'a mesma "Descri\xE7\xE3o do Ocorrido" do formul\xE1rio (claims_peripherals.occurrence_description_final)',
  "Estado ": "o endere\xE7o do associado (claims_peripherals.member_address_id) \u2014 fora da primeira vers\xE3o",
  Cidade: "o endere\xE7o do associado (claims_peripherals.member_address_id) \u2014 fora da primeira vers\xE3o",
  Bairro: "o endere\xE7o do associado (claims_peripherals.member_address_id) \u2014 fora da primeira vers\xE3o",
  "Link da Localiza\xE7\xE3o": "o endere\xE7o do associado (addresses.location_link) \u2014 fora da primeira vers\xE3o",
  "CEP (Reparo)": "o local do servi\xE7o (claims_peripherals.repair_address_id) \u2014 fora da primeira vers\xE3o",
  "Estado (Reparo)": "o local do servi\xE7o (claims_peripherals.repair_address_id) \u2014 fora da primeira vers\xE3o",
  "Cidade (Reparo)": "o local do servi\xE7o (claims_peripherals.repair_address_id) \u2014 fora da primeira vers\xE3o",
  "Bairro (Reparo)": "o local do servi\xE7o (claims_peripherals.repair_address_id) \u2014 fora da primeira vers\xE3o",
  "Protocolo OpaSuite": "a tentativa de contato do acionamento (claims_contacts.opa_suite_protocol) \u2014 fora da primeira vers\xE3o",
  "Auto conex\xE3o": AUTOMATION,
  "HTTP response auto conex\xE3o": AUTOMATION,
  "T\xEDtulo formatado": AUTOMATION,
  "Status disparo whatsapp (correto)": AUTOMATION,
  "Status disparo NPS": AUTOMATION,
  /* Entrada e Em Validação. */
  "Buscar dados no SGA": `${AUTOMATION}: a busca \xE9 a do ve\xEDculo, na abertura`,
  "Status Financeiro": "lido, n\xE3o digitado: os boletos do ve\xEDculo em app.boletos \u2014 a mesa mostra, e n\xE3o decide nada",
  "Percentual de Cobertura": 'a mesma "Porcentagem de Cobertura (%)" da Entrada (claims_peripherals.coverage_percent, D6)',
  /* Pendente — a parada "Pendência", igual à da Análise. */
  "Motivo da pend\xEAncia": 'a parada "Pend\xEAncia": o motivo (claims_pendencies.reason)',
  "Descri\xE7\xE3o do problema": 'a parada "Pend\xEAncia": a mensagem (claims_pendencies.message)',
  Evid\u00EAncias: 'a parada "Pend\xEAncia" da An\xE1lise n\xE3o recebe anexo, e Perif\xE9ricos segue igual; na Entrada e no Agendamento, "Evid\xEAncias" \xE9 campo da etapa',
  /* Aprovação do Supervisor. */
  "Gerar resumo das cota\xE7\xF5es": AUTOMATION,
  "HTML resumo das cota\xE7\xF5es": `${AUTOMATION}: a gaveta do item mostra as cota\xE7\xF5es lado a lado`,
  "\u{1F4F1}Disparar Solicita\xE7\xE3o de PI": PI_LATER,
  "Etiqueta disparo whatsapp PI": PI_LATER,
  "ID link de cobran\xE7a (definitivo)": PI_LATER,
  "Chave pix vinculado (definitivo)": PI_LATER,
  "Pix copia e cola vinculado (definitivo)": PI_LATER,
  "Valor original vinculado (definitivo)": PI_LATER,
  "HTML Preview disparo Whatsapp": PI_LATER,
  /* As colunas da franquia — a etapa Franquia (PI). */
  "Gerar script de c\xE1lculo de PI.": AUTOMATION,
  Script: AUTOMATION,
  "Script de disparo de PI": PI_LATER,
  "Data do envio": PI_LATER,
  "Hist\xF3rico do Link": PI_LATER,
  "Analise do comprovante de pagamento - HTML": PI_LATER,
  "Identificador de transa\xE7\xE3o": PI_LATER,
  "Identificador de pagamento": PI_LATER,
  "Data hora de pagamento": PI_LATER,
  "Informa\xE7\xF5es do pagador": PI_LATER,
  "Nome pagador": PI_LATER,
  "CPF/CNPJ pagador": PI_LATER,
  "C\xF3digo banco": PI_LATER,
  "Situa\xE7\xE3o do pagamento": 'a situa\xE7\xE3o da Franquia (claims_phase_passages.status): pago \xE9 mover para a Compra; expirado, "Pagamento n\xE3o realizado"',
  "Total Cota\xE7\xE3o": 'o "Total cota\xE7\xE3o (definitivo)" da Aprova\xE7\xE3o \u2014 calculado (D8)',
  "Total Aprovado": 'o "Total cota\xE7\xE3o aprovado (definitivo)" da Aprova\xE7\xE3o \u2014 calculado (D8)',
  "Total Associado": 'o "Total associado (definitivo)" da Aprova\xE7\xE3o \u2014 calculado (D8)',
  "Valor da Associa\xE7\xE3o": 'o "Total associa\xE7\xE3o (definitivo)" da Aprova\xE7\xE3o \u2014 calculado (D8)',
  /* Compra. */
  "Gerar Script de Compra": AUTOMATION,
  "Script de Compra": AUTOMATION,
  /* Agendados — a situação "Agendado" do Agendamento. */
  "Data de Agendamento do Servi\xE7o": 'a mesma "Data de agendamento" do Agendamento (claims_schedulings.scheduled_for)',
  /* Finalizados — o NPS é a pesquisa geral (F8). */
  "Avalia\xE7\xE3o NPS": "a pesquisa geral (claims_surveys, F8) \u2014 fora da primeira vers\xE3o",
  "Observa\xE7\xF5es NPS": "a pesquisa geral (claims_surveys, F8) \u2014 fora da primeira vers\xE3o",
  "Anexos NPS": "a pesquisa geral (claims_surveys, F8) \u2014 fora da primeira vers\xE3o",
  "Status avalia\xE7\xE3o NPS": "a pesquisa geral (claims_surveys, F8) \u2014 fora da primeira vers\xE3o",
  /* Pré-desistentes — a parada "Pedido de desistência", igual à da Análise. */
  "Justificativa da desist\xEAncia": 'a parada "Pedido de desist\xEAncia": a decis\xE3o desistencia (claims_decisions.reason)',
  Anexos: 'o pedido de desist\xEAncia da An\xE1lise n\xE3o recebe anexo; Perif\xE9ricos segue igual (o "Anexos" do formul\xE1rio inicial est\xE1 na Entrada)'
};
var options4 = catalogOptions;
var YES_NO3 = options4("Sim", "N\xE3o");
var PERIPHERAL_REQUEST_ORIGINS = options4("CHATBOT", "ADMINISTRATIVO", "PORTAL");
var PERIPHERAL_PORTAL_ORIGIN = "portal";
var PERIPHERAL_WHATSAPP_ORIGINS = ["chatbot", PERIPHERAL_PORTAL_ORIGIN];
function peripheralOriginHasWhatsapp(origin) {
  return typeof origin === "string" && PERIPHERAL_WHATSAPP_ORIGINS.includes(origin);
}
var DENIAL_SUGGESTIONS = options4(
  "Inadimpl\xE9ncia",
  "Avaria pr\xE9-\xE9xist\xE9nt\xE9",
  "Car\xE9ncia",
  "Outros"
);
var field3 = (key, label, type, required, binding, extra = {}) => ({ key, label, type, required, binding, ...extra });
var document4 = (key, label, kind, required = false) => field3(key, label, "attachment", required, { subject: "document", kind });
var comment3 = (key, label, required = false) => field3(key, label, "long_text", required, { subject: "comment" });
var derived2 = (key, label, source) => field3(
  key,
  label,
  "currency",
  false,
  { subject: "derived", source },
  { help: "Calculado das cota\xE7\xF5es aprovadas e da cobertura \u2014 ningu\xE9m digita (D8)." }
);
var situation = (key, label, codes) => field3(
  key,
  label,
  "select",
  false,
  { subject: "passage_status" },
  { options: codes.map((value2) => ({ value: value2, label: PERIPHERAL_SITUATIONS[value2] })) }
);
var outcome3 = (code, label) => ({
  code,
  label,
  kind: "general",
  moves: [],
  fields: []
});
var PHASES4 = [
  {
    code: "entrada",
    label: "Entrada",
    kind: "stage",
    moves: ["cotacao", "negados"],
    fields: [
      field3(
        "occurrenceDescription",
        "Descri\xE7\xE3o do Ocorrido",
        "long_text",
        true,
        { subject: "peripheral", column: "occurrenceDescriptionFinal" },
        { origin: "start_form" }
      ),
      field3(
        "coveragePercent",
        "Porcentagem de Cobertura (%)",
        "select",
        true,
        { subject: "peripheral", column: "coveragePercent" },
        {
          origin: "start_form",
          options: PERIPHERAL_COVERAGE_PERCENTS.map((p) => ({
            value: String(p),
            label: String(p)
          })),
          help: "Lida do produto de Perif\xE9ricos do contrato do ve\xEDculo \u2014 ningu\xE9m digita."
        }
      ),
      field3(
        "requestOrigin",
        "Origem de Solicita\xE7\xE3o",
        "select",
        false,
        { subject: "peripheral", column: "requestOrigin" },
        { origin: "start_form", options: PERIPHERAL_REQUEST_ORIGINS }
      ),
      field3(
        "requestWhatsapp",
        "Whatsapp da Solicita\xE7\xE3o",
        "short_text",
        false,
        { subject: "peripheral", column: "requestWhatsapp" },
        {
          origin: "start_form",
          /* Só o pedido do chatbot e o do portal têm um WhatsApp de origem. */
          showWhen: { field: "requestOrigin", in: [...PERIPHERAL_WHATSAPP_ORIGINS] }
        }
      ),
      {
        ...document4(
          "frontPhoto",
          "Foto frontal pegando a placa do ve\xEDculo ",
          "foto_frontal_placa"
        ),
        origin: "start_form"
      },
      { ...document4("attachments", "Anexos", "anexo"), origin: "start_form" },
      {
        ...document4("quoteAttachments", "Anexo de Or\xE7amentos", "orcamento"),
        origin: "start_form"
      },
      field3(
        "denialSuggestion",
        "Sugest\xE3o de Negativa",
        "select",
        false,
        { subject: "decision", kind: "sugestao_negativa", column: "result" },
        { origin: "start_form", options: DENIAL_SUGGESTIONS }
      ),
      field3(
        "denialSuggestionNotes",
        "Observa\xE7\xE3o da Sugest\xE3o de Negativa",
        "long_text",
        false,
        { subject: "decision", kind: "sugestao_negativa", column: "notes" },
        {
          origin: "start_form",
          /* Aparece quando há sugestão — qualquer uma das quatro. */
          showWhen: {
            field: "denialSuggestion",
            in: DENIAL_SUGGESTIONS.map((o) => o.value)
          }
        }
      ),
      /* As conferências de "Em Validação" (D2). */
      field3(
        "informationValid",
        "Informa\xE7\xF5es Validas?",
        "select",
        true,
        { subject: "decision", kind: "informacoes_validas", column: "result" },
        { options: YES_NO3, section: "Confer\xEAncia" }
      ),
      field3(
        "phoneValid",
        "Dados do telefone/whatsapp v\xE1lidos?",
        "select",
        true,
        { subject: "decision", kind: "telefone_valido", column: "result" },
        { options: YES_NO3, section: "Confer\xEAncia" }
      ),
      { ...document4("evidence", "Evid\xEAncias", "evidencia"), section: "Confer\xEAncia" }
    ]
  },
  {
    code: "cotacao",
    label: "Cota\xE7\xE3o",
    kind: "stage",
    moves: ["entrada", "aprovacao_do_supervisor"],
    fields: [
      field3(
        "items",
        "Adicionar Perif\xE9ricos",
        "connector",
        true,
        { subject: "items" },
        { help: "Os itens acionados, na coluna da esquerda. Pelo menos um." }
      )
    ]
  },
  {
    code: "aprovacao_do_supervisor",
    label: "Aprova\xE7\xE3o do Supervisor",
    kind: "stage",
    moves: ["cotacao", "franquia", "acordo", "negados"],
    fields: [
      field3(
        "supervisionResult",
        "Resultado da Supervis\xE3o de Or\xE7amento",
        "select",
        true,
        { subject: "decision", kind: "resultado_supervisao", column: "result" },
        { options: options4("Aprovado", "Reprovado", "Reembolso / Acordo") }
      ),
      field3(
        "supervisionNotes",
        "Descri\xE7\xE3o da supervis\xE3o de or\xE7amento",
        "long_text",
        false,
        { subject: "decision", kind: "resultado_supervisao", column: "notes" }
      ),
      derived2("totalQuoted", "Total cota\xE7\xE3o (definitivo)", "total_quoted"),
      derived2("totalApproved", "Total cota\xE7\xE3o aprovado (definitivo)", "total_approved"),
      derived2("memberShare", "Total associado (definitivo)", "member_share"),
      derived2("associationShare", "Total associa\xE7\xE3o (definitivo)", "association_share")
    ]
  },
  {
    code: "franquia",
    label: "Franquia (PI)",
    kind: "stage",
    moves: ["aprovacao_do_supervisor", "acordo", "compra", "concluidos"],
    situations: [
      "erro_no_disparo",
      "aguardando_pagamento",
      "pagamento_nao_realizado",
      "comprovante_em_validacao"
    ],
    fields: [
      situation("franchiseSituation", "Situa\xE7\xE3o da franquia", [
        "erro_no_disparo",
        "aguardando_pagamento",
        "pagamento_nao_realizado",
        "comprovante_em_validacao"
      ]),
      document4("franchiseEvidence", "Evid\xEAncia", "evidencia_franquia"),
      comment3("franchiseNotes", "Observa\xE7\xF5es")
    ]
  },
  {
    code: "acordo",
    label: "Acordo",
    kind: "stage",
    moves: ["aprovacao_do_supervisor", "franquia", "concluidos"],
    fields: [
      document4("agreementTerm", "Anexo do termo de acordo ou reembolso", "termo_acordo"),
      field3("agreementGeneratedOn", "Data da gera\xE7\xE3o do acordo", "date", true, {
        subject: "agreement",
        column: "generatedOn"
      }),
      field3("agreementSignedOn", "Data da assinatura do acordo", "date", true, {
        subject: "agreement",
        column: "signedOn"
      }),
      comment3("agreementNotes", "Observa\xE7\xE3o")
    ]
  },
  {
    code: "compra",
    label: "Compra",
    kind: "stage",
    moves: ["acordo", "agendamento", "concluidos"],
    situations: ["aguardando_chegada"],
    fields: [
      field3(
        "partOrdered",
        "Realizado o pedido da pe\xE7a",
        "select",
        false,
        { subject: "decision", kind: "pedido_peca", column: "result" },
        { options: YES_NO3 }
      ),
      situation("purchaseSituation", "Situa\xE7\xE3o da compra", ["aguardando_chegada"]),
      field3(
        "partForecastOn",
        "Previs\xE3o de chegada",
        "due_date",
        false,
        { subject: "part", column: "forecastOn" },
        { dateOnly: true }
      )
    ]
  },
  {
    code: "agendamento",
    label: "Agendamento",
    kind: "stage",
    moves: ["concluidos"],
    situations: ["agendado"],
    fields: [
      field3(
        "serviceMode",
        "Status do atendimento",
        "select",
        false,
        { subject: "scheduling", column: "status" },
        {
          options: options4(
            "Aguardando parada do associado em prestador",
            "Servi\xE7o \xE0 domic\xEDlio"
          )
        }
      ),
      field3("scheduledFor", "Data de agendamento", "date", true, {
        subject: "scheduling",
        column: "scheduledFor"
      }),
      situation("schedulingSituation", "Situa\xE7\xE3o do agendamento", ["agendado"]),
      field3("serviceExecutedAt", "Data da execu\xE7\xE3o do servi\xE7o", "datetime", false, {
        subject: "deferred",
        reason: "Sem coluna em claims_schedulings, e a primeira vers\xE3o n\xE3o cria uma: a conclus\xE3o do acionamento registra quando ele terminou."
      }),
      comment3("schedulingNotes", "Observa\xE7\xF5es"),
      document4("schedulingEvidence", "Evid\xEAncias", "evidencia_agendamento")
    ]
  },
  outcome3("concluidos", "Conclu\xEDdos"),
  outcome3("desistencia", "Desist\xEAncia"),
  outcome3("negados", "Negados")
];
var PERIPHERAL_PHASES = Object.fromEntries(PHASES4.map((p) => [p.code, p]));
var PERIPHERAL_PIPE_ORDER = PHASES4.map(
  (p) => p.code
);
function peripheralPhaseOf(phase) {
  return PERIPHERAL_PHASES[phase];
}
function peripheralPhaseLabel(phase) {
  return peripheralPhaseOf(phase)?.label ?? phase;
}
function isPeripheralWorkStage(phase) {
  return PERIPHERAL_WORK_STAGES.includes(phase);
}
function isPeripheralOutcome(phase) {
  return PERIPHERAL_OUTCOMES.includes(phase);
}
function peripheralMoveDirection(from, to) {
  return catalogMoveDirection(PERIPHERAL_PIPE_ORDER, from, to);
}
function peripheralMovesOf(phase, hold = null) {
  return catalogMovesOf(
    {
      order: PERIPHERAL_PIPE_ORDER,
      phases: PERIPHERAL_PHASES,
      withdrawal: PERIPHERAL_WITHDRAWAL_OUTCOME
    },
    phase,
    hold
  );
}
function isPeripheralMoveAllowed(from, to, hold) {
  const m = peripheralMovesOf(from, hold);
  return [...m.forward, ...m.outcomes, ...m.back].includes(to);
}
var NO_CLAIM = { claimType: "associado" };
function visiblePeripheralFields(phase) {
  return visibleCatalogFields(PERIPHERAL_PHASES[phase]);
}
function shownPeripheralFields(phase, state) {
  return shownCatalogFields(PERIPHERAL_PHASES[phase], state, NO_CLAIM);
}
function missingPeripheralFields(phase, state) {
  return missingCatalogFields(PERIPHERAL_PHASES[phase], state, NO_CLAIM);
}
function isDerivedPeripheralField(field4) {
  return field4.binding.subject === "derived" || field4.binding.subject === "items" || field4.binding.subject === "peripheral" && field4.binding.column === "coveragePercent";
}
function isPassageBoundPeripheralField(field4) {
  return field4.binding.subject === "passage_status";
}
var PERIPHERAL_ASSIGNEE_LABEL = "Respons\xE1vel";
function isPeripheralCorrectablePhase(phase, current, visited) {
  return phase !== current && PERIPHERAL_WORK_STAGES.includes(phase) && visited.includes(phase);
}
function peripheralValueText(field4, value2) {
  return catalogValueText(field4, value2);
}
var PERIPHERAL_ITEM_TYPES = {
  farol_esquerdo: "Farol Lado Esquerdo",
  farol_direito: "Farol Lado Direito",
  retrovisor_esquerdo: "Retrovisor Externo Lado Esquerdo",
  retrovisor_direito: "Retrovisor Externo Lado Direito",
  lanterna_esquerda: "Lanterna Lado Esquerdo",
  lanterna_direita: "Lanterna Lado Direito",
  parabrisa: "Para-brisa",
  vidro_porta_dianteira_esquerda: "Vidro Porta Dianteira Lado Esquerdo",
  vidro_porta_traseira_esquerda: "Vidro Porta Traseira Lado Esquerdo",
  vidro_porta_dianteira_direita: "Vidro Porta Dianteira Lado Direito",
  vidro_porta_traseira_direita: "Vidro Porta Traseira Lado Direito",
  vidro_vigia_traseiro: "Vidro Vigia (Traseiro)"
};
function peripheralItemTypeLabel(code) {
  return PERIPHERAL_ITEM_TYPES[code] ?? code;
}
function peripheralItemFamily(type) {
  if (type.startsWith("farol")) return "farol";
  if (type.startsWith("lanterna")) return "lanterna";
  if (type.startsWith("retrovisor")) return "retrovisor";
  if (type === "parabrisa") return "parabrisa";
  return "vidro";
}
var YES_NO_UNSURE = options4("Sim", "N\xE3o", "N\xE3o Consegui Identificar");
var question = (column, label, families, opts) => ({ column, label, families, options: opts });
var PERIPHERAL_ITEM_QUESTIONS = [
  question(
    "headlightInterior",
    "O interior do farol \xE9?",
    ["farol"],
    options4(
      "Cromado (prateado brilhante)",
      "M\xE1scara negra (parte interna escura/preta)",
      "N\xE3o Consegui Identificar"
    )
  ),
  question(
    "headlightHasLedDrl",
    "O farol tem algum detalhe em LED em formato de \u201Clinha\u201D ou \u201Cassinatura luminosa\u201D (DRL) mesmo quando o farol est\xE1 s\xF3 com a luz de posi\xE7\xE3o ligada?",
    ["farol"],
    YES_NO_UNSURE
  ),
  question(
    "headlightMainLight",
    "A luz principal do farol (farol baixo) \xE9:",
    ["farol"],
    options4(
      "L\xE2mpada comum (hal\xF3gena, amarela)",
      "LED original de f\xE1brica",
      "Xenon original de f\xE1brica",
      "N\xE3o Consegui Identificar"
    )
  ),
  question(
    "headlightAutoLeveling",
    "O farol tem regulagem autom\xE1tica de altura de facho (quando carrega o carro o farol se ajusta sozinho)?",
    ["farol"],
    YES_NO_UNSURE
  ),
  question(
    "headlightIsFullLed",
    "O farol \xE9 do tipo Full LED?",
    ["farol"],
    options4("Sim", "N\xE3o", "N\xE3o sei informar")
  ),
  question(
    "taillightPart",
    "A lanterna \xE9:",
    ["lanterna"],
    options4(
      "Do para-lama (fixa na lateral da carroceria)",
      "Da tampa do porta\u2011malas (vai junto na tampa)",
      "Ou s\xE3o as duas partes (paralama + tampa) que est\xE3o danificadas"
    )
  ),
  question(
    "taillightBrakePositionType",
    "As luzes de freio e posi\xE7\xE3o s\xE3o:",
    ["lanterna"],
    options4(
      "L\xE2mpadas comuns (incandescentes/hal\xF3genas)",
      "LED original de f\xE1brica",
      "N\xE3o Consegui Identificar"
    )
  ),
  question(
    "taillightTurnSignalType",
    "As setas (pisca) s\xE3o:",
    ["lanterna"],
    options4("L\xE2mpadas comuns", "LED", "N\xE3o Consegui Identificar")
  ),
  question(
    "taillightTintType",
    "O tipo da lanterna \xE9:",
    ["lanterna"],
    options4("Fum\xEA/escurecida", "Clara/vermelha padr\xE3o", "N\xE3o Consegui Identificar")
  ),
  question(
    "mirrorAdjustmentType",
    "O retrovisor \xE9:",
    ["retrovisor"],
    options4(
      "De regulagem manual por haste/\u201Cvaretinha\u201D na porta",
      "De regulagem manual empurrando o espelho com a m\xE3o (sem comando interno)",
      "El\xE9trico (ajuste por bot\xE3o no painel/porta)"
    )
  ),
  question(
    "mirrorHasElectricFold",
    "O retrovisor tem rebatimento el\xE9trico (se fecha de forma el\xE9trica)?",
    ["retrovisor"],
    YES_NO_UNSURE
  ),
  question(
    "mirrorHasTurnSignal",
    "O retrovisor tem seta/pisca integrada na carca\xE7a?",
    ["retrovisor"],
    options4(
      "Sim, a seta \xE9 em LED",
      "Sim, a seta \xE9 l\xE2mpada comum",
      "N\xE3o tem",
      "N\xE3o Consegui Identificar"
    )
  ),
  question(
    "damageLocation",
    "O dano foi:",
    ["retrovisor"],
    options4(
      "S\xF3 no vidro/espelho",
      "S\xF3 na capa",
      "Na carca\xE7a inteira (quebrou a base, suporte, etc.)",
      "N\xE3o Consegui Identificar"
    )
  ),
  question(
    "windshieldHasRainSensor",
    "O carro tem sensor de chuva (limpador liga sozinho quando chove)?",
    ["parabrisa"],
    YES_NO_UNSURE
  ),
  question(
    "windshieldRainSensorCount",
    "Quantos sensores de chuva o parabrisa possui?",
    ["parabrisa"],
    options4("1", "2", "N\xE3o consegui identificar")
  ),
  question(
    "windshieldHasLightSensor",
    "O carro tem sensor de luminosidade (acende farol autom\xE1tico quando escurece)?",
    ["parabrisa"],
    YES_NO_UNSURE
  ),
  question(
    "windshieldHasCameraArea",
    "No vidro, atr\xE1s do espelho retrovisor interno, existe:  Uma \u201Cbolha\u201D, \xE1rea mais escura ou suporte diferente para sensor? Algum componente eletr\xF4nico vis\xEDvel colado ao vidro?",
    ["parabrisa"],
    YES_NO_UNSURE
  ),
  question(
    "windshieldTintType",
    "O para-brisa \xE9:",
    ["parabrisa"],
    options4(
      "Verde (levemente esverdeado, padr\xE3o)",
      "Incolor (transparente)",
      "Com faixa degrad\xEA superior (franja azul, verde ou outra cor)",
      "N\xE3o Consegui Identificar"
    )
  )
];
function peripheralItemQuestions(type) {
  const family = peripheralItemFamily(type);
  return PERIPHERAL_ITEM_QUESTIONS.filter((q) => q.families.includes(family));
}
function missingPeripheralAnswers(type, answers) {
  return peripheralItemQuestions(type).filter(
    (q) => q.column !== "windshieldRainSensorCount" || answers.windshieldHasRainSensor === "sim"
  ).filter((q) => !answers[q.column]).map((q) => q.column);
}
var PERIPHERAL_PORTAL_DESCRIPTION_MIN = 20;
var PERIPHERAL_ITEM_PHOTOS = {
  foto_peca_toda: "Foto da pe\xE7a toda",
  foto_item_angulo_1: "Foto localizada da avaria (\xE2ngulo 1)",
  foto_item_angulo_2: "Foto localizada da avaria (\xE2ngulo 2)",
  foto_item_anterior: "Foto anterior",
  foto_item_posterior: "Foto posterior"
};
var PERIPHERAL_PORTAL_ITEM_PHOTOS = [
  "foto_peca_toda",
  "foto_item_angulo_1",
  "foto_item_angulo_2"
];
var PERIPHERAL_QUOTE_STATUSES = {
  aguardando_valores: "Aguardando valores",
  aguardando_aprovacao: "Aguardando aprova\xE7\xE3o",
  aprovado: "Aprovado",
  reprovado: "Reprovado"
};
var PERIPHERAL_PART_ORIGINS = {
  genuino: "Genu\xEDno",
  original: "Original",
  importado: "Importado",
  genuino_usado: "Genu\xEDno Usado"
};
var PERIPHERAL_QUOTE_ORIGINS = {
  cliente: "Cliente",
  associacao: "Associa\xE7\xE3o"
};
var PERIPHERAL_INVOICING_TYPES = {
  antecipado: "Antecipado",
  faturado: "Faturado"
};
var PERIPHERAL_AVAILABILITIES = {
  imediata: "Imediata",
  para_pedido: "Para Pedido"
};
function peripheralQuoteStatusAfterValues(status, hasValue) {
  if (status === "aguardando_valores" && hasValue) return "aguardando_aprovacao";
  if (status === "aguardando_aprovacao" && !hasValue) return "aguardando_valores";
  return status;
}
function peripheralTotals(items, coveragePercent) {
  if (items.length === 0) return { ok: false, reason: "sem_itens" };
  if (coveragePercent === null || !PERIPHERAL_COVERAGE_PERCENTS.includes(coveragePercent)) {
    return { ok: false, reason: "sem_cobertura" };
  }
  const approved = [];
  const quoted = [];
  const missing = [];
  for (const item of items) {
    const valued = item.quotes.filter(
      (q) => q.value !== null
    );
    const approvedQuote = valued.find((q) => q.status === "aprovado");
    if (!approvedQuote) missing.push(item.id);
    else approved.push(approvedQuote.value);
    const lowest = valued.filter((q) => q.status !== "reprovado").reduce(
      (min, q) => min === null || q.value < min ? q.value : min,
      null
    );
    if (lowest !== null) quoted.push(lowest);
  }
  if (missing.length > 0) {
    return { ok: false, reason: "item_sem_cotacao_aprovada", itemIds: missing };
  }
  const totalApproved = approved.length ? sum(...approved) : ZERO;
  const associationShare = percentageOf(totalApproved, coveragePercent);
  return {
    ok: true,
    totalQuoted: quoted.length ? sum(...quoted) : ZERO,
    totalApproved,
    associationShare,
    memberShare: subtract(totalApproved, associationShare)
  };
}
function peripheralTotalsRefusal(reason) {
  switch (reason) {
    case "sem_itens":
      return "O acionamento ainda n\xE3o tem item.";
    case "sem_cobertura":
      return "O acionamento n\xE3o tem cobertura: o contrato do ve\xEDculo n\xE3o diz o percentual de Perif\xE9ricos.";
    case "item_sem_cotacao_aprovada":
      return "H\xE1 item sem cota\xE7\xE3o aprovada.";
  }
}
var PERIPHERAL_PI_MESSAGE_ITEMS = 3;
var NOTHING = "-";
function peripheralPiVariables(message) {
  const blocks = [];
  for (let i = 0; i < PERIPHERAL_PI_MESSAGE_ITEMS; i++) {
    const item = message.items[i];
    if (!item) {
      blocks.push(NOTHING, NOTHING, NOTHING, NOTHING, NOTHING);
      continue;
    }
    blocks.push(
      peripheralItemTypeLabel(item.itemType),
      orNothing(item.supplier),
      orNothing(item.brand),
      item.partOrigin ? labelOf(PERIPHERAL_PART_ORIGINS, item.partOrigin) : NOTHING,
      availabilityText(item)
    );
  }
  return [
    ...blocks,
    format(message.totalApproved),
    `${message.coveragePercent}%`,
    `${100 - message.coveragePercent}%`,
    format(message.memberShare),
    message.paymentLink ?? ""
  ];
}
function availabilityText(item) {
  if (!item.availability) return NOTHING;
  const label = labelOf(PERIPHERAL_AVAILABILITIES, item.availability);
  return item.availability === "para_pedido" && item.expectedArrival ? `${label} (previs\xE3o ${formatDate(item.expectedArrival)})` : label;
}
function orNothing(value2) {
  return value2 && value2.trim() !== "" ? value2.trim() : NOTHING;
}
function labelOf(labels, code) {
  return Object.hasOwn(labels, code) ? labels[code] : code;
}
var PERIPHERAL_PRODUCT = /^\s*PERIFERICOS?\b/;
var PERIPHERAL_PRODUCT_PERCENT = /^\s*PERIFERICOS?\s*(\d{1,3})\s*%/;
function upperWithoutAccents2(text) {
  return text.normalize("NFD").replace(/[̀-ͯ]/g, "").toUpperCase();
}
function peripheralCoverageOf(products, productsRead) {
  if (!productsRead) return { kind: "produtos_nao_lidos" };
  const peripheral = products.filter(
    (p) => p.label !== null && PERIPHERAL_PRODUCT.test(upperWithoutAccents2(p.label)) && upperWithoutAccents2(p.erpStatus ?? "").trim() === "ATIVO"
  );
  if (peripheral.length === 0) return { kind: "sem_periferico" };
  const percents = /* @__PURE__ */ new Set();
  for (const p of peripheral) {
    const match = PERIPHERAL_PRODUCT_PERCENT.exec(upperWithoutAccents2(p.label));
    percents.add(match ? Number(match[1]) : Number.NaN);
  }
  const [percent] = [...percents];
  if (percents.size !== 1 || !PERIPHERAL_COVERAGE_PERCENTS.includes(percent)) {
    return { kind: "ilegivel", productLabels: peripheral.map((p) => p.label) };
  }
  return {
    kind: "coberto",
    percent,
    productLabel: peripheral[0].label
  };
}
function peripheralCoverageRefusal(coverage) {
  switch (coverage.kind) {
    case "sem_periferico":
      return "O contrato deste ve\xEDculo n\xE3o tem a cobertura de Perif\xE9ricos.";
    case "produtos_nao_lidos":
      return "Os produtos deste ve\xEDculo ainda n\xE3o foram lidos do SGA \u2014 atualize a ficha do ve\xEDculo e tente de novo.";
    case "ilegivel":
      return `O percentual de Perif\xE9ricos do contrato n\xE3o p\xF4de ser lido (${coverage.productLabels.join(" \xB7 ")}).`;
  }
}

// src/claims-closures.ts
var CLAIM_CLOSURE_KINDS = [
  "concluido_reparo",
  "concluido_indenizacao",
  "concluido_periferico",
  "concluido_somente_terceiro",
  "desistencia",
  "negado"
];
var CLAIM_CONCLUSION_KINDS = [
  "concluido_reparo",
  "concluido_indenizacao",
  "concluido_periferico",
  "concluido_somente_terceiro"
];
function isClaimConclusion(kind) {
  return CLAIM_CONCLUSION_KINDS.includes(kind);
}
var CLAIM_CLOSURE_ORIGINS = [
  "analise",
  "reparo",
  "indenizacao",
  "perifericos"
];
var CLAIM_CLOSURE_KIND_LABELS = {
  concluido_reparo: "Conclu\xEDdo no Reparo",
  concluido_indenizacao: "Conclu\xEDdo na Indeniza\xE7\xE3o",
  concluido_periferico: "Conclu\xEDdo em Perif\xE9ricos",
  concluido_somente_terceiro: "Conclu\xEDdo Somente Terceiro",
  desistencia: "Desist\xEAncia",
  negado: "Negativa"
};
var CLAIM_CLOSURE_PHASES = {
  analise: {
    concluido_somente_terceiro: "concluido_somente_terceiro",
    desistencia: "desistencia",
    negado: "negado",
    negados_com_posse: "negado",
    negados_com_posse_juridico: "negado"
  },
  reparo: {
    concluidos: "concluido_reparo",
    desistencia: "desistencia"
  },
  indenizacao: {
    concluidos: "concluido_indenizacao",
    desistencia: "desistencia"
  },
  perifericos: {
    concluidos: "concluido_periferico",
    desistencia: "desistencia",
    negados: "negado"
  }
};
function claimClosureKindOf(origin, phase) {
  return CLAIM_CLOSURE_PHASES[origin][phase] ?? null;
}
function claimClosurePhasesOf(origin, kind) {
  return Object.entries(CLAIM_CLOSURE_PHASES[origin]).filter(([, k]) => !kind || k === kind).map(([phase]) => phase);
}
var CLAIM_CLOSURE_ACTIONS = ["reabrir", "garantia"];
var CLAIM_CLOSURE_WARRANTY = {
  kind: "concluido_reparo",
  to: "retorno_garantia"
};
function claimClosureActionOf(origin, phase) {
  const kind = claimClosureKindOf(origin, phase);
  if (kind === null) return null;
  if (!isClaimConclusion(kind)) return "reabrir";
  return kind === CLAIM_CLOSURE_WARRANTY.kind ? "garantia" : null;
}
var CLAIM_CLOSURES_DEFAULT_DAYS = 90;

// src/claims-management.ts
var MANAGEMENT_LINES = [
  "analise",
  "reparo",
  "indenizacao",
  "perifericos"
];
var MANAGEMENT_BLOCKING_SITUATIONS = {
  analise: [],
  reparo: ["cliente_nao_compareceu_reagendar"],
  indenizacao: ["sem_comprovacao"],
  perifericos: ["erro_no_disparo", "pagamento_nao_realizado"]
};
var MANAGEMENT_DETOURS = {
  analise: ["sindicancia", "negativas_a_enviar"],
  reparo: ["negociacao_para_acordo", "retorno_garantia"],
  indenizacao: [],
  perifericos: ["acordo"]
};
function isManagementDetour(line2, phase) {
  return MANAGEMENT_DETOURS[line2].includes(phase);
}
function managementAvenueOf(line2) {
  return managementStagesOf(line2).filter((phase) => !isManagementDetour(line2, phase));
}
var MANAGEMENT_DOTS_PER_PHASE = 4;
var MANAGEMENT_FRESH_HOURS = 24;
var MANAGEMENT_AGE_LIMITS = [3, 7, 15];
var HANDOFFS = {
  analise: ANALYSIS_HANDOFFS,
  reparo: REPAIR_HANDOFFS,
  indenizacao: COMPENSATION_HANDOFFS,
  perifericos: {}
};
var PHASES5 = {
  analise: ANALYSIS_PHASES,
  reparo: REPAIR_PHASES,
  indenizacao: COMPENSATION_PHASES,
  perifericos: PERIPHERAL_PHASES
};
function managementStagesOf(line2) {
  return SLA_PHASES[line2];
}
function managementStepsOf(line2, phase) {
  return (PHASES5[line2][phase]?.situations ?? []).filter(
    (s) => !MANAGEMENT_BLOCKING_SITUATIONS[line2].includes(s)
  );
}
function isManagementBlocking(line2, situation2) {
  return MANAGEMENT_BLOCKING_SITUATIONS[line2].includes(situation2);
}
function managementEndKindsOf(line2) {
  const here = new Set(Object.values(CLAIM_CLOSURE_PHASES[line2]));
  return CLAIM_CLOSURE_KINDS.filter((k) => k !== "desistencia" && here.has(k));
}
function managementExitsOf(line2) {
  return Object.entries(HANDOFFS[line2]).map(([phase, to]) => ({
    phase,
    department: to.department,
    arrivesAt: to.phase
  }));
}
function managementSourcesOf(line2) {
  return MANAGEMENT_LINES.filter(
    (other) => other !== line2 && managementExitsOf(other).some((e) => e.department === line2)
  );
}
var NEXT_LINE = {
  analise: "reparo",
  reparo: "indenizacao"
};
function managementMovesOf(line2, phase) {
  return PHASES5[line2][phase]?.moves ?? [];
}
function managementTopologyOf(line2) {
  const avenue = managementAvenueOf(line2);
  const stages = managementStagesOf(line2);
  const exits = managementExitsOf(line2);
  const next = NEXT_LINE[line2];
  const isExit = (code) => exits.some((e) => e.phase === code);
  const continuation = exits.find(
    (e) => e.department === next && avenue.some((a) => managementMovesOf(line2, a).includes(e.phase))
  ) ?? null;
  const detours = MANAGEMENT_DETOURS[line2].map((phase) => {
    const leavesFrom = avenue.find((a) => managementMovesOf(line2, a).includes(phase)) ?? null;
    const from = leavesFrom === null ? -1 : avenue.indexOf(leavesFrom);
    const moves = managementMovesOf(line2, phase);
    const rejoinsAt = continuation && moves.includes(continuation.phase) ? continuation.phase : [...avenue].reverse().find((a) => moves.includes(a) && avenue.indexOf(a) > from) ?? null;
    return { phase, leavesFrom, rejoinsAt };
  });
  const stubs = stages.flatMap(
    (from) => managementMovesOf(line2, from).filter((to) => isExit(to) && to !== continuation?.phase).map((to) => ({ from, exit: exits.find((e) => e.phase === to) }))
  );
  const ends = Object.fromEntries(
    stages.map((phase) => [
      phase,
      [
        ...new Set(
          managementMovesOf(line2, phase).flatMap((to) => {
            const kind = claimClosureKindOf(line2, to);
            return kind && kind !== "desistencia" ? [kind] : [];
          })
        )
      ]
    ])
  );
  const continuationFrom = continuation ? avenue.filter((a) => managementMovesOf(line2, a).includes(continuation.phase)) : [];
  return { line: line2, avenue, detours, continuation, continuationFrom, stubs, ends };
}
function managementMoveKind(line2, from, to) {
  if (claimClosureKindOf(line2, to)) return "encerra";
  if (managementExitsOf(line2).some((e) => e.phase === to)) return "envia";
  if (isManagementDetour(line2, to)) return "desvia";
  if (isManagementDetour(line2, from)) return "retorna";
  const avenue = managementAvenueOf(line2);
  return avenue.indexOf(to) > avenue.indexOf(from) ? "avanca" : "volta";
}
function daysInPhase(enteredAt, now) {
  return Math.max(0, Math.floor((now.getTime() - enteredAt.getTime()) / 864e5));
}
function managementAgeBucket(days) {
  const i = MANAGEMENT_AGE_LIMITS.findIndex((limit) => days <= limit);
  return i === -1 ? MANAGEMENT_AGE_LIMITS.length : i;
}
function isManagementStalled(row) {
  return row.hold !== null || row.situation !== null && isManagementBlocking(row.line, row.situation);
}
function managementStepOf(row) {
  if (row.situation === null || isManagementStalled(row)) return null;
  return managementStepsOf(row.line, row.phase).includes(row.situation) ? row.situation : null;
}
function summarizeManagement(rows, now, searching) {
  const daysOf = (r) => r.phaseEnteredAt ? daysInPhase(r.phaseEnteredAt, now) : 0;
  const stats = (list) => {
    const days = list.map(daysOf);
    const ages = new Array(MANAGEMENT_AGE_LIMITS.length + 1).fill(0);
    for (const d of days) ages[managementAgeBucket(d)] += 1;
    return {
      total: list.length,
      slaExpired: list.filter((r) => r.slaExpired).length,
      thirdParty: list.filter((r) => r.type === "terceiro").length,
      onHold: list.filter(isManagementStalled).length,
      matches: searching ? list.filter((r) => r.matched).length : null,
      ages,
      averageDays: days.length ? Math.round(days.reduce((a, b) => a + b, 0) / days.length) : 0,
      oldestDays: days.length ? Math.max(...days) : 0
    };
  };
  const group = (list) => ({
    ...stats(list),
    items: [...list].sort((a, b) => daysOf(b) - daysOf(a)).slice(0, MANAGEMENT_DOTS_PER_PHASE)
  });
  const inProcess = rows.filter((r) => managementStagesOf(r.line).includes(r.phase));
  const freshSince = now.getTime() - MANAGEMENT_FRESH_HOURS * 36e5;
  return {
    totals: {
      open: inProcess.length,
      fresh: inProcess.filter((r) => r.createdAt.getTime() >= freshSince).length,
      slaExpired: inProcess.filter((r) => r.slaExpired).length,
      thirdParty: inProcess.filter((r) => r.type === "terceiro").length
    },
    lines: MANAGEMENT_LINES.map((line2) => {
      const mine = inProcess.filter((r) => r.line === line2);
      const stalled = mine.filter(isManagementStalled);
      const stallOf = (r) => r.hold !== null ? "parada" : "situacao";
      const codeOf = (r) => r.hold ?? r.situation;
      const keys = [...new Set(stalled.map((r) => `${stallOf(r)}:${codeOf(r)}`))].sort();
      return {
        line: line2,
        total: mine.length,
        slaExpired: mine.filter((r) => r.slaExpired).length,
        fresh: mine.filter((r) => r.createdAt.getTime() >= freshSince).length,
        thirdParty: mine.filter((r) => r.type === "terceiro").length,
        phases: managementStagesOf(line2).map((phase) => {
          const here = mine.filter((r) => r.phase === phase);
          return {
            phase,
            ...stats(here),
            station: group(here.filter((r) => managementStepOf(r) === null)),
            steps: managementStepsOf(line2, phase).map((situation2) => ({
              situation: situation2,
              ...group(here.filter((r) => managementStepOf(r) === situation2))
            }))
          };
        }),
        stalls: keys.map((key) => {
          const [kind, code] = key.split(":");
          return {
            kind,
            code,
            total: stalled.filter((r) => stallOf(r) === kind && codeOf(r) === code).length
          };
        })
      };
    })
  };
}

// src/claims-management-flow.ts
var CLAIM_FLOW_NODES = [
  ...CLAIM_DEPARTMENTS,
  "concluido",
  "negado",
  "desistencia"
];
var CLAIM_FLOW_PERIODS = [30, 90, 180, 365];
var CLAIM_FLOW_DEFAULT_PERIOD = 90;
var isDepartment = (d) => CLAIM_DEPARTMENTS.includes(d);
function claimFlowOutcomeOf(department, phase) {
  if (!isDepartment(department)) return null;
  const kind = claimClosureKindOf(department, phase);
  if (kind === null) return null;
  if (isClaimConclusion(kind)) return "concluido";
  return kind === "negado" ? "negado" : "desistencia";
}
function claimFlowPathOf(row) {
  const seen = /* @__PURE__ */ new Set([...row.departments, row.currentDepartment]);
  const departments = CLAIM_DEPARTMENTS.filter((d) => seen.has(d));
  if (departments.length === 0) departments.push(CLAIM_DEPARTMENTS[0]);
  return {
    departments,
    outcome: claimFlowOutcomeOf(row.currentDepartment, row.currentPhase)
  };
}
function summarizeClaimFlow(rows) {
  const counts = /* @__PURE__ */ new Map();
  const add3 = (from, to) => {
    const key = `${from}>${to}`;
    counts.set(key, (counts.get(key) ?? 0) + 1);
  };
  const inProcess = Object.fromEntries(CLAIM_DEPARTMENTS.map((d) => [d, 0]));
  for (const row of rows) {
    const { departments, outcome: outcome4 } = claimFlowPathOf(row);
    departments.slice(1).forEach((d, i) => add3(departments[i], d));
    const last = departments[departments.length - 1];
    if (outcome4) add3(last, outcome4);
    else inProcess[last]++;
  }
  const links = [];
  for (const from of CLAIM_FLOW_NODES)
    for (const to of CLAIM_FLOW_NODES) {
      const total = counts.get(`${from}>${to}`);
      if (total) links.push({ from, to, total });
    }
  return { total: rows.length, links, inProcess };
}

// src/claims-management-durations.ts
var CLAIM_WORK_STAGES = {
  analise: ANALYSIS_WORK_STAGES,
  reparo: REPAIR_WORK_STAGES,
  indenizacao: COMPENSATION_WORK_STAGES
};
var DAY_MS2 = 24 * 60 * 60 * 1e3;
var round1 = (n) => Math.round(n * 10) / 10;
function median(sorted) {
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
}
var mean = (xs) => xs.reduce((n, x) => n + x, 0) / xs.length;
function summarizeDepartmentDurations(passages, now) {
  const stays = new Map(
    CLAIM_DEPARTMENTS.map((d) => [d, /* @__PURE__ */ new Map()])
  );
  for (const p of passages) {
    const department = p.department;
    const byClaim = stays.get(department);
    if (!byClaim || !CLAIM_WORK_STAGES[department].includes(p.phase)) continue;
    const days = passageDays(p.enteredAt, p.leftAt, now);
    const stay = byClaim.get(p.claimId) ?? { days: 0, open: false };
    stay.days += days;
    stay.open ||= p.leftAt === null;
    byClaim.set(p.claimId, stay);
  }
  return CLAIM_DEPARTMENTS.map((department) => ({
    department,
    ...summarizeStays([...stays.get(department).values()])
  }));
}
function summarizeStays(all) {
  const done = all.filter((s) => !s.open).map((s) => s.days).sort((a, b) => a - b);
  const open = all.filter((s) => s.open).map((s) => s.days);
  return {
    done: done.length,
    meanDays: done.length ? round1(mean(done)) : null,
    medianDays: done.length ? round1(median(done)) : null,
    inProgress: open.length,
    inProgressMeanDays: open.length ? round1(mean(open)) : null
  };
}
function passageDays(enteredAt, leftAt, now) {
  return Math.max(0, (leftAt ?? now).getTime() - enteredAt.getTime()) / DAY_MS2;
}
function summarizeStageDurations(passages, now) {
  const stays = /* @__PURE__ */ new Map();
  for (const p of passages) {
    const department = p.department;
    if (!CLAIM_WORK_STAGES[department]?.includes(p.phase)) continue;
    const key = `${department}:${p.phase}`;
    const byClaim = stays.get(key) ?? /* @__PURE__ */ new Map();
    const stay = byClaim.get(p.claimId) ?? { days: 0, open: false };
    stay.days += passageDays(p.enteredAt, p.leftAt, now);
    stay.open ||= p.leftAt === null;
    byClaim.set(p.claimId, stay);
    stays.set(key, byClaim);
  }
  return CLAIM_DEPARTMENTS.flatMap(
    (department) => CLAIM_WORK_STAGES[department].flatMap((phase) => {
      const byClaim = stays.get(`${department}:${phase}`);
      return byClaim ? [{ department, phase, ...summarizeStays([...byClaim.values()]) }] : [];
    })
  );
}

// src/claims-management-panel.ts
var isDepartment2 = (d) => CLAIM_DEPARTMENTS.includes(d);
function deadlineBucketOf(deadlineAt, now) {
  if (deadlineAt === null) return "noDeadline";
  return deadlineAt.getTime() < now.getTime() ? "expired" : "withinDeadline";
}
function summarizeStageDeadlines(passages, now) {
  const byStage = /* @__PURE__ */ new Map();
  for (const p of passages) {
    if (!isDepartment2(p.department)) continue;
    if (!CLAIM_WORK_STAGES[p.department].includes(p.phase)) continue;
    const key = `${p.department}:${p.phase}`;
    const stage = byStage.get(key) ?? {
      department: p.department,
      phase: p.phase,
      withinDeadline: 0,
      expired: 0,
      noDeadline: 0
    };
    stage[deadlineBucketOf(p.deadlineAt, now)]++;
    byStage.set(key, stage);
  }
  return CLAIM_DEPARTMENTS.flatMap(
    (d) => CLAIM_WORK_STAGES[d].flatMap((phase) => byStage.get(`${d}:${phase}`) ?? [])
  );
}
var DAY_MS3 = 24 * 60 * 60 * 1e3;
var toUtc = (d) => {
  const [y, m, day] = businessDateParts(d);
  return Date.UTC(y, m - 1, day);
};
var fromUtc = (ms) => new Date(ms).toISOString().slice(0, 10);
function weekOf(date) {
  const ms = toUtc(date);
  const weekday = (new Date(ms).getUTCDay() + 6) % 7;
  return fromUtc(ms - weekday * DAY_MS3);
}
function weeklyNotices(rows, since, today) {
  const weeks = new Map(
    weekSlots(since, today).map((s) => [s.week, { ...s, member: 0, thirdParty: 0 }])
  );
  for (const r of rows) {
    const w = weeks.get(weekOf(r.date));
    if (!w) continue;
    if (r.type === "terceiro") w.thirdParty++;
    else w.member++;
  }
  return [...weeks.values()];
}
function weekSlots(since, today) {
  const slots = [];
  for (let ms = toUtc(weekOf(since)); ms <= toUtc(weekOf(today)); ms += 7 * DAY_MS3) {
    slots.push({
      week: fromUtc(ms),
      partial: ms < toUtc(since) || ms + 6 * DAY_MS3 > toUtc(today)
    });
  }
  return slots;
}
function summarizeClaimExits(rows) {
  const exits = /* @__PURE__ */ new Map();
  for (const r of rows) {
    const kind = claimFlowOutcomeOf(r.currentDepartment, r.currentPhase);
    if (kind !== "negado" && kind !== "desistencia") continue;
    const department = r.currentDepartment;
    const key = `${kind}:${department}:${r.fromPhase ?? ""}`;
    const exit = exits.get(key) ?? { kind, department, phase: r.fromPhase, total: 0 };
    exit.total++;
    exits.set(key, exit);
  }
  const order = (e) => CLAIM_DEPARTMENTS.indexOf(e.department);
  return [...exits.values()].sort(
    (a, b) => (a.kind === b.kind ? 0 : a.kind === "negado" ? -1 : 1) || b.total - a.total || order(a) - order(b)
  );
}

// src/claims-management-peripherals.ts
var isWorkStage = (phase) => PERIPHERAL_WORK_STAGES.includes(phase);
function summarizePeripheralDurations(passages, now) {
  const stays = new Map(
    PERIPHERAL_WORK_STAGES.map((s) => [s, /* @__PURE__ */ new Map()])
  );
  for (const p of passages) {
    if (!isWorkStage(p.phase)) continue;
    const byPeripheral = stays.get(p.phase);
    const stay = byPeripheral.get(p.peripheralId) ?? { days: 0, open: false };
    stay.days += passageDays(p.enteredAt, p.leftAt, now);
    stay.open ||= p.leftAt === null;
    byPeripheral.set(p.peripheralId, stay);
  }
  return PERIPHERAL_WORK_STAGES.map((phase) => ({
    phase,
    ...summarizeStays([...stays.get(phase).values()])
  }));
}
function summarizePeripheralDeadlines(passages, now) {
  const byStage = /* @__PURE__ */ new Map();
  for (const p of passages) {
    if (!isWorkStage(p.phase)) continue;
    const stage = byStage.get(p.phase) ?? {
      phase: p.phase,
      withinDeadline: 0,
      expired: 0,
      noDeadline: 0
    };
    stage[deadlineBucketOf(p.deadlineAt, now)]++;
    byStage.set(p.phase, stage);
  }
  return PERIPHERAL_WORK_STAGES.flatMap((phase) => byStage.get(phase) ?? []);
}
var PERIPHERAL_WEEK_ORIGINS = [
  "chatbot",
  "administrativo",
  "portal",
  "unknown"
];
function peripheralWeekOriginOf(origin) {
  const known = PERIPHERAL_WEEK_ORIGINS.find((o) => o === origin?.trim().toLowerCase());
  return known && known !== "unknown" ? known : "unknown";
}
function weeklyPeripherals(rows, since, today) {
  const weeks = new Map(
    weekSlots(since, today).map((s) => [
      s.week,
      {
        ...s,
        origins: Object.fromEntries(PERIPHERAL_WEEK_ORIGINS.map((o) => [o, 0]))
      }
    ])
  );
  for (const r of rows) {
    const w = weeks.get(weekOf(r.date));
    if (w) w.origins[peripheralWeekOriginOf(r.origin)]++;
  }
  return [...weeks.values()];
}
function summarizePeripheralMoney(peripherals) {
  const byCoverage = PERIPHERAL_COVERAGE_PERCENTS.map((percent) => ({
    percent,
    peripherals: 0,
    totalApproved: ZERO,
    associationShare: ZERO
  }));
  let priced = 0;
  let totalApproved = ZERO;
  let associationShare = ZERO;
  let memberShare = ZERO;
  for (const p of peripherals) {
    const totals = peripheralTotals(p.items, p.coveragePercent);
    if (!totals.ok) continue;
    priced++;
    totalApproved = sum(totalApproved, totals.totalApproved);
    associationShare = sum(associationShare, totals.associationShare);
    memberShare = sum(memberShare, totals.memberShare);
    const slot = byCoverage.find((c) => c.percent === p.coveragePercent);
    slot.peripherals++;
    slot.totalApproved = sum(slot.totalApproved, totals.totalApproved);
    slot.associationShare = sum(slot.associationShare, totals.associationShare);
  }
  return {
    priced,
    pending: peripherals.length - priced,
    totalApproved,
    associationShare,
    memberShare,
    byCoverage
  };
}
var PERIPHERAL_PANEL_TOP_PROVIDERS = 5;
function summarizePeripheralQuotes(items) {
  const origins = /* @__PURE__ */ new Map();
  const providers = /* @__PURE__ */ new Map();
  let approvedItems = 0;
  let atLowest = 0;
  let approvedTotal = ZERO;
  let lowestTotal = ZERO;
  for (const item of items) {
    const approved = item.quotes.find((q) => q.status === "aprovado" && q.value !== null);
    if (!approved) continue;
    const lowest = item.quotes.filter((q) => q.value !== null && q.status !== "reprovado").reduce(
      (min, q) => compareMoney(q.value, min) < 0 ? q.value : min,
      approved.value
    );
    approvedItems++;
    if (compareMoney(approved.value, lowest) === 0) atLowest++;
    approvedTotal = sum(approvedTotal, approved.value);
    lowestTotal = sum(lowestTotal, lowest);
    const origin = approved.partOrigin && Object.hasOwn(PERIPHERAL_PART_ORIGINS, approved.partOrigin) ? approved.partOrigin : "unknown";
    const o = origins.get(origin) ?? { items: 0, total: ZERO };
    origins.set(origin, { items: o.items + 1, total: sum(o.total, approved.value) });
    const p = providers.get(approved.providerCompanyId) ?? { items: 0, total: ZERO };
    providers.set(approved.providerCompanyId, {
      items: p.items + 1,
      total: sum(p.total, approved.value)
    });
  }
  const originOrder = [...Object.keys(PERIPHERAL_PART_ORIGINS), "unknown"];
  return {
    approvedItems,
    atLowest,
    approvedTotal,
    lowestTotal,
    aboveLowest: subtract(approvedTotal, lowestTotal),
    origins: [...origins].map(([origin, o]) => ({ origin, ...o })).sort((a, b) => originOrder.indexOf(a.origin) - originOrder.indexOf(b.origin)),
    providers: [...providers].map(([companyId, p]) => ({ companyId, ...p })).sort((a, b) => compareMoney(b.total, a.total) || b.items - a.items)
  };
}

// src/brazilian-states.ts
var BRAZILIAN_STATE_INFO = {
  AC: { name: "Acre", ibge: "12" },
  AL: { name: "Alagoas", ibge: "27" },
  AM: { name: "Amazonas", ibge: "13" },
  AP: { name: "Amap\xE1", ibge: "16" },
  BA: { name: "Bahia", ibge: "29" },
  CE: { name: "Cear\xE1", ibge: "23" },
  DF: { name: "Distrito Federal", ibge: "53" },
  ES: { name: "Esp\xEDrito Santo", ibge: "32" },
  GO: { name: "Goi\xE1s", ibge: "52" },
  MA: { name: "Maranh\xE3o", ibge: "21" },
  MG: { name: "Minas Gerais", ibge: "31" },
  MS: { name: "Mato Grosso do Sul", ibge: "50" },
  MT: { name: "Mato Grosso", ibge: "51" },
  PA: { name: "Par\xE1", ibge: "15" },
  PB: { name: "Para\xEDba", ibge: "25" },
  PE: { name: "Pernambuco", ibge: "26" },
  PI: { name: "Piau\xED", ibge: "22" },
  PR: { name: "Paran\xE1", ibge: "41" },
  RJ: { name: "Rio de Janeiro", ibge: "33" },
  RN: { name: "Rio Grande do Norte", ibge: "24" },
  RO: { name: "Rond\xF4nia", ibge: "11" },
  RR: { name: "Roraima", ibge: "14" },
  RS: { name: "Rio Grande do Sul", ibge: "43" },
  SC: { name: "Santa Catarina", ibge: "42" },
  SE: { name: "Sergipe", ibge: "28" },
  SP: { name: "S\xE3o Paulo", ibge: "35" },
  TO: { name: "Tocantins", ibge: "17" }
};
var BRAZILIAN_STATES = Object.keys(BRAZILIAN_STATE_INFO).sort();
function isBrazilianState(value2) {
  return Object.hasOwn(BRAZILIAN_STATE_INFO, value2);
}
function brazilianStateName(value2) {
  return isBrazilianState(value2) ? BRAZILIAN_STATE_INFO[value2].name : null;
}
var CEP_RANGES = [
  [1e3, 19999, "SP"],
  [2e4, 28999, "RJ"],
  [29e3, 29999, "ES"],
  [3e4, 39999, "MG"],
  [4e4, 48999, "BA"],
  [49e3, 49999, "SE"],
  [5e4, 56999, "PE"],
  [57e3, 57999, "AL"],
  [58e3, 58999, "PB"],
  [59e3, 59999, "RN"],
  [6e4, 63999, "CE"],
  [64e3, 64999, "PI"],
  [65e3, 65999, "MA"],
  [66e3, 68899, "PA"],
  [68900, 68999, "AP"],
  [69e3, 69299, "AM"],
  [69300, 69399, "RR"],
  [69400, 69899, "AM"],
  [69900, 69999, "AC"],
  [7e4, 72799, "DF"],
  [72800, 72999, "GO"],
  [73e3, 73699, "DF"],
  [73700, 76799, "GO"],
  [76800, 76999, "RO"],
  [77e3, 77999, "TO"],
  [78e3, 78899, "MT"],
  [79e3, 79999, "MS"],
  [8e4, 87999, "PR"],
  [88e3, 89999, "SC"],
  [9e4, 99999, "RS"]
];
function stateOfCep(cep) {
  const digits = cep.replace(/\D/g, "");
  if (digits.length !== 8) return null;
  const prefix = Number(digits.slice(0, 5));
  return CEP_RANGES.find(([from, to]) => prefix >= from && prefix <= to)?.[2] ?? null;
}

// src/claims-phase-label.ts
function claimPhaseLabel(department, phase) {
  if (department === "analise") return analysisPhaseLabel(phase);
  if (department === "reparo") return repairPhaseLabel(phase);
  return compensationPhaseLabel(phase);
}

// src/assistance.ts
var ASSISTANCE_SERVICE_TYPES = [
  "reboque",
  "bateria",
  "pneu",
  "pane_seca",
  "chaveiro",
  "residencial",
  "taxi",
  "hospedagem"
];
var ASSISTANCE_SERVICES = [
  { type: "reboque", label: "Reboque", shortLabel: "Reboque", needsDestination: true },
  {
    type: "bateria",
    label: "Carga de bateria",
    shortLabel: "Bateria",
    needsDestination: false
  },
  { type: "pneu", label: "Troca de pneu", shortLabel: "Pneu", needsDestination: false },
  {
    type: "pane_seca",
    label: "Pane seca",
    shortLabel: "Pane seca",
    needsDestination: false
  },
  {
    type: "chaveiro",
    label: "Chaveiro",
    shortLabel: "Chaveiro",
    needsDestination: false
  },
  {
    type: "residencial",
    label: "Assist\xEAncia residencial",
    shortLabel: "Residencial",
    needsDestination: false
  },
  { type: "taxi", label: "T\xE1xi", shortLabel: "T\xE1xi", needsDestination: false },
  {
    type: "hospedagem",
    label: "Hospedagem",
    shortLabel: "Hospedagem",
    needsDestination: false
  }
];
function assistanceService(type) {
  const found = ASSISTANCE_SERVICES.find((s) => s.type === type);
  if (!found) throw new Error(`servi\xE7o de assist\xEAncia desconhecido: ${type}`);
  return found;
}
var SERVICE_VARIANTS = {
  reboque: ["pane", "sinistro", "terceiro"],
  residencial: [
    "chaveiro",
    "desentupimento",
    "eletricista",
    "encanador",
    "ar_condicionado"
  ]
};
var ALL_SERVICE_VARIANTS = [
  ...SERVICE_VARIANTS.reboque,
  ...SERVICE_VARIANTS.residencial
];
var SERVICE_VARIANT_LABELS = {
  pane: "Pane",
  sinistro: "Sinistro do associado",
  terceiro: "Terceiro",
  chaveiro: "Chaveiro",
  desentupimento: "Desentupimento",
  eletricista: "Eletricista",
  encanador: "Encanador",
  ar_condicionado: "Limpeza de ar-condicionado"
};
var SERVICE_VARIANT_FIELD = {
  reboque: "Motivo do reboque",
  residencial: "Servi\xE7o residencial"
};
function serviceVariantsOf(type) {
  return type in SERVICE_VARIANTS ? SERVICE_VARIANTS[type] : null;
}
function serviceVariantFits(type, variant) {
  const options5 = serviceVariantsOf(type);
  return options5 === null ? variant === null : variant !== null && options5.includes(variant);
}
var PROVIDER_PAYMENT_MODES = ["a_vista", "mensal"];
var ASSISTANCE_PRICINGS = ["saida_e_km", "fixo", "a_combinar"];
var seed = (group, code, name, fixedVariant = null, archived = false, addon = false) => ({ code, group, name, fixedVariant, archived, addon });
var ASSISTANCE_SERVICE_SEED = [
  seed("reboque", "reboque_leve", "Reboque Leve"),
  seed("reboque", "reboque_moto", "Reboque Moto", null, true),
  seed("reboque", "reboque_utilitario", "Reboque Utilit\xE1rio"),
  seed("reboque", "reboque_pesado", "Reboque Pesado"),
  seed("reboque", "reboque_extra_pesado", "Reboque Extra Pesado"),
  seed("reboque", "reboque_bicicleta", "Reboque Bicicleta", null, true),
  seed("reboque", "reboque_patins", "Patins", null, false, true),
  seed("reboque", "reboque_guindaste", "Reboque Guindaste", null, true),
  seed("reboque", "reboque_garagem", "Reboque Garagem", null, true),
  seed("reboque", "reboque_sem_porte", "Reboque (sem porte)", null, true),
  seed("bateria", "bateria_carga_troca", "Carga ou Troca de Bateria"),
  seed("bateria", "socorro_eletrico_leve", "Socorro El\xE9trico Leve"),
  seed("bateria", "socorro_eletrico_pesado", "Socorro El\xE9trico Pesado"),
  seed("pneu", "pneu_substituicao", "Substitui\xE7\xE3o de Pneu"),
  seed("pneu", "socorro_borracheiro_leve", "Socorro Borracheiro Leve"),
  seed("pane_seca", "pane_seca_combustivel", "Envio de Combust\xEDvel"),
  seed("chaveiro", "chaveiro_automotivo", "Chaveiro Automotivo"),
  seed("residencial", "residencial_chaveiro", "Chaveiro Residencial", "chaveiro"),
  seed("residencial", "residencial_desentupimento", "Desentupimento", "desentupimento"),
  seed("residencial", "residencial_eletrico", "El\xE9trico", "eletricista"),
  seed("residencial", "residencial_encanador", "Encanador", "encanador"),
  seed(
    "residencial",
    "residencial_ar_condicionado",
    "Limpeza de Ar Condicionado",
    "ar_condicionado"
  ),
  seed("residencial", "residencial_sem_tipo", "Residencial (sem tipo)", null, true),
  seed("taxi", "taxi", "T\xE1xi"),
  seed("taxi", "taxi_especial", "T\xE1xi Especial"),
  seed("hospedagem", "hospedagem", "Hospedagem")
];
function legacyServiceCode(group, variant) {
  switch (group) {
    case "reboque":
      return "reboque_sem_porte";
    case "bateria":
      return "bateria_carga_troca";
    case "pneu":
      return "pneu_substituicao";
    case "pane_seca":
      return "pane_seca_combustivel";
    case "chaveiro":
      return "chaveiro_automotivo";
    case "residencial":
      return ASSISTANCE_SERVICE_SEED.find(
        (s) => s.group === "residencial" && s.fixedVariant === variant && !s.archived
      )?.code ?? "residencial_sem_tipo";
    case "taxi":
      return "taxi";
    case "hospedagem":
      return "hospedagem";
  }
}
var TOW_KINDS = ["comum", "emergencial"];
var DISPATCH_VALUATION_SOURCES = [
  "tabela",
  "informado",
  "cancelamento",
  "a_combinar"
];
var DISPATCH_STATUSES = [
  "rascunho",
  "agendado",
  "acionado",
  "cancelado"
];
function draftMissing(d) {
  const missing = [];
  if (d.serviceId === null) missing.push("servi\xE7o");
  if (d.vehicleId === null) missing.push("placa");
  if (!d.opaSuiteProtocol) missing.push("protocolo");
  if (d.origin === null) missing.push("onde est\xE1 o ve\xEDculo");
  if (assistanceService(d.serviceType).needsDestination) {
    if (d.destination === null) missing.push("destino");
    if (d.towKind === null) missing.push("tipo de reboque");
  }
  if (serviceVariantsOf(d.serviceType) !== null && d.serviceVariant === null)
    missing.push(
      SERVICE_VARIANT_FIELD[d.serviceType].toLowerCase()
    );
  if (!d.callbackPhone) missing.push("telefone");
  if (!d.description) missing.push("descri\xE7\xE3o");
  if (d.providerId === null) missing.push("prestador");
  return missing;
}
var DISPATCH_FILE_KINDS = ["origem", "destino", "odometro", "outra"];
var SETTLEMENT_KINDS = PROVIDER_PAYMENT_MODES;
var SETTLEMENT_METHODS = ["pix", "dinheiro", "cartao"];
function hasTablePrice(price) {
  return price !== null && price.pricing !== "a_combinar";
}
function meters(value2, name) {
  if (!Number.isInteger(value2) || value2 < 0) {
    throw new Error(
      `${name} precisa ser um n\xFAmero inteiro de metros, maior ou igual a zero: ${value2}`
    );
  }
  return value2;
}
function perMeters(perKm, m) {
  return m === 0 ? ZERO : multiply(perKm, m / 1e3);
}
function dispatchAmount(price, totalM, coverageM) {
  meters(totalM, "o percurso");
  if (price.pricing === "fixo")
    return { evogard: price.flatAmount, associate: ZERO, countedM: 0 };
  const b = towBreakdown(price, totalM, coverageM);
  return { evogard: b.evogard, associate: b.associate, countedM: b.totalM };
}
function towBreakdown(price, totalM, coverageM) {
  meters(totalM, "o percurso");
  meters(price.includedM, "o que a sa\xEDda cobre");
  const cap = coverageM === null ? Infinity : Math.max(meters(coverageM, "a cobertura"), price.includedM);
  const coveredExtraM = Math.max(0, Math.min(totalM, cap) - price.includedM);
  const excessM = cap === Infinity ? 0 : Math.max(0, totalM - cap);
  const coveredExtraAmount = perMeters(price.perKmAmount, coveredExtraM);
  return {
    totalM,
    includedM: price.includedM,
    flatAmount: price.flatAmount,
    perKmAmount: price.perKmAmount,
    coverageM,
    paidUpToM: cap === Infinity ? null : cap,
    coveredExtraM,
    coveredExtraAmount,
    evogard: sum(price.flatAmount, coveredExtraAmount),
    excessM,
    associate: perMeters(price.perKmAmount, excessM)
  };
}
function withAddon(amount, addon) {
  if (addon === null) return amount;
  if (addon < 0) throw new Error(`O adicional n\xE3o pode ser negativo: ${addon}`);
  return { ...amount, evogard: sum(amount.evogard, addon) };
}
function routeTotalM(legs) {
  return meters(legs.approachM, "a ida") + (legs.towM === null ? 0 : meters(legs.towM, "o reboque")) + meters(legs.returnM, "a volta");
}
function cancellationSuggestion(price) {
  return hasTablePrice(price) ? price.flatAmount : cents(0);
}
var DISPATCH_LINK_TTL_MS = 3 * 24 * 60 * 60 * 1e3;
function dispatchLinkExpiresAt(issuedAt) {
  return new Date(issuedAt.getTime() + DISPATCH_LINK_TTL_MS);
}
function dispatchSituation(row) {
  if (row.canceledAt) return "cancelado";
  return row.executedAt ? "executado" : "agendado";
}

// src/assistance-script.ts
function km(m) {
  return `${(m / 1e3).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} KM`;
}
function money(d) {
  return format(d);
}
function line(label, value2) {
  return value2 === null || value2.trim() === "" ? null : `${label}: ${value2.trim()}`;
}
function accountBlock(input) {
  const { price, amount } = input;
  if (price?.pricing === "a_combinar") return ["VALOR: A COMBINAR"];
  if (!price || !amount) return [];
  const addon = input.addon ? `${input.addon.name.toUpperCase()}: ${money(input.addon.amount)}` : null;
  if (price.pricing === "fixo") {
    const fixed = `VALOR: ${money(price.flatAmount)} (PRE\xC7O FIXO)`;
    return addon ? [fixed, addon, `PAGO PELA EVOGARD: ${money(amount.evogard)}`] : [fixed];
  }
  const extraM = Math.max(0, amount.countedM - price.includedM);
  const out = [
    `KM DE SA\xCDDA: ${km(price.includedM)}`,
    `VALOR DE SA\xCDDA: ${money(price.flatAmount)}`,
    `VALOR DO EXCEDENTE: ${money(price.perKmAmount)} POR KM`,
    `KM TOTAL: ${km(amount.countedM)}`,
    `${km(amount.countedM)} - ${km(price.includedM)} (SA\xCDDA) = ${km(extraM)}`,
    `COBERTURA DO PLANO: ${input.coverageM === null ? "SEM LIMITE" : km(input.coverageM)}`,
    ...addon ? [addon] : [],
    `PAGO PELA EVOGARD: ${money(amount.evogard)}`
  ];
  if (amount.associate > 0) {
    out.push(
      `ACIMA DA COBERTURA, PAGO PELO ASSOCIADO AO PRESTADOR: ${money(amount.associate)}`
    );
  }
  return out;
}
function serviceScript(input) {
  const service = assistanceService(input.serviceType);
  const residential = input.serviceType === "residencial";
  const label = `${input.serviceName ?? service.label}${input.addon ? ` + ${input.addon.name}` : ""}`;
  const title = residential ? `ASSIST\xCANCIA RESIDENCIAL${input.serviceName ? `: ${input.serviceName.toUpperCase()}` : ""}` : `SERVI\xC7O: ${label.toUpperCase()}${input.towKind ? ` (${input.towKind.toUpperCase()})` : ""}`;
  const blocks = [
    [title],
    [
      line("ASSOCIADO", input.memberName),
      residential ? null : line("PLACA", input.plate),
      residential ? null : line("VE\xCDCULO", input.vehicle),
      line("CONSULTOR", input.consultant),
      line("COOPERATIVA", input.cooperative),
      `CONTATO: https://wa.me/55${input.callbackPhone.replace(/\D/g, "")}`
    ],
    residential ? [line("ENDERE\xC7O", input.origin), line("DEFEITO", input.description)] : [
      line("OCORR\xCANCIA", input.description),
      line("ORIGEM", input.origin),
      line("DESTINO", input.destination)
    ],
    [
      line("PRESTADOR", input.providerName),
      input.scheduledFor ? `AGENDADO PARA: ${formatInstant(input.scheduledFor)}` : null,
      line("OBSERVA\xC7\xC3O", input.providerNotes)
    ],
    accountBlock(input),
    input.linkUrl ? [`FOTOS E KM DO SERVI\xC7O: ${input.linkUrl}`] : []
  ];
  return blocks.map((b) => b.filter((l) => l !== null)).filter((b) => b.length > 0).map((b) => b.join("\n")).join("\n\n");
}

// src/assistance-progress.ts
var DISPATCH_PROGRESS_STEPS = [
  "saiu",
  "chegou",
  "placa_conferida",
  "iniciou",
  "embarcou",
  "chegou_destino",
  "finalizou"
];
var DISPATCH_STEP_KINDS = [
  ...DISPATCH_PROGRESS_STEPS,
  "abriu",
  "placa_errada",
  "placa_destravada",
  "fora_da_tela",
  "voltou_a_tela"
];
var PROVIDER_BUTTON_STEPS = [
  "saiu",
  "chegou",
  "iniciou",
  "embarcou",
  "chegou_destino",
  "finalizou"
];
var DISPATCH_STEP_LABELS = {
  abriu: "Abriu o link",
  saiu: "Saiu para o local",
  chegou: "Chegou no local",
  placa_conferida: "Placa conferida",
  iniciou: "Iniciou o servi\xE7o",
  embarcou: "Carro embarcado",
  chegou_destino: "Chegou ao destino",
  finalizou: "Finalizou",
  placa_errada: "Placa errada",
  placa_destravada: "Placa destravada pela central",
  fora_da_tela: "Saiu da tela do link",
  voltou_a_tela: "Voltou \xE0 tela do link"
};
var PLATE_CHECKED = /* @__PURE__ */ new Set([
  "reboque",
  "bateria",
  "pneu",
  "pane_seca",
  "chaveiro"
]);
function checksPlate(type) {
  return PLATE_CHECKED.has(type);
}
function progressStepsOf(type) {
  return DISPATCH_PROGRESS_STEPS.filter((step) => {
    if (step === "placa_conferida") return checksPlate(type);
    if (step === "embarcou" || step === "chegou_destino") return type === "reboque";
    return true;
  });
}
function nextProgressStep(type, done) {
  const seen = new Set(done);
  return progressStepsOf(type).find((step) => !seen.has(step)) ?? null;
}
var PLATE_ATTEMPTS = 3;
function plateMatches(typed, expected) {
  const a = normalizePlate(typed);
  return a !== null && a === normalizePlate(expected);
}
function plateAttemptsLeft(kinds) {
  let wrong = 0;
  for (const kind of kinds) {
    if (kind === "placa_destravada") wrong = 0;
    else if (kind === "placa_errada") wrong += 1;
  }
  return Math.max(0, PLATE_ATTEMPTS - wrong);
}
var ARRIVAL_FAR_M = 500;
function distanceM(a, b) {
  const R = 6371e3;
  const rad = (d) => d * Math.PI / 180;
  const dLat = rad(b.lat - a.lat);
  const dLng = rad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return Math.round(2 * R * Math.asin(Math.min(1, Math.sqrt(h))));
}
var DISPATCH_PROGRESS = [
  "nao_abriu",
  "link_aberto",
  "a_caminho",
  "no_local",
  "em_servico",
  "em_transito",
  "no_destino",
  "finalizado"
];
var DISPATCH_PROGRESS_LABELS = {
  nao_abriu: "N\xE3o abriu o link",
  link_aberto: "Link aberto",
  a_caminho: "A caminho",
  no_local: "No local",
  em_servico: "Em servi\xE7o",
  em_transito: "Em tr\xE2nsito",
  no_destino: "No destino",
  finalizado: "Finalizado"
};
function progressOf(done) {
  const seen = new Set(done);
  if (seen.has("finalizou")) return "finalizado";
  if (seen.has("chegou_destino")) return "no_destino";
  if (seen.has("embarcou")) return "em_transito";
  if (seen.has("iniciou")) return "em_servico";
  if (seen.has("chegou") || seen.has("placa_conferida")) return "no_local";
  if (seen.has("saiu")) return "a_caminho";
  return seen.has("abriu") ? "link_aberto" : "nao_abriu";
}
function isTracking(progress) {
  return progress !== "nao_abriu" && progress !== "link_aberto" && progress !== "finalizado";
}
function arrivalForecast(input) {
  const { arrivalPrepMin, arrivalSlackPct } = input.settings;
  const factor = arrivalSlackPct === null ? null : 1 + arrivalSlackPct / 100;
  const add3 = (from, s) => new Date(from.getTime() + s * 1e3);
  if (input.departure && input.departure.etaS !== null) {
    const { at: at2, etaS } = input.departure;
    return {
      googleAt: add3(at2, etaS),
      deadline: factor === null || arrivalPrepMin === null ? null : add3(at2, etaS * factor)
    };
  }
  if (input.approachS === null) return { googleAt: null, deadline: null };
  return {
    googleAt: add3(input.executedAt, input.approachS),
    deadline: factor === null || arrivalPrepMin === null ? null : add3(input.executedAt, arrivalPrepMin * 60 + input.approachS * factor)
  };
}
function signalLost(input) {
  if (input.noSignalMin === null || !isTracking(input.progress)) return false;
  if (input.lastSignalAt === null) return true;
  return input.now.getTime() - input.lastSignalAt.getTime() > input.noSignalMin * 6e4;
}
function openLinkReminder(code, linkUrl) {
  return `Ol\xE1! A central da Evogard n\xE3o est\xE1 recebendo a sua localiza\xE7\xE3o no servi\xE7o ${code}. Abra o link e deixe a tela aberta enquanto estiver no servi\xE7o: ${linkUrl}`;
}
var MEMBER_TRACKING_STAGES = ["acionado", "a_caminho", "chegou"];
var MEMBER_TRACKING_LABELS = {
  acionado: "Prestador acionado",
  a_caminho: "A caminho",
  chegou: "Chegou ao local"
};
var ARRIVED_STEPS = /* @__PURE__ */ new Set([
  "chegou",
  "placa_conferida",
  "iniciou",
  "embarcou",
  "chegou_destino",
  "finalizou"
]);
function memberStageOf(done) {
  if (done.some((kind) => ARRIVED_STEPS.has(kind))) return "chegou";
  return done.includes("saiu") ? "a_caminho" : "acionado";
}
function memberStepsOf(input) {
  const first = (match) => input.steps.filter((s) => match(s.kind)).reduce((min, s) => min === null || s.at < min ? s.at : min, null);
  return [
    { stage: "acionado", at: input.executedAt },
    { stage: "a_caminho", at: first((kind) => kind === "saiu") },
    { stage: "chegou", at: first((kind) => ARRIVED_STEPS.has(kind)) }
  ];
}
function memberTrackingMessage(code, linkUrl) {
  return `Ol\xE1! O prestador do seu atendimento ${code} da Evogard j\xE1 foi acionado. Acompanhe por aqui at\xE9 ele chegar: ${linkUrl}`;
}

// src/assistance-management.ts
var MANAGEMENT_NOW_HOURS = 24;
var MANAGEMENT_SCHEDULED_AHEAD_HOURS = 24;
var MANAGEMENT_PERIOD_DAYS = [1, 7, 30];
var MANAGEMENT_OPEN_STAGES = DISPATCH_PROGRESS.filter(
  (p) => p !== "finalizado"
);
var MANAGEMENT_STAGES = [...DISPATCH_PROGRESS, "agendado", "cancelado"];
function managementStageOf(status, progress) {
  switch (status) {
    case "rascunho":
      return null;
    case "agendado":
      return "agendado";
    case "cancelado":
      return "cancelado";
    case "acionado":
      return progress ?? "nao_abriu";
  }
}
function isOpenStage(stage) {
  return MANAGEMENT_OPEN_STAGES.includes(stage);
}
function tallyByType(rows) {
  const byType = /* @__PURE__ */ new Map();
  for (const { serviceType, stage } of rows) {
    const t = byType.get(serviceType) ?? {
      type: serviceType,
      total: 0,
      finished: 0,
      inProgress: 0,
      scheduled: 0,
      canceled: 0
    };
    t.total += 1;
    if (stage === "finalizado") t.finished += 1;
    else if (stage === "agendado") t.scheduled += 1;
    else if (stage === "cancelado") t.canceled += 1;
    else t.inProgress += 1;
    byType.set(serviceType, t);
  }
  return [...byType.values()].sort(
    (a, b) => b.total - a.total || a.type.localeCompare(b.type)
  );
}

// src/assistance-usage.ts
var USAGE_RULE_KINDS = ["limitado", "sem_limite", "nao_definido"];
var USAGE_WINDOW_UNITS = ["dias", "meses"];
var DEFAULT_WINDOW = { amount: 30, unit: "dias" };
var TOW_CONTINUATION_DAYS = 7;
var USAGE_LINES = [
  { serviceType: "reboque", serviceVariant: "pane", label: "Reboque por pane" },
  { serviceType: "reboque", serviceVariant: "sinistro", label: "Reboque por sinistro" },
  { serviceType: "reboque", serviceVariant: "terceiro", label: "Reboque do terceiro" },
  { serviceType: "bateria", serviceVariant: null, label: "Bateria" },
  { serviceType: "pneu", serviceVariant: null, label: "Pneu" },
  { serviceType: "pane_seca", serviceVariant: null, label: "Pane seca" },
  { serviceType: "chaveiro", serviceVariant: null, label: "Chaveiro" },
  { serviceType: "hospedagem", serviceVariant: null, label: "Hospedagem" },
  { serviceType: "taxi", serviceVariant: null, label: "T\xE1xi" },
  { serviceType: "residencial", serviceVariant: null, label: "Residencial" }
];
function usageLineOf(serviceType, serviceVariant) {
  const wanted = serviceType === "reboque" ? serviceVariant ?? "pane" : null;
  const found = USAGE_LINES.find(
    (l) => l.serviceType === serviceType && l.serviceVariant === wanted
  );
  if (!found) throw new Error(`linha de cota desconhecida: ${serviceType}/${wanted}`);
  return found;
}
function shiftByWindow(at2, window, direction) {
  if (window.unit === "dias") {
    return new Date(at2.getTime() + direction * window.amount * 864e5);
  }
  const result = new Date(at2.getTime());
  const day = result.getUTCDate();
  result.setUTCDate(1);
  result.setUTCMonth(result.getUTCMonth() + direction * window.amount);
  const lastDay = new Date(
    Date.UTC(result.getUTCFullYear(), result.getUTCMonth() + 1, 0)
  ).getUTCDate();
  result.setUTCDate(Math.min(day, lastDay));
  return result;
}
function countsAsUse(event, window, at2, cancelGraceMin) {
  if (event.continuesDispatchId !== null) return false;
  const from = shiftByWindow(at2, window, -1).getTime();
  const inPast = (when) => when !== null && when.getTime() > from;
  if (event.status === "acionado") return inPast(event.executedAt);
  if (event.status === "agendado") {
    if (event.scheduledFor === null) return false;
    const until = shiftByWindow(at2, window, 1).getTime();
    const when = event.scheduledFor.getTime();
    return when > from && when < until;
  }
  if (event.status === "cancelado") {
    if (cancelGraceMin === null) return false;
    if (event.executedAt === null || event.canceledAt === null) return false;
    const minutes = (event.canceledAt.getTime() - event.executedAt.getTime()) / 6e4;
    return minutes > cancelGraceMin && inPast(event.executedAt);
  }
  return false;
}
function ruleOf(line2, rules) {
  return rules.find(
    (r) => r.serviceType === line2.serviceType && r.serviceVariant === line2.serviceVariant
  ) ?? null;
}
function usageRowOf(input) {
  const { line: line2, rules, events, at: at2, cancelGraceMin } = input;
  const rule = ruleOf(line2, rules);
  const limited = rule?.kind === "limitado" && rule.maxUses !== null && rule.window;
  const window = limited && rule.window ? rule.window : input.displayWindow ?? DEFAULT_WINDOW;
  const counted = events.filter(
    (e) => e.id !== input.exceptDispatchId && usageLineOf(e.serviceType, e.serviceVariant) === line2 && countsAsUse(e, window, at2, cancelGraceMin)
  ).sort(
    (a, b) => (a.executedAt ?? a.scheduledFor ?? at2).getTime() - (b.executedAt ?? b.scheduledFor ?? at2).getTime()
  );
  const maxUses = limited ? rule.maxUses : null;
  return {
    serviceType: line2.serviceType,
    serviceVariant: line2.serviceVariant,
    label: line2.label,
    ruleId: rule?.id ?? null,
    kind: rule?.kind ?? "nao_definido",
    maxUses,
    window,
    used: counted.length,
    usedCodes: counted.map((e) => e.code),
    canDispatch: maxUses === null || counted.length < maxUses,
    regulationText: rule?.regulationText ?? null
  };
}
function usageDisplayWindow(rules) {
  const tally = /* @__PURE__ */ new Map();
  for (const r of rules) {
    if (r.kind !== "limitado" || !r.window) continue;
    const key = `${r.window.amount}:${r.window.unit}`;
    const entry = tally.get(key) ?? { window: r.window, total: 0 };
    entry.total += 1;
    tally.set(key, entry);
  }
  const best = [...tally.values()].sort((a, b) => b.total - a.total)[0];
  return best?.window ?? DEFAULT_WINDOW;
}
function usageTable(input) {
  const displayWindow = usageDisplayWindow(input.rules);
  return USAGE_LINES.map((line2) => usageRowOf({ ...input, line: line2, displayWindow }));
}
function usageWindowLabel(window) {
  if (window.unit === "dias")
    return `${window.amount} ${window.amount === 1 ? "dia" : "dias"}`;
  return `${window.amount} ${window.amount === 1 ? "m\xEAs" : "meses"}`;
}

// src/breaks.ts
var BREAK_MINUTES = 15;
var BREAK_OVERRUN_TOLERANCE_MINUTES = 1;
var BREAK_DEFAULT_WINDOW = { startHour: 15, endHour: 16 };
var BREAK_ADJUSTMENT_STATUSES = ["pendente", "aprovado", "reprovado"];
var BREAK_STATUSES = ["pontual", "em_andamento", "estourado"];
var SLOT_FORMAT = /^([01]\d|2[0-3]):([0-5]\d)$/;
function isValidBreakWindow(window) {
  const { startHour, endHour } = window;
  return Number.isInteger(startHour) && Number.isInteger(endHour) && startHour >= 0 && endHour <= 24 && startHour < endHour;
}
function slotMinutes(slot) {
  const m = SLOT_FORMAT.exec(slot);
  if (!m) return null;
  const minutes = Number(m[1]) * 60 + Number(m[2]);
  return minutes % BREAK_MINUTES === 0 ? minutes : null;
}
function slotLabel(minutes) {
  const h = String(Math.floor(minutes / 60)).padStart(2, "0");
  const m = String(minutes % 60).padStart(2, "0");
  return `${h}:${m}`;
}
function breakSlotsOf(window) {
  if (!isValidBreakWindow(window)) return [];
  const slots = [];
  for (let minutes = window.startHour * 60; minutes + BREAK_MINUTES <= window.endHour * 60; minutes += BREAK_MINUTES) {
    slots.push(slotLabel(minutes));
  }
  return slots;
}
function slotFitsWindow(slot, window) {
  const minutes = slotMinutes(slot);
  if (minutes === null || !isValidBreakWindow(window)) return false;
  return minutes >= window.startHour * 60 && minutes + BREAK_MINUTES <= window.endHour * 60;
}
function slotInterval(day, slot, timezone = HOUSE_TIMEZONE) {
  const minutes = slotMinutes(slot);
  if (minutes === null) throw new Error(`Hor\xE1rio de intervalo inv\xE1lido: ${slot}`);
  const start = new Date(startOfDay(day, 0, timezone).getTime() + minutes * 6e4);
  return { start, end: new Date(start.getTime() + BREAK_MINUTES * 6e4) };
}
function breakOverrunAt(expectedEndAt) {
  return new Date(expectedEndAt.getTime() + BREAK_OVERRUN_TOLERANCE_MINUTES * 6e4);
}
function breakStatus(record2, now) {
  const limit = breakOverrunAt(record2.expectedEndAt).getTime();
  if (record2.endedAt === null) return now.getTime() > limit ? "estourado" : "em_andamento";
  return record2.endedAt.getTime() <= limit ? "pontual" : "estourado";
}
function breakRefusal(facts) {
  if (facts.slot === null) return "sem_horario";
  if (!slotFitsWindow(facts.slot, facts.window)) return "fora_da_janela";
  if (facts.usedToday) return "ja_utilizado";
  const { start, end } = slotInterval(facts.day, facts.slot);
  const t = facts.now.getTime();
  if (t < start.getTime() || t >= end.getTime()) return "fora_do_horario";
  return null;
}
var BREAK_MODES = ["fixo", "livre"];
function flexibleInterval(day, window, timezone = HOUSE_TIMEZONE) {
  const midnight = startOfDay(day, 0, timezone).getTime();
  const opensAt = new Date(midnight + window.startHour * 36e5);
  const closesAt = new Date(midnight + window.endHour * 36e5);
  return {
    opensAt,
    lastStartAt: new Date(closesAt.getTime() - BREAK_MINUTES * 6e4),
    closesAt
  };
}
function flexibleRefusal(facts) {
  if (!isValidBreakWindow(facts.window)) return "fora_da_janela_livre";
  if (facts.usedToday) return "ja_utilizado";
  const { opensAt, lastStartAt } = flexibleInterval(facts.day, facts.window);
  const t = facts.now.getTime();
  if (t < opensAt.getTime() || t > lastStartAt.getTime()) return "fora_da_janela_livre";
  return null;
}
var BREAK_REFUSAL_MESSAGES = {
  sem_horario: "Voc\xEA n\xE3o tem hor\xE1rio de intervalo nesta base.",
  fora_da_janela: "O seu hor\xE1rio ficou fora da janela de intervalos desta base.",
  fora_do_horario: "O intervalo s\xF3 pode ser ativado dentro do seu hor\xE1rio.",
  fora_da_janela_livre: "O intervalo livre precisa caber inteiro na janela da base.",
  ja_utilizado: "Voc\xEA j\xE1 utilizou o intervalo de hoje."
};

// src/charges.ts
var CHARGE_PROVIDERS = ["asaas"];
var CHARGE_STATUSES = [
  "emitindo",
  "falhou",
  "pendente",
  "vencida",
  "paga",
  "em_estorno",
  "estornada",
  "em_contestacao",
  "cancelada",
  "desconhecida"
];
var CHARGE_STATUS_LABELS = {
  "emitindo": "Emitindo",
  "falhou": "N\xE3o emitida",
  "pendente": "Aguardando pagamento",
  "vencida": "Vencida",
  "paga": "Paga",
  "em_estorno": "Estorno em andamento",
  "estornada": "Estornada",
  "em_contestacao": "Em contesta\xE7\xE3o",
  "cancelada": "Cancelada",
  "desconhecida": "Situa\xE7\xE3o desconhecida"
};
var PAID = /* @__PURE__ */ new Set(["CONFIRMED", "RECEIVED", "RECEIVED_IN_CASH", "DUNNING_RECEIVED"]);
function chargeStatusFromAsaas(providerStatus, deleted = false) {
  if (deleted) return "cancelada";
  const status = (providerStatus ?? "").trim().toUpperCase();
  if (PAID.has(status)) return "paga";
  switch (status) {
    case "PENDING":
    case "AWAITING_RISK_ANALYSIS":
      return "pendente";
    case "OVERDUE":
    case "DUNNING_REQUESTED":
      return "vencida";
    case "REFUND_REQUESTED":
    case "REFUND_IN_PROGRESS":
      return "em_estorno";
    case "REFUNDED":
      return "estornada";
    case "CHARGEBACK_REQUESTED":
    case "CHARGEBACK_DISPUTE":
    case "AWAITING_CHARGEBACK_REVERSAL":
      return "em_contestacao";
    default:
      return "desconhecida";
  }
}
function isAsaasPayment(providerStatus) {
  return PAID.has((providerStatus ?? "").trim().toUpperCase());
}
function applyChargeSnapshot(current, snapshot, now) {
  const status = chargeStatusFromAsaas(snapshot.providerStatus, snapshot.deleted);
  const paidNow = !snapshot.deleted && isAsaasPayment(snapshot.providerStatus);
  const firstPayment = paidNow && current.confirmedAt === null;
  const providerStatus = snapshot.providerStatus.trim().toUpperCase();
  const receivedNow = !snapshot.deleted && (providerStatus === "RECEIVED" || providerStatus === "RECEIVED_IN_CASH");
  return {
    status,
    confirmedAt: current.confirmedAt ?? (paidNow ? now : null),
    receivedAt: current.receivedAt ?? (receivedNow ? now : null),
    firstPayment
  };
}
function chargeIsOpen(status) {
  return status === "emitindo" || status === "pendente" || status === "vencida" || status === "em_estorno" || status === "em_contestacao" || status === "desconhecida";
}
var ASAAS_BILLING_TYPE_LABELS = {
  PIX: "Pix",
  CREDIT_CARD: "Cart\xE3o de cr\xE9dito",
  DEBIT_CARD: "Cart\xE3o de d\xE9bito",
  BOLETO: "Boleto",
  UNDEFINED: "A escolher"
};
function billingTypeLabel(billingType) {
  if (!billingType) return null;
  return ASAAS_BILLING_TYPE_LABELS[billingType] ?? billingType;
}
var ASAAS_ENVIRONMENTS = ["sandbox", "producao"];
var ASAAS_ENVIRONMENT_LABELS = {
  "sandbox": "Sandbox",
  "producao": "Produ\xE7\xE3o"
};
var ASAAS_WEBHOOK_EVENTS = [
  "PAYMENT_CREATED",
  "PAYMENT_UPDATED",
  "PAYMENT_AWAITING_RISK_ANALYSIS",
  "PAYMENT_APPROVED_BY_RISK_ANALYSIS",
  "PAYMENT_REPROVED_BY_RISK_ANALYSIS",
  "PAYMENT_AUTHORIZED",
  "PAYMENT_CONFIRMED",
  "PAYMENT_RECEIVED",
  "PAYMENT_CREDIT_CARD_CAPTURE_REFUSED",
  "PAYMENT_OVERDUE",
  "PAYMENT_DELETED",
  "PAYMENT_RESTORED",
  "PAYMENT_REFUNDED",
  "PAYMENT_PARTIALLY_REFUNDED",
  "PAYMENT_REFUND_IN_PROGRESS",
  "PAYMENT_RECEIVED_IN_CASH_UNDONE",
  "PAYMENT_CHARGEBACK_REQUESTED",
  "PAYMENT_CHARGEBACK_DISPUTE",
  "PAYMENT_AWAITING_CHARGEBACK_REVERSAL",
  "PAYMENT_DUNNING_REQUESTED",
  "PAYMENT_DUNNING_RECEIVED"
];
function chargeReference(tenantId, chargeId) {
  return `evogard-${tenantId}-${chargeId}`;
}
var CHARGE_DESCRIPTION_MAX = 500;

// src/revenues.ts
var REVENUE_STATUSES = [
  "a_receber",
  "vencida",
  "recebida",
  "cancelada",
  "estornada"
];
var REVENUE_STATUS_LABELS = {
  a_receber: "A receber",
  vencida: "Vencida",
  recebida: "Recebida",
  cancelada: "Cancelada",
  estornada: "Estornada"
};
var REVENUE_STATUS_TONES = {
  a_receber: "informacao",
  vencida: "alerta",
  recebida: "sucesso",
  cancelada: "neutro",
  estornada: "neutro"
};
var OPEN_REVENUE_STATUSES = ["a_receber", "vencida"];
function revenueIsOpen(status) {
  return OPEN_REVENUE_STATUSES.includes(status);
}
var REVENUE_SOURCE_TYPES = ["sinistro", "avulsa"];
var REVENUE_SOURCE_LABELS = {
  sinistro: "Sinistro",
  avulsa: "Avulsa"
};
var PAYMENT_ACCOUNT_PROVIDERS = ["asaas"];
var PAYMENT_ACCOUNT_PROVIDER_LABELS = {
  asaas: "Asaas"
};
function revenueStatusAfterCharge(current, charge) {
  if (current === "cancelada" || current === "estornada") return null;
  if (charge === "paga") return current === "recebida" ? null : "recebida";
  if (charge === "estornada") return current === "recebida" ? "estornada" : null;
  return null;
}
function revenueStatusOnDate(current, dueDate, today) {
  if (current === "a_receber" && dueDate < today) return "vencida";
  if (current === "vencida" && dueDate >= today) return "a_receber";
  return null;
}
var REVENUE_DESCRIPTION_MAX = 200;
var REVENUE_NOTES_MAX = 2e3;

// src/finance-dashboard.ts
var FINANCE_DASHBOARD_DATE_KINDS = [
  "competencia",
  "vencimento",
  "pagamento"
];
var FINANCE_DASHBOARD_BASIS_LABELS = {
  competencia: "Compet\xEAncia",
  vencimento: "Vencimento",
  pagamento: "Pagamento"
};
var FINANCE_DASHBOARD_EXPENSE_STAGES = FINANCE_BOARD_STAGES.filter(
  (s) => s !== "pagamento_recusado"
);
var FINANCE_DASHBOARD_REVENUE_STATUSES = [
  "a_receber",
  "vencida",
  "recebida"
];
function financeDashboardDate(basis, dates) {
  if (basis === "competencia") return dates.competencyDate ?? dates.dueDate;
  if (basis === "vencimento") return dates.dueDate;
  return dates.settledOn;
}
var GAPS = {
  noVehicle: "Sem ve\xEDculo",
  severalVehicles: "V\xE1rios ve\xEDculos",
  noMember: "Sem associado",
  noAddress: "Sem endere\xE7o no cadastro",
  noConsultant: "Sem consultor no ve\xEDculo",
  noTeam: "Sem time",
  notInformed: "N\xE3o informado"
};
var gap = (label) => ({ key: `~${label}`, label, gap: true });
var value = (key, label) => ({ key, label, gap: false });
var clean = (s) => {
  const t = s?.trim().replace(/\s+/g, " ");
  return t ? t.toUpperCase() : null;
};
function vehicleGap(e) {
  if (e.vehicles === "none") return gap(GAPS.noVehicle);
  if (e.vehicles === "several") return gap(GAPS.severalVehicles);
  return null;
}
function homeGap(e) {
  if (e.vehicles === "several") return gap(GAPS.severalVehicles);
  if (!e.home) return gap(e.vehicles === "none" ? GAPS.noVehicle : GAPS.noMember);
  return null;
}
var FINANCE_DASHBOARD_SLOTS = {
  state(e) {
    const missing = homeGap(e);
    if (missing) return missing;
    const state = clean(e.home.state);
    return state ? value(state, state) : gap(GAPS.noAddress);
  },
  city(e) {
    const missing = homeGap(e);
    if (missing) return missing;
    const city = clean(e.home.city);
    const state = clean(e.home.state);
    if (!city) return gap(GAPS.noAddress);
    return value(`${city}/${state ?? ""}`, state ? `${city} \xB7 ${state}` : city);
  },
  consultant(e) {
    const missing = vehicleGap(e);
    if (missing) return missing;
    if (!e.consultant) return gap(GAPS.noConsultant);
    return value(
      String(e.consultant.id),
      e.consultant.name?.trim() || `Volunt\xE1rio ${e.consultant.id}`
    );
  },
  team(e) {
    const missing = vehicleGap(e);
    if (missing) return missing;
    if (!e.consultant) return gap(GAPS.noConsultant);
    if (!e.team) return gap(GAPS.noTeam);
    return value(String(e.team.id), e.team.name);
  },
  vehicleType(e) {
    const missing = vehicleGap(e);
    if (missing) return missing;
    const type = clean(e.vehicleType);
    return type ? value(type, type) : gap(GAPS.notInformed);
  },
  vehiclePlan(e) {
    const missing = vehicleGap(e);
    if (missing) return missing;
    const plan = clean(e.vehiclePlan);
    return plan ? value(plan, plan) : gap(GAPS.notInformed);
  }
};
var emptyTally = () => ({
  count: 0,
  amount: ZERO,
  settled: ZERO
});
var add2 = (t, e) => ({
  count: t.count + 1,
  amount: sum(t.amount, e.amount),
  settled: e.settled ? sum(t.settled, e.amount) : t.settled
});
function rowsBy(entries, slotOf) {
  const rows = /* @__PURE__ */ new Map();
  for (const e of entries) {
    const slot = slotOf(e);
    const row = rows.get(slot.key) ?? {
      ...slot,
      revenue: emptyTally(),
      expense: emptyTally()
    };
    if (e.direction === "receita") row.revenue = add2(row.revenue, e);
    else row.expense = add2(row.expense, e);
    rows.set(slot.key, row);
  }
  return [...rows.values()].sort(
    (a, b) => Number(a.gap) - Number(b.gap) || b.revenue.amount + b.expense.amount - (a.revenue.amount + a.expense.amount) || a.label.localeCompare(b.label, "pt-BR")
  );
}
function financeDashboardOf(entries) {
  let revenue = emptyTally();
  let expense = emptyTally();
  for (const e of entries) {
    if (e.direction === "receita") revenue = add2(revenue, e);
    else expense = add2(expense, e);
  }
  return {
    revenue,
    expense,
    byState: rowsBy(entries, FINANCE_DASHBOARD_SLOTS.state),
    byCity: rowsBy(entries, FINANCE_DASHBOARD_SLOTS.city),
    byConsultant: rowsBy(entries, FINANCE_DASHBOARD_SLOTS.consultant),
    byTeam: rowsBy(entries, FINANCE_DASHBOARD_SLOTS.team),
    byVehicleType: rowsBy(entries, FINANCE_DASHBOARD_SLOTS.vehicleType),
    byVehiclePlan: rowsBy(entries, FINANCE_DASHBOARD_SLOTS.vehiclePlan)
  };
}
function financeDashboardMonths(to, n = 12) {
  const [y, m] = to.split("-").map(Number);
  return Array.from(
    { length: n },
    (_, i) => new Date(Date.UTC(y, m - n + i, 1)).toISOString().slice(0, 7)
  );
}
function financeDashboardTrend(items, months) {
  const byMonth = new Map(
    months.map((month) => [month, { month, revenue: ZERO, expense: ZERO }])
  );
  for (const item of items) {
    const row = item.date ? byMonth.get(item.date.slice(0, 7)) : void 0;
    if (!row) continue;
    if (item.direction === "receita") row.revenue = sum(row.revenue, item.amount);
    else row.expense = sum(row.expense, item.amount);
  }
  return [...byMonth.values()];
}
function financeDashboardPrevious(from, to) {
  const day = (s) => Date.UTC(Number(s.slice(0, 4)), Number(s.slice(5, 7)) - 1, Number(s.slice(8, 10)));
  const iso = (ms) => new Date(ms).toISOString().slice(0, 10);
  const lastOfMonth = (s) => new Date(Date.UTC(Number(s.slice(0, 4)), Number(s.slice(5, 7)), 0)).toISOString().slice(0, 10);
  if (from.endsWith("-01") && to === lastOfMonth(to)) {
    const months = (Number(to.slice(0, 4)) - Number(from.slice(0, 4))) * 12 + Number(to.slice(5, 7)) - Number(from.slice(5, 7)) + 1;
    const start = new Date(
      Date.UTC(Number(from.slice(0, 4)), Number(from.slice(5, 7)) - 1 - months, 1)
    );
    return { from: iso(start.getTime()), to: iso(day(from) - 864e5) };
  }
  const length = (day(to) - day(from)) / 864e5 + 1;
  return { from: iso(day(from) - length * 864e5), to: iso(day(from) - 864e5) };
}
function financeDashboardChange(now, before) {
  if (before === 0) return null;
  return Math.round((now - before) / Math.abs(before) * 100);
}
function financeDashboardOpenKind(item, today) {
  if (item.settled) return null;
  return item.flaggedOverdue || item.dueDate < today ? "vencido" : "aguardando";
}
function financeDashboardOpen(items) {
  const zero = () => ({ count: 0, amount: ZERO });
  const out = {
    overdue: { revenue: zero(), expense: zero() },
    awaiting: { revenue: zero(), expense: zero() }
  };
  for (const item of items) {
    if (item.kind === null) continue;
    const group = item.kind === "vencido" ? out.overdue : out.awaiting;
    const side = item.direction === "receita" ? "revenue" : "expense";
    group[side] = {
      count: group[side].count + 1,
      amount: sum(group[side].amount, item.amount)
    };
  }
  return out;
}

// src/payment-options.ts
var CARD_MAX_INSTALLMENTS = 12;
var PAYMENT_METHODS = ["pix", "cartao"];
var PAYMENT_METHOD_LABELS = {
  pix: "Pix",
  cartao: "Cart\xE3o de cr\xE9dito"
};
function cardRateOf(installments, feePercentage, operationFee) {
  if (!Number.isInteger(installments) || installments < 1) {
    throw new Error(`n\xFAmero de parcelas inv\xE1lido: ${installments}`);
  }
  if (!Number.isFinite(feePercentage) || feePercentage < 0 || feePercentage >= 100) {
    throw new Error(`percentual de taxa inv\xE1lido: ${feePercentage}`);
  }
  if (!Number.isFinite(operationFee) || operationFee < 0) {
    throw new Error(`tarifa fixa inv\xE1lida: ${operationFee}`);
  }
  return {
    installments,
    percentBasisPoints: Math.round(feePercentage * 100),
    fixedFee: cents(Math.round(operationFee * 100))
  };
}
function cardInstallmentFee(installmentValue, rate) {
  const percent = Math.floor(installmentValue * rate.percentBasisPoints / 1e4);
  const fixed = Math.floor(rate.fixedFee / rate.installments);
  return cents(percent + fixed);
}
function cardNet(installmentValue, rate) {
  const perInstallment = subtract(
    installmentValue,
    cardInstallmentFee(installmentValue, rate)
  );
  return cents(perInstallment * rate.installments);
}
function cardOption(net, rate) {
  if (net <= 0) throw new Error("o valor pedido precisa ser maior que zero");
  const n = rate.installments;
  const perInstallmentNet = Math.ceil(net / n);
  const estimate = Math.ceil(
    (perInstallmentNet + rate.fixedFee / n) / (1 - rate.percentBasisPoints / 1e4)
  );
  let value2 = Math.max(1, estimate - 3);
  while (cardNet(cents(value2), rate) < net) value2 += 1;
  const installmentValue = cents(value2);
  const total = cents(value2 * n);
  return {
    method: "cartao",
    installments: n,
    installmentValue,
    total,
    fee: subtract(total, net)
  };
}
function pixOption(net) {
  if (net <= 0) throw new Error("o valor pedido precisa ser maior que zero");
  return {
    method: "pix",
    installments: null,
    installmentValue: net,
    total: net,
    fee: ZERO
  };
}
function paymentOptions(net, rates) {
  const cards = [...rates].filter((r) => r.installments >= 1 && r.installments <= CARD_MAX_INSTALLMENTS).sort((a, b) => a.installments - b.installments).filter((r, i, all) => i === 0 || all[i - 1].installments !== r.installments).map((r) => cardOption(net, r));
  return [pixOption(net), ...cards];
}
function sameOption(a, b) {
  return a.method === b.method && (a.installments ?? null) === (b.installments ?? null);
}
function asaasBillingTypeOf(method) {
  return method === "pix" ? "PIX" : "CREDIT_CARD";
}
function paymentMethodOf(billingType) {
  if (billingType === "PIX") return "pix";
  if (billingType === "CREDIT_CARD") return "cartao";
  return null;
}
function planChargeChange(current, wanted) {
  if (!current) return "criar";
  const currentInstallments = current.method === "cartao" ? current.installments ?? 1 : null;
  if (current.method && sameOption({ method: current.method, installments: currentInstallments }, wanted)) {
    return "manter";
  }
  const single = (o) => o.method === "pix" || o.method === "cartao" && (o.installments ?? 1) === 1;
  return current.method !== null && single(current) && single(wanted) ? "atualizar" : "substituir";
}

// src/payment-links.ts
var CLAIM_FINANCIAL_REQUEST_KINDS = ["despesa", "receita"];
var PAYMENT_LINK_TTL_MS = 24 * 60 * 60 * 1e3;
function paymentLinkExpiresAt(createdAt) {
  return new Date(createdAt.getTime() + PAYMENT_LINK_TTL_MS);
}
var PAYMENT_LINK_STATES = ["aberto", "pago", "expirado", "substituido"];
var PAYMENT_LINK_STATE_LABELS = {
  aberto: "Aguardando o associado",
  pago: "Pago",
  expirado: "Link expirado",
  substituido: "Substitu\xEDdo por um link novo"
};
function paymentLinkState(facts, now) {
  if (facts.chargeStatus === "paga") return "pago";
  if (facts.archivedAt) return "substituido";
  if (now.getTime() >= facts.linkExpiresAt.getTime()) return "expirado";
  return "aberto";
}
function paymentRequestCode(peripheralId) {
  return `#${peripheralId}`;
}

// src/team-map.ts
var TEAM_MAP_ROOT = "praca";
var TEAM_MAP_GAP_GROUP = "sem_consultor";
var TEAM_MAP_NO_TEAM = "time:nenhum";
var TEAM_MAP_GAPS = [
  "sem_vinculo",
  "fora_do_cadastro",
  "sem_veiculo",
  "varios_veiculos"
];
var TEAM_MAP_GAP_LABELS = {
  sem_vinculo: {
    label: "Consultor sem v\xEDnculo ou inativo",
    sub: "o volunt\xE1rio do carro n\xE3o est\xE1 ativo em Consultores e times"
  },
  fora_do_cadastro: {
    label: "Consultor fora do cadastro",
    sub: "o carro cita um volunt\xE1rio que o SGA n\xE3o devolve"
  },
  sem_veiculo: {
    label: "Sem ve\xEDculo",
    sub: "lan\xE7amento do associado, sem carro (a receita avulsa)"
  },
  varios_veiculos: {
    label: "V\xE1rios ve\xEDculos",
    sub: "lan\xE7amento de mais de um carro, que n\xE3o \xE9 dividido"
  }
};
var TEAM_MAP_NODE_KINDS = [
  "praca",
  "gestor",
  "time",
  "consultor",
  "grupo",
  "lacuna"
];
var teamMapTeamKey = (id) => `time:${id}`;
var teamMapConsultantKey = (userId) => `consultor:${userId}`;
var teamMapManagerKey = (userId) => `gestor:${userId}`;
var teamMapGapKey = (gap2) => `lacuna:${gap2}`;
function teamMapTree(roster) {
  const nameOf = (userId) => roster.names[userId] ?? "Sem nome no cadastro";
  const managerOf = new Map(roster.supervisors.map((s) => [s.userId, s.managerId]));
  const nodes = /* @__PURE__ */ new Map();
  nodes.set(TEAM_MAP_ROOT, {
    key: TEAM_MAP_ROOT,
    parentKey: null,
    kind: "praca",
    label: `Comercial ${roster.tenantLabel}`,
    sub: "A montagem de hoje",
    leader: false,
    photoUrl: null
  });
  const managerChain = (userId, seen) => {
    const key = teamMapManagerKey(userId);
    if (nodes.has(key)) return key;
    seen.add(userId);
    const above = managerOf.get(userId);
    const parentKey = above === void 0 || seen.has(above) ? TEAM_MAP_ROOT : managerChain(above, seen);
    nodes.set(key, {
      key,
      parentKey,
      kind: "gestor",
      label: nameOf(userId),
      sub: "Gestor",
      leader: false,
      photoUrl: roster.photos[userId] ?? null
    });
    return key;
  };
  const leaders = /* @__PURE__ */ new Set();
  for (const team of [...roster.teams].sort(
    (a, b) => a.name.localeCompare(b.name, "pt-BR")
  )) {
    const above = team.leaderUserId ? managerOf.get(team.leaderUserId) : void 0;
    const parentKey = above === void 0 || above === team.leaderUserId ? TEAM_MAP_ROOT : managerChain(above, /* @__PURE__ */ new Set([team.leaderUserId]));
    if (team.leaderUserId) leaders.add(`${team.id}:${team.leaderUserId}`);
    nodes.set(teamMapTeamKey(team.id), {
      key: teamMapTeamKey(team.id),
      parentKey,
      kind: "time",
      label: team.name,
      sub: team.leaderUserId ? `L\xEDder: ${nameOf(team.leaderUserId)}` : "Sem l\xEDder",
      leader: false,
      photoUrl: null
    });
  }
  const teamIds = new Set(roster.teams.map((t) => t.id));
  const consultants = [...roster.consultants].sort(
    (a, b) => nameOf(a.userId).localeCompare(nameOf(b.userId), "pt-BR")
  );
  for (const c of consultants) {
    const inTeam = c.teamId !== null && teamIds.has(c.teamId);
    if (!inTeam && !nodes.has(TEAM_MAP_NO_TEAM)) {
      nodes.set(TEAM_MAP_NO_TEAM, {
        key: TEAM_MAP_NO_TEAM,
        parentKey: TEAM_MAP_ROOT,
        kind: "time",
        label: "Sem time",
        sub: "Consultores ativos sem time",
        leader: false,
        photoUrl: null
      });
    }
    const leader = inTeam && leaders.has(`${c.teamId}:${c.userId}`);
    nodes.set(teamMapConsultantKey(c.userId), {
      key: teamMapConsultantKey(c.userId),
      parentKey: inTeam ? teamMapTeamKey(c.teamId) : TEAM_MAP_NO_TEAM,
      kind: "consultor",
      label: nameOf(c.userId),
      sub: leader ? "L\xEDder \xB7 tamb\xE9m vende" : "Consultor",
      leader,
      photoUrl: roster.photos[c.userId] ?? null
    });
  }
  nodes.set(TEAM_MAP_GAP_GROUP, {
    key: TEAM_MAP_GAP_GROUP,
    parentKey: TEAM_MAP_ROOT,
    kind: "grupo",
    label: "Sem consultor",
    sub: "O que n\xE3o chega a um consultor de hoje",
    leader: false,
    photoUrl: null
  });
  for (const gap2 of TEAM_MAP_GAPS) {
    nodes.set(teamMapGapKey(gap2), {
      key: teamMapGapKey(gap2),
      parentKey: TEAM_MAP_GAP_GROUP,
      kind: "lacuna",
      label: TEAM_MAP_GAP_LABELS[gap2].label,
      sub: TEAM_MAP_GAP_LABELS[gap2].sub,
      leader: false,
      photoUrl: null
    });
  }
  return [...nodes.values()];
}
function teamMapPlace(roster) {
  const byVolunteer = /* @__PURE__ */ new Map();
  for (const c of roster.consultants) {
    if (c.volunteerId !== null) byVolunteer.set(c.volunteerId, c.userId);
  }
  return (vehicle) => {
    if (vehicle.kind === "none") return teamMapGapKey("sem_veiculo");
    if (vehicle.kind === "several") return teamMapGapKey("varios_veiculos");
    if (vehicle.volunteerId === null) return teamMapGapKey("fora_do_cadastro");
    const userId = byVolunteer.get(vehicle.volunteerId);
    return userId === void 0 ? teamMapGapKey("sem_vinculo") : teamMapConsultantKey(userId);
  };
}
var FINANCE_TEAM_MAP_METRICS = [
  "receita",
  "despesa_assistencia",
  "despesa_periferico",
  "despesa_sinistro"
];
var CLAIMS_TEAM_MAP_METRICS = [
  "veiculos",
  "assistencia",
  "periferico",
  "sinistro",
  "terceiro"
];
function teamMapRollup(tree, entries, metrics) {
  const empty2 = () => Object.fromEntries(metrics.map((m) => [m, { count: 0, amount: ZERO }]));
  const values = new Map(tree.map((n) => [n.key, empty2()]));
  const parentOf = new Map(tree.map((n) => [n.key, n.parentKey]));
  for (const e of entries) {
    let key = values.has(e.leaf) ? e.leaf : null;
    while (key !== null) {
      const v = values.get(key);
      const t = v[e.metric];
      v[e.metric] = { count: t.count + e.count, amount: sum(t.amount, e.amount) };
      key = parentOf.get(key) ?? null;
    }
  }
  const isEmpty = (v) => metrics.every((m) => v[m].count === 0 && v[m].amount === ZERO);
  const dropped = new Set(
    tree.filter(
      (n) => (n.kind === "lacuna" || n.kind === "grupo") && isEmpty(values.get(n.key))
    ).map((n) => n.key)
  );
  return tree.filter((n) => !dropped.has(n.key)).map((n) => ({ ...n, values: values.get(n.key) }));
}

// src/map-link.ts
var NUMBER = String.raw`(-?\d{1,3}(?:\.\d+)?)`;
var PAIR = new RegExp(String.raw`^\s*${NUMBER}\s*[,;\s]\s*${NUMBER}\s*$`);
var PIN = new RegExp(String.raw`!3d${NUMBER}!4d${NUMBER}`);
var CENTER = new RegExp(String.raw`/@${NUMBER},${NUMBER}`);
var PATH_PAIR = new RegExp(String.raw`/(?:search|place|dir)/${NUMBER},[+\s]?${NUMBER}`);
var QUERY_KEYS = ["q", "query", "ll", "destination", "daddr", "center", "sll"];
var MAP_HOSTS = /^(?:www\.|maps\.)?google\.com(?:\.br)?$|^maps\.app\.goo\.gl$|^goo\.gl$|^maps\.google\.com(?:\.br)?$/;
function valid(lat, lng) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  if (lat === 0 && lng === 0) return null;
  return { lat, lng };
}
function pair(text) {
  const m = text ? PAIR.exec(text) : null;
  return m ? valid(Number(m[1]), Number(m[2])) : null;
}
var LINK = /^https?:\/\/([^/?#:@]+)(?::\d+)?([^?#]*)(?:\?([^#]*))?/i;
function decode(text) {
  try {
    return decodeURIComponent(text.replace(/\+/g, " "));
  } catch {
    return text;
  }
}
function mapLinkUrl(text) {
  const href = text.trim();
  const m = LINK.exec(href);
  if (!m) return null;
  const host = m[1].toLowerCase();
  if (!MAP_HOSTS.test(host)) return null;
  const params = /* @__PURE__ */ new Map();
  for (const part of (m[3] ?? "").split("&")) {
    const [k, ...v] = part.split("=");
    if (k) params.set(decode(k), decode(v.join("=")));
  }
  return { href, host, path: m[2] ?? "", params };
}
function isShortMapLink(link) {
  return link.host === "maps.app.goo.gl" || link.host === "goo.gl" && link.path.startsWith("/maps");
}
function looksLikeLocation(text) {
  return mapLinkUrl(text) !== null || pair(text) !== null;
}
function coordinatesFromLocation(text) {
  const loose = pair(text);
  if (loose) return loose;
  const url = mapLinkUrl(text);
  if (!url) return null;
  const raw = decode(url.href);
  const pin = PIN.exec(raw);
  if (pin) return valid(Number(pin[1]), Number(pin[2]));
  for (const key of QUERY_KEYS) {
    const found = pair(url.params.get(key)?.replace(/^loc:/, ""));
    if (found) return found;
  }
  const inPath = PATH_PAIR.exec(raw);
  if (inPath) return valid(Number(inPath[1]), Number(inPath[2]));
  const center = CENTER.exec(raw);
  return center ? valid(Number(center[1]), Number(center[2])) : null;
}
function placeTextFromLocation(text) {
  const url = mapLinkUrl(text);
  if (!url) return null;
  const q = url.params.get("q") ?? url.params.get("query");
  if (q?.trim()) return q.trim();
  const place2 = /\/place\/([^/@]+)/.exec(url.path);
  return place2 ? decode(place2[1]).trim() || null : null;
}
export {
  ACCOUNT_ACCESS_REASONS,
  ACCOUNT_ACCESS_REASON_LABELS,
  ALL_SERVICE_VARIANTS,
  AMBIGUOUS_CHARS,
  ANALYSIS_GENERAL_PHASES,
  ANALYSIS_HANDOFFS,
  ANALYSIS_HANDOFF_PHASES,
  ANALYSIS_HOLDS,
  ANALYSIS_OUTCOMES,
  ANALYSIS_PHASES,
  ANALYSIS_PIPE_COLUMNS,
  ANALYSIS_PIPE_FIELD_HOMES,
  ANALYSIS_PIPE_ORDER,
  ANALYSIS_POSSESSION,
  ANALYSIS_SITUATIONS,
  ANALYSIS_STAGES,
  ANALYSIS_STAGE_COLORS,
  ANALYSIS_WORK_STAGES,
  APPROVED_EXPENSE_STAGES,
  ARRIVAL_FAR_M,
  ASAAS_BILLING_TYPE_LABELS,
  ASAAS_ENVIRONMENTS,
  ASAAS_ENVIRONMENT_LABELS,
  ASAAS_WEBHOOK_EVENTS,
  ASSISTANCE_PRICINGS,
  ASSISTANCE_SERVICES,
  ASSISTANCE_SERVICE_SEED,
  ASSISTANCE_SERVICE_TYPES,
  AUTOMATIC_CLOSING_SINCE,
  AWARD_BUCKETS,
  AWARD_DEFAULT_PAYMENT_METHOD,
  AWARD_EXPENSE_STAGES,
  BALANCE_PART_SOURCES,
  BALANCE_SETTLED_STATUSES,
  BENEFICIARY_ACCOUNT_TYPES,
  BENEFICIARY_REF_TYPES,
  BENEFICIARY_REF_TYPE_LABELS,
  BILLING_AWARD_BOLETO_CATEGORIES,
  BILLING_AWARD_BOLETO_CATEGORY_LABELS,
  BILLING_AWARD_CANCELED_STATUS_CODE,
  BILLING_AWARD_CANDIDATE_STATUS_CODES,
  BILLING_AWARD_DISCOUNT_STATUS_CODE,
  BILLING_AWARD_KINDS,
  BILLING_AWARD_KIND_LABELS,
  BILLING_AWARD_LINK_DEADLINE_DAYS,
  BILLING_AWARD_LINK_STATUSES,
  BILLING_AWARD_LINK_STATUS_LABELS,
  BILLING_AWARD_OPERATOR_KINDS,
  BLOCKED_CODE,
  BOARD_STATUSES,
  BRAZILIAN_STATES,
  BRAZILIAN_STATE_INFO,
  BREAK_ADJUSTMENT_STATUSES,
  BREAK_DEFAULT_WINDOW,
  BREAK_MINUTES,
  BREAK_MODES,
  BREAK_OVERRUN_TOLERANCE_MINUTES,
  BREAK_REFUSAL_MESSAGES,
  BREAK_STATUSES,
  CAF_LINK_COOLDOWN_MS,
  CAF_RESULT_KIND,
  CAF_STATUSES,
  CAF_TEMPLATE_DEFAULTS,
  CAF_TEMPLATE_ID,
  CAF_TEMPLATE_KEYS,
  CAF_UNMAPPED_KIND,
  CAF_WEBHOOK_KEY,
  CARD_MAX_INSTALLMENTS,
  CAREER_PLAN_TIERS,
  CHARGE_DESCRIPTION_MAX,
  CHARGE_PROVIDERS,
  CHARGE_STATUSES,
  CHARGE_STATUS_LABELS,
  CLAIMS_TEAM_MAP_METRICS,
  CLAIM_CLOSURES_DEFAULT_DAYS,
  CLAIM_CLOSURE_ACTIONS,
  CLAIM_CLOSURE_KINDS,
  CLAIM_CLOSURE_KIND_LABELS,
  CLAIM_CLOSURE_ORIGINS,
  CLAIM_CLOSURE_PHASES,
  CLAIM_CLOSURE_WARRANTY,
  CLAIM_CONCLUSION_KINDS,
  CLAIM_DEPARTMENTS,
  CLAIM_DEPARTMENT_LABELS,
  CLAIM_DUE_SOON_MS,
  CLAIM_EVENT_TYPE_LABELS,
  CLAIM_EXPENSE_STAGES,
  CLAIM_FINANCIAL_REQUEST_KINDS,
  CLAIM_FLOW_DEFAULT_PERIOD,
  CLAIM_FLOW_NODES,
  CLAIM_FLOW_PERIODS,
  CLAIM_MESSAGES,
  CLAIM_PHASES,
  CLAIM_TYPES,
  CLAIM_WORK_STAGES,
  COMPANY_CATEGORIES,
  COMPANY_DOCUMENT_TYPES_BY_CATEGORY,
  COMPANY_TYPES,
  COMPANY_TYPES_BY_CATEGORY,
  COMPANY_TYPE_LABELS,
  COMPENSATION_ACTIVE_DEDUCTION_STATUSES,
  COMPENSATION_DEADLINE_DAYS,
  COMPENSATION_DEADLINE_FIPE_LIMIT,
  COMPENSATION_DEBT_KINDS,
  COMPENSATION_DEBT_STATUSES,
  COMPENSATION_DISCOUNT_KINDS,
  COMPENSATION_DOCUMENTS,
  COMPENSATION_GENERAL_PHASES,
  COMPENSATION_HANDOFFS,
  COMPENSATION_HANDOFF_PHASES,
  COMPENSATION_OUTCOMES,
  COMPENSATION_PAID_DEBT_KINDS,
  COMPENSATION_PENDENCY_KINDS,
  COMPENSATION_PHASES,
  COMPENSATION_PIPE_COLUMNS,
  COMPENSATION_PIPE_FIELD_HOMES,
  COMPENSATION_PIPE_ORDER,
  COMPENSATION_SITUATIONS,
  COMPENSATION_STAGES,
  COMPENSATION_STAGE_COLORS,
  COMPENSATION_WITHDRAWAL_OUTCOME,
  COMPENSATION_WORK_STAGES,
  CONSULTANT_PROFILE_RULES,
  CONTAAZUL_AWARD_CATALOGS,
  CONTAAZUL_CATALOGS,
  CONTAAZUL_COMPANIES,
  CONTAAZUL_LAUNCH_ACCOUNTS,
  CONTAAZUL_REVENUE_CATEGORIES,
  CONTACT_DUE_BUSINESS_DAYS,
  CORE_CODE_SIZE,
  CSV_SEPARATOR,
  DEFAULT_RULE,
  DEFAULT_THEME,
  DEPRECIATION_REASONS,
  DESK_AUTO_IMPORT_FROM_HOUR,
  DESK_AUTO_IMPORT_REQUEST_FROM_HOUR,
  DESK_AUTO_IMPORT_STATES,
  DESK_BANDS,
  DESK_BAND_LABELS,
  DESK_BLOCKS,
  DESK_DUE_BANDS,
  DESK_EDIT_EVENTS,
  DESK_FLOWS,
  DESK_IMPORT_DUE_DAYS,
  DESK_IMPORT_MAX_AMOUNT,
  DESK_IMPORT_MIN_AMOUNT,
  DESK_IMPORT_ORIGINS,
  DESK_OPERATOR_GROUPS,
  DESK_OUTCOMES,
  DESK_PAID_OUTCOMES,
  DESK_PAID_STATUS_LABELS,
  DESK_TOUCH_EVENTS,
  DISPATCH_DISCARD_REASONS,
  DISPATCH_FILE_KINDS,
  DISPATCH_LINK_TTL_MS,
  DISPATCH_PROGRESS,
  DISPATCH_PROGRESS_LABELS,
  DISPATCH_PROGRESS_STEPS,
  DISPATCH_STATUSES,
  DISPATCH_STEP_KINDS,
  DISPATCH_STEP_LABELS,
  DISPATCH_VALUATION_SOURCES,
  EXPENSE_ACTS_WITH_REASON,
  EXPENSE_FINANCE_ACTS,
  EXPENSE_FINANCE_ACT_LABELS,
  EXPENSE_FLOWS,
  EXPENSE_LAUNCH_ACTION,
  EXPENSE_PAYMENT_METHODS,
  EXPENSE_PAYMENT_METHOD_LABELS,
  EXPENSE_REQUEST_RESOURCES,
  EXPENSE_REQUEST_STAGES,
  EXPENSE_REQUEST_STAGE_LABELS,
  EXPENSE_RESULTS,
  EXPENSE_SOURCE_LABELS,
  EXPENSE_SOURCE_TYPES,
  EXPENSE_STAGES,
  EXPENSE_STAGE_LABELS,
  EXPENSE_STAGE_TONES,
  EXPENSE_SUPERVISE_ACTION,
  EXPENSE_SUPERVISOR_ACTS,
  EXPENSE_SUPERVISOR_ACT_LABELS,
  ErrorMoney,
  FINAL_EXPENSE_STAGES,
  FINANCE_ACTS_WITH_REASON,
  FINANCE_BOARD_SOURCES,
  FINANCE_BOARD_STAGES,
  FINANCE_DASHBOARD_BASIS_LABELS,
  FINANCE_DASHBOARD_DATE_KINDS,
  FINANCE_DASHBOARD_EXPENSE_STAGES,
  FINANCE_DASHBOARD_REVENUE_STATUSES,
  FINANCE_DASHBOARD_SLOTS,
  FINANCE_TEAM_MAP_METRICS,
  HOUSE_TIMEZONE,
  INCREMENTAL_WINDOW_DAYS,
  INITIAL_CLAIM_POSITION,
  INITIAL_STATE,
  INPUT_MASKS,
  INPUT_MASK_MAX_LENGTH,
  INPUT_MASK_PLACEHOLDER,
  INTERNAL_AWARD_DAY,
  LABEL_COLORS,
  LABEL_NAME_MAX,
  LATE_SEND_LABEL,
  MANAGEMENT_AGE_LIMITS,
  MANAGEMENT_BLOCKING_SITUATIONS,
  MANAGEMENT_DETOURS,
  MANAGEMENT_DOTS_PER_PHASE,
  MANAGEMENT_FRESH_HOURS,
  MANAGEMENT_LINES,
  MANAGEMENT_NOW_HOURS,
  MANAGEMENT_OPEN_STAGES,
  MANAGEMENT_PERIOD_DAYS,
  MANAGEMENT_SCHEDULED_AHEAD_HOURS,
  MANAGEMENT_STAGES,
  MAX_DEADLINE_HOURS,
  MEMBER_CODE_PREFIX,
  MEMBER_TRACKING_LABELS,
  MEMBER_TRACKING_STAGES,
  OPEN_REVENUE_STATUSES,
  OPEN_STATUSES,
  PARTICIPATION_DEDUCTION,
  PAYMENT_ACCOUNT_PROVIDERS,
  PAYMENT_ACCOUNT_PROVIDER_LABELS,
  PAYMENT_ACT_ACTIONS,
  PAYMENT_LINK_STATES,
  PAYMENT_LINK_STATE_LABELS,
  PAYMENT_LINK_TTL_MS,
  PAYMENT_METHODS,
  PAYMENT_METHOD_LABELS,
  PAYMENT_STAGE_DEFAULT_COLORS,
  PAYMENT_STAGE_EVENT_LABELS,
  PAYMENT_STAGE_EVENT_RUNS,
  PAYMENT_STAGE_EVENT_TYPES,
  PAYMENT_STAGE_NAME_MAX,
  PAYMENT_STATUSES,
  PAYMENT_STATUS_LABELS,
  PAYMENT_STATUS_TONES,
  PERIPHERAL_ASSIGNEE_LABEL,
  PERIPHERAL_AVAILABILITIES,
  PERIPHERAL_COVERAGE_PERCENTS,
  PERIPHERAL_INVOICING_TYPES,
  PERIPHERAL_ITEM_PHOTOS,
  PERIPHERAL_ITEM_QUESTIONS,
  PERIPHERAL_ITEM_TYPES,
  PERIPHERAL_OPENING_STAGE,
  PERIPHERAL_OUTCOMES,
  PERIPHERAL_PANEL_TOP_PROVIDERS,
  PERIPHERAL_PART_ORIGINS,
  PERIPHERAL_PHASES,
  PERIPHERAL_PIPE_COLUMNS,
  PERIPHERAL_PIPE_FIELD_HOMES,
  PERIPHERAL_PIPE_ORDER,
  PERIPHERAL_PI_MESSAGE_ITEMS,
  PERIPHERAL_PI_WHATSAPP,
  PERIPHERAL_PORTAL_DESCRIPTION_MIN,
  PERIPHERAL_PORTAL_ITEM_PHOTOS,
  PERIPHERAL_PORTAL_ORIGIN,
  PERIPHERAL_QUOTE_ORIGINS,
  PERIPHERAL_QUOTE_STATUSES,
  PERIPHERAL_REQUEST_ORIGINS,
  PERIPHERAL_SITUATIONS,
  PERIPHERAL_STAGES,
  PERIPHERAL_STAGE_COLORS,
  PERIPHERAL_WEEK_ORIGINS,
  PERIPHERAL_WHATSAPP_ORIGINS,
  PERIPHERAL_WITHDRAWAL_OUTCOME,
  PERIPHERAL_WORK_STAGES,
  PHASE_SLA_SOON_RATIO,
  PIX_KEY_TYPES,
  PLATE_ATTEMPTS,
  PLATE_CLASSIFICATIONS,
  PROGRESS_STALE_MS,
  PROVIDER_BUTTON_STEPS,
  PROVIDER_PAYMENT_MODES,
  RANKING_COUNTING,
  RANKING_COUNTINGS,
  RANKING_ORDERS,
  RANKING_SEGMENTS,
  REFUSED_EXPENSE_STAGES,
  REOPEN_LOCKED_REASON,
  REPAIR_GENERAL_PHASES,
  REPAIR_HANDOFFS,
  REPAIR_HANDOFF_PHASES,
  REPAIR_OPENING_PHASE,
  REPAIR_OUTCOMES,
  REPAIR_PART_ORIGINS,
  REPAIR_PART_ORIGIN_LABELS,
  REPAIR_PART_SUPPLIERS,
  REPAIR_PART_SUPPLIER_LABELS,
  REPAIR_PHASES,
  REPAIR_PIPE_COLUMNS,
  REPAIR_PIPE_FIELD_HOMES,
  REPAIR_PIPE_ORDER,
  REPAIR_QUOTE_COVERAGES,
  REPAIR_QUOTE_COVERAGE_LABELS,
  REPAIR_QUOTE_ITEM_KINDS,
  REPAIR_QUOTE_MONEY_COLUMNS,
  REPAIR_QUOTE_SOURCES,
  REPAIR_QUOTE_SOURCE_LABELS,
  REPAIR_QUOTE_SOURCE_NAMES,
  REPAIR_SITUATIONS,
  REPAIR_STAGES,
  REPAIR_STAGE_COLORS,
  REPAIR_SUPERVISION_STAGES,
  REPAIR_WITHDRAWAL_OUTCOME,
  REPAIR_WORK_STAGES,
  RETENTION_ACTIVE_PHASES,
  RETENTION_FINAL_PHASES,
  RETENTION_FINISH_FIELDS,
  RETENTION_FIRST_WINDOW_HOURS,
  RETENTION_LEGACY_BLOCKED_STATUS_CODES,
  RETENTION_PHASES,
  RETENTION_PHASE_LABELS,
  RETENTION_REFERENCE_PREFIX,
  RETENTION_SECOND_WINDOW_HOURS,
  RETENTION_TENANT_PRECEDENCE,
  RETENTION_WORKING_PHASES,
  REVENUE_DESCRIPTION_MAX,
  REVENUE_NOTES_MAX,
  REVENUE_SOURCE_LABELS,
  REVENUE_SOURCE_TYPES,
  REVENUE_STATUSES,
  REVENUE_STATUS_LABELS,
  REVENUE_STATUS_TONES,
  ROTATION_DEPARTMENTS,
  ROTATION_NAME_MAX,
  ROTATION_PHASES,
  SALE_EXPENSES_DISABLED_REASON,
  SALE_EXPENSE_ACTS,
  SALE_EXPENSE_ACT_ACTIONS,
  SALE_EXPENSE_ATTACHMENT,
  SALE_EXPENSE_ATTACHMENT_HELP,
  SALE_EXPENSE_FORMS,
  SALE_EXPENSE_MOVES,
  SALE_EXPENSE_REASON_MAX,
  SALE_EXPENSE_STATUSES,
  SALE_EXPENSE_STATUS_COLORS,
  SALE_EXPENSE_STATUS_LABELS,
  SALE_EXPENSE_STATUS_TONES,
  SALE_EXPENSE_TEXT_MAX,
  SALE_EXPENSE_TYPES,
  SALE_EXPENSE_TYPE_LABELS,
  SALE_EXPENSE_TYPE_SHORT_LABELS,
  SENDGRID_SENDER_NAME_DEFAULT,
  SENDGRID_SETTING_KEYS,
  SENDGRID_SETTING_PREFIX,
  SERVICE_VARIANTS,
  SERVICE_VARIANT_FIELD,
  SERVICE_VARIANT_LABELS,
  SETTLEMENT_KINDS,
  SETTLEMENT_METHODS,
  SGA_BOLETO_PROVIDER,
  SGA_QUEUE_STALL_MS,
  SGA_TOKEN_LENGTH,
  SGA_WINDOWS,
  SLA_DAY_KINDS,
  SLA_DAY_KIND_LABEL,
  SLA_DEPARTMENTS,
  SLA_PHASES,
  SPEAKABLE_ALPHABET,
  STAGE_COLORS,
  SUPERVISOR_EXPENSE_STAGES,
  SUPERVISOR_EXPENSE_STAGE_LABELS,
  TEAM_MAP_GAPS,
  TEAM_MAP_GAP_GROUP,
  TEAM_MAP_GAP_LABELS,
  TEAM_MAP_NODE_KINDS,
  TEAM_MAP_NO_TEAM,
  TEAM_MAP_ROOT,
  TECHNOLOGY_FEE_DEFAULT_TIERS,
  TECHNOLOGY_FEE_LOTS,
  TECHNOLOGY_FEE_LOT_LABELS,
  THEFT_CLAIM_EVENT,
  THEMES,
  TICKET_CODE_PREFIX,
  TICKET_CODE_SIZE,
  TICKET_PRIORITIES,
  TICKET_STATUSES,
  TICKET_TRANSITIONS,
  TONES,
  TOW_CONTINUATION_DAYS,
  TOW_KINDS,
  USAGE_LINES,
  USAGE_RULE_KINDS,
  USAGE_WINDOW_UNITS,
  USEFUL_LINK_ICONS,
  VEHICLE_CODE_PREFIX,
  VEHICLE_SITUATION_TONES,
  VOLUNTEER_CODE_PREFIX,
  WHATSAPP_PURPOSES,
  WILDCARD,
  WITHDRAWAL_OUTCOME,
  WORKER_BEAT_MS,
  WORKER_BOOT_LIMIT_MS,
  WORKER_STALE_MS,
  ZERO,
  accountAccess,
  actFitsLot,
  activeRoute,
  addBusinessDays,
  afterFailure,
  afterSuccess,
  ageInMs,
  analysisChecklistValues,
  analysisConditionHolds,
  analysisHandoffOf,
  analysisHoldLabel,
  analysisMoveDirection,
  analysisMovesOf,
  analysisOptionCode,
  analysisPhaseLabel,
  analysisPhaseOf,
  analysisSituationLabel,
  analysisValueText,
  applyChargeSnapshot,
  applyExceptions,
  applyInputMask,
  apportion,
  apportionAward,
  arrivalForecast,
  asaasBillingTypeOf,
  asksThirdPartyNotices,
  assistanceCategoryOf,
  assistanceCategoryShortName,
  assistancePaymentDefaultsOf,
  assistanceService,
  awardDays,
  awardPayableDescription,
  awardShares,
  balanceParts,
  beneficiaryKindLabel,
  billingAwardBoletoPayment,
  billingAwardLinkCounts,
  billingAwardLinkDeadline,
  billingAwardPeriodBounds,
  billingAwardPeriodOf,
  billingAwardProtocolOf,
  billingAwardRuleProblem,
  billingAwardTier,
  billingAwardWeekOf,
  billingAwardWeeksOf,
  billingAwardsOf,
  billingTypeLabel,
  boardAct,
  boletoPayment,
  brazilianStateName,
  breakOverrunAt,
  breakRefusal,
  breakSlotsOf,
  breakStatus,
  breakerStatus,
  bucketOf,
  businessDate,
  businessDateParts,
  cafCallbackReceivesHere,
  cafCallbackUrl,
  cafFileKind,
  cafImageKind,
  cafLinkAvailableAt,
  cafMessage,
  cafRuleLabel,
  cafStatusLabel,
  cafStatusNeedsAction,
  cafStatusOf,
  cafTransactionFacts,
  canAccess,
  canDispatch,
  canEditRetention,
  canEnterPortal,
  canFinishRetention,
  canPullRetention,
  canRequestCancellation,
  canRetainRetentionFrom72h,
  canSeeRankingSales,
  canSeeTicketDetail,
  canTransferRetention,
  cancellationSuggestion,
  cardExpenseStages,
  cardInstallmentFee,
  cardNet,
  cardOption,
  cardRateOf,
  careerRole,
  catalogChecklistValues,
  catalogConditionHolds,
  catalogMoveDirection,
  catalogMoveNeedsForm,
  catalogMovesOf,
  catalogOptionCode,
  catalogOptions,
  catalogValueText,
  cents,
  chargeIsOpen,
  chargeReference,
  chargeStatusFromAsaas,
  checkPaymentData,
  checkPixKey,
  checkSaleExpense,
  checkSaleExpenseAttachment,
  checksPlate,
  claimClosureActionOf,
  claimClosureKindOf,
  claimClosurePhasesOf,
  claimDueState,
  claimFlowOutcomeOf,
  claimFlowPathOf,
  claimPhaseLabel,
  classifyLoadFailure,
  classifySignInFailure,
  closesAutomatically,
  companyCategoryOf,
  compareMoney,
  compareRepairQuotes,
  compensationAccount,
  compensationChecklist,
  compensationDeadlines,
  compensationDebtProblem,
  compensationDebtsBlocking,
  compensationDocumentationSituation,
  compensationHandoffOf,
  compensationMoveDirection,
  compensationMoveNeedsForm,
  compensationMovesOf,
  compensationPhaseLabel,
  compensationPhaseOf,
  compensationSituationLabel,
  compensationValueText,
  competenceClosingDate,
  composeCatalog,
  consultantBalance,
  contaAzulAwardCatalogOf,
  contaAzulCatalogOf,
  contaAzulCategoriesFor,
  contaAzulExpenseDescription,
  contaAzulLaunchAllowed,
  contaAzulPiPeripheralsCategoryOf,
  contaAzulRevenueCategoriesOf,
  contactedToday,
  coordinatesFromLocation,
  count,
  countsActivations,
  countsAsUse,
  countsForRanking,
  countsForSalesTarget,
  credentialProblem,
  csvCell,
  csvContent,
  csvDecimal,
  csvFileNamePart,
  dayAfter,
  dayShares,
  daysInPhase,
  daysOverdue,
  daysUntil,
  deadlineBucketOf,
  deadlineFrom,
  decideOutcome,
  deductionCounts,
  deductionKindLabel,
  dedupeRetentionVehicles,
  describeBillingAwardEvent,
  describeDeskEvent,
  describeKanbanMove,
  deskAutoImportDueDate,
  deskAutoImportRequests,
  deskAutoImportState,
  deskBand,
  deskBandRank,
  deskBlock,
  deskBoletoPaid,
  deskColumnKey,
  deskColumnOf,
  deskColumnTitle,
  deskEfficiency,
  deskErpCheckDue,
  deskImportDiscard,
  deskOperatorColumnTitle,
  deskOperatorGroup,
  deskPlateMatch,
  digitsOnly,
  directAward,
  directCompetence,
  directCycleEnd,
  dispatchAmount,
  dispatchLinkExpiresAt,
  dispatchSituation,
  distanceM,
  documentLabel,
  documentationSituation,
  draftMissing,
  dueMonth,
  easterSunday,
  entersRanking,
  entityFreshness,
  equalShares,
  exceedsRepairSpendingCap,
  expandPermissions,
  expenseAlreadyPaid,
  expenseEntryAllowed,
  expenseMoveActor,
  expenseMoveAllowed,
  expenseStageLabel,
  expenseTotals,
  financeActsFor,
  financeDashboardChange,
  financeDashboardDate,
  financeDashboardMonths,
  financeDashboardOf,
  financeDashboardOpen,
  financeDashboardOpenKind,
  financeDashboardPrevious,
  financeDashboardTrend,
  financeTransition,
  flexibleInterval,
  flexibleRefusal,
  format,
  formatAge,
  formatDate,
  formatDocument,
  formatDueDate,
  formatInstant,
  formatPercentage,
  formatPhone,
  formatSpan,
  fromColumn,
  fromReais,
  generateCode,
  generateNumericCode,
  generateTicketCode,
  googleMapsKeyProblem,
  hasTablePrice,
  houseLocalOf,
  importRangeProblem,
  importTargetDate,
  inMonth,
  initialExpenseStage,
  instantFromHouseLocal,
  internalLaunchOn,
  internalLaunchRefusal,
  isActiveDeduction,
  isAllowed,
  isAnalysisCorrectablePhase,
  isAnalysisFieldFilled,
  isAnalysisFieldRequired,
  isAnalysisGeneralPhase,
  isAnalysisMoveAllowed,
  isAnalysisOutcome,
  isAsaasPayment,
  isBillingAwardCandidate,
  isBrazilianState,
  isBusinessDay,
  isCafWebhookAddress,
  isCatalogFieldFilled,
  isCatalogFieldRequired,
  isClaimConclusion,
  isClaimPhase,
  isCompensationCorrectablePhase,
  isCompensationDebtKind,
  isCompensationDebtStatus,
  isCompensationDiscountKind,
  isCompensationDocumentRequired,
  isCompensationFieldFilled,
  isCompensationFieldRequired,
  isCompensationGeneralPhase,
  isCompensationMoveAllowed,
  isCompensationOutcome,
  isCompensationPaidDebtKind,
  isDerivedAnalysisField,
  isDerivedCompensationField,
  isDerivedPeripheralField,
  isDerivedRepairField,
  isDueDepartment,
  isEmailAddress,
  isFinalPaymentStatus,
  isFinalState,
  isFresh,
  isHoliday,
  isInviteUsable,
  isManagementBlocking,
  isManagementDetour,
  isManagementStalled,
  isOpenStage,
  isOverdue,
  isPaid,
  isPassageBoundAnalysisField,
  isPassageBoundCompensationField,
  isPassageBoundPeripheralField,
  isPassageBoundRepairField,
  isPeripheralCorrectablePhase,
  isPeripheralMoveAllowed,
  isPeripheralOutcome,
  isPeripheralWorkStage,
  isPhaseOverdue,
  isRepairCorrectablePhase,
  isRepairFieldFilled,
  isRepairFieldRequired,
  isRepairGeneralPhase,
  isRepairMoveAllowed,
  isRepairOutcome,
  isRepairSupervisionStage,
  isRetentionActivePhase,
  isRetentionFinalPhase,
  isRetentionWorkingPhase,
  isRotationDepartment,
  isRotationPhase,
  isShortMapLink,
  isSlaPhase,
  isSupervisionPhase,
  isTheme,
  isTracking,
  isValidBreakWindow,
  isValidCnpj,
  isValidCpf,
  isValidTicketStatus,
  isValidTransition,
  isValidWindow,
  isVehicleInYard,
  isZero,
  jwtExpiry,
  jwtProblem,
  kanbanColumnLabel,
  labelChanges,
  lastClosedMonth,
  lateSend,
  leaderAmount,
  legacyServiceCode,
  linkTransition,
  loadFailureMessage,
  looksLikeLocation,
  managementAgeBucket,
  managementAvenueOf,
  managementEndKindsOf,
  managementExitsOf,
  managementMoveKind,
  managementMovesOf,
  managementSourcesOf,
  managementStageOf,
  managementStagesOf,
  managementStepOf,
  managementStepsOf,
  managementTopologyOf,
  mapLinkUrl,
  maskBankNumber,
  maskCpf,
  maskCpfInternal,
  maskEmail,
  maskPhone,
  matchBillingAwards,
  matchesOpenBoleto,
  memberCodeOf,
  memberStageOf,
  memberStepsOf,
  memberTrackingMessage,
  mergeDeskStreams,
  messageRecipient,
  mirrorAge,
  mirrorPhone,
  mirrorPhoneNumbers,
  missingAnalysisFields,
  missingCatalogFields,
  missingCompensationFields,
  missingPeripheralAnswers,
  missingPeripheralFields,
  missingRepairFields,
  missingRetentionFinishFields,
  moneyInputText,
  monthEnd,
  monthsAfter,
  monthsEndingAt,
  multiply,
  nationalBankHolidays,
  negate,
  nextBillingAwardLinkStatus,
  nextInRotation,
  nextProgressStep,
  nextTier,
  normalizeCode,
  normalizeCpf,
  normalizeDocument,
  normalizeEmail,
  normalizeMemberCode,
  normalizeName,
  normalizePhone,
  normalizePlate,
  normalizeTicketCode,
  normalizeVehicleCode,
  normalizeVolunteerCode,
  opaqueSecretProblem,
  opasuiteBaseUrl,
  opasuiteBaseUrlProblem,
  openLinkReminder,
  ownerExpired,
  parseDeskColumnKey,
  parseMoneyInput,
  parseRetentionColumnKey,
  passageDays,
  paymentDueOn,
  paymentLinkExpiresAt,
  paymentLinkState,
  paymentMethodOf,
  paymentOptions,
  paymentRequestCode,
  paymentStageRefusal,
  paymentTransition,
  percentageOf,
  peripheralCoverageOf,
  peripheralCoverageRefusal,
  peripheralItemFamily,
  peripheralItemQuestions,
  peripheralItemTypeLabel,
  peripheralMoveDirection,
  peripheralMovesOf,
  peripheralOriginHasWhatsapp,
  peripheralPhaseLabel,
  peripheralPhaseOf,
  peripheralPiVariables,
  peripheralQuoteStatusAfterValues,
  peripheralSituationLabel,
  peripheralTotals,
  peripheralTotalsRefusal,
  peripheralValueText,
  peripheralWeekOriginOf,
  permission,
  permissionParts,
  personTypeOfDocument,
  phaseDeadline,
  phaseSlaState,
  pixKeyTypeOf,
  pixOption,
  placeTextFromLocation,
  planChargeChange,
  plateAttemptsLeft,
  plateClassificationOf,
  plateMatches,
  platesByClassification,
  positionInRanking,
  possessionOutcomeOf,
  preExpenseStatus,
  previousBillingAwardPeriod,
  previousMonthSameDay,
  productAward,
  productLineAmount,
  progressLabel,
  progressOf,
  progressPercent,
  progressStepsOf,
  properName,
  quoteItemKey,
  quoteItemLabor,
  quoteItemNet,
  quoteItemTotal,
  rankingPodiumOf,
  rankingSegmentOf,
  rankingTallyOf,
  reachedTier,
  recurrenceAward,
  recurrencePlan,
  redactIdentifiers,
  refusalToActOnTicket,
  refusalToOpenTicketCategory,
  repairBenefitsOf,
  repairHandoffOf,
  repairMoveDirection,
  repairMovesOf,
  repairPhaseLabel,
  repairPhaseOf,
  repairQuoteTotals,
  repairReferralMessage,
  repairSituationLabel,
  repairSpendingCap,
  repairValueText,
  resolveDefaultTenant,
  resolveMaxAge,
  resolvePaymentStages,
  resolveSaleExpenseStages,
  retentionCancellationBlock,
  retentionColumnKey,
  retentionColumnOf,
  retentionPhaseAgeTone,
  retentionTimerMove,
  revenueIsOpen,
  revenueStatusAfterCharge,
  revenueStatusOnDate,
  rotationOutcome,
  rotationProblems,
  routeTotalM,
  safeReturnPath,
  saleExpenseActFor,
  saleExpenseTransition,
  salesTargetProgressOf,
  salesTargetTallyOf,
  sameOption,
  seesConsultant,
  sendRefusal,
  sendgridKeyProblem,
  serviceScript,
  serviceVariantFits,
  serviceVariantsOf,
  settleBonus,
  settleCommission,
  sgaAssociationTokenProblem,
  sgaTokenProblem,
  shiftByWindow,
  shownAnalysisFields,
  shownCatalogFields,
  shownCompensationFields,
  shownPeripheralFields,
  shownRepairFields,
  signInFailureMessage,
  signalLost,
  slaDeadline,
  slotFitsWindow,
  slotInterval,
  slotMinutes,
  splitPeriod,
  stageOf,
  startOfDay,
  stateOfCep,
  subordinatesAt,
  subtract,
  sum,
  summarizeClaimExits,
  summarizeClaimFlow,
  summarizeDepartmentDurations,
  summarizeManagement,
  summarizePeripheralDeadlines,
  summarizePeripheralDurations,
  summarizePeripheralMoney,
  summarizePeripheralQuotes,
  summarizeRepairMoney,
  summarizeStageDeadlines,
  summarizeStageDurations,
  summarizeStays,
  supervisorActsFor,
  supervisorAt,
  supervisorChainAt,
  supervisorFromTeams,
  supervisorStage,
  supervisorTransition,
  tallyByType,
  teamCycle,
  teamMapConsultantKey,
  teamMapGapKey,
  teamMapManagerKey,
  teamMapPlace,
  teamMapRollup,
  teamMapTeamKey,
  teamMapTree,
  technologyFeeByLot,
  technologyFeeLine,
  technologyFeeOf,
  technologyFeeTarget,
  technologyFeeTiersRefusal,
  templatePlainText,
  templateVariables,
  thirdPartyQuestions,
  ticketDeadline,
  ticketPriorityLabel,
  ticketStatusLabel,
  ticketStatusTone,
  toColumn,
  towBreakdown,
  typeMasked,
  usageDisplayWindow,
  usageLineOf,
  usageRowOf,
  usageTable,
  usageWindowLabel,
  usefulLinkUrl,
  validTheme,
  validTransitions,
  variation,
  vehicleCodeOf,
  vehicleSituationTone,
  vehicleStatusAccepted,
  vendorDay,
  vendorUpperCase,
  visibleAnalysisFields,
  visibleCatalogFields,
  visibleCompensationFields,
  visiblePeripheralFields,
  visibleRepairFields,
  volunteerCodeOf,
  walletPlan,
  walletScenarios,
  weekOf,
  weekSlots,
  weeklyNotices,
  weeklyPeripherals,
  whatsappAddress,
  whatsappPurpose,
  windowOfEndpoint,
  windowState,
  withAddon,
  within,
  withinImportRange,
  workerState,
  zapsignMessage
};
//# sourceMappingURL=index.js.map